function _typeof(e) {
	return (_typeof =
	  "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
		? function (e) {
			return typeof e;
		  }
		: function (e) {
			return e &&
			  "function" == typeof Symbol &&
			  e.constructor === Symbol &&
			  e !== Symbol.prototype
			  ? "symbol"
			  : typeof e;
		  })(e);
  }
  !(function (e, t) {
	"use strict";
	"object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
	"object" == _typeof(module.exports)
	  ? (module.exports = e.document
		  ? t(e, !0)
		  : function (e) {
			  if (!e.document)
				throw new Error("jQuery requires a window with a document");
			  return t(e);
			})
	  : t(e);
  })("undefined" != typeof window ? window : this, function (S, e) {
	"use strict";
	function v(e) {
	  return null != e && e === e.window;
	}
	var t = [],
	  n = Object.getPrototypeOf,
	  o = t.slice,
	  g = t.flat
		? function (e) {
			return t.flat.call(e);
		  }
		: function (e) {
			return t.concat.apply([], e);
		  },
	  l = t.push,
	  s = t.indexOf,
	  i = {},
	  r = i.toString,
	  m = i.hasOwnProperty,
	  a = m.toString,
	  d = a.call(Object),
	  y = {},
	  b = function (e) {
		return "function" == typeof e && "number" != typeof e.nodeType;
	  },
	  C = S.document,
	  c = { type: !0, src: !0, nonce: !0, noModule: !0 };
	function w(e, t, i) {
	  var n,
		s,
		r = (i = i || C).createElement("script");
	  if (((r.text = e), t))
		for (n in c)
		  (s = t[n] || (t.getAttribute && t.getAttribute(n))) &&
			r.setAttribute(n, s);
	  i.head.appendChild(r).parentNode.removeChild(r);
	}
	function x(e) {
	  return null == e
		? e + ""
		: "object" == _typeof(e) || "function" == typeof e
		? i[r.call(e)] || "object"
		: _typeof(e);
	}
	var u = "3.5.1",
	  E = function e(t, i) {
		return new e.fn.init(t, i);
	  };
	function h(e) {
	  var t = !!e && "length" in e && e.length,
		i = x(e);
	  return (
		!b(e) &&
		!v(e) &&
		("array" === i ||
		  0 === t ||
		  ("number" == typeof t && 0 < t && t - 1 in e))
	  );
	}
	(E.fn = E.prototype =
	  {
		jquery: u,
		constructor: E,
		length: 0,
		toArray: function () {
		  return o.call(this);
		},
		get: function (e) {
		  return null == e
			? o.call(this)
			: e < 0
			? this[e + this.length]
			: this[e];
		},
		pushStack: function (e) {
		  var t = E.merge(this.constructor(), e);
		  return (t.prevObject = this), t;
		},
		each: function (e) {
		  return E.each(this, e);
		},
		map: function (i) {
		  return this.pushStack(
			E.map(this, function (e, t) {
			  return i.call(e, t, e);
			})
		  );
		},
		slice: function () {
		  return this.pushStack(o.apply(this, arguments));
		},
		first: function () {
		  return this.eq(0);
		},
		last: function () {
		  return this.eq(-1);
		},
		even: function () {
		  return this.pushStack(
			E.grep(this, function (e, t) {
			  return (t + 1) % 2;
			})
		  );
		},
		odd: function () {
		  return this.pushStack(
			E.grep(this, function (e, t) {
			  return t % 2;
			})
		  );
		},
		eq: function (e) {
		  var t = this.length,
			i = +e + (e < 0 ? t : 0);
		  return this.pushStack(0 <= i && i < t ? [this[i]] : []);
		},
		end: function () {
		  return this.prevObject || this.constructor();
		},
		push: l,
		sort: t.sort,
		splice: t.splice,
	  }),
	  (E.extend = E.fn.extend =
		function () {
		  var e,
			t,
			i,
			n,
			s,
			r,
			a = arguments[0] || {},
			o = 1,
			l = arguments.length,
			d = !1;
		  for (
			"boolean" == typeof a && ((d = a), (a = arguments[o] || {}), o++),
			  "object" == _typeof(a) || b(a) || (a = {}),
			  o === l && ((a = this), o--);
			o < l;
			o++
		  )
			if (null != (e = arguments[o]))
			  for (t in e)
				(n = e[t]),
				  "__proto__" !== t &&
					a !== n &&
					(d && n && (E.isPlainObject(n) || (s = Array.isArray(n)))
					  ? ((i = a[t]),
						(r =
						  s && !Array.isArray(i)
							? []
							: s || E.isPlainObject(i)
							? i
							: {}),
						(s = !1),
						(a[t] = E.extend(d, r, n)))
					  : void 0 !== n && (a[t] = n));
		  return a;
		}),
	  E.extend({
		expando: "jQuery" + (u + Math.random()).replace(/\D/g, ""),
		isReady: !0,
		error: function (e) {
		  throw new Error(e);
		},
		noop: function () {},
		isPlainObject: function (e) {
		  var t, i;
		  return !(
			!e ||
			"[object Object]" !== r.call(e) ||
			((t = n(e)) &&
			  ("function" !=
				typeof (i = m.call(t, "constructor") && t.constructor) ||
				a.call(i) !== d))
		  );
		},
		isEmptyObject: function (e) {
		  var t;
		  for (t in e) return !1;
		  return !0;
		},
		globalEval: function (e, t, i) {
		  w(e, { nonce: t && t.nonce }, i);
		},
		each: function (e, t) {
		  var i,
			n = 0;
		  if (h(e))
			for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
		  else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
		  return e;
		},
		makeArray: function (e, t) {
		  var i = t || [];
		  return (
			null != e &&
			  (h(Object(e))
				? E.merge(i, "string" == typeof e ? [e] : e)
				: l.call(i, e)),
			i
		  );
		},
		inArray: function (e, t, i) {
		  return null == t ? -1 : s.call(t, e, i);
		},
		merge: function (e, t) {
		  for (var i = +t.length, n = 0, s = e.length; n < i; n++) e[s++] = t[n];
		  return (e.length = s), e;
		},
		grep: function (e, t, i) {
		  for (var n = [], s = 0, r = e.length, a = !i; s < r; s++)
			!t(e[s], s) != a && n.push(e[s]);
		  return n;
		},
		map: function (e, t, i) {
		  var n,
			s,
			r = 0,
			a = [];
		  if (h(e))
			for (n = e.length; r < n; r++)
			  null != (s = t(e[r], r, i)) && a.push(s);
		  else for (r in e) null != (s = t(e[r], r, i)) && a.push(s);
		  return g(a);
		},
		guid: 1,
		support: y,
	  }),
	  "function" == typeof Symbol && (E.fn[Symbol.iterator] = t[Symbol.iterator]),
	  E.each(
		"Boolean Number String Function Array Date RegExp Object Error Symbol".split(
		  " "
		),
		function (e, t) {
		  i["[object " + t + "]"] = t.toLowerCase();
		}
	  );
	var p = (function (i) {
	  function u(e, t) {
		var i = "0x" + e.slice(1) - 65536;
		return (
		  t ||
		  (i < 0
			? String.fromCharCode(65536 + i)
			: String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
		);
	  }
	  function s() {
		T();
	  }
	  var e,
		p,
		w,
		r,
		a,
		f,
		h,
		v,
		x,
		l,
		d,
		T,
		S,
		o,
		C,
		g,
		c,
		m,
		y,
		E = "sizzle" + +new Date(),
		b = i.document,
		k = 0,
		n = 0,
		Y = le(),
		z = le(),
		$ = le(),
		P = le(),
		A = function (e, t) {
		  return e === t && (d = !0), 0;
		},
		M = {}.hasOwnProperty,
		t = [],
		L = t.pop,
		D = t.push,
		O = t.push,
		N = t.slice,
		I = function (e, t) {
		  for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
		  return -1;
		},
		H =
		  "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
		j = "[\\x20\\t\\r\\n\\f]",
		q =
		  "(?:\\\\[\\da-fA-F]{1,6}" +
		  j +
		  "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
		B =
		  "\\[" +
		  j +
		  "*(" +
		  q +
		  ")(?:" +
		  j +
		  "*([*^$|!~]?=)" +
		  j +
		  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
		  q +
		  "))|)" +
		  j +
		  "*\\]",
		R =
		  ":(" +
		  q +
		  ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
		  B +
		  ")*)|.*)\\)|)",
		W = new RegExp(j + "+", "g"),
		F = new RegExp("^" + j + "+|((?:^|[^\\\\])(?:\\\\.)*)" + j + "+$", "g"),
		X = new RegExp("^" + j + "*," + j + "*"),
		_ = new RegExp("^" + j + "*([>+~]|" + j + ")" + j + "*"),
		V = new RegExp(j + "|>"),
		Z = new RegExp(R),
		G = new RegExp("^" + q + "$"),
		U = {
		  ID: new RegExp("^#(" + q + ")"),
		  CLASS: new RegExp("^\\.(" + q + ")"),
		  TAG: new RegExp("^(" + q + "|[*])"),
		  ATTR: new RegExp("^" + B),
		  PSEUDO: new RegExp("^" + R),
		  CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			  j +
			  "*(even|odd|(([+-]|)(\\d*)n|)" +
			  j +
			  "*(?:([+-]|)" +
			  j +
			  "*(\\d+)|))" +
			  j +
			  "*\\)|)",
			"i"
		  ),
		  bool: new RegExp("^(?:" + H + ")$", "i"),
		  needsContext: new RegExp(
			"^" +
			  j +
			  "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			  j +
			  "*((?:-\\d)?\\d*)" +
			  j +
			  "*\\)|)(?=[^-]|$)",
			"i"
		  ),
		},
		Q = /HTML$/i,
		K = /^(?:input|select|textarea|button)$/i,
		J = /^h\d$/i,
		ee = /^[^{]+\{\s*\[native \w/,
		te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
		ie = /[+~]/,
		ne = new RegExp("\\\\[\\da-fA-F]{1,6}" + j + "?|\\\\([^\\r\\n\\f])", "g"),
		se = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		re = function (e, t) {
		  return t
			? "\0" === e
			  ? "�"
			  : e.slice(0, -1) +
				"\\" +
				e.charCodeAt(e.length - 1).toString(16) +
				" "
			: "\\" + e;
		},
		ae = we(
		  function (e) {
			return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
		  },
		  { dir: "parentNode", next: "legend" }
		);
	  try {
		O.apply((t = N.call(b.childNodes)), b.childNodes),
		  t[b.childNodes.length].nodeType;
	  } catch (e) {
		O = {
		  apply: t.length
			? function (e, t) {
				D.apply(e, N.call(t));
			  }
			: function (e, t) {
				for (var i = e.length, n = 0; (e[i++] = t[n++]); );
				e.length = i - 1;
			  },
		};
	  }
	  function oe(e, t, i, n) {
		var s,
		  r,
		  a,
		  o,
		  l,
		  d,
		  c,
		  u = t && t.ownerDocument,
		  h = t ? t.nodeType : 9;
		if (
		  ((i = i || []),
		  "string" != typeof e || !e || (1 !== h && 9 !== h && 11 !== h))
		)
		  return i;
		if (!n && (T(t), (t = t || S), C)) {
		  if (11 !== h && (l = te.exec(e)))
			if ((s = l[1])) {
			  if (9 === h) {
				if (!(a = t.getElementById(s))) return i;
				if (a.id === s) return i.push(a), i;
			  } else if (u && (a = u.getElementById(s)) && y(t, a) && a.id === s)
				return i.push(a), i;
			} else {
			  if (l[2]) return O.apply(i, t.getElementsByTagName(e)), i;
			  if (
				(s = l[3]) &&
				p.getElementsByClassName &&
				t.getElementsByClassName
			  )
				return O.apply(i, t.getElementsByClassName(s)), i;
			}
		  if (
			p.qsa &&
			!P[e + " "] &&
			(!g || !g.test(e)) &&
			(1 !== h || "object" !== t.nodeName.toLowerCase())
		  ) {
			if (((c = e), (u = t), 1 === h && (V.test(e) || _.test(e)))) {
			  for (
				((u = (ie.test(e) && me(t.parentNode)) || t) === t && p.scope) ||
				  ((o = t.getAttribute("id"))
					? (o = o.replace(se, re))
					: t.setAttribute("id", (o = E))),
				  r = (d = f(e)).length;
				r--;
  
			  )
				d[r] = (o ? "#" + o : ":scope") + " " + be(d[r]);
			  c = d.join(",");
			}
			try {
			  return O.apply(i, u.querySelectorAll(c)), i;
			} catch (t) {
			  P(e, !0);
			} finally {
			  o === E && t.removeAttribute("id");
			}
		  }
		}
		return v(e.replace(F, "$1"), t, i, n);
	  }
	  function le() {
		var n = [];
		return function e(t, i) {
		  return (
			n.push(t + " ") > w.cacheLength && delete e[n.shift()],
			(e[t + " "] = i)
		  );
		};
	  }
	  function de(e) {
		return (e[E] = !0), e;
	  }
	  function ce(e) {
		var t = S.createElement("fieldset");
		try {
		  return !!e(t);
		} catch (e) {
		  return !1;
		} finally {
		  t.parentNode && t.parentNode.removeChild(t), (t = null);
		}
	  }
	  function ue(e, t) {
		for (var i = e.split("|"), n = i.length; n--; ) w.attrHandle[i[n]] = t;
	  }
	  function he(e, t) {
		var i = t && e,
		  n =
			i &&
			1 === e.nodeType &&
			1 === t.nodeType &&
			e.sourceIndex - t.sourceIndex;
		if (n) return n;
		if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
		return e ? 1 : -1;
	  }
	  function pe(t) {
		return function (e) {
		  return "input" === e.nodeName.toLowerCase() && e.type === t;
		};
	  }
	  function fe(i) {
		return function (e) {
		  var t = e.nodeName.toLowerCase();
		  return ("input" === t || "button" === t) && e.type === i;
		};
	  }
	  function ve(t) {
		return function (e) {
		  return "form" in e
			? e.parentNode && !1 === e.disabled
			  ? "label" in e
				? "label" in e.parentNode
				  ? e.parentNode.disabled === t
				  : e.disabled === t
				: e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
			  : e.disabled === t
			: "label" in e && e.disabled === t;
		};
	  }
	  function ge(a) {
		return de(function (r) {
		  return (
			(r = +r),
			de(function (e, t) {
			  for (var i, n = a([], e.length, r), s = n.length; s--; )
				e[(i = n[s])] && (e[i] = !(t[i] = e[i]));
			})
		  );
		});
	  }
	  function me(e) {
		return e && void 0 !== e.getElementsByTagName && e;
	  }
	  for (e in ((p = oe.support = {}),
	  (a = oe.isXML =
		function (e) {
		  var t = e.namespaceURI,
			i = (e.ownerDocument || e).documentElement;
		  return !Q.test(t || (i && i.nodeName) || "HTML");
		}),
	  (T = oe.setDocument =
		function (e) {
		  var t,
			i,
			n = e ? e.ownerDocument || e : b;
		  return (
			n != S &&
			  9 === n.nodeType &&
			  n.documentElement &&
			  ((o = (S = n).documentElement),
			  (C = !a(S)),
			  b != S &&
				(i = S.defaultView) &&
				i.top !== i &&
				(i.addEventListener
				  ? i.addEventListener("unload", s, !1)
				  : i.attachEvent && i.attachEvent("onunload", s)),
			  (p.scope = ce(function (e) {
				return (
				  o.appendChild(e).appendChild(S.createElement("div")),
				  void 0 !== e.querySelectorAll &&
					!e.querySelectorAll(":scope fieldset div").length
				);
			  })),
			  (p.attributes = ce(function (e) {
				return (e.className = "i"), !e.getAttribute("className");
			  })),
			  (p.getElementsByTagName = ce(function (e) {
				return (
				  e.appendChild(S.createComment("")),
				  !e.getElementsByTagName("*").length
				);
			  })),
			  (p.getElementsByClassName = ee.test(S.getElementsByClassName)),
			  (p.getById = ce(function (e) {
				return (
				  (o.appendChild(e).id = E),
				  !S.getElementsByName || !S.getElementsByName(E).length
				);
			  })),
			  p.getById
				? ((w.filter.ID = function (e) {
					var t = e.replace(ne, u);
					return function (e) {
					  return e.getAttribute("id") === t;
					};
				  }),
				  (w.find.ID = function (e, t) {
					if (void 0 !== t.getElementById && C) {
					  var i = t.getElementById(e);
					  return i ? [i] : [];
					}
				  }))
				: ((w.filter.ID = function (e) {
					var i = e.replace(ne, u);
					return function (e) {
					  var t =
						void 0 !== e.getAttributeNode && e.getAttributeNode("id");
					  return t && t.value === i;
					};
				  }),
				  (w.find.ID = function (e, t) {
					if (void 0 !== t.getElementById && C) {
					  var i,
						n,
						s,
						r = t.getElementById(e);
					  if (r) {
						if ((i = r.getAttributeNode("id")) && i.value === e)
						  return [r];
						for (s = t.getElementsByName(e), n = 0; (r = s[n++]); )
						  if ((i = r.getAttributeNode("id")) && i.value === e)
							return [r];
					  }
					  return [];
					}
				  })),
			  (w.find.TAG = p.getElementsByTagName
				? function (e, t) {
					return void 0 !== t.getElementsByTagName
					  ? t.getElementsByTagName(e)
					  : p.qsa
					  ? t.querySelectorAll(e)
					  : void 0;
				  }
				: function (e, t) {
					var i,
					  n = [],
					  s = 0,
					  r = t.getElementsByTagName(e);
					if ("*" !== e) return r;
					for (; (i = r[s++]); ) 1 === i.nodeType && n.push(i);
					return n;
				  }),
			  (w.find.CLASS =
				p.getElementsByClassName &&
				function (e, t) {
				  if (void 0 !== t.getElementsByClassName && C)
					return t.getElementsByClassName(e);
				}),
			  (c = []),
			  (g = []),
			  (p.qsa = ee.test(S.querySelectorAll)) &&
				(ce(function (e) {
				  var t;
				  (o.appendChild(e).innerHTML =
					"<a id='" +
					E +
					"'></a><select id='" +
					E +
					"-\r\\' msallowcapture=''><option selected=''></option></select>"),
					e.querySelectorAll("[msallowcapture^='']").length &&
					  g.push("[*^$]=" + j + "*(?:''|\"\")"),
					e.querySelectorAll("[selected]").length ||
					  g.push("\\[" + j + "*(?:value|" + H + ")"),
					e.querySelectorAll("[id~=" + E + "-]").length || g.push("~="),
					(t = S.createElement("input")).setAttribute("name", ""),
					e.appendChild(t),
					e.querySelectorAll("[name='']").length ||
					  g.push("\\[" + j + "*name" + j + "*=" + j + "*(?:''|\"\")"),
					e.querySelectorAll(":checked").length || g.push(":checked"),
					e.querySelectorAll("a#" + E + "+*").length ||
					  g.push(".#.+[+~]"),
					e.querySelectorAll("\\\f"),
					g.push("[\\r\\n\\f]");
				}),
				ce(function (e) {
				  e.innerHTML =
					"<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
				  var t = S.createElement("input");
				  t.setAttribute("type", "hidden"),
					e.appendChild(t).setAttribute("name", "D"),
					e.querySelectorAll("[name=d]").length &&
					  g.push("name" + j + "*[*^$|!~]?="),
					2 !== e.querySelectorAll(":enabled").length &&
					  g.push(":enabled", ":disabled"),
					(o.appendChild(e).disabled = !0),
					2 !== e.querySelectorAll(":disabled").length &&
					  g.push(":enabled", ":disabled"),
					e.querySelectorAll("*,:x"),
					g.push(",.*:");
				})),
			  (p.matchesSelector = ee.test(
				(m =
				  o.matches ||
				  o.webkitMatchesSelector ||
				  o.mozMatchesSelector ||
				  o.oMatchesSelector ||
				  o.msMatchesSelector)
			  )) &&
				ce(function (e) {
				  (p.disconnectedMatch = m.call(e, "*")),
					m.call(e, "[s!='']:x"),
					c.push("!=", R);
				}),
			  (g = g.length && new RegExp(g.join("|"))),
			  (c = c.length && new RegExp(c.join("|"))),
			  (t = ee.test(o.compareDocumentPosition)),
			  (y =
				t || ee.test(o.contains)
				  ? function (e, t) {
					  var i = 9 === e.nodeType ? e.documentElement : e,
						n = t && t.parentNode;
					  return (
						e === n ||
						!(
						  !n ||
						  1 !== n.nodeType ||
						  !(i.contains
							? i.contains(n)
							: e.compareDocumentPosition &&
							  16 & e.compareDocumentPosition(n))
						)
					  );
					}
				  : function (e, t) {
					  if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
					  return !1;
					}),
			  (A = t
				? function (e, t) {
					if (e === t) return (d = !0), 0;
					var i =
					  !e.compareDocumentPosition - !t.compareDocumentPosition;
					return (
					  i ||
					  (1 &
						(i =
						  (e.ownerDocument || e) == (t.ownerDocument || t)
							? e.compareDocumentPosition(t)
							: 1) ||
					  (!p.sortDetached && t.compareDocumentPosition(e) === i)
						? e == S || (e.ownerDocument == b && y(b, e))
						  ? -1
						  : t == S || (t.ownerDocument == b && y(b, t))
						  ? 1
						  : l
						  ? I(l, e) - I(l, t)
						  : 0
						: 4 & i
						? -1
						: 1)
					);
				  }
				: function (e, t) {
					if (e === t) return (d = !0), 0;
					var i,
					  n = 0,
					  s = e.parentNode,
					  r = t.parentNode,
					  a = [e],
					  o = [t];
					if (!s || !r)
					  return e == S
						? -1
						: t == S
						? 1
						: s
						? -1
						: r
						? 1
						: l
						? I(l, e) - I(l, t)
						: 0;
					if (s === r) return he(e, t);
					for (i = e; (i = i.parentNode); ) a.unshift(i);
					for (i = t; (i = i.parentNode); ) o.unshift(i);
					for (; a[n] === o[n]; ) n++;
					return n
					  ? he(a[n], o[n])
					  : a[n] == b
					  ? -1
					  : o[n] == b
					  ? 1
					  : 0;
				  })),
			S
		  );
		}),
	  (oe.matches = function (e, t) {
		return oe(e, null, null, t);
	  }),
	  (oe.matchesSelector = function (e, t) {
		if (
		  (T(e),
		  p.matchesSelector &&
			C &&
			!P[t + " "] &&
			(!c || !c.test(t)) &&
			(!g || !g.test(t)))
		)
		  try {
			var i = m.call(e, t);
			if (
			  i ||
			  p.disconnectedMatch ||
			  (e.document && 11 !== e.document.nodeType)
			)
			  return i;
		  } catch (e) {
			P(t, !0);
		  }
		return 0 < oe(t, S, null, [e]).length;
	  }),
	  (oe.contains = function (e, t) {
		return (e.ownerDocument || e) != S && T(e), y(e, t);
	  }),
	  (oe.attr = function (e, t) {
		(e.ownerDocument || e) != S && T(e);
		var i = w.attrHandle[t.toLowerCase()],
		  n = i && M.call(w.attrHandle, t.toLowerCase()) ? i(e, t, !C) : void 0;
		return void 0 !== n
		  ? n
		  : p.attributes || !C
		  ? e.getAttribute(t)
		  : (n = e.getAttributeNode(t)) && n.specified
		  ? n.value
		  : null;
	  }),
	  (oe.escape = function (e) {
		return (e + "").replace(se, re);
	  }),
	  (oe.error = function (e) {
		throw new Error("Syntax error, unrecognized expression: " + e);
	  }),
	  (oe.uniqueSort = function (e) {
		var t,
		  i = [],
		  n = 0,
		  s = 0;
		if (
		  ((d = !p.detectDuplicates),
		  (l = !p.sortStable && e.slice(0)),
		  e.sort(A),
		  d)
		) {
		  for (; (t = e[s++]); ) t === e[s] && (n = i.push(s));
		  for (; n--; ) e.splice(i[n], 1);
		}
		return (l = null), e;
	  }),
	  (r = oe.getText =
		function (e) {
		  var t,
			i = "",
			n = 0,
			s = e.nodeType;
		  if (s) {
			if (1 === s || 9 === s || 11 === s) {
			  if ("string" == typeof e.textContent) return e.textContent;
			  for (e = e.firstChild; e; e = e.nextSibling) i += r(e);
			} else if (3 === s || 4 === s) return e.nodeValue;
		  } else for (; (t = e[n++]); ) i += r(t);
		  return i;
		}),
	  ((w = oe.selectors =
		{
		  cacheLength: 50,
		  createPseudo: de,
		  match: U,
		  attrHandle: {},
		  find: {},
		  relative: {
			">": { dir: "parentNode", first: !0 },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: !0 },
			"~": { dir: "previousSibling" },
		  },
		  preFilter: {
			ATTR: function (e) {
			  return (
				(e[1] = e[1].replace(ne, u)),
				(e[3] = (e[3] || e[4] || e[5] || "").replace(ne, u)),
				"~=" === e[2] && (e[3] = " " + e[3] + " "),
				e.slice(0, 4)
			  );
			},
			CHILD: function (e) {
			  return (
				(e[1] = e[1].toLowerCase()),
				"nth" === e[1].slice(0, 3)
				  ? (e[3] || oe.error(e[0]),
					(e[4] = +(e[4]
					  ? e[5] + (e[6] || 1)
					  : 2 * ("even" === e[3] || "odd" === e[3]))),
					(e[5] = +(e[7] + e[8] || "odd" === e[3])))
				  : e[3] && oe.error(e[0]),
				e
			  );
			},
			PSEUDO: function (e) {
			  var t,
				i = !e[6] && e[2];
			  return U.CHILD.test(e[0])
				? null
				: (e[3]
					? (e[2] = e[4] || e[5] || "")
					: i &&
					  Z.test(i) &&
					  (t = f(i, !0)) &&
					  (t = i.indexOf(")", i.length - t) - i.length) &&
					  ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
				  e.slice(0, 3));
			},
		  },
		  filter: {
			TAG: function (e) {
			  var t = e.replace(ne, u).toLowerCase();
			  return "*" === e
				? function () {
					return !0;
				  }
				: function (e) {
					return e.nodeName && e.nodeName.toLowerCase() === t;
				  };
			},
			CLASS: function (e) {
			  var t = Y[e + " "];
			  return (
				t ||
				((t = new RegExp("(^|" + j + ")" + e + "(" + j + "|$)")) &&
				  Y(e, function (e) {
					return t.test(
					  ("string" == typeof e.className && e.className) ||
						(void 0 !== e.getAttribute && e.getAttribute("class")) ||
						""
					);
				  }))
			  );
			},
			ATTR: function (i, n, s) {
			  return function (e) {
				var t = oe.attr(e, i);
				return null == t
				  ? "!=" === n
				  : !n ||
					  ((t += ""),
					  "=" === n
						? t === s
						: "!=" === n
						? t !== s
						: "^=" === n
						? s && 0 === t.indexOf(s)
						: "*=" === n
						? s && -1 < t.indexOf(s)
						: "$=" === n
						? s && t.slice(-s.length) === s
						: "~=" === n
						? -1 < (" " + t.replace(W, " ") + " ").indexOf(s)
						: "|=" === n &&
						  (t === s || t.slice(0, s.length + 1) === s + "-"));
			  };
			},
			CHILD: function (f, e, t, v, g) {
			  var m = "nth" !== f.slice(0, 3),
				y = "last" !== f.slice(-4),
				b = "of-type" === e;
			  return 1 === v && 0 === g
				? function (e) {
					return !!e.parentNode;
				  }
				: function (e, t, i) {
					var n,
					  s,
					  r,
					  a,
					  o,
					  l,
					  d = m != y ? "nextSibling" : "previousSibling",
					  c = e.parentNode,
					  u = b && e.nodeName.toLowerCase(),
					  h = !i && !b,
					  p = !1;
					if (c) {
					  if (m) {
						for (; d; ) {
						  for (a = e; (a = a[d]); )
							if (
							  b
								? a.nodeName.toLowerCase() === u
								: 1 === a.nodeType
							)
							  return !1;
						  l = d = "only" === f && !l && "nextSibling";
						}
						return !0;
					  }
					  if (((l = [y ? c.firstChild : c.lastChild]), y && h)) {
						for (
						  p =
							(o =
							  (n =
								(s =
								  (r = (a = c)[E] || (a[E] = {}))[a.uniqueID] ||
								  (r[a.uniqueID] = {}))[f] || [])[0] === k &&
							  n[1]) && n[2],
							a = o && c.childNodes[o];
						  (a = (++o && a && a[d]) || (p = o = 0) || l.pop());
  
						)
						  if (1 === a.nodeType && ++p && a === e) {
							s[f] = [k, o, p];
							break;
						  }
					  } else if (
						(h &&
						  (p = o =
							(n =
							  (s =
								(r = (a = e)[E] || (a[E] = {}))[a.uniqueID] ||
								(r[a.uniqueID] = {}))[f] || [])[0] === k && n[1]),
						!1 === p)
					  )
						for (
						  ;
						  (a = (++o && a && a[d]) || (p = o = 0) || l.pop()) &&
						  ((b
							? a.nodeName.toLowerCase() !== u
							: 1 !== a.nodeType) ||
							!++p ||
							(h &&
							  ((s =
								(r = a[E] || (a[E] = {}))[a.uniqueID] ||
								(r[a.uniqueID] = {}))[f] = [k, p]),
							a !== e));
  
						);
					  return (p -= g) === v || (p % v == 0 && 0 <= p / v);
					}
				  };
			},
			PSEUDO: function (e, r) {
			  var t,
				a =
				  w.pseudos[e] ||
				  w.setFilters[e.toLowerCase()] ||
				  oe.error("unsupported pseudo: " + e);
			  return a[E]
				? a(r)
				: 1 < a.length
				? ((t = [e, e, "", r]),
				  w.setFilters.hasOwnProperty(e.toLowerCase())
					? de(function (e, t) {
						for (var i, n = a(e, r), s = n.length; s--; )
						  e[(i = I(e, n[s]))] = !(t[i] = n[s]);
					  })
					: function (e) {
						return a(e, 0, t);
					  })
				: a;
			},
		  },
		  pseudos: {
			not: de(function (e) {
			  var n = [],
				s = [],
				o = h(e.replace(F, "$1"));
			  return o[E]
				? de(function (e, t, i, n) {
					for (var s, r = o(e, null, n, []), a = e.length; a--; )
					  (s = r[a]) && (e[a] = !(t[a] = s));
				  })
				: function (e, t, i) {
					return (n[0] = e), o(n, null, i, s), (n[0] = null), !s.pop();
				  };
			}),
			has: de(function (t) {
			  return function (e) {
				return 0 < oe(t, e).length;
			  };
			}),
			contains: de(function (t) {
			  return (
				(t = t.replace(ne, u)),
				function (e) {
				  return -1 < (e.textContent || r(e)).indexOf(t);
				}
			  );
			}),
			lang: de(function (i) {
			  return (
				G.test(i || "") || oe.error("unsupported lang: " + i),
				(i = i.replace(ne, u).toLowerCase()),
				function (e) {
				  var t;
				  do {
					if (
					  (t = C
						? e.lang
						: e.getAttribute("xml:lang") || e.getAttribute("lang"))
					)
					  return (
						(t = t.toLowerCase()) === i || 0 === t.indexOf(i + "-")
					  );
				  } while ((e = e.parentNode) && 1 === e.nodeType);
				  return !1;
				}
			  );
			}),
			target: function (e) {
			  var t = i.location && i.location.hash;
			  return t && t.slice(1) === e.id;
			},
			root: function (e) {
			  return e === o;
			},
			focus: function (e) {
			  return (
				e === S.activeElement &&
				(!S.hasFocus || S.hasFocus()) &&
				!!(e.type || e.href || ~e.tabIndex)
			  );
			},
			enabled: ve(!1),
			disabled: ve(!0),
			checked: function (e) {
			  var t = e.nodeName.toLowerCase();
			  return (
				("input" === t && !!e.checked) || ("option" === t && !!e.selected)
			  );
			},
			selected: function (e) {
			  return (
				e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
			  );
			},
			empty: function (e) {
			  for (e = e.firstChild; e; e = e.nextSibling)
				if (e.nodeType < 6) return !1;
			  return !0;
			},
			parent: function (e) {
			  return !w.pseudos.empty(e);
			},
			header: function (e) {
			  return J.test(e.nodeName);
			},
			input: function (e) {
			  return K.test(e.nodeName);
			},
			button: function (e) {
			  var t = e.nodeName.toLowerCase();
			  return ("input" === t && "button" === e.type) || "button" === t;
			},
			text: function (e) {
			  var t;
			  return (
				"input" === e.nodeName.toLowerCase() &&
				"text" === e.type &&
				(null == (t = e.getAttribute("type")) ||
				  "text" === t.toLowerCase())
			  );
			},
			first: ge(function () {
			  return [0];
			}),
			last: ge(function (e, t) {
			  return [t - 1];
			}),
			eq: ge(function (e, t, i) {
			  return [i < 0 ? i + t : i];
			}),
			even: ge(function (e, t) {
			  for (var i = 0; i < t; i += 2) e.push(i);
			  return e;
			}),
			odd: ge(function (e, t) {
			  for (var i = 1; i < t; i += 2) e.push(i);
			  return e;
			}),
			lt: ge(function (e, t, i) {
			  for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; ) e.push(n);
			  return e;
			}),
			gt: ge(function (e, t, i) {
			  for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
			  return e;
			}),
		  },
		}).pseudos.nth = w.pseudos.eq),
	  { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
		w.pseudos[e] = pe(e);
	  for (e in { submit: !0, reset: !0 }) w.pseudos[e] = fe(e);
	  function ye() {}
	  function be(e) {
		for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
		return n;
	  }
	  function we(o, e, t) {
		var l = e.dir,
		  d = e.next,
		  c = d || l,
		  u = t && "parentNode" === c,
		  h = n++;
		return e.first
		  ? function (e, t, i) {
			  for (; (e = e[l]); ) if (1 === e.nodeType || u) return o(e, t, i);
			  return !1;
			}
		  : function (e, t, i) {
			  var n,
				s,
				r,
				a = [k, h];
			  if (i) {
				for (; (e = e[l]); )
				  if ((1 === e.nodeType || u) && o(e, t, i)) return !0;
			  } else
				for (; (e = e[l]); )
				  if (1 === e.nodeType || u)
					if (
					  ((s =
						(r = e[E] || (e[E] = {}))[e.uniqueID] ||
						(r[e.uniqueID] = {})),
					  d && d === e.nodeName.toLowerCase())
					)
					  e = e[l] || e;
					else {
					  if ((n = s[c]) && n[0] === k && n[1] === h)
						return (a[2] = n[2]);
					  if (((s[c] = a)[2] = o(e, t, i))) return !0;
					}
			  return !1;
			};
	  }
	  function xe(s) {
		return 1 < s.length
		  ? function (e, t, i) {
			  for (var n = s.length; n--; ) if (!s[n](e, t, i)) return !1;
			  return !0;
			}
		  : s[0];
	  }
	  function Te(e, t, i, n, s) {
		for (var r, a = [], o = 0, l = e.length, d = null != t; o < l; o++)
		  (r = e[o]) && ((i && !i(r, n, s)) || (a.push(r), d && t.push(o)));
		return a;
	  }
	  function Se(p, f, v, g, m, e) {
		return (
		  g && !g[E] && (g = Se(g)),
		  m && !m[E] && (m = Se(m, e)),
		  de(function (e, t, i, n) {
			var s,
			  r,
			  a,
			  o = [],
			  l = [],
			  d = t.length,
			  c =
				e ||
				(function (e, t, i) {
				  for (var n = 0, s = t.length; n < s; n++) oe(e, t[n], i);
				  return i;
				})(f || "*", i.nodeType ? [i] : i, []),
			  u = !p || (!e && f) ? c : Te(c, o, p, i, n),
			  h = v ? (m || (e ? p : d || g) ? [] : t) : u;
			if ((v && v(u, h, i, n), g))
			  for (s = Te(h, l), g(s, [], i, n), r = s.length; r--; )
				(a = s[r]) && (h[l[r]] = !(u[l[r]] = a));
			if (e) {
			  if (m || p) {
				if (m) {
				  for (s = [], r = h.length; r--; )
					(a = h[r]) && s.push((u[r] = a));
				  m(null, (h = []), s, n);
				}
				for (r = h.length; r--; )
				  (a = h[r]) &&
					-1 < (s = m ? I(e, a) : o[r]) &&
					(e[s] = !(t[s] = a));
			  }
			} else (h = Te(h === t ? h.splice(d, h.length) : h)), m ? m(null, t, h, n) : O.apply(t, h);
		  })
		);
	  }
	  function Ce(e) {
		for (
		  var s,
			t,
			i,
			n = e.length,
			r = w.relative[e[0].type],
			a = r || w.relative[" "],
			o = r ? 1 : 0,
			l = we(
			  function (e) {
				return e === s;
			  },
			  a,
			  !0
			),
			d = we(
			  function (e) {
				return -1 < I(s, e);
			  },
			  a,
			  !0
			),
			c = [
			  function (e, t, i) {
				var n =
				  (!r && (i || t !== x)) || ((s = t).nodeType ? l : d)(e, t, i);
				return (s = null), n;
			  },
			];
		  o < n;
		  o++
		)
		  if ((t = w.relative[e[o].type])) c = [we(xe(c), t)];
		  else {
			if ((t = w.filter[e[o].type].apply(null, e[o].matches))[E]) {
			  for (i = ++o; i < n && !w.relative[e[i].type]; i++);
			  return Se(
				1 < o && xe(c),
				1 < o &&
				  be(
					e
					  .slice(0, o - 1)
					  .concat({ value: " " === e[o - 2].type ? "*" : "" })
				  ).replace(F, "$1"),
				t,
				o < i && Ce(e.slice(o, i)),
				i < n && Ce((e = e.slice(i))),
				i < n && be(e)
			  );
			}
			c.push(t);
		  }
		return xe(c);
	  }
	  return (
		(ye.prototype = w.filters = w.pseudos),
		(w.setFilters = new ye()),
		(f = oe.tokenize =
		  function (e, t) {
			var i,
			  n,
			  s,
			  r,
			  a,
			  o,
			  l,
			  d = z[e + " "];
			if (d) return t ? 0 : d.slice(0);
			for (a = e, o = [], l = w.preFilter; a; ) {
			  for (r in ((i && !(n = X.exec(a))) ||
				(n && (a = a.slice(n[0].length) || a), o.push((s = []))),
			  (i = !1),
			  (n = _.exec(a)) &&
				((i = n.shift()),
				s.push({ value: i, type: n[0].replace(F, " ") }),
				(a = a.slice(i.length))),
			  w.filter))
				!(n = U[r].exec(a)) ||
				  (l[r] && !(n = l[r](n))) ||
				  ((i = n.shift()),
				  s.push({ value: i, type: r, matches: n }),
				  (a = a.slice(i.length)));
			  if (!i) break;
			}
			return t ? a.length : a ? oe.error(e) : z(e, o).slice(0);
		  }),
		(h = oe.compile =
		  function (e, t) {
			var i,
			  g,
			  m,
			  y,
			  b,
			  n,
			  s = [],
			  r = [],
			  a = $[e + " "];
			if (!a) {
			  for (i = (t = t || f(e)).length; i--; )
				(a = Ce(t[i]))[E] ? s.push(a) : r.push(a);
			  (a = $(
				e,
				((g = r),
				(y = 0 < (m = s).length),
				(b = 0 < g.length),
				(n = function (e, t, i, n, s) {
				  var r,
					a,
					o,
					l = 0,
					d = "0",
					c = e && [],
					u = [],
					h = x,
					p = e || (b && w.find.TAG("*", s)),
					f = (k += null == h ? 1 : Math.random() || 0.1),
					v = p.length;
				  for (
					s && (x = t == S || t || s);
					d !== v && null != (r = p[d]);
					d++
				  ) {
					if (b && r) {
					  for (
						a = 0, t || r.ownerDocument == S || (T(r), (i = !C));
						(o = g[a++]);
  
					  )
						if (o(r, t || S, i)) {
						  n.push(r);
						  break;
						}
					  s && (k = f);
					}
					y && ((r = !o && r) && l--, e && c.push(r));
				  }
				  if (((l += d), y && d !== l)) {
					for (a = 0; (o = m[a++]); ) o(c, u, t, i);
					if (e) {
					  if (0 < l) for (; d--; ) c[d] || u[d] || (u[d] = L.call(n));
					  u = Te(u);
					}
					O.apply(n, u),
					  s &&
						!e &&
						0 < u.length &&
						1 < l + m.length &&
						oe.uniqueSort(n);
				  }
				  return s && ((k = f), (x = h)), c;
				}),
				y ? de(n) : n)
			  )).selector = e;
			}
			return a;
		  }),
		(v = oe.select =
		  function (e, t, i, n) {
			var s,
			  r,
			  a,
			  o,
			  l,
			  d = "function" == typeof e && e,
			  c = !n && f((e = d.selector || e));
			if (((i = i || []), 1 === c.length)) {
			  if (
				2 < (r = c[0] = c[0].slice(0)).length &&
				"ID" === (a = r[0]).type &&
				9 === t.nodeType &&
				C &&
				w.relative[r[1].type]
			  ) {
				if (!(t = (w.find.ID(a.matches[0].replace(ne, u), t) || [])[0]))
				  return i;
				d && (t = t.parentNode), (e = e.slice(r.shift().value.length));
			  }
			  for (
				s = U.needsContext.test(e) ? 0 : r.length;
				s-- && ((a = r[s]), !w.relative[(o = a.type)]);
  
			  )
				if (
				  (l = w.find[o]) &&
				  (n = l(
					a.matches[0].replace(ne, u),
					(ie.test(r[0].type) && me(t.parentNode)) || t
				  ))
				) {
				  if ((r.splice(s, 1), !(e = n.length && be(r))))
					return O.apply(i, n), i;
				  break;
				}
			}
			return (
			  (d || h(e, c))(
				n,
				t,
				!C,
				i,
				!t || (ie.test(e) && me(t.parentNode)) || t
			  ),
			  i
			);
		  }),
		(p.sortStable = E.split("").sort(A).join("") === E),
		(p.detectDuplicates = !!d),
		T(),
		(p.sortDetached = ce(function (e) {
		  return 1 & e.compareDocumentPosition(S.createElement("fieldset"));
		})),
		ce(function (e) {
		  return (
			(e.innerHTML = "<a href='#'></a>"),
			"#" === e.firstChild.getAttribute("href")
		  );
		}) ||
		  ue("type|href|height|width", function (e, t, i) {
			if (!i) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
		  }),
		(p.attributes &&
		  ce(function (e) {
			return (
			  (e.innerHTML = "<input/>"),
			  e.firstChild.setAttribute("value", ""),
			  "" === e.firstChild.getAttribute("value")
			);
		  })) ||
		  ue("value", function (e, t, i) {
			if (!i && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
		  }),
		ce(function (e) {
		  return null == e.getAttribute("disabled");
		}) ||
		  ue(H, function (e, t, i) {
			var n;
			if (!i)
			  return !0 === e[t]
				? t.toLowerCase()
				: (n = e.getAttributeNode(t)) && n.specified
				? n.value
				: null;
		  }),
		oe
	  );
	})(S);
	(E.find = p),
	  (E.expr = p.selectors),
	  (E.expr[":"] = E.expr.pseudos),
	  (E.uniqueSort = E.unique = p.uniqueSort),
	  (E.text = p.getText),
	  (E.isXMLDoc = p.isXML),
	  (E.contains = p.contains),
	  (E.escapeSelector = p.escape);
	function f(e, t, i) {
	  for (var n = [], s = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
		if (1 === e.nodeType) {
		  if (s && E(e).is(i)) break;
		  n.push(e);
		}
	  return n;
	}
	function T(e, t) {
	  for (var i = []; e; e = e.nextSibling)
		1 === e.nodeType && e !== t && i.push(e);
	  return i;
	}
	var k = E.expr.match.needsContext;
	function Y(e, t) {
	  return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
	}
	var z = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
	function $(e, i, n) {
	  return b(i)
		? E.grep(e, function (e, t) {
			return !!i.call(e, t, e) !== n;
		  })
		: i.nodeType
		? E.grep(e, function (e) {
			return (e === i) !== n;
		  })
		: "string" != typeof i
		? E.grep(e, function (e) {
			return -1 < s.call(i, e) !== n;
		  })
		: E.filter(i, e, n);
	}
	(E.filter = function (e, t, i) {
	  var n = t[0];
	  return (
		i && (e = ":not(" + e + ")"),
		1 === t.length && 1 === n.nodeType
		  ? E.find.matchesSelector(n, e)
			? [n]
			: []
		  : E.find.matches(
			  e,
			  E.grep(t, function (e) {
				return 1 === e.nodeType;
			  })
			)
	  );
	}),
	  E.fn.extend({
		find: function (e) {
		  var t,
			i,
			n = this.length,
			s = this;
		  if ("string" != typeof e)
			return this.pushStack(
			  E(e).filter(function () {
				for (t = 0; t < n; t++) if (E.contains(s[t], this)) return !0;
			  })
			);
		  for (i = this.pushStack([]), t = 0; t < n; t++) E.find(e, s[t], i);
		  return 1 < n ? E.uniqueSort(i) : i;
		},
		filter: function (e) {
		  return this.pushStack($(this, e || [], !1));
		},
		not: function (e) {
		  return this.pushStack($(this, e || [], !0));
		},
		is: function (e) {
		  return !!$(this, "string" == typeof e && k.test(e) ? E(e) : e || [], !1)
			.length;
		},
	  });
	var P,
	  A = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
	((E.fn.init = function (e, t, i) {
	  var n, s;
	  if (!e) return this;
	  if (((i = i || P), "string" != typeof e))
		return e.nodeType
		  ? ((this[0] = e), (this.length = 1), this)
		  : b(e)
		  ? void 0 !== i.ready
			? i.ready(e)
			: e(E)
		  : E.makeArray(e, this);
	  if (
		!(n =
		  "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
			? [null, e, null]
			: A.exec(e)) ||
		(!n[1] && t)
	  )
		return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
	  if (n[1]) {
		if (
		  ((t = t instanceof E ? t[0] : t),
		  E.merge(
			this,
			E.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : C, !0)
		  ),
		  z.test(n[1]) && E.isPlainObject(t))
		)
		  for (n in t) b(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
		return this;
	  }
	  return (
		(s = C.getElementById(n[2])) && ((this[0] = s), (this.length = 1)), this
	  );
	}).prototype = E.fn),
	  (P = E(C));
	var M = /^(?:parents|prev(?:Until|All))/,
	  L = { children: !0, contents: !0, next: !0, prev: !0 };
	function D(e, t) {
	  for (; (e = e[t]) && 1 !== e.nodeType; );
	  return e;
	}
	E.fn.extend({
	  has: function (e) {
		var t = E(e, this),
		  i = t.length;
		return this.filter(function () {
		  for (var e = 0; e < i; e++) if (E.contains(this, t[e])) return !0;
		});
	  },
	  closest: function (e, t) {
		var i,
		  n = 0,
		  s = this.length,
		  r = [],
		  a = "string" != typeof e && E(e);
		if (!k.test(e))
		  for (; n < s; n++)
			for (i = this[n]; i && i !== t; i = i.parentNode)
			  if (
				i.nodeType < 11 &&
				(a
				  ? -1 < a.index(i)
				  : 1 === i.nodeType && E.find.matchesSelector(i, e))
			  ) {
				r.push(i);
				break;
			  }
		return this.pushStack(1 < r.length ? E.uniqueSort(r) : r);
	  },
	  index: function (e) {
		return e
		  ? "string" == typeof e
			? s.call(E(e), this[0])
			: s.call(this, e.jquery ? e[0] : e)
		  : this[0] && this[0].parentNode
		  ? this.first().prevAll().length
		  : -1;
	  },
	  add: function (e, t) {
		return this.pushStack(E.uniqueSort(E.merge(this.get(), E(e, t))));
	  },
	  addBack: function (e) {
		return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
	  },
	}),
	  E.each(
		{
		  parent: function (e) {
			var t = e.parentNode;
			return t && 11 !== t.nodeType ? t : null;
		  },
		  parents: function (e) {
			return f(e, "parentNode");
		  },
		  parentsUntil: function (e, t, i) {
			return f(e, "parentNode", i);
		  },
		  next: function (e) {
			return D(e, "nextSibling");
		  },
		  prev: function (e) {
			return D(e, "previousSibling");
		  },
		  nextAll: function (e) {
			return f(e, "nextSibling");
		  },
		  prevAll: function (e) {
			return f(e, "previousSibling");
		  },
		  nextUntil: function (e, t, i) {
			return f(e, "nextSibling", i);
		  },
		  prevUntil: function (e, t, i) {
			return f(e, "previousSibling", i);
		  },
		  siblings: function (e) {
			return T((e.parentNode || {}).firstChild, e);
		  },
		  children: function (e) {
			return T(e.firstChild);
		  },
		  contents: function (e) {
			return null != e.contentDocument && n(e.contentDocument)
			  ? e.contentDocument
			  : (Y(e, "template") && (e = e.content || e),
				E.merge([], e.childNodes));
		  },
		},
		function (n, s) {
		  E.fn[n] = function (e, t) {
			var i = E.map(this, s, e);
			return (
			  "Until" !== n.slice(-5) && (t = e),
			  t && "string" == typeof t && (i = E.filter(t, i)),
			  1 < this.length &&
				(L[n] || E.uniqueSort(i), M.test(n) && i.reverse()),
			  this.pushStack(i)
			);
		  };
		}
	  );
	var O = /[^\x20\t\r\n\f]+/g;
	function N(e) {
	  return e;
	}
	function I(e) {
	  throw e;
	}
	function H(e, t, i, n) {
	  var s;
	  try {
		e && b((s = e.promise))
		  ? s.call(e).done(t).fail(i)
		  : e && b((s = e.then))
		  ? s.call(e, t, i)
		  : t.apply(void 0, [e].slice(n));
	  } catch (e) {
		i.apply(void 0, [e]);
	  }
	}
	(E.Callbacks = function (n) {
	  var i;
	  n =
		"string" == typeof n
		  ? ((i = {}),
			E.each(n.match(O) || [], function (e, t) {
			  i[t] = !0;
			}),
			i)
		  : E.extend({}, n);
	  function s() {
		for (a = a || n.once, t = r = !0; l.length; d = -1)
		  for (e = l.shift(); ++d < o.length; )
			!1 === o[d].apply(e[0], e[1]) &&
			  n.stopOnFalse &&
			  ((d = o.length), (e = !1));
		n.memory || (e = !1), (r = !1), a && (o = e ? [] : "");
	  }
	  var r,
		e,
		t,
		a,
		o = [],
		l = [],
		d = -1,
		c = {
		  add: function () {
			return (
			  o &&
				(e && !r && ((d = o.length - 1), l.push(e)),
				(function i(e) {
				  E.each(e, function (e, t) {
					b(t)
					  ? (n.unique && c.has(t)) || o.push(t)
					  : t && t.length && "string" !== x(t) && i(t);
				  });
				})(arguments),
				e && !r && s()),
			  this
			);
		  },
		  remove: function () {
			return (
			  E.each(arguments, function (e, t) {
				for (var i; -1 < (i = E.inArray(t, o, i)); )
				  o.splice(i, 1), i <= d && d--;
			  }),
			  this
			);
		  },
		  has: function (e) {
			return e ? -1 < E.inArray(e, o) : 0 < o.length;
		  },
		  empty: function () {
			return (o = o && []), this;
		  },
		  disable: function () {
			return (a = l = []), (o = e = ""), this;
		  },
		  disabled: function () {
			return !o;
		  },
		  lock: function () {
			return (a = l = []), e || r || (o = e = ""), this;
		  },
		  locked: function () {
			return !!a;
		  },
		  fireWith: function (e, t) {
			return (
			  a ||
				((t = [e, (t = t || []).slice ? t.slice() : t]),
				l.push(t),
				r || s()),
			  this
			);
		  },
		  fire: function () {
			return c.fireWith(this, arguments), this;
		  },
		  fired: function () {
			return !!t;
		  },
		};
	  return c;
	}),
	  E.extend({
		Deferred: function (e) {
		  var r = [
			  [
				"notify",
				"progress",
				E.Callbacks("memory"),
				E.Callbacks("memory"),
				2,
			  ],
			  [
				"resolve",
				"done",
				E.Callbacks("once memory"),
				E.Callbacks("once memory"),
				0,
				"resolved",
			  ],
			  [
				"reject",
				"fail",
				E.Callbacks("once memory"),
				E.Callbacks("once memory"),
				1,
				"rejected",
			  ],
			],
			s = "pending",
			a = {
			  state: function () {
				return s;
			  },
			  always: function () {
				return o.done(arguments).fail(arguments), this;
			  },
			  catch: function (e) {
				return a.then(null, e);
			  },
			  pipe: function () {
				var s = arguments;
				return E.Deferred(function (n) {
				  E.each(r, function (e, t) {
					var i = b(s[t[4]]) && s[t[4]];
					o[t[1]](function () {
					  var e = i && i.apply(this, arguments);
					  e && b(e.promise)
						? e
							.promise()
							.progress(n.notify)
							.done(n.resolve)
							.fail(n.reject)
						: n[t[0] + "With"](this, i ? [e] : arguments);
					});
				  }),
					(s = null);
				}).promise();
			  },
			  then: function (t, i, n) {
				var l = 0;
				function d(s, r, a, o) {
				  return function () {
					function e() {
					  var e, t;
					  if (!(s < l)) {
						if ((e = a.apply(i, n)) === r.promise())
						  throw new TypeError("Thenable self-resolution");
						(t =
						  e &&
						  ("object" == _typeof(e) || "function" == typeof e) &&
						  e.then),
						  b(t)
							? o
							  ? t.call(e, d(l, r, N, o), d(l, r, I, o))
							  : (l++,
								t.call(
								  e,
								  d(l, r, N, o),
								  d(l, r, I, o),
								  d(l, r, N, r.notifyWith)
								))
							: (a !== N && ((i = void 0), (n = [e])),
							  (o || r.resolveWith)(i, n));
					  }
					}
					var i = this,
					  n = arguments,
					  t = o
						? e
						: function () {
							try {
							  e();
							} catch (e) {
							  E.Deferred.exceptionHook &&
								E.Deferred.exceptionHook(e, t.stackTrace),
								l <= s + 1 &&
								  (a !== I && ((i = void 0), (n = [e])),
								  r.rejectWith(i, n));
							}
						  };
					s
					  ? t()
					  : (E.Deferred.getStackHook &&
						  (t.stackTrace = E.Deferred.getStackHook()),
						S.setTimeout(t));
				  };
				}
				return E.Deferred(function (e) {
				  r[0][3].add(d(0, e, b(n) ? n : N, e.notifyWith)),
					r[1][3].add(d(0, e, b(t) ? t : N)),
					r[2][3].add(d(0, e, b(i) ? i : I));
				}).promise();
			  },
			  promise: function (e) {
				return null != e ? E.extend(e, a) : a;
			  },
			},
			o = {};
		  return (
			E.each(r, function (e, t) {
			  var i = t[2],
				n = t[5];
			  (a[t[1]] = i.add),
				n &&
				  i.add(
					function () {
					  s = n;
					},
					r[3 - e][2].disable,
					r[3 - e][3].disable,
					r[0][2].lock,
					r[0][3].lock
				  ),
				i.add(t[3].fire),
				(o[t[0]] = function () {
				  return (
					o[t[0] + "With"](this === o ? void 0 : this, arguments), this
				  );
				}),
				(o[t[0] + "With"] = i.fireWith);
			}),
			a.promise(o),
			e && e.call(o, o),
			o
		  );
		},
		when: function (e) {
		  function t(t) {
			return function (e) {
			  (s[t] = this),
				(r[t] = 1 < arguments.length ? o.call(arguments) : e),
				--i || a.resolveWith(s, r);
			};
		  }
		  var i = arguments.length,
			n = i,
			s = Array(n),
			r = o.call(arguments),
			a = E.Deferred();
		  if (
			i <= 1 &&
			(H(e, a.done(t(n)).resolve, a.reject, !i),
			"pending" === a.state() || b(r[n] && r[n].then))
		  )
			return a.then();
		  for (; n--; ) H(r[n], t(n), a.reject);
		  return a.promise();
		},
	  });
	var j = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	(E.Deferred.exceptionHook = function (e, t) {
	  S.console &&
		S.console.warn &&
		e &&
		j.test(e.name) &&
		S.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
	}),
	  (E.readyException = function (e) {
		S.setTimeout(function () {
		  throw e;
		});
	  });
	var q = E.Deferred();
	function B() {
	  C.removeEventListener("DOMContentLoaded", B),
		S.removeEventListener("load", B),
		E.ready();
	}
	(E.fn.ready = function (e) {
	  return (
		q.then(e).catch(function (e) {
		  E.readyException(e);
		}),
		this
	  );
	}),
	  E.extend({
		isReady: !1,
		readyWait: 1,
		ready: function (e) {
		  (!0 === e ? --E.readyWait : E.isReady) ||
			((E.isReady = !0) !== e && 0 < --E.readyWait) ||
			q.resolveWith(C, [E]);
		},
	  }),
	  (E.ready.then = q.then),
	  "complete" === C.readyState ||
	  ("loading" !== C.readyState && !C.documentElement.doScroll)
		? S.setTimeout(E.ready)
		: (C.addEventListener("DOMContentLoaded", B),
		  S.addEventListener("load", B));
	function R(e, t, i, n, s, r, a) {
	  var o = 0,
		l = e.length,
		d = null == i;
	  if ("object" === x(i)) for (o in ((s = !0), i)) R(e, t, o, i[o], !0, r, a);
	  else if (
		void 0 !== n &&
		((s = !0),
		b(n) || (a = !0),
		d &&
		  (t = a
			? (t.call(e, n), null)
			: ((d = t),
			  function (e, t, i) {
				return d.call(E(e), i);
			  })),
		t)
	  )
		for (; o < l; o++) t(e[o], i, a ? n : n.call(e[o], o, t(e[o], i)));
	  return s ? e : d ? t.call(e) : l ? t(e[0], i) : r;
	}
	var W = /^-ms-/,
	  F = /-([a-z])/g;
	function X(e, t) {
	  return t.toUpperCase();
	}
	function _(e) {
	  return e.replace(W, "ms-").replace(F, X);
	}
	function V(e) {
	  return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
	}
	function Z() {
	  this.expando = E.expando + Z.uid++;
	}
	(Z.uid = 1),
	  (Z.prototype = {
		cache: function (e) {
		  var t = e[this.expando];
		  return (
			t ||
			  ((t = {}),
			  V(e) &&
				(e.nodeType
				  ? (e[this.expando] = t)
				  : Object.defineProperty(e, this.expando, {
					  value: t,
					  configurable: !0,
					}))),
			t
		  );
		},
		set: function (e, t, i) {
		  var n,
			s = this.cache(e);
		  if ("string" == typeof t) s[_(t)] = i;
		  else for (n in t) s[_(n)] = t[n];
		  return s;
		},
		get: function (e, t) {
		  return void 0 === t
			? this.cache(e)
			: e[this.expando] && e[this.expando][_(t)];
		},
		access: function (e, t, i) {
		  return void 0 === t || (t && "string" == typeof t && void 0 === i)
			? this.get(e, t)
			: (this.set(e, t, i), void 0 !== i ? i : t);
		},
		remove: function (e, t) {
		  var i,
			n = e[this.expando];
		  if (void 0 !== n) {
			if (void 0 !== t) {
			  i = (t = Array.isArray(t)
				? t.map(_)
				: (t = _(t)) in n
				? [t]
				: t.match(O) || []).length;
			  for (; i--; ) delete n[t[i]];
			}
			(void 0 !== t && !E.isEmptyObject(n)) ||
			  (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
		  }
		},
		hasData: function (e) {
		  var t = e[this.expando];
		  return void 0 !== t && !E.isEmptyObject(t);
		},
	  });
	var G = new Z(),
	  U = new Z(),
	  Q = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	  K = /[A-Z]/g;
	function J(e, t, i) {
	  var n, s;
	  if (void 0 === i && 1 === e.nodeType)
		if (
		  ((n = "data-" + t.replace(K, "-$&").toLowerCase()),
		  "string" == typeof (i = e.getAttribute(n)))
		) {
		  try {
			i =
			  "true" === (s = i) ||
			  ("false" !== s &&
				("null" === s
				  ? null
				  : s === +s + ""
				  ? +s
				  : Q.test(s)
				  ? JSON.parse(s)
				  : s));
		  } catch (e) {}
		  U.set(e, t, i);
		} else i = void 0;
	  return i;
	}
	E.extend({
	  hasData: function (e) {
		return U.hasData(e) || G.hasData(e);
	  },
	  data: function (e, t, i) {
		return U.access(e, t, i);
	  },
	  removeData: function (e, t) {
		U.remove(e, t);
	  },
	  _data: function (e, t, i) {
		return G.access(e, t, i);
	  },
	  _removeData: function (e, t) {
		G.remove(e, t);
	  },
	}),
	  E.fn.extend({
		data: function (i, e) {
		  var t,
			n,
			s,
			r = this[0],
			a = r && r.attributes;
		  if (void 0 !== i)
			return "object" == _typeof(i)
			  ? this.each(function () {
				  U.set(this, i);
				})
			  : R(
				  this,
				  function (e) {
					var t;
					if (r && void 0 === e)
					  return void 0 !== (t = U.get(r, i)) ||
						void 0 !== (t = J(r, i))
						? t
						: void 0;
					this.each(function () {
					  U.set(this, i, e);
					});
				  },
				  null,
				  e,
				  1 < arguments.length,
				  null,
				  !0
				);
		  if (
			this.length &&
			((s = U.get(r)), 1 === r.nodeType && !G.get(r, "hasDataAttrs"))
		  ) {
			for (t = a.length; t--; )
			  a[t] &&
				0 === (n = a[t].name).indexOf("data-") &&
				((n = _(n.slice(5))), J(r, n, s[n]));
			G.set(r, "hasDataAttrs", !0);
		  }
		  return s;
		},
		removeData: function (e) {
		  return this.each(function () {
			U.remove(this, e);
		  });
		},
	  }),
	  E.extend({
		queue: function (e, t, i) {
		  var n;
		  if (e)
			return (
			  (t = (t || "fx") + "queue"),
			  (n = G.get(e, t)),
			  i &&
				(!n || Array.isArray(i)
				  ? (n = G.access(e, t, E.makeArray(i)))
				  : n.push(i)),
			  n || []
			);
		},
		dequeue: function (e, t) {
		  t = t || "fx";
		  var i = E.queue(e, t),
			n = i.length,
			s = i.shift(),
			r = E._queueHooks(e, t);
		  "inprogress" === s && ((s = i.shift()), n--),
			s &&
			  ("fx" === t && i.unshift("inprogress"),
			  delete r.stop,
			  s.call(
				e,
				function () {
				  E.dequeue(e, t);
				},
				r
			  )),
			!n && r && r.empty.fire();
		},
		_queueHooks: function (e, t) {
		  var i = t + "queueHooks";
		  return (
			G.get(e, i) ||
			G.access(e, i, {
			  empty: E.Callbacks("once memory").add(function () {
				G.remove(e, [t + "queue", i]);
			  }),
			})
		  );
		},
	  }),
	  E.fn.extend({
		queue: function (t, i) {
		  var e = 2;
		  return (
			"string" != typeof t && ((i = t), (t = "fx"), e--),
			arguments.length < e
			  ? E.queue(this[0], t)
			  : void 0 === i
			  ? this
			  : this.each(function () {
				  var e = E.queue(this, t, i);
				  E._queueHooks(this, t),
					"fx" === t && "inprogress" !== e[0] && E.dequeue(this, t);
				})
		  );
		},
		dequeue: function (e) {
		  return this.each(function () {
			E.dequeue(this, e);
		  });
		},
		clearQueue: function (e) {
		  return this.queue(e || "fx", []);
		},
		promise: function (e, t) {
		  function i() {
			--s || r.resolveWith(a, [a]);
		  }
		  var n,
			s = 1,
			r = E.Deferred(),
			a = this,
			o = this.length;
		  for (
			"string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
			o--;
  
		  )
			(n = G.get(a[o], e + "queueHooks")) &&
			  n.empty &&
			  (s++, n.empty.add(i));
		  return i(), r.promise(t);
		},
	  });
	var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
	  te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
	  ie = ["Top", "Right", "Bottom", "Left"],
	  ne = C.documentElement,
	  se = function (e) {
		return E.contains(e.ownerDocument, e);
	  },
	  re = { composed: !0 };
	ne.getRootNode &&
	  (se = function (e) {
		return (
		  E.contains(e.ownerDocument, e) || e.getRootNode(re) === e.ownerDocument
		);
	  });
	function ae(e, t) {
	  return (
		"none" === (e = t || e).style.display ||
		("" === e.style.display && se(e) && "none" === E.css(e, "display"))
	  );
	}
	function oe(e, t, i, n) {
	  var s,
		r,
		a = 20,
		o = n
		  ? function () {
			  return n.cur();
			}
		  : function () {
			  return E.css(e, t, "");
			},
		l = o(),
		d = (i && i[3]) || (E.cssNumber[t] ? "" : "px"),
		c =
		  e.nodeType &&
		  (E.cssNumber[t] || ("px" !== d && +l)) &&
		  te.exec(E.css(e, t));
	  if (c && c[3] !== d) {
		for (l /= 2, d = d || c[3], c = +l || 1; a--; )
		  E.style(e, t, c + d),
			(1 - r) * (1 - (r = o() / l || 0.5)) <= 0 && (a = 0),
			(c /= r);
		(c *= 2), E.style(e, t, c + d), (i = i || []);
	  }
	  return (
		i &&
		  ((c = +c || +l || 0),
		  (s = i[1] ? c + (i[1] + 1) * i[2] : +i[2]),
		  n && ((n.unit = d), (n.start = c), (n.end = s))),
		s
	  );
	}
	var le = {};
	function de(e, t) {
	  for (var i, n, s, r, a, o, l = [], d = 0, c = e.length; d < c; d++)
		(n = e[d]).style &&
		  ((i = n.style.display),
		  t
			? ("none" === i &&
				((l[d] = G.get(n, "display") || null),
				l[d] || (n.style.display = "")),
			  "" === n.style.display &&
				ae(n) &&
				(l[d] =
				  ((o = r = s = void 0),
				  (r = n.ownerDocument),
				  (a = n.nodeName),
				  (o = le[a]) ||
					((s = r.body.appendChild(r.createElement(a))),
					(o = E.css(s, "display")),
					s.parentNode.removeChild(s),
					"none" === o && (o = "block"),
					(le[a] = o)))))
			: "none" !== i && ((l[d] = "none"), G.set(n, "display", i)));
	  for (d = 0; d < c; d++) null != l[d] && (e[d].style.display = l[d]);
	  return e;
	}
	E.fn.extend({
	  show: function () {
		return de(this, !0);
	  },
	  hide: function () {
		return de(this);
	  },
	  toggle: function (e) {
		return "boolean" == typeof e
		  ? e
			? this.show()
			: this.hide()
		  : this.each(function () {
			  ae(this) ? E(this).show() : E(this).hide();
			});
	  },
	});
	var ce,
	  ue,
	  he = /^(?:checkbox|radio)$/i,
	  pe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
	  fe = /^$|^module$|\/(?:java|ecma)script/i;
	(ce = C.createDocumentFragment().appendChild(C.createElement("div"))),
	  (ue = C.createElement("input")).setAttribute("type", "radio"),
	  ue.setAttribute("checked", "checked"),
	  ue.setAttribute("name", "t"),
	  ce.appendChild(ue),
	  (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
	  (ce.innerHTML = "<textarea>x</textarea>"),
	  (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
	  (ce.innerHTML = "<option></option>"),
	  (y.option = !!ce.lastChild);
	var ve = {
	  thead: [1, "<table>", "</table>"],
	  col: [2, "<table><colgroup>", "</colgroup></table>"],
	  tr: [2, "<table><tbody>", "</tbody></table>"],
	  td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
	  _default: [0, "", ""],
	};
	function ge(e, t) {
	  var i;
	  return (
		(i =
		  void 0 !== e.getElementsByTagName
			? e.getElementsByTagName(t || "*")
			: void 0 !== e.querySelectorAll
			? e.querySelectorAll(t || "*")
			: []),
		void 0 === t || (t && Y(e, t)) ? E.merge([e], i) : i
	  );
	}
	function me(e, t) {
	  for (var i = 0, n = e.length; i < n; i++)
		G.set(e[i], "globalEval", !t || G.get(t[i], "globalEval"));
	}
	(ve.tbody = ve.tfoot = ve.colgroup = ve.caption = ve.thead),
	  (ve.th = ve.td),
	  y.option ||
		(ve.optgroup = ve.option =
		  [1, "<select multiple='multiple'>", "</select>"]);
	var ye = /<|&#?\w+;/;
	function be(e, t, i, n, s) {
	  for (
		var r,
		  a,
		  o,
		  l,
		  d,
		  c,
		  u = t.createDocumentFragment(),
		  h = [],
		  p = 0,
		  f = e.length;
		p < f;
		p++
	  )
		if ((r = e[p]) || 0 === r)
		  if ("object" === x(r)) E.merge(h, r.nodeType ? [r] : r);
		  else if (ye.test(r)) {
			for (
			  a = a || u.appendChild(t.createElement("div")),
				o = (pe.exec(r) || ["", ""])[1].toLowerCase(),
				l = ve[o] || ve._default,
				a.innerHTML = l[1] + E.htmlPrefilter(r) + l[2],
				c = l[0];
			  c--;
  
			)
			  a = a.lastChild;
			E.merge(h, a.childNodes), ((a = u.firstChild).textContent = "");
		  } else h.push(t.createTextNode(r));
	  for (u.textContent = "", p = 0; (r = h[p++]); )
		if (n && -1 < E.inArray(r, n)) s && s.push(r);
		else if (
		  ((d = se(r)), (a = ge(u.appendChild(r), "script")), d && me(a), i)
		)
		  for (c = 0; (r = a[c++]); ) fe.test(r.type || "") && i.push(r);
	  return u;
	}
	var we = /^key/,
	  xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	  Te = /^([^.]*)(?:\.(.+)|)/;
	function Se() {
	  return !0;
	}
	function Ce() {
	  return !1;
	}
	function Ee(e, t) {
	  return (
		(e ===
		  (function () {
			try {
			  return C.activeElement;
			} catch (e) {}
		  })()) ==
		("focus" === t)
	  );
	}
	function ke(e, t, i, n, s, r) {
	  var a, o;
	  if ("object" == _typeof(t)) {
		for (o in ("string" != typeof i && ((n = n || i), (i = void 0)), t))
		  ke(e, o, i, n, t[o], r);
		return e;
	  }
	  if (
		(null == n && null == s
		  ? ((s = i), (n = i = void 0))
		  : null == s &&
			("string" == typeof i
			  ? ((s = n), (n = void 0))
			  : ((s = n), (n = i), (i = void 0))),
		!1 === s)
	  )
		s = Ce;
	  else if (!s) return e;
	  return (
		1 === r &&
		  ((a = s),
		  ((s = function (e) {
			return E().off(e), a.apply(this, arguments);
		  }).guid = a.guid || (a.guid = E.guid++))),
		e.each(function () {
		  E.event.add(this, t, s, n, i);
		})
	  );
	}
	function Ye(e, s, r) {
	  r
		? (G.set(e, s, !1),
		  E.event.add(e, s, {
			namespace: !1,
			handler: function (e) {
			  var t,
				i,
				n = G.get(this, s);
			  if (1 & e.isTrigger && this[s]) {
				if (n.length)
				  (E.event.special[s] || {}).delegateType && e.stopPropagation();
				else if (
				  ((n = o.call(arguments)),
				  G.set(this, s, n),
				  (t = r(this, s)),
				  this[s](),
				  n !== (i = G.get(this, s)) || t ? G.set(this, s, !1) : (i = {}),
				  n !== i)
				)
				  return (
					e.stopImmediatePropagation(), e.preventDefault(), i.value
				  );
			  } else
				n.length &&
				  (G.set(this, s, {
					value: E.event.trigger(
					  E.extend(n[0], E.Event.prototype),
					  n.slice(1),
					  this
					),
				  }),
				  e.stopImmediatePropagation());
			},
		  }))
		: void 0 === G.get(e, s) && E.event.add(e, s, Se);
	}
	(E.event = {
	  global: {},
	  add: function (t, e, i, n, s) {
		var r,
		  a,
		  o,
		  l,
		  d,
		  c,
		  u,
		  h,
		  p,
		  f,
		  v,
		  g = G.get(t);
		if (V(t))
		  for (
			i.handler && ((i = (r = i).handler), (s = r.selector)),
			  s && E.find.matchesSelector(ne, s),
			  i.guid || (i.guid = E.guid++),
			  (l = g.events) || (l = g.events = Object.create(null)),
			  (a = g.handle) ||
				(a = g.handle =
				  function (e) {
					return void 0 !== E && E.event.triggered !== e.type
					  ? E.event.dispatch.apply(t, arguments)
					  : void 0;
				  }),
			  d = (e = (e || "").match(O) || [""]).length;
			d--;
  
		  )
			(p = v = (o = Te.exec(e[d]) || [])[1]),
			  (f = (o[2] || "").split(".").sort()),
			  p &&
				((u = E.event.special[p] || {}),
				(p = (s ? u.delegateType : u.bindType) || p),
				(u = E.event.special[p] || {}),
				(c = E.extend(
				  {
					type: p,
					origType: v,
					data: n,
					handler: i,
					guid: i.guid,
					selector: s,
					needsContext: s && E.expr.match.needsContext.test(s),
					namespace: f.join("."),
				  },
				  r
				)),
				(h = l[p]) ||
				  (((h = l[p] = []).delegateCount = 0),
				  (u.setup && !1 !== u.setup.call(t, n, f, a)) ||
					(t.addEventListener && t.addEventListener(p, a))),
				u.add &&
				  (u.add.call(t, c), c.handler.guid || (c.handler.guid = i.guid)),
				s ? h.splice(h.delegateCount++, 0, c) : h.push(c),
				(E.event.global[p] = !0));
	  },
	  remove: function (e, t, i, n, s) {
		var r,
		  a,
		  o,
		  l,
		  d,
		  c,
		  u,
		  h,
		  p,
		  f,
		  v,
		  g = G.hasData(e) && G.get(e);
		if (g && (l = g.events)) {
		  for (d = (t = (t || "").match(O) || [""]).length; d--; )
			if (
			  ((p = v = (o = Te.exec(t[d]) || [])[1]),
			  (f = (o[2] || "").split(".").sort()),
			  p)
			) {
			  for (
				u = E.event.special[p] || {},
				  h = l[(p = (n ? u.delegateType : u.bindType) || p)] || [],
				  o =
					o[2] &&
					new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
				  a = r = h.length;
				r--;
  
			  )
				(c = h[r]),
				  (!s && v !== c.origType) ||
					(i && i.guid !== c.guid) ||
					(o && !o.test(c.namespace)) ||
					(n && n !== c.selector && ("**" !== n || !c.selector)) ||
					(h.splice(r, 1),
					c.selector && h.delegateCount--,
					u.remove && u.remove.call(e, c));
			  a &&
				!h.length &&
				((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) ||
				  E.removeEvent(e, p, g.handle),
				delete l[p]);
			} else for (p in l) E.event.remove(e, p + t[d], i, n, !0);
		  E.isEmptyObject(l) && G.remove(e, "handle events");
		}
	  },
	  dispatch: function (e) {
		var t,
		  i,
		  n,
		  s,
		  r,
		  a,
		  o = new Array(arguments.length),
		  l = E.event.fix(e),
		  d = (G.get(this, "events") || Object.create(null))[l.type] || [],
		  c = E.event.special[l.type] || {};
		for (o[0] = l, t = 1; t < arguments.length; t++) o[t] = arguments[t];
		if (
		  ((l.delegateTarget = this),
		  !c.preDispatch || !1 !== c.preDispatch.call(this, l))
		) {
		  for (
			a = E.event.handlers.call(this, l, d), t = 0;
			(s = a[t++]) && !l.isPropagationStopped();
  
		  )
			for (
			  l.currentTarget = s.elem, i = 0;
			  (r = s.handlers[i++]) && !l.isImmediatePropagationStopped();
  
			)
			  (l.rnamespace &&
				!1 !== r.namespace &&
				!l.rnamespace.test(r.namespace)) ||
				((l.handleObj = r),
				(l.data = r.data),
				void 0 !==
				  (n = (
					(E.event.special[r.origType] || {}).handle || r.handler
				  ).apply(s.elem, o)) &&
				  !1 === (l.result = n) &&
				  (l.preventDefault(), l.stopPropagation()));
		  return c.postDispatch && c.postDispatch.call(this, l), l.result;
		}
	  },
	  handlers: function (e, t) {
		var i,
		  n,
		  s,
		  r,
		  a,
		  o = [],
		  l = t.delegateCount,
		  d = e.target;
		if (l && d.nodeType && !("click" === e.type && 1 <= e.button))
		  for (; d !== this; d = d.parentNode || this)
			if (1 === d.nodeType && ("click" !== e.type || !0 !== d.disabled)) {
			  for (r = [], a = {}, i = 0; i < l; i++)
				void 0 === a[(s = (n = t[i]).selector + " ")] &&
				  (a[s] = n.needsContext
					? -1 < E(s, this).index(d)
					: E.find(s, this, null, [d]).length),
				  a[s] && r.push(n);
			  r.length && o.push({ elem: d, handlers: r });
			}
		return (
		  (d = this), l < t.length && o.push({ elem: d, handlers: t.slice(l) }), o
		);
	  },
	  addProp: function (t, e) {
		Object.defineProperty(E.Event.prototype, t, {
		  enumerable: !0,
		  configurable: !0,
		  get: b(e)
			? function () {
				if (this.originalEvent) return e(this.originalEvent);
			  }
			: function () {
				if (this.originalEvent) return this.originalEvent[t];
			  },
		  set: function (e) {
			Object.defineProperty(this, t, {
			  enumerable: !0,
			  configurable: !0,
			  writable: !0,
			  value: e,
			});
		  },
		});
	  },
	  fix: function (e) {
		return e[E.expando] ? e : new E.Event(e);
	  },
	  special: {
		load: { noBubble: !0 },
		click: {
		  setup: function (e) {
			var t = this || e;
			return (
			  he.test(t.type) && t.click && Y(t, "input") && Ye(t, "click", Se),
			  !1
			);
		  },
		  trigger: function (e) {
			var t = this || e;
			return (
			  he.test(t.type) && t.click && Y(t, "input") && Ye(t, "click"), !0
			);
		  },
		  _default: function (e) {
			var t = e.target;
			return (
			  (he.test(t.type) &&
				t.click &&
				Y(t, "input") &&
				G.get(t, "click")) ||
			  Y(t, "a")
			);
		  },
		},
		beforeunload: {
		  postDispatch: function (e) {
			void 0 !== e.result &&
			  e.originalEvent &&
			  (e.originalEvent.returnValue = e.result);
		  },
		},
	  },
	}),
	  (E.removeEvent = function (e, t, i) {
		e.removeEventListener && e.removeEventListener(t, i);
	  }),
	  (E.Event = function (e, t) {
		if (!(this instanceof E.Event)) return new E.Event(e, t);
		e && e.type
		  ? ((this.originalEvent = e),
			(this.type = e.type),
			(this.isDefaultPrevented =
			  e.defaultPrevented ||
			  (void 0 === e.defaultPrevented && !1 === e.returnValue)
				? Se
				: Ce),
			(this.target =
			  e.target && 3 === e.target.nodeType
				? e.target.parentNode
				: e.target),
			(this.currentTarget = e.currentTarget),
			(this.relatedTarget = e.relatedTarget))
		  : (this.type = e),
		  t && E.extend(this, t),
		  (this.timeStamp = (e && e.timeStamp) || Date.now()),
		  (this[E.expando] = !0);
	  }),
	  (E.Event.prototype = {
		constructor: E.Event,
		isDefaultPrevented: Ce,
		isPropagationStopped: Ce,
		isImmediatePropagationStopped: Ce,
		isSimulated: !1,
		preventDefault: function () {
		  var e = this.originalEvent;
		  (this.isDefaultPrevented = Se),
			e && !this.isSimulated && e.preventDefault();
		},
		stopPropagation: function () {
		  var e = this.originalEvent;
		  (this.isPropagationStopped = Se),
			e && !this.isSimulated && e.stopPropagation();
		},
		stopImmediatePropagation: function () {
		  var e = this.originalEvent;
		  (this.isImmediatePropagationStopped = Se),
			e && !this.isSimulated && e.stopImmediatePropagation(),
			this.stopPropagation();
		},
	  }),
	  E.each(
		{
		  altKey: !0,
		  bubbles: !0,
		  cancelable: !0,
		  changedTouches: !0,
		  ctrlKey: !0,
		  detail: !0,
		  eventPhase: !0,
		  metaKey: !0,
		  pageX: !0,
		  pageY: !0,
		  shiftKey: !0,
		  view: !0,
		  char: !0,
		  code: !0,
		  charCode: !0,
		  key: !0,
		  keyCode: !0,
		  button: !0,
		  buttons: !0,
		  clientX: !0,
		  clientY: !0,
		  offsetX: !0,
		  offsetY: !0,
		  pointerId: !0,
		  pointerType: !0,
		  screenX: !0,
		  screenY: !0,
		  targetTouches: !0,
		  toElement: !0,
		  touches: !0,
		  which: function (e) {
			var t = e.button;
			return null == e.which && we.test(e.type)
			  ? null != e.charCode
				? e.charCode
				: e.keyCode
			  : !e.which && void 0 !== t && xe.test(e.type)
			  ? 1 & t
				? 1
				: 2 & t
				? 3
				: 4 & t
				? 2
				: 0
			  : e.which;
		  },
		},
		E.event.addProp
	  ),
	  E.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
		E.event.special[e] = {
		  setup: function () {
			return Ye(this, e, Ee), !1;
		  },
		  trigger: function () {
			return Ye(this, e), !0;
		  },
		  delegateType: t,
		};
	  }),
	  E.each(
		{
		  mouseenter: "mouseover",
		  mouseleave: "mouseout",
		  pointerenter: "pointerover",
		  pointerleave: "pointerout",
		},
		function (e, s) {
		  E.event.special[e] = {
			delegateType: s,
			bindType: s,
			handle: function (e) {
			  var t,
				i = e.relatedTarget,
				n = e.handleObj;
			  return (
				(i && (i === this || E.contains(this, i))) ||
				  ((e.type = n.origType),
				  (t = n.handler.apply(this, arguments)),
				  (e.type = s)),
				t
			  );
			},
		  };
		}
	  ),
	  E.fn.extend({
		on: function (e, t, i, n) {
		  return ke(this, e, t, i, n);
		},
		one: function (e, t, i, n) {
		  return ke(this, e, t, i, n, 1);
		},
		off: function (e, t, i) {
		  var n, s;
		  if (e && e.preventDefault && e.handleObj)
			return (
			  (n = e.handleObj),
			  E(e.delegateTarget).off(
				n.namespace ? n.origType + "." + n.namespace : n.origType,
				n.selector,
				n.handler
			  ),
			  this
			);
		  if ("object" != _typeof(e))
			return (
			  (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
			  !1 === i && (i = Ce),
			  this.each(function () {
				E.event.remove(this, e, i, t);
			  })
			);
		  for (s in e) this.off(s, t, e[s]);
		  return this;
		},
	  });
	var ze = /<script|<style|<link/i,
	  $e = /checked\s*(?:[^=]|=\s*.checked.)/i,
	  Pe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	function Ae(e, t) {
	  return (
		(Y(e, "table") &&
		  Y(11 !== t.nodeType ? t : t.firstChild, "tr") &&
		  E(e).children("tbody")[0]) ||
		e
	  );
	}
	function Me(e) {
	  return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
	}
	function Le(e) {
	  return (
		"true/" === (e.type || "").slice(0, 5)
		  ? (e.type = e.type.slice(5))
		  : e.removeAttribute("type"),
		e
	  );
	}
	function De(e, t) {
	  var i, n, s, r, a, o;
	  if (1 === t.nodeType) {
		if (G.hasData(e) && (o = G.get(e).events))
		  for (s in (G.remove(t, "handle events"), o))
			for (i = 0, n = o[s].length; i < n; i++) E.event.add(t, s, o[s][i]);
		U.hasData(e) && ((r = U.access(e)), (a = E.extend({}, r)), U.set(t, a));
	  }
	}
	function Oe(i, n, s, r) {
	  n = g(n);
	  var e,
		t,
		a,
		o,
		l,
		d,
		c = 0,
		u = i.length,
		h = u - 1,
		p = n[0],
		f = b(p);
	  if (f || (1 < u && "string" == typeof p && !y.checkClone && $e.test(p)))
		return i.each(function (e) {
		  var t = i.eq(e);
		  f && (n[0] = p.call(this, e, t.html())), Oe(t, n, s, r);
		});
	  if (
		u &&
		((t = (e = be(n, i[0].ownerDocument, !1, i, r)).firstChild),
		1 === e.childNodes.length && (e = t),
		t || r)
	  ) {
		for (o = (a = E.map(ge(e, "script"), Me)).length; c < u; c++)
		  (l = e),
			c !== h &&
			  ((l = E.clone(l, !0, !0)), o && E.merge(a, ge(l, "script"))),
			s.call(i[c], l, c);
		if (o)
		  for (d = a[a.length - 1].ownerDocument, E.map(a, Le), c = 0; c < o; c++)
			(l = a[c]),
			  fe.test(l.type || "") &&
				!G.access(l, "globalEval") &&
				E.contains(d, l) &&
				(l.src && "module" !== (l.type || "").toLowerCase()
				  ? E._evalUrl &&
					!l.noModule &&
					E._evalUrl(
					  l.src,
					  { nonce: l.nonce || l.getAttribute("nonce") },
					  d
					)
				  : w(l.textContent.replace(Pe, ""), l, d));
	  }
	  return i;
	}
	function Ne(e, t, i) {
	  for (var n, s = t ? E.filter(t, e) : e, r = 0; null != (n = s[r]); r++)
		i || 1 !== n.nodeType || E.cleanData(ge(n)),
		  n.parentNode &&
			(i && se(n) && me(ge(n, "script")), n.parentNode.removeChild(n));
	  return e;
	}
	E.extend({
	  htmlPrefilter: function (e) {
		return e;
	  },
	  clone: function (e, t, i) {
		var n,
		  s,
		  r,
		  a,
		  o,
		  l,
		  d,
		  c = e.cloneNode(!0),
		  u = se(e);
		if (
		  !(
			y.noCloneChecked ||
			(1 !== e.nodeType && 11 !== e.nodeType) ||
			E.isXMLDoc(e)
		  )
		)
		  for (a = ge(c), n = 0, s = (r = ge(e)).length; n < s; n++)
			(o = r[n]),
			  "input" === (d = (l = a[n]).nodeName.toLowerCase()) &&
			  he.test(o.type)
				? (l.checked = o.checked)
				: ("input" !== d && "textarea" !== d) ||
				  (l.defaultValue = o.defaultValue);
		if (t)
		  if (i)
			for (r = r || ge(e), a = a || ge(c), n = 0, s = r.length; n < s; n++)
			  De(r[n], a[n]);
		  else De(e, c);
		return (
		  0 < (a = ge(c, "script")).length && me(a, !u && ge(e, "script")), c
		);
	  },
	  cleanData: function (e) {
		for (var t, i, n, s = E.event.special, r = 0; void 0 !== (i = e[r]); r++)
		  if (V(i)) {
			if ((t = i[G.expando])) {
			  if (t.events)
				for (n in t.events)
				  s[n] ? E.event.remove(i, n) : E.removeEvent(i, n, t.handle);
			  i[G.expando] = void 0;
			}
			i[U.expando] && (i[U.expando] = void 0);
		  }
	  },
	}),
	  E.fn.extend({
		detach: function (e) {
		  return Ne(this, e, !0);
		},
		remove: function (e) {
		  return Ne(this, e);
		},
		text: function (e) {
		  return R(
			this,
			function (e) {
			  return void 0 === e
				? E.text(this)
				: this.empty().each(function () {
					(1 !== this.nodeType &&
					  11 !== this.nodeType &&
					  9 !== this.nodeType) ||
					  (this.textContent = e);
				  });
			},
			null,
			e,
			arguments.length
		  );
		},
		append: function () {
		  return Oe(this, arguments, function (e) {
			(1 !== this.nodeType &&
			  11 !== this.nodeType &&
			  9 !== this.nodeType) ||
			  Ae(this, e).appendChild(e);
		  });
		},
		prepend: function () {
		  return Oe(this, arguments, function (e) {
			if (
			  1 === this.nodeType ||
			  11 === this.nodeType ||
			  9 === this.nodeType
			) {
			  var t = Ae(this, e);
			  t.insertBefore(e, t.firstChild);
			}
		  });
		},
		before: function () {
		  return Oe(this, arguments, function (e) {
			this.parentNode && this.parentNode.insertBefore(e, this);
		  });
		},
		after: function () {
		  return Oe(this, arguments, function (e) {
			this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
		  });
		},
		empty: function () {
		  for (var e, t = 0; null != (e = this[t]); t++)
			1 === e.nodeType && (E.cleanData(ge(e, !1)), (e.textContent = ""));
		  return this;
		},
		clone: function (e, t) {
		  return (
			(e = null != e && e),
			(t = null == t ? e : t),
			this.map(function () {
			  return E.clone(this, e, t);
			})
		  );
		},
		html: function (e) {
		  return R(
			this,
			function (e) {
			  var t = this[0] || {},
				i = 0,
				n = this.length;
			  if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
			  if (
				"string" == typeof e &&
				!ze.test(e) &&
				!ve[(pe.exec(e) || ["", ""])[1].toLowerCase()]
			  ) {
				e = E.htmlPrefilter(e);
				try {
				  for (; i < n; i++)
					1 === (t = this[i] || {}).nodeType &&
					  (E.cleanData(ge(t, !1)), (t.innerHTML = e));
				  t = 0;
				} catch (e) {}
			  }
			  t && this.empty().append(e);
			},
			null,
			e,
			arguments.length
		  );
		},
		replaceWith: function () {
		  var i = [];
		  return Oe(
			this,
			arguments,
			function (e) {
			  var t = this.parentNode;
			  E.inArray(this, i) < 0 &&
				(E.cleanData(ge(this)), t && t.replaceChild(e, this));
			},
			i
		  );
		},
	  }),
	  E.each(
		{
		  appendTo: "append",
		  prependTo: "prepend",
		  insertBefore: "before",
		  insertAfter: "after",
		  replaceAll: "replaceWith",
		},
		function (e, a) {
		  E.fn[e] = function (e) {
			for (var t, i = [], n = E(e), s = n.length - 1, r = 0; r <= s; r++)
			  (t = r === s ? this : this.clone(!0)),
				E(n[r])[a](t),
				l.apply(i, t.get());
			return this.pushStack(i);
		  };
		}
	  );
	function Ie(e, t, i) {
	  var n,
		s,
		r = {};
	  for (s in t) (r[s] = e.style[s]), (e.style[s] = t[s]);
	  for (s in ((n = i.call(e)), t)) e.style[s] = r[s];
	  return n;
	}
	var He,
	  je,
	  qe,
	  Be,
	  Re,
	  We,
	  Fe,
	  Xe,
	  _e = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
	  Ve = function (e) {
		var t = e.ownerDocument.defaultView;
		return (t && t.opener) || (t = S), t.getComputedStyle(e);
	  },
	  Ze = new RegExp(ie.join("|"), "i");
	function Ge(e, t, i) {
	  var n,
		s,
		r,
		a,
		o = e.style;
	  return (
		(i = i || Ve(e)) &&
		  ("" !== (a = i.getPropertyValue(t) || i[t]) ||
			se(e) ||
			(a = E.style(e, t)),
		  !y.pixelBoxStyles() &&
			_e.test(a) &&
			Ze.test(t) &&
			((n = o.width),
			(s = o.minWidth),
			(r = o.maxWidth),
			(o.minWidth = o.maxWidth = o.width = a),
			(a = i.width),
			(o.width = n),
			(o.minWidth = s),
			(o.maxWidth = r))),
		void 0 !== a ? a + "" : a
	  );
	}
	function Ue(e, t) {
	  return {
		get: function () {
		  if (!e()) return (this.get = t).apply(this, arguments);
		  delete this.get;
		},
	  };
	}
	function Qe() {
	  if (Xe) {
		(Fe.style.cssText =
		  "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
		  (Xe.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
		  ne.appendChild(Fe).appendChild(Xe);
		var e = S.getComputedStyle(Xe);
		(He = "1%" !== e.top),
		  (We = 12 === Ke(e.marginLeft)),
		  (Xe.style.right = "60%"),
		  (Be = 36 === Ke(e.right)),
		  (je = 36 === Ke(e.width)),
		  (Xe.style.position = "absolute"),
		  (qe = 12 === Ke(Xe.offsetWidth / 3)),
		  ne.removeChild(Fe),
		  (Xe = null);
	  }
	}
	function Ke(e) {
	  return Math.round(parseFloat(e));
	}
	(Fe = C.createElement("div")),
	  (Xe = C.createElement("div")).style &&
		((Xe.style.backgroundClip = "content-box"),
		(Xe.cloneNode(!0).style.backgroundClip = ""),
		(y.clearCloneStyle = "content-box" === Xe.style.backgroundClip),
		E.extend(y, {
		  boxSizingReliable: function () {
			return Qe(), je;
		  },
		  pixelBoxStyles: function () {
			return Qe(), Be;
		  },
		  pixelPosition: function () {
			return Qe(), He;
		  },
		  reliableMarginLeft: function () {
			return Qe(), We;
		  },
		  scrollboxSize: function () {
			return Qe(), qe;
		  },
		  reliableTrDimensions: function () {
			var e, t, i, n;
			return (
			  null == Re &&
				((e = C.createElement("table")),
				(t = C.createElement("tr")),
				(i = C.createElement("div")),
				(e.style.cssText = "position:absolute;left:-11111px"),
				(t.style.height = "1px"),
				(i.style.height = "9px"),
				ne.appendChild(e).appendChild(t).appendChild(i),
				(n = S.getComputedStyle(t)),
				(Re = 3 < parseInt(n.height)),
				ne.removeChild(e)),
			  Re
			);
		  },
		}));
	var Je = ["Webkit", "Moz", "ms"],
	  et = C.createElement("div").style,
	  tt = {};
	function it(e) {
	  return (
		E.cssProps[e] ||
		tt[e] ||
		(e in et
		  ? e
		  : (tt[e] =
			  (function (e) {
				for (
				  var t = e[0].toUpperCase() + e.slice(1), i = Je.length;
				  i--;
  
				)
				  if ((e = Je[i] + t) in et) return e;
			  })(e) || e))
	  );
	}
	var nt = /^(none|table(?!-c[ea]).+)/,
	  st = /^--/,
	  rt = { position: "absolute", visibility: "hidden", display: "block" },
	  at = { letterSpacing: "0", fontWeight: "400" };
	function ot(e, t, i) {
	  var n = te.exec(t);
	  return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
	}
	function lt(e, t, i, n, s, r) {
	  var a = "width" === t ? 1 : 0,
		o = 0,
		l = 0;
	  if (i === (n ? "border" : "content")) return 0;
	  for (; a < 4; a += 2)
		"margin" === i && (l += E.css(e, i + ie[a], !0, s)),
		  n
			? ("content" === i && (l -= E.css(e, "padding" + ie[a], !0, s)),
			  "margin" !== i &&
				(l -= E.css(e, "border" + ie[a] + "Width", !0, s)))
			: ((l += E.css(e, "padding" + ie[a], !0, s)),
			  "padding" !== i
				? (l += E.css(e, "border" + ie[a] + "Width", !0, s))
				: (o += E.css(e, "border" + ie[a] + "Width", !0, s)));
	  return (
		!n &&
		  0 <= r &&
		  (l +=
			Math.max(
			  0,
			  Math.ceil(
				e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - o - 0.5
			  )
			) || 0),
		l
	  );
	}
	function dt(e, t, i) {
	  var n = Ve(e),
		s =
		  (!y.boxSizingReliable() || i) &&
		  "border-box" === E.css(e, "boxSizing", !1, n),
		r = s,
		a = Ge(e, t, n),
		o = "offset" + t[0].toUpperCase() + t.slice(1);
	  if (_e.test(a)) {
		if (!i) return a;
		a = "auto";
	  }
	  return (
		((!y.boxSizingReliable() && s) ||
		  (!y.reliableTrDimensions() && Y(e, "tr")) ||
		  "auto" === a ||
		  (!parseFloat(a) && "inline" === E.css(e, "display", !1, n))) &&
		  e.getClientRects().length &&
		  ((s = "border-box" === E.css(e, "boxSizing", !1, n)),
		  (r = o in e) && (a = e[o])),
		(a = parseFloat(a) || 0) +
		  lt(e, t, i || (s ? "border" : "content"), r, n, a) +
		  "px"
	  );
	}
	function ct(e, t, i, n, s) {
	  return new ct.prototype.init(e, t, i, n, s);
	}
	E.extend({
	  cssHooks: {
		opacity: {
		  get: function (e, t) {
			if (t) {
			  var i = Ge(e, "opacity");
			  return "" === i ? "1" : i;
			}
		  },
		},
	  },
	  cssNumber: {
		animationIterationCount: !0,
		columnCount: !0,
		fillOpacity: !0,
		flexGrow: !0,
		flexShrink: !0,
		fontWeight: !0,
		gridArea: !0,
		gridColumn: !0,
		gridColumnEnd: !0,
		gridColumnStart: !0,
		gridRow: !0,
		gridRowEnd: !0,
		gridRowStart: !0,
		lineHeight: !0,
		opacity: !0,
		order: !0,
		orphans: !0,
		widows: !0,
		zIndex: !0,
		zoom: !0,
	  },
	  cssProps: {},
	  style: function (e, t, i, n) {
		if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
		  var s,
			r,
			a,
			o = _(t),
			l = st.test(t),
			d = e.style;
		  if (
			(l || (t = it(o)), (a = E.cssHooks[t] || E.cssHooks[o]), void 0 === i)
		  )
			return a && "get" in a && void 0 !== (s = a.get(e, !1, n)) ? s : d[t];
		  "string" === (r = _typeof(i)) &&
			(s = te.exec(i)) &&
			s[1] &&
			((i = oe(e, t, s)), (r = "number")),
			null != i &&
			  i == i &&
			  ("number" !== r ||
				l ||
				(i += (s && s[3]) || (E.cssNumber[o] ? "" : "px")),
			  y.clearCloneStyle ||
				"" !== i ||
				0 !== t.indexOf("background") ||
				(d[t] = "inherit"),
			  (a && "set" in a && void 0 === (i = a.set(e, i, n))) ||
				(l ? d.setProperty(t, i) : (d[t] = i)));
		}
	  },
	  css: function (e, t, i, n) {
		var s,
		  r,
		  a,
		  o = _(t);
		return (
		  st.test(t) || (t = it(o)),
		  (a = E.cssHooks[t] || E.cssHooks[o]) &&
			"get" in a &&
			(s = a.get(e, !0, i)),
		  void 0 === s && (s = Ge(e, t, n)),
		  "normal" === s && t in at && (s = at[t]),
		  "" === i || i
			? ((r = parseFloat(s)), !0 === i || isFinite(r) ? r || 0 : s)
			: s
		);
	  },
	}),
	  E.each(["height", "width"], function (e, l) {
		E.cssHooks[l] = {
		  get: function (e, t, i) {
			if (t)
			  return !nt.test(E.css(e, "display")) ||
				(e.getClientRects().length && e.getBoundingClientRect().width)
				? dt(e, l, i)
				: Ie(e, rt, function () {
					return dt(e, l, i);
				  });
		  },
		  set: function (e, t, i) {
			var n,
			  s = Ve(e),
			  r = !y.scrollboxSize() && "absolute" === s.position,
			  a = (r || i) && "border-box" === E.css(e, "boxSizing", !1, s),
			  o = i ? lt(e, l, i, a, s) : 0;
			return (
			  a &&
				r &&
				(o -= Math.ceil(
				  e["offset" + l[0].toUpperCase() + l.slice(1)] -
					parseFloat(s[l]) -
					lt(e, l, "border", !1, s) -
					0.5
				)),
			  o &&
				(n = te.exec(t)) &&
				"px" !== (n[3] || "px") &&
				((e.style[l] = t), (t = E.css(e, l))),
			  ot(0, t, o)
			);
		  },
		};
	  }),
	  (E.cssHooks.marginLeft = Ue(y.reliableMarginLeft, function (e, t) {
		if (t)
		  return (
			(parseFloat(Ge(e, "marginLeft")) ||
			  e.getBoundingClientRect().left -
				Ie(e, { marginLeft: 0 }, function () {
				  return e.getBoundingClientRect().left;
				})) + "px"
		  );
	  })),
	  E.each({ margin: "", padding: "", border: "Width" }, function (s, r) {
		(E.cssHooks[s + r] = {
		  expand: function (e) {
			for (
			  var t = 0, i = {}, n = "string" == typeof e ? e.split(" ") : [e];
			  t < 4;
			  t++
			)
			  i[s + ie[t] + r] = n[t] || n[t - 2] || n[0];
			return i;
		  },
		}),
		  "margin" !== s && (E.cssHooks[s + r].set = ot);
	  }),
	  E.fn.extend({
		css: function (e, t) {
		  return R(
			this,
			function (e, t, i) {
			  var n,
				s,
				r = {},
				a = 0;
			  if (Array.isArray(t)) {
				for (n = Ve(e), s = t.length; a < s; a++)
				  r[t[a]] = E.css(e, t[a], !1, n);
				return r;
			  }
			  return void 0 !== i ? E.style(e, t, i) : E.css(e, t);
			},
			e,
			t,
			1 < arguments.length
		  );
		},
	  }),
	  (((E.Tween = ct).prototype = {
		constructor: ct,
		init: function (e, t, i, n, s, r) {
		  (this.elem = e),
			(this.prop = i),
			(this.easing = s || E.easing._default),
			(this.options = t),
			(this.start = this.now = this.cur()),
			(this.end = n),
			(this.unit = r || (E.cssNumber[i] ? "" : "px"));
		},
		cur: function () {
		  var e = ct.propHooks[this.prop];
		  return e && e.get ? e.get(this) : ct.propHooks._default.get(this);
		},
		run: function (e) {
		  var t,
			i = ct.propHooks[this.prop];
		  return (
			this.options.duration
			  ? (this.pos = t =
				  E.easing[this.easing](
					e,
					this.options.duration * e,
					0,
					1,
					this.options.duration
				  ))
			  : (this.pos = t = e),
			(this.now = (this.end - this.start) * t + this.start),
			this.options.step &&
			  this.options.step.call(this.elem, this.now, this),
			i && i.set ? i.set(this) : ct.propHooks._default.set(this),
			this
		  );
		},
	  }).init.prototype = ct.prototype),
	  ((ct.propHooks = {
		_default: {
		  get: function (e) {
			var t;
			return 1 !== e.elem.nodeType ||
			  (null != e.elem[e.prop] && null == e.elem.style[e.prop])
			  ? e.elem[e.prop]
			  : (t = E.css(e.elem, e.prop, "")) && "auto" !== t
			  ? t
			  : 0;
		  },
		  set: function (e) {
			E.fx.step[e.prop]
			  ? E.fx.step[e.prop](e)
			  : 1 !== e.elem.nodeType ||
				(!E.cssHooks[e.prop] && null == e.elem.style[it(e.prop)])
			  ? (e.elem[e.prop] = e.now)
			  : E.style(e.elem, e.prop, e.now + e.unit);
		  },
		},
	  }).scrollTop = ct.propHooks.scrollLeft =
		{
		  set: function (e) {
			e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
		  },
		}),
	  (E.easing = {
		linear: function (e) {
		  return e;
		},
		swing: function (e) {
		  return 0.5 - Math.cos(e * Math.PI) / 2;
		},
		_default: "swing",
	  }),
	  (E.fx = ct.prototype.init),
	  (E.fx.step = {});
	var ut,
	  ht,
	  pt,
	  ft,
	  vt = /^(?:toggle|show|hide)$/,
	  gt = /queueHooks$/;
	function mt() {
	  ht &&
		(!1 === C.hidden && S.requestAnimationFrame
		  ? S.requestAnimationFrame(mt)
		  : S.setTimeout(mt, E.fx.interval),
		E.fx.tick());
	}
	function yt() {
	  return (
		S.setTimeout(function () {
		  ut = void 0;
		}),
		(ut = Date.now())
	  );
	}
	function bt(e, t) {
	  var i,
		n = 0,
		s = { height: e };
	  for (t = t ? 1 : 0; n < 4; n += 2 - t)
		s["margin" + (i = ie[n])] = s["padding" + i] = e;
	  return t && (s.opacity = s.width = e), s;
	}
	function wt(e, t, i) {
	  for (
		var n,
		  s = (xt.tweeners[t] || []).concat(xt.tweeners["*"]),
		  r = 0,
		  a = s.length;
		r < a;
		r++
	  )
		if ((n = s[r].call(i, t, e))) return n;
	}
	function xt(r, e, t) {
	  var i,
		a,
		n = 0,
		s = xt.prefilters.length,
		o = E.Deferred().always(function () {
		  delete l.elem;
		}),
		l = function () {
		  if (a) return !1;
		  for (
			var e = ut || yt(),
			  t = Math.max(0, d.startTime + d.duration - e),
			  i = 1 - (t / d.duration || 0),
			  n = 0,
			  s = d.tweens.length;
			n < s;
			n++
		  )
			d.tweens[n].run(i);
		  return (
			o.notifyWith(r, [d, i, t]),
			i < 1 && s
			  ? t
			  : (s || o.notifyWith(r, [d, 1, 0]), o.resolveWith(r, [d]), !1)
		  );
		},
		d = o.promise({
		  elem: r,
		  props: E.extend({}, e),
		  opts: E.extend(!0, { specialEasing: {}, easing: E.easing._default }, t),
		  originalProperties: e,
		  originalOptions: t,
		  startTime: ut || yt(),
		  duration: t.duration,
		  tweens: [],
		  createTween: function (e, t) {
			var i = E.Tween(
			  r,
			  d.opts,
			  e,
			  t,
			  d.opts.specialEasing[e] || d.opts.easing
			);
			return d.tweens.push(i), i;
		  },
		  stop: function (e) {
			var t = 0,
			  i = e ? d.tweens.length : 0;
			if (a) return this;
			for (a = !0; t < i; t++) d.tweens[t].run(1);
			return (
			  e
				? (o.notifyWith(r, [d, 1, 0]), o.resolveWith(r, [d, e]))
				: o.rejectWith(r, [d, e]),
			  this
			);
		  },
		}),
		c = d.props;
	  for (
		(function (e, t) {
		  var i, n, s, r, a;
		  for (i in e)
			if (
			  ((s = t[(n = _(i))]),
			  (r = e[i]),
			  Array.isArray(r) && ((s = r[1]), (r = e[i] = r[0])),
			  i !== n && ((e[n] = r), delete e[i]),
			  (a = E.cssHooks[n]) && ("expand" in a))
			)
			  for (i in ((r = a.expand(r)), delete e[n], r))
				(i in e) || ((e[i] = r[i]), (t[i] = s));
			else t[n] = s;
		})(c, d.opts.specialEasing);
		n < s;
		n++
	  )
		if ((i = xt.prefilters[n].call(d, r, c, d.opts)))
		  return (
			b(i.stop) &&
			  (E._queueHooks(d.elem, d.opts.queue).stop = i.stop.bind(i)),
			i
		  );
	  return (
		E.map(c, wt, d),
		b(d.opts.start) && d.opts.start.call(r, d),
		d
		  .progress(d.opts.progress)
		  .done(d.opts.done, d.opts.complete)
		  .fail(d.opts.fail)
		  .always(d.opts.always),
		E.fx.timer(E.extend(l, { elem: r, anim: d, queue: d.opts.queue })),
		d
	  );
	}
	(E.Animation = E.extend(xt, {
	  tweeners: {
		"*": [
		  function (e, t) {
			var i = this.createTween(e, t);
			return oe(i.elem, e, te.exec(t), i), i;
		  },
		],
	  },
	  tweener: function (e, t) {
		for (
		  var i, n = 0, s = (e = b(e) ? ((t = e), ["*"]) : e.match(O)).length;
		  n < s;
		  n++
		)
		  (i = e[n]),
			(xt.tweeners[i] = xt.tweeners[i] || []),
			xt.tweeners[i].unshift(t);
	  },
	  prefilters: [
		function (e, t, i) {
		  var n,
			s,
			r,
			a,
			o,
			l,
			d,
			c,
			u = "width" in t || "height" in t,
			h = this,
			p = {},
			f = e.style,
			v = e.nodeType && ae(e),
			g = G.get(e, "fxshow");
		  for (n in (i.queue ||
			(null == (a = E._queueHooks(e, "fx")).unqueued &&
			  ((a.unqueued = 0),
			  (o = a.empty.fire),
			  (a.empty.fire = function () {
				a.unqueued || o();
			  })),
			a.unqueued++,
			h.always(function () {
			  h.always(function () {
				a.unqueued--, E.queue(e, "fx").length || a.empty.fire();
			  });
			})),
		  t))
			if (((s = t[n]), vt.test(s))) {
			  if (
				(delete t[n],
				(r = r || "toggle" === s),
				s === (v ? "hide" : "show"))
			  ) {
				if ("show" !== s || !g || void 0 === g[n]) continue;
				v = !0;
			  }
			  p[n] = (g && g[n]) || E.style(e, n);
			}
		  if ((l = !E.isEmptyObject(t)) || !E.isEmptyObject(p))
			for (n in (u &&
			  1 === e.nodeType &&
			  ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
			  null == (d = g && g.display) && (d = G.get(e, "display")),
			  "none" === (c = E.css(e, "display")) &&
				(d
				  ? (c = d)
				  : (de([e], !0),
					(d = e.style.display || d),
					(c = E.css(e, "display")),
					de([e]))),
			  ("inline" === c || ("inline-block" === c && null != d)) &&
				"none" === E.css(e, "float") &&
				(l ||
				  (h.done(function () {
					f.display = d;
				  }),
				  null == d && ((c = f.display), (d = "none" === c ? "" : c))),
				(f.display = "inline-block"))),
			i.overflow &&
			  ((f.overflow = "hidden"),
			  h.always(function () {
				(f.overflow = i.overflow[0]),
				  (f.overflowX = i.overflow[1]),
				  (f.overflowY = i.overflow[2]);
			  })),
			(l = !1),
			p))
			  l ||
				(g
				  ? "hidden" in g && (v = g.hidden)
				  : (g = G.access(e, "fxshow", { display: d })),
				r && (g.hidden = !v),
				v && de([e], !0),
				h.done(function () {
				  for (n in (v || de([e]), G.remove(e, "fxshow"), p))
					E.style(e, n, p[n]);
				})),
				(l = wt(v ? g[n] : 0, n, h)),
				n in g ||
				  ((g[n] = l.start), v && ((l.end = l.start), (l.start = 0)));
		},
	  ],
	  prefilter: function (e, t) {
		t ? xt.prefilters.unshift(e) : xt.prefilters.push(e);
	  },
	})),
	  (E.speed = function (e, t, i) {
		var n =
		  e && "object" == _typeof(e)
			? E.extend({}, e)
			: {
				complete: i || (!i && t) || (b(e) && e),
				duration: e,
				easing: (i && t) || (t && !b(t) && t),
			  };
		return (
		  E.fx.off
			? (n.duration = 0)
			: "number" != typeof n.duration &&
			  (n.duration in E.fx.speeds
				? (n.duration = E.fx.speeds[n.duration])
				: (n.duration = E.fx.speeds._default)),
		  (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
		  (n.old = n.complete),
		  (n.complete = function () {
			b(n.old) && n.old.call(this), n.queue && E.dequeue(this, n.queue);
		  }),
		  n
		);
	  }),
	  E.fn.extend({
		fadeTo: function (e, t, i, n) {
		  return this.filter(ae)
			.css("opacity", 0)
			.show()
			.end()
			.animate({ opacity: t }, e, i, n);
		},
		animate: function (t, e, i, n) {
		  function s() {
			var e = xt(this, E.extend({}, t), a);
			(r || G.get(this, "finish")) && e.stop(!0);
		  }
		  var r = E.isEmptyObject(t),
			a = E.speed(e, i, n);
		  return (
			(s.finish = s),
			r || !1 === a.queue ? this.each(s) : this.queue(a.queue, s)
		  );
		},
		stop: function (s, e, r) {
		  function a(e) {
			var t = e.stop;
			delete e.stop, t(r);
		  }
		  return (
			"string" != typeof s && ((r = e), (e = s), (s = void 0)),
			e && this.queue(s || "fx", []),
			this.each(function () {
			  var e = !0,
				t = null != s && s + "queueHooks",
				i = E.timers,
				n = G.get(this);
			  if (t) n[t] && n[t].stop && a(n[t]);
			  else for (t in n) n[t] && n[t].stop && gt.test(t) && a(n[t]);
			  for (t = i.length; t--; )
				i[t].elem !== this ||
				  (null != s && i[t].queue !== s) ||
				  (i[t].anim.stop(r), (e = !1), i.splice(t, 1));
			  (!e && r) || E.dequeue(this, s);
			})
		  );
		},
		finish: function (a) {
		  return (
			!1 !== a && (a = a || "fx"),
			this.each(function () {
			  var e,
				t = G.get(this),
				i = t[a + "queue"],
				n = t[a + "queueHooks"],
				s = E.timers,
				r = i ? i.length : 0;
			  for (
				t.finish = !0,
				  E.queue(this, a, []),
				  n && n.stop && n.stop.call(this, !0),
				  e = s.length;
				e--;
  
			  )
				s[e].elem === this &&
				  s[e].queue === a &&
				  (s[e].anim.stop(!0), s.splice(e, 1));
			  for (e = 0; e < r; e++)
				i[e] && i[e].finish && i[e].finish.call(this);
			  delete t.finish;
			})
		  );
		},
	  }),
	  E.each(["toggle", "show", "hide"], function (e, n) {
		var s = E.fn[n];
		E.fn[n] = function (e, t, i) {
		  return null == e || "boolean" == typeof e
			? s.apply(this, arguments)
			: this.animate(bt(n, !0), e, t, i);
		};
	  }),
	  E.each(
		{
		  slideDown: bt("show"),
		  slideUp: bt("hide"),
		  slideToggle: bt("toggle"),
		  fadeIn: { opacity: "show" },
		  fadeOut: { opacity: "hide" },
		  fadeToggle: { opacity: "toggle" },
		},
		function (e, n) {
		  E.fn[e] = function (e, t, i) {
			return this.animate(n, e, t, i);
		  };
		}
	  ),
	  (E.timers = []),
	  (E.fx.tick = function () {
		var e,
		  t = 0,
		  i = E.timers;
		for (ut = Date.now(); t < i.length; t++)
		  (e = i[t])() || i[t] !== e || i.splice(t--, 1);
		i.length || E.fx.stop(), (ut = void 0);
	  }),
	  (E.fx.timer = function (e) {
		E.timers.push(e), E.fx.start();
	  }),
	  (E.fx.interval = 13),
	  (E.fx.start = function () {
		ht || ((ht = !0), mt());
	  }),
	  (E.fx.stop = function () {
		ht = null;
	  }),
	  (E.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
	  (E.fn.delay = function (n, e) {
		return (
		  (n = (E.fx && E.fx.speeds[n]) || n),
		  (e = e || "fx"),
		  this.queue(e, function (e, t) {
			var i = S.setTimeout(e, n);
			t.stop = function () {
			  S.clearTimeout(i);
			};
		  })
		);
	  }),
	  (pt = C.createElement("input")),
	  (ft = C.createElement("select").appendChild(C.createElement("option"))),
	  (pt.type = "checkbox"),
	  (y.checkOn = "" !== pt.value),
	  (y.optSelected = ft.selected),
	  ((pt = C.createElement("input")).value = "t"),
	  (pt.type = "radio"),
	  (y.radioValue = "t" === pt.value);
	var Tt,
	  St = E.expr.attrHandle;
	E.fn.extend({
	  attr: function (e, t) {
		return R(this, E.attr, e, t, 1 < arguments.length);
	  },
	  removeAttr: function (e) {
		return this.each(function () {
		  E.removeAttr(this, e);
		});
	  },
	}),
	  E.extend({
		attr: function (e, t, i) {
		  var n,
			s,
			r = e.nodeType;
		  if (3 !== r && 8 !== r && 2 !== r)
			return void 0 === e.getAttribute
			  ? E.prop(e, t, i)
			  : ((1 === r && E.isXMLDoc(e)) ||
				  (s =
					E.attrHooks[t.toLowerCase()] ||
					(E.expr.match.bool.test(t) ? Tt : void 0)),
				void 0 !== i
				  ? null === i
					? void E.removeAttr(e, t)
					: s && "set" in s && void 0 !== (n = s.set(e, i, t))
					? n
					: (e.setAttribute(t, i + ""), i)
				  : !(s && "get" in s && null !== (n = s.get(e, t))) &&
					null == (n = E.find.attr(e, t))
				  ? void 0
				  : n);
		},
		attrHooks: {
		  type: {
			set: function (e, t) {
			  if (!y.radioValue && "radio" === t && Y(e, "input")) {
				var i = e.value;
				return e.setAttribute("type", t), i && (e.value = i), t;
			  }
			},
		  },
		},
		removeAttr: function (e, t) {
		  var i,
			n = 0,
			s = t && t.match(O);
		  if (s && 1 === e.nodeType) for (; (i = s[n++]); ) e.removeAttribute(i);
		},
	  }),
	  (Tt = {
		set: function (e, t, i) {
		  return !1 === t ? E.removeAttr(e, i) : e.setAttribute(i, i), i;
		},
	  }),
	  E.each(E.expr.match.bool.source.match(/\w+/g), function (e, t) {
		var a = St[t] || E.find.attr;
		St[t] = function (e, t, i) {
		  var n,
			s,
			r = t.toLowerCase();
		  return (
			i ||
			  ((s = St[r]),
			  (St[r] = n),
			  (n = null != a(e, t, i) ? r : null),
			  (St[r] = s)),
			n
		  );
		};
	  });
	var Ct = /^(?:input|select|textarea|button)$/i,
	  Et = /^(?:a|area)$/i;
	function kt(e) {
	  return (e.match(O) || []).join(" ");
	}
	function Yt(e) {
	  return (e.getAttribute && e.getAttribute("class")) || "";
	}
	function zt(e) {
	  return Array.isArray(e) ? e : ("string" == typeof e && e.match(O)) || [];
	}
	E.fn.extend({
	  prop: function (e, t) {
		return R(this, E.prop, e, t, 1 < arguments.length);
	  },
	  removeProp: function (e) {
		return this.each(function () {
		  delete this[E.propFix[e] || e];
		});
	  },
	}),
	  E.extend({
		prop: function (e, t, i) {
		  var n,
			s,
			r = e.nodeType;
		  if (3 !== r && 8 !== r && 2 !== r)
			return (
			  (1 === r && E.isXMLDoc(e)) ||
				((t = E.propFix[t] || t), (s = E.propHooks[t])),
			  void 0 !== i
				? s && "set" in s && void 0 !== (n = s.set(e, i, t))
				  ? n
				  : (e[t] = i)
				: s && "get" in s && null !== (n = s.get(e, t))
				? n
				: e[t]
			);
		},
		propHooks: {
		  tabIndex: {
			get: function (e) {
			  var t = E.find.attr(e, "tabindex");
			  return t
				? parseInt(t, 10)
				: Ct.test(e.nodeName) || (Et.test(e.nodeName) && e.href)
				? 0
				: -1;
			},
		  },
		},
		propFix: { for: "htmlFor", class: "className" },
	  }),
	  y.optSelected ||
		(E.propHooks.selected = {
		  get: function (e) {
			var t = e.parentNode;
			return t && t.parentNode && t.parentNode.selectedIndex, null;
		  },
		  set: function (e) {
			var t = e.parentNode;
			t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
		  },
		}),
	  E.each(
		[
		  "tabIndex",
		  "readOnly",
		  "maxLength",
		  "cellSpacing",
		  "cellPadding",
		  "rowSpan",
		  "colSpan",
		  "useMap",
		  "frameBorder",
		  "contentEditable",
		],
		function () {
		  E.propFix[this.toLowerCase()] = this;
		}
	  ),
	  E.fn.extend({
		addClass: function (t) {
		  var e,
			i,
			n,
			s,
			r,
			a,
			o,
			l = 0;
		  if (b(t))
			return this.each(function (e) {
			  E(this).addClass(t.call(this, e, Yt(this)));
			});
		  if ((e = zt(t)).length)
			for (; (i = this[l++]); )
			  if (((s = Yt(i)), (n = 1 === i.nodeType && " " + kt(s) + " "))) {
				for (a = 0; (r = e[a++]); )
				  n.indexOf(" " + r + " ") < 0 && (n += r + " ");
				s !== (o = kt(n)) && i.setAttribute("class", o);
			  }
		  return this;
		},
		removeClass: function (t) {
		  var e,
			i,
			n,
			s,
			r,
			a,
			o,
			l = 0;
		  if (b(t))
			return this.each(function (e) {
			  E(this).removeClass(t.call(this, e, Yt(this)));
			});
		  if (!arguments.length) return this.attr("class", "");
		  if ((e = zt(t)).length)
			for (; (i = this[l++]); )
			  if (((s = Yt(i)), (n = 1 === i.nodeType && " " + kt(s) + " "))) {
				for (a = 0; (r = e[a++]); )
				  for (; -1 < n.indexOf(" " + r + " "); )
					n = n.replace(" " + r + " ", " ");
				s !== (o = kt(n)) && i.setAttribute("class", o);
			  }
		  return this;
		},
		toggleClass: function (s, t) {
		  var r = _typeof(s),
			a = "string" === r || Array.isArray(s);
		  return "boolean" == typeof t && a
			? t
			  ? this.addClass(s)
			  : this.removeClass(s)
			: b(s)
			? this.each(function (e) {
				E(this).toggleClass(s.call(this, e, Yt(this), t), t);
			  })
			: this.each(function () {
				var e, t, i, n;
				if (a)
				  for (t = 0, i = E(this), n = zt(s); (e = n[t++]); )
					i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
				else
				  (void 0 !== s && "boolean" !== r) ||
					((e = Yt(this)) && G.set(this, "__className__", e),
					this.setAttribute &&
					  this.setAttribute(
						"class",
						(!e && !1 !== s && G.get(this, "__className__")) || ""
					  ));
			  });
		},
		hasClass: function (e) {
		  var t,
			i,
			n = 0;
		  for (t = " " + e + " "; (i = this[n++]); )
			if (1 === i.nodeType && -1 < (" " + kt(Yt(i)) + " ").indexOf(t))
			  return !0;
		  return !1;
		},
	  });
	var $t = /\r/g;
	E.fn.extend({
	  val: function (i) {
		var n,
		  e,
		  s,
		  t = this[0];
		return arguments.length
		  ? ((s = b(i)),
			this.each(function (e) {
			  var t;
			  1 === this.nodeType &&
				(null == (t = s ? i.call(this, e, E(this).val()) : i)
				  ? (t = "")
				  : "number" == typeof t
				  ? (t += "")
				  : Array.isArray(t) &&
					(t = E.map(t, function (e) {
					  return null == e ? "" : e + "";
					})),
				((n =
				  E.valHooks[this.type] ||
				  E.valHooks[this.nodeName.toLowerCase()]) &&
				  "set" in n &&
				  void 0 !== n.set(this, t, "value")) ||
				  (this.value = t));
			}))
		  : t
		  ? (n = E.valHooks[t.type] || E.valHooks[t.nodeName.toLowerCase()]) &&
			"get" in n &&
			void 0 !== (e = n.get(t, "value"))
			? e
			: "string" == typeof (e = t.value)
			? e.replace($t, "")
			: null == e
			? ""
			: e
		  : void 0;
	  },
	}),
	  E.extend({
		valHooks: {
		  option: {
			get: function (e) {
			  var t = E.find.attr(e, "value");
			  return null != t ? t : kt(E.text(e));
			},
		  },
		  select: {
			get: function (e) {
			  var t,
				i,
				n,
				s = e.options,
				r = e.selectedIndex,
				a = "select-one" === e.type,
				o = a ? null : [],
				l = a ? r + 1 : s.length;
			  for (n = r < 0 ? l : a ? r : 0; n < l; n++)
				if (
				  ((i = s[n]).selected || n === r) &&
				  !i.disabled &&
				  (!i.parentNode.disabled || !Y(i.parentNode, "optgroup"))
				) {
				  if (((t = E(i).val()), a)) return t;
				  o.push(t);
				}
			  return o;
			},
			set: function (e, t) {
			  for (
				var i, n, s = e.options, r = E.makeArray(t), a = s.length;
				a--;
  
			  )
				((n = s[a]).selected =
				  -1 < E.inArray(E.valHooks.option.get(n), r)) && (i = !0);
			  return i || (e.selectedIndex = -1), r;
			},
		  },
		},
	  }),
	  E.each(["radio", "checkbox"], function () {
		(E.valHooks[this] = {
		  set: function (e, t) {
			if (Array.isArray(t))
			  return (e.checked = -1 < E.inArray(E(e).val(), t));
		  },
		}),
		  y.checkOn ||
			(E.valHooks[this].get = function (e) {
			  return null === e.getAttribute("value") ? "on" : e.value;
			});
	  }),
	  (y.focusin = "onfocusin" in S);
	function Pt(e) {
	  e.stopPropagation();
	}
	var At = /^(?:focusinfocus|focusoutblur)$/;
	E.extend(E.event, {
	  trigger: function (e, t, i, n) {
		var s,
		  r,
		  a,
		  o,
		  l,
		  d,
		  c,
		  u,
		  h = [i || C],
		  p = m.call(e, "type") ? e.type : e,
		  f = m.call(e, "namespace") ? e.namespace.split(".") : [];
		if (
		  ((r = u = a = i = i || C),
		  3 !== i.nodeType &&
			8 !== i.nodeType &&
			!At.test(p + E.event.triggered) &&
			(-1 < p.indexOf(".") && ((p = (f = p.split(".")).shift()), f.sort()),
			(l = p.indexOf(":") < 0 && "on" + p),
			((e = e[E.expando]
			  ? e
			  : new E.Event(p, "object" == _typeof(e) && e)).isTrigger = n
			  ? 2
			  : 3),
			(e.namespace = f.join(".")),
			(e.rnamespace = e.namespace
			  ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)")
			  : null),
			(e.result = void 0),
			e.target || (e.target = i),
			(t = null == t ? [e] : E.makeArray(t, [e])),
			(c = E.event.special[p] || {}),
			n || !c.trigger || !1 !== c.trigger.apply(i, t)))
		) {
		  if (!n && !c.noBubble && !v(i)) {
			for (
			  o = c.delegateType || p, At.test(o + p) || (r = r.parentNode);
			  r;
			  r = r.parentNode
			)
			  h.push(r), (a = r);
			a === (i.ownerDocument || C) &&
			  h.push(a.defaultView || a.parentWindow || S);
		  }
		  for (s = 0; (r = h[s++]) && !e.isPropagationStopped(); )
			(u = r),
			  (e.type = 1 < s ? o : c.bindType || p),
			  (d =
				(G.get(r, "events") || Object.create(null))[e.type] &&
				G.get(r, "handle")) && d.apply(r, t),
			  (d = l && r[l]) &&
				d.apply &&
				V(r) &&
				((e.result = d.apply(r, t)),
				!1 === e.result && e.preventDefault());
		  return (
			(e.type = p),
			n ||
			  e.isDefaultPrevented() ||
			  (c._default && !1 !== c._default.apply(h.pop(), t)) ||
			  !V(i) ||
			  (l &&
				b(i[p]) &&
				!v(i) &&
				((a = i[l]) && (i[l] = null),
				(E.event.triggered = p),
				e.isPropagationStopped() && u.addEventListener(p, Pt),
				i[p](),
				e.isPropagationStopped() && u.removeEventListener(p, Pt),
				(E.event.triggered = void 0),
				a && (i[l] = a))),
			e.result
		  );
		}
	  },
	  simulate: function (e, t, i) {
		var n = E.extend(new E.Event(), i, { type: e, isSimulated: !0 });
		E.event.trigger(n, null, t);
	  },
	}),
	  E.fn.extend({
		trigger: function (e, t) {
		  return this.each(function () {
			E.event.trigger(e, t, this);
		  });
		},
		triggerHandler: function (e, t) {
		  var i = this[0];
		  if (i) return E.event.trigger(e, t, i, !0);
		},
	  }),
	  y.focusin ||
		E.each({ focus: "focusin", blur: "focusout" }, function (i, n) {
		  function s(e) {
			E.event.simulate(n, e.target, E.event.fix(e));
		  }
		  E.event.special[n] = {
			setup: function () {
			  var e = this.ownerDocument || this.document || this,
				t = G.access(e, n);
			  t || e.addEventListener(i, s, !0), G.access(e, n, (t || 0) + 1);
			},
			teardown: function () {
			  var e = this.ownerDocument || this.document || this,
				t = G.access(e, n) - 1;
			  t
				? G.access(e, n, t)
				: (e.removeEventListener(i, s, !0), G.remove(e, n));
			},
		  };
		});
	var Mt = S.location,
	  Lt = { guid: Date.now() },
	  Dt = /\?/;
	E.parseXML = function (e) {
	  var t;
	  if (!e || "string" != typeof e) return null;
	  try {
		t = new S.DOMParser().parseFromString(e, "text/xml");
	  } catch (e) {
		t = void 0;
	  }
	  return (
		(t && !t.getElementsByTagName("parsererror").length) ||
		  E.error("Invalid XML: " + e),
		t
	  );
	};
	var Ot = /\[\]$/,
	  Nt = /\r?\n/g,
	  It = /^(?:submit|button|image|reset|file)$/i,
	  Ht = /^(?:input|select|textarea|keygen)/i;
	function jt(i, e, n, s) {
	  var t;
	  if (Array.isArray(e))
		E.each(e, function (e, t) {
		  n || Ot.test(i)
			? s(i, t)
			: jt(
				i + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]",
				t,
				n,
				s
			  );
		});
	  else if (n || "object" !== x(e)) s(i, e);
	  else for (t in e) jt(i + "[" + t + "]", e[t], n, s);
	}
	(E.param = function (e, t) {
	  function i(e, t) {
		var i = b(t) ? t() : t;
		s[s.length] =
		  encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i);
	  }
	  var n,
		s = [];
	  if (null == e) return "";
	  if (Array.isArray(e) || (e.jquery && !E.isPlainObject(e)))
		E.each(e, function () {
		  i(this.name, this.value);
		});
	  else for (n in e) jt(n, e[n], t, i);
	  return s.join("&");
	}),
	  E.fn.extend({
		serialize: function () {
		  return E.param(this.serializeArray());
		},
		serializeArray: function () {
		  return this.map(function () {
			var e = E.prop(this, "elements");
			return e ? E.makeArray(e) : this;
		  })
			.filter(function () {
			  var e = this.type;
			  return (
				this.name &&
				!E(this).is(":disabled") &&
				Ht.test(this.nodeName) &&
				!It.test(e) &&
				(this.checked || !he.test(e))
			  );
			})
			.map(function (e, t) {
			  var i = E(this).val();
			  return null == i
				? null
				: Array.isArray(i)
				? E.map(i, function (e) {
					return { name: t.name, value: e.replace(Nt, "\r\n") };
				  })
				: { name: t.name, value: i.replace(Nt, "\r\n") };
			})
			.get();
		},
	  });
	var qt = /%20/g,
	  Bt = /#.*$/,
	  Rt = /([?&])_=[^&]*/,
	  Wt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
	  Ft = /^(?:GET|HEAD)$/,
	  Xt = /^\/\//,
	  _t = {},
	  Vt = {},
	  Zt = "*/".concat("*"),
	  Gt = C.createElement("a");
	function Ut(r) {
	  return function (e, t) {
		"string" != typeof e && ((t = e), (e = "*"));
		var i,
		  n = 0,
		  s = e.toLowerCase().match(O) || [];
		if (b(t))
		  for (; (i = s[n++]); )
			"+" === i[0]
			  ? ((i = i.slice(1) || "*"), (r[i] = r[i] || []).unshift(t))
			  : (r[i] = r[i] || []).push(t);
	  };
	}
	function Qt(t, s, r, a) {
	  var o = {},
		l = t === Vt;
	  function d(e) {
		var n;
		return (
		  (o[e] = !0),
		  E.each(t[e] || [], function (e, t) {
			var i = t(s, r, a);
			return "string" != typeof i || l || o[i]
			  ? l
				? !(n = i)
				: void 0
			  : (s.dataTypes.unshift(i), d(i), !1);
		  }),
		  n
		);
	  }
	  return d(s.dataTypes[0]) || (!o["*"] && d("*"));
	}
	function Kt(e, t) {
	  var i,
		n,
		s = E.ajaxSettings.flatOptions || {};
	  for (i in t) void 0 !== t[i] && ((s[i] ? e : (n = n || {}))[i] = t[i]);
	  return n && E.extend(!0, e, n), e;
	}
	(Gt.href = Mt.href),
	  E.extend({
		active: 0,
		lastModified: {},
		etag: {},
		ajaxSettings: {
		  url: Mt.href,
		  type: "GET",
		  isLocal:
			/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
			  Mt.protocol
			),
		  global: !0,
		  processData: !0,
		  async: !0,
		  contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		  accepts: {
			"*": Zt,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript",
		  },
		  contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
		  responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON",
		  },
		  converters: {
			"* text": String,
			"text html": !0,
			"text json": JSON.parse,
			"text xml": E.parseXML,
		  },
		  flatOptions: { url: !0, context: !0 },
		},
		ajaxSetup: function (e, t) {
		  return t ? Kt(Kt(e, E.ajaxSettings), t) : Kt(E.ajaxSettings, e);
		},
		ajaxPrefilter: Ut(_t),
		ajaxTransport: Ut(Vt),
		ajax: function (e, t) {
		  "object" == _typeof(e) && ((t = e), (e = void 0)), (t = t || {});
		  var c,
			u,
			h,
			i,
			p,
			n,
			f,
			v,
			s,
			r,
			g = E.ajaxSetup({}, t),
			m = g.context || g,
			y = g.context && (m.nodeType || m.jquery) ? E(m) : E.event,
			b = E.Deferred(),
			w = E.Callbacks("once memory"),
			x = g.statusCode || {},
			a = {},
			o = {},
			l = "canceled",
			T = {
			  readyState: 0,
			  getResponseHeader: function (e) {
				var t;
				if (f) {
				  if (!i)
					for (i = {}; (t = Wt.exec(h)); )
					  i[t[1].toLowerCase() + " "] = (
						i[t[1].toLowerCase() + " "] || []
					  ).concat(t[2]);
				  t = i[e.toLowerCase() + " "];
				}
				return null == t ? null : t.join(", ");
			  },
			  getAllResponseHeaders: function () {
				return f ? h : null;
			  },
			  setRequestHeader: function (e, t) {
				return (
				  null == f &&
					((e = o[e.toLowerCase()] = o[e.toLowerCase()] || e),
					(a[e] = t)),
				  this
				);
			  },
			  overrideMimeType: function (e) {
				return null == f && (g.mimeType = e), this;
			  },
			  statusCode: function (e) {
				var t;
				if (e)
				  if (f) T.always(e[T.status]);
				  else for (t in e) x[t] = [x[t], e[t]];
				return this;
			  },
			  abort: function (e) {
				var t = e || l;
				return c && c.abort(t), d(0, t), this;
			  },
			};
		  if (
			(b.promise(T),
			(g.url = ((e || g.url || Mt.href) + "").replace(
			  Xt,
			  Mt.protocol + "//"
			)),
			(g.type = t.method || t.type || g.method || g.type),
			(g.dataTypes = (g.dataType || "*").toLowerCase().match(O) || [""]),
			null == g.crossDomain)
		  ) {
			n = C.createElement("a");
			try {
			  (n.href = g.url),
				(n.href = n.href),
				(g.crossDomain =
				  Gt.protocol + "//" + Gt.host != n.protocol + "//" + n.host);
			} catch (e) {
			  g.crossDomain = !0;
			}
		  }
		  if (
			(g.data &&
			  g.processData &&
			  "string" != typeof g.data &&
			  (g.data = E.param(g.data, g.traditional)),
			Qt(_t, g, t, T),
			f)
		  )
			return T;
		  for (s in ((v = E.event && g.global) &&
			0 == E.active++ &&
			E.event.trigger("ajaxStart"),
		  (g.type = g.type.toUpperCase()),
		  (g.hasContent = !Ft.test(g.type)),
		  (u = g.url.replace(Bt, "")),
		  g.hasContent
			? g.data &&
			  g.processData &&
			  0 ===
				(g.contentType || "").indexOf(
				  "application/x-www-form-urlencoded"
				) &&
			  (g.data = g.data.replace(qt, "+"))
			: ((r = g.url.slice(u.length)),
			  g.data &&
				(g.processData || "string" == typeof g.data) &&
				((u += (Dt.test(u) ? "&" : "?") + g.data), delete g.data),
			  !1 === g.cache &&
				((u = u.replace(Rt, "$1")),
				(r = (Dt.test(u) ? "&" : "?") + "_=" + Lt.guid++ + r)),
			  (g.url = u + r)),
		  g.ifModified &&
			(E.lastModified[u] &&
			  T.setRequestHeader("If-Modified-Since", E.lastModified[u]),
			E.etag[u] && T.setRequestHeader("If-None-Match", E.etag[u])),
		  ((g.data && g.hasContent && !1 !== g.contentType) || t.contentType) &&
			T.setRequestHeader("Content-Type", g.contentType),
		  T.setRequestHeader(
			"Accept",
			g.dataTypes[0] && g.accepts[g.dataTypes[0]]
			  ? g.accepts[g.dataTypes[0]] +
				  ("*" !== g.dataTypes[0] ? ", " + Zt + "; q=0.01" : "")
			  : g.accepts["*"]
		  ),
		  g.headers))
			T.setRequestHeader(s, g.headers[s]);
		  if (g.beforeSend && (!1 === g.beforeSend.call(m, T, g) || f))
			return T.abort();
		  if (
			((l = "abort"),
			w.add(g.complete),
			T.done(g.success),
			T.fail(g.error),
			(c = Qt(Vt, g, t, T)))
		  ) {
			if (((T.readyState = 1), v && y.trigger("ajaxSend", [T, g]), f))
			  return T;
			g.async &&
			  0 < g.timeout &&
			  (p = S.setTimeout(function () {
				T.abort("timeout");
			  }, g.timeout));
			try {
			  (f = !1), c.send(a, d);
			} catch (e) {
			  if (f) throw e;
			  d(-1, e);
			}
		  } else d(-1, "No Transport");
		  function d(e, t, i, n) {
			var s,
			  r,
			  a,
			  o,
			  l,
			  d = t;
			f ||
			  ((f = !0),
			  p && S.clearTimeout(p),
			  (c = void 0),
			  (h = n || ""),
			  (T.readyState = 0 < e ? 4 : 0),
			  (s = (200 <= e && e < 300) || 304 === e),
			  i &&
				(o = (function (e, t, i) {
				  for (
					var n, s, r, a, o = e.contents, l = e.dataTypes;
					"*" === l[0];
  
				  )
					l.shift(),
					  void 0 === n &&
						(n = e.mimeType || t.getResponseHeader("Content-Type"));
				  if (n)
					for (s in o)
					  if (o[s] && o[s].test(n)) {
						l.unshift(s);
						break;
					  }
				  if (l[0] in i) r = l[0];
				  else {
					for (s in i) {
					  if (!l[0] || e.converters[s + " " + l[0]]) {
						r = s;
						break;
					  }
					  a = a || s;
					}
					r = r || a;
				  }
				  if (r) return r !== l[0] && l.unshift(r), i[r];
				})(g, T, i)),
			  !s &&
				-1 < E.inArray("script", g.dataTypes) &&
				(g.converters["text script"] = function () {}),
			  (o = (function (e, t, i, n) {
				var s,
				  r,
				  a,
				  o,
				  l,
				  d = {},
				  c = e.dataTypes.slice();
				if (c[1])
				  for (a in e.converters) d[a.toLowerCase()] = e.converters[a];
				for (r = c.shift(); r; )
				  if (
					(e.responseFields[r] && (i[e.responseFields[r]] = t),
					!l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
					(l = r),
					(r = c.shift()))
				  )
					if ("*" === r) r = l;
					else if ("*" !== l && l !== r) {
					  if (!(a = d[l + " " + r] || d["* " + r]))
						for (s in d)
						  if (
							(o = s.split(" "))[1] === r &&
							(a = d[l + " " + o[0]] || d["* " + o[0]])
						  ) {
							!0 === a
							  ? (a = d[s])
							  : !0 !== d[s] && ((r = o[0]), c.unshift(o[1]));
							break;
						  }
					  if (!0 !== a)
						if (a && e.throws) t = a(t);
						else
						  try {
							t = a(t);
						  } catch (e) {
							return {
							  state: "parsererror",
							  error: a
								? e
								: "No conversion from " + l + " to " + r,
							};
						  }
					}
				return { state: "success", data: t };
			  })(g, o, T, s)),
			  s
				? (g.ifModified &&
					((l = T.getResponseHeader("Last-Modified")) &&
					  (E.lastModified[u] = l),
					(l = T.getResponseHeader("etag")) && (E.etag[u] = l)),
				  204 === e || "HEAD" === g.type
					? (d = "nocontent")
					: 304 === e
					? (d = "notmodified")
					: ((d = o.state), (r = o.data), (s = !(a = o.error))))
				: ((a = d), (!e && d) || ((d = "error"), e < 0 && (e = 0))),
			  (T.status = e),
			  (T.statusText = (t || d) + ""),
			  s ? b.resolveWith(m, [r, d, T]) : b.rejectWith(m, [T, d, a]),
			  T.statusCode(x),
			  (x = void 0),
			  v && y.trigger(s ? "ajaxSuccess" : "ajaxError", [T, g, s ? r : a]),
			  w.fireWith(m, [T, d]),
			  v &&
				(y.trigger("ajaxComplete", [T, g]),
				--E.active || E.event.trigger("ajaxStop")));
		  }
		  return T;
		},
		getJSON: function (e, t, i) {
		  return E.get(e, t, i, "json");
		},
		getScript: function (e, t) {
		  return E.get(e, void 0, t, "script");
		},
	  }),
	  E.each(["get", "post"], function (e, s) {
		E[s] = function (e, t, i, n) {
		  return (
			b(t) && ((n = n || i), (i = t), (t = void 0)),
			E.ajax(
			  E.extend(
				{ url: e, type: s, dataType: n, data: t, success: i },
				E.isPlainObject(e) && e
			  )
			)
		  );
		};
	  }),
	  E.ajaxPrefilter(function (e) {
		var t;
		for (t in e.headers)
		  "content-type" === t.toLowerCase() &&
			(e.contentType = e.headers[t] || "");
	  }),
	  (E._evalUrl = function (e, t, i) {
		return E.ajax({
		  url: e,
		  type: "GET",
		  dataType: "script",
		  cache: !0,
		  async: !1,
		  global: !1,
		  converters: { "text script": function () {} },
		  dataFilter: function (e) {
			E.globalEval(e, t, i);
		  },
		});
	  }),
	  E.fn.extend({
		wrapAll: function (e) {
		  var t;
		  return (
			this[0] &&
			  (b(e) && (e = e.call(this[0])),
			  (t = E(e, this[0].ownerDocument).eq(0).clone(!0)),
			  this[0].parentNode && t.insertBefore(this[0]),
			  t
				.map(function () {
				  for (var e = this; e.firstElementChild; )
					e = e.firstElementChild;
				  return e;
				})
				.append(this)),
			this
		  );
		},
		wrapInner: function (i) {
		  return b(i)
			? this.each(function (e) {
				E(this).wrapInner(i.call(this, e));
			  })
			: this.each(function () {
				var e = E(this),
				  t = e.contents();
				t.length ? t.wrapAll(i) : e.append(i);
			  });
		},
		wrap: function (t) {
		  var i = b(t);
		  return this.each(function (e) {
			E(this).wrapAll(i ? t.call(this, e) : t);
		  });
		},
		unwrap: function (e) {
		  return (
			this.parent(e)
			  .not("body")
			  .each(function () {
				E(this).replaceWith(this.childNodes);
			  }),
			this
		  );
		},
	  }),
	  (E.expr.pseudos.hidden = function (e) {
		return !E.expr.pseudos.visible(e);
	  }),
	  (E.expr.pseudos.visible = function (e) {
		return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
	  }),
	  (E.ajaxSettings.xhr = function () {
		try {
		  return new S.XMLHttpRequest();
		} catch (e) {}
	  });
	var Jt = { 0: 200, 1223: 204 },
	  ei = E.ajaxSettings.xhr();
	(y.cors = !!ei && "withCredentials" in ei),
	  (y.ajax = ei = !!ei),
	  E.ajaxTransport(function (s) {
		var r, a;
		if (y.cors || (ei && !s.crossDomain))
		  return {
			send: function (e, t) {
			  var i,
				n = s.xhr();
			  if (
				(n.open(s.type, s.url, s.async, s.username, s.password),
				s.xhrFields)
			  )
				for (i in s.xhrFields) n[i] = s.xhrFields[i];
			  for (i in (s.mimeType &&
				n.overrideMimeType &&
				n.overrideMimeType(s.mimeType),
			  s.crossDomain ||
				e["X-Requested-With"] ||
				(e["X-Requested-With"] = "XMLHttpRequest"),
			  e))
				n.setRequestHeader(i, e[i]);
			  (r = function (e) {
				return function () {
				  r &&
					((r =
					  a =
					  n.onload =
					  n.onerror =
					  n.onabort =
					  n.ontimeout =
					  n.onreadystatechange =
						null),
					"abort" === e
					  ? n.abort()
					  : "error" === e
					  ? "number" != typeof n.status
						? t(0, "error")
						: t(n.status, n.statusText)
					  : t(
						  Jt[n.status] || n.status,
						  n.statusText,
						  "text" !== (n.responseType || "text") ||
							"string" != typeof n.responseText
							? { binary: n.response }
							: { text: n.responseText },
						  n.getAllResponseHeaders()
						));
				};
			  }),
				(n.onload = r()),
				(a = n.onerror = n.ontimeout = r("error")),
				void 0 !== n.onabort
				  ? (n.onabort = a)
				  : (n.onreadystatechange = function () {
					  4 === n.readyState &&
						S.setTimeout(function () {
						  r && a();
						});
					}),
				(r = r("abort"));
			  try {
				n.send((s.hasContent && s.data) || null);
			  } catch (e) {
				if (r) throw e;
			  }
			},
			abort: function () {
			  r && r();
			},
		  };
	  }),
	  E.ajaxPrefilter(function (e) {
		e.crossDomain && (e.contents.script = !1);
	  }),
	  E.ajaxSetup({
		accepts: {
		  script:
			"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
		},
		contents: { script: /\b(?:java|ecma)script\b/ },
		converters: {
		  "text script": function (e) {
			return E.globalEval(e), e;
		  },
		},
	  }),
	  E.ajaxPrefilter("script", function (e) {
		void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
	  }),
	  E.ajaxTransport("script", function (i) {
		var n, s;
		if (i.crossDomain || i.scriptAttrs)
		  return {
			send: function (e, t) {
			  (n = E("<script>")
				.attr(i.scriptAttrs || {})
				.prop({ charset: i.scriptCharset, src: i.url })
				.on(
				  "load error",
				  (s = function (e) {
					n.remove(),
					  (s = null),
					  e && t("error" === e.type ? 404 : 200, e.type);
				  })
				)),
				C.head.appendChild(n[0]);
			},
			abort: function () {
			  s && s();
			},
		  };
	  });
	var ti,
	  ii = [],
	  ni = /(=)\?(?=&|$)|\?\?/;
	E.ajaxSetup({
	  jsonp: "callback",
	  jsonpCallback: function () {
		var e = ii.pop() || E.expando + "_" + Lt.guid++;
		return (this[e] = !0), e;
	  },
	}),
	  E.ajaxPrefilter("json jsonp", function (e, t, i) {
		var n,
		  s,
		  r,
		  a =
			!1 !== e.jsonp &&
			(ni.test(e.url)
			  ? "url"
			  : "string" == typeof e.data &&
				0 ===
				  (e.contentType || "").indexOf(
					"application/x-www-form-urlencoded"
				  ) &&
				ni.test(e.data) &&
				"data");
		if (a || "jsonp" === e.dataTypes[0])
		  return (
			(n = e.jsonpCallback =
			  b(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
			a
			  ? (e[a] = e[a].replace(ni, "$1" + n))
			  : !1 !== e.jsonp &&
				(e.url += (Dt.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
			(e.converters["script json"] = function () {
			  return r || E.error(n + " was not called"), r[0];
			}),
			(e.dataTypes[0] = "json"),
			(s = S[n]),
			(S[n] = function () {
			  r = arguments;
			}),
			i.always(function () {
			  void 0 === s ? E(S).removeProp(n) : (S[n] = s),
				e[n] && ((e.jsonpCallback = t.jsonpCallback), ii.push(n)),
				r && b(s) && s(r[0]),
				(r = s = void 0);
			}),
			"script"
		  );
	  }),
	  (y.createHTMLDocument =
		(((ti = C.implementation.createHTMLDocument("").body).innerHTML =
		  "<form></form><form></form>"),
		2 === ti.childNodes.length)),
	  (E.parseHTML = function (e, t, i) {
		return "string" != typeof e
		  ? []
		  : ("boolean" == typeof t && ((i = t), (t = !1)),
			t ||
			  (y.createHTMLDocument
				? (((n = (t =
					C.implementation.createHTMLDocument("")).createElement(
					"base"
				  )).href = C.location.href),
				  t.head.appendChild(n))
				: (t = C)),
			(r = !i && []),
			(s = z.exec(e))
			  ? [t.createElement(s[1])]
			  : ((s = be([e], t, r)),
				r && r.length && E(r).remove(),
				E.merge([], s.childNodes)));
		var n, s, r;
	  }),
	  (E.fn.load = function (e, t, i) {
		var n,
		  s,
		  r,
		  a = this,
		  o = e.indexOf(" ");
		return (
		  -1 < o && ((n = kt(e.slice(o))), (e = e.slice(0, o))),
		  b(t)
			? ((i = t), (t = void 0))
			: t && "object" == _typeof(t) && (s = "POST"),
		  0 < a.length &&
			E.ajax({ url: e, type: s || "GET", dataType: "html", data: t })
			  .done(function (e) {
				(r = arguments),
				  a.html(n ? E("<div>").append(E.parseHTML(e)).find(n) : e);
			  })
			  .always(
				i &&
				  function (e, t) {
					a.each(function () {
					  i.apply(this, r || [e.responseText, t, e]);
					});
				  }
			  ),
		  this
		);
	  }),
	  (E.expr.pseudos.animated = function (t) {
		return E.grep(E.timers, function (e) {
		  return t === e.elem;
		}).length;
	  }),
	  (E.offset = {
		setOffset: function (e, t, i) {
		  var n,
			s,
			r,
			a,
			o,
			l,
			d = E.css(e, "position"),
			c = E(e),
			u = {};
		  "static" === d && (e.style.position = "relative"),
			(o = c.offset()),
			(r = E.css(e, "top")),
			(l = E.css(e, "left")),
			(s =
			  ("absolute" === d || "fixed" === d) && -1 < (r + l).indexOf("auto")
				? ((a = (n = c.position()).top), n.left)
				: ((a = parseFloat(r) || 0), parseFloat(l) || 0)),
			b(t) && (t = t.call(e, i, E.extend({}, o))),
			null != t.top && (u.top = t.top - o.top + a),
			null != t.left && (u.left = t.left - o.left + s),
			"using" in t
			  ? t.using.call(e, u)
			  : ("number" == typeof u.top && (u.top += "px"),
				"number" == typeof u.left && (u.left += "px"),
				c.css(u));
		},
	  }),
	  E.fn.extend({
		offset: function (t) {
		  if (arguments.length)
			return void 0 === t
			  ? this
			  : this.each(function (e) {
				  E.offset.setOffset(this, t, e);
				});
		  var e,
			i,
			n = this[0];
		  return n
			? n.getClientRects().length
			  ? ((e = n.getBoundingClientRect()),
				(i = n.ownerDocument.defaultView),
				{ top: e.top + i.pageYOffset, left: e.left + i.pageXOffset })
			  : { top: 0, left: 0 }
			: void 0;
		},
		position: function () {
		  if (this[0]) {
			var e,
			  t,
			  i,
			  n = this[0],
			  s = { top: 0, left: 0 };
			if ("fixed" === E.css(n, "position")) t = n.getBoundingClientRect();
			else {
			  for (
				t = this.offset(),
				  i = n.ownerDocument,
				  e = n.offsetParent || i.documentElement;
				e &&
				(e === i.body || e === i.documentElement) &&
				"static" === E.css(e, "position");
  
			  )
				e = e.parentNode;
			  e &&
				e !== n &&
				1 === e.nodeType &&
				(((s = E(e).offset()).top += E.css(e, "borderTopWidth", !0)),
				(s.left += E.css(e, "borderLeftWidth", !0)));
			}
			return {
			  top: t.top - s.top - E.css(n, "marginTop", !0),
			  left: t.left - s.left - E.css(n, "marginLeft", !0),
			};
		  }
		},
		offsetParent: function () {
		  return this.map(function () {
			for (
			  var e = this.offsetParent;
			  e && "static" === E.css(e, "position");
  
			)
			  e = e.offsetParent;
			return e || ne;
		  });
		},
	  }),
	  E.each(
		{ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
		function (t, s) {
		  var r = "pageYOffset" === s;
		  E.fn[t] = function (e) {
			return R(
			  this,
			  function (e, t, i) {
				var n;
				if (
				  (v(e) ? (n = e) : 9 === e.nodeType && (n = e.defaultView),
				  void 0 === i)
				)
				  return n ? n[s] : e[t];
				n
				  ? n.scrollTo(r ? n.pageXOffset : i, r ? i : n.pageYOffset)
				  : (e[t] = i);
			  },
			  t,
			  e,
			  arguments.length
			);
		  };
		}
	  ),
	  E.each(["top", "left"], function (e, i) {
		E.cssHooks[i] = Ue(y.pixelPosition, function (e, t) {
		  if (t)
			return (t = Ge(e, i)), _e.test(t) ? E(e).position()[i] + "px" : t;
		});
	  }),
	  E.each({ Height: "height", Width: "width" }, function (a, o) {
		E.each(
		  { padding: "inner" + a, content: o, "": "outer" + a },
		  function (n, r) {
			E.fn[r] = function (e, t) {
			  var i = arguments.length && (n || "boolean" != typeof e),
				s = n || (!0 === e || !0 === t ? "margin" : "border");
			  return R(
				this,
				function (e, t, i) {
				  var n;
				  return v(e)
					? 0 === r.indexOf("outer")
					  ? e["inner" + a]
					  : e.document.documentElement["client" + a]
					: 9 === e.nodeType
					? ((n = e.documentElement),
					  Math.max(
						e.body["scroll" + a],
						n["scroll" + a],
						e.body["offset" + a],
						n["offset" + a],
						n["client" + a]
					  ))
					: void 0 === i
					? E.css(e, t, s)
					: E.style(e, t, i, s);
				},
				o,
				i ? e : void 0,
				i
			  );
			};
		  }
		);
	  }),
	  E.each(
		[
		  "ajaxStart",
		  "ajaxStop",
		  "ajaxComplete",
		  "ajaxError",
		  "ajaxSuccess",
		  "ajaxSend",
		],
		function (e, t) {
		  E.fn[t] = function (e) {
			return this.on(t, e);
		  };
		}
	  ),
	  E.fn.extend({
		bind: function (e, t, i) {
		  return this.on(e, null, t, i);
		},
		unbind: function (e, t) {
		  return this.off(e, null, t);
		},
		delegate: function (e, t, i, n) {
		  return this.on(t, e, i, n);
		},
		undelegate: function (e, t, i) {
		  return 1 === arguments.length
			? this.off(e, "**")
			: this.off(t, e || "**", i);
		},
		hover: function (e, t) {
		  return this.mouseenter(e).mouseleave(t || e);
		},
	  }),
	  E.each(
		"blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
		  " "
		),
		function (e, i) {
		  E.fn[i] = function (e, t) {
			return 0 < arguments.length
			  ? this.on(i, null, e, t)
			  : this.trigger(i);
		  };
		}
	  );
	var si = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	(E.proxy = function (e, t) {
	  var i, n, s;
	  if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), b(e)))
		return (
		  (n = o.call(arguments, 2)),
		  ((s = function () {
			return e.apply(t || this, n.concat(o.call(arguments)));
		  }).guid = e.guid =
			e.guid || E.guid++),
		  s
		);
	}),
	  (E.holdReady = function (e) {
		e ? E.readyWait++ : E.ready(!0);
	  }),
	  (E.isArray = Array.isArray),
	  (E.parseJSON = JSON.parse),
	  (E.nodeName = Y),
	  (E.isFunction = b),
	  (E.isWindow = v),
	  (E.camelCase = _),
	  (E.type = x),
	  (E.now = Date.now),
	  (E.isNumeric = function (e) {
		var t = E.type(e);
		return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
	  }),
	  (E.trim = function (e) {
		return null == e ? "" : (e + "").replace(si, "");
	  }),
	  "function" == typeof define &&
		define.amd &&
		define("jquery", [], function () {
		  return E;
		});
	var ri = S.jQuery,
	  ai = S.$;
	return (
	  (E.noConflict = function (e) {
		return S.$ === E && (S.$ = ai), e && S.jQuery === E && (S.jQuery = ri), E;
	  }),
	  void 0 === e && (S.jQuery = S.$ = E),
	  E
	);
  }),
	(theme.jQuery = $),
	(function ($) {
	  var $ = (jQuery = $),
		define = null,
		BM,
		DM,
		BQ,
		CQ,
		qU,
		rU,
		EU,
		FU,
		xV,
		yV,
		lX,
		mX,
		dY,
		eY,
		fY,
		vY,
		wY,
		xY,
		yY,
		zY,
		AY,
		BY,
		CY,
		DY,
		EY,
		FY,
		GY,
		HY,
		IY,
		JY,
		KY,
		LY,
		MY,
		NY,
		OY,
		PY,
		QY,
		RY,
		SY,
		TY,
		UY,
		VY,
		WY,
		XY,
		YY,
		ZY,
		$Y,
		_Y,
		z$,
		A$,
		B$,
		C$,
		aZ,
		bZ,
		cZ,
		dZ,
		eZ,
		fZ,
		gZ,
		hZ,
		iZ,
		jZ,
		kZ,
		lZ,
		mZ,
		nZ,
		oZ,
		j_,
		k_,
		wxa,
		Uxa,
		Vxa,
		Txa,
		Wxa;
	  function DQ() {
		CQ(BQ.lazySizes), BQ.removeEventListener("lazyunveilread", DQ, !0);
	  }
	  function sU() {
		rU(qU.lazySizes), qU.removeEventListener("lazyunveilread", sU, !0);
	  }
	  function GU() {
		FU(EU.lazySizes), EU.removeEventListener("lazyunveilread", GU, !0);
	  }
	  function zV() {
		yV(xV.lazySizes), xV.removeEventListener("lazyunveilread", zV, !0);
	  }
	  function nX() {
		mX(lX.lazySizes), lX.removeEventListener("lazyunveilread", nX, !0);
	  }
	  function gY(e, t, i) {
		var n = eY.createElement(e);
		return t && (n.id = cZ + t), i && (n.style.cssText = i), dY(n);
	  }
	  function hY() {
		return fY.innerHeight ? fY.innerHeight : dY(fY).height();
	  }
	  function iY(e, i) {
		i !== Object(i) && (i = {}),
		  (this.cache = {}),
		  (this.el = e),
		  (this.value = function (e) {
			var t;
			return (
			  void 0 === this.cache[e] &&
				(void 0 !== (t = dY(this.el).attr("data-cbox-" + e))
				  ? (this.cache[e] = t)
				  : void 0 !== i[e]
				  ? (this.cache[e] = i[e])
				  : void 0 !== aZ[e] && (this.cache[e] = aZ[e])),
			  this.cache[e]
			);
		  }),
		  (this.get = function (e) {
			var t = this.value(e);
			return dY.isFunction(t) ? t.call(this.el, this) : t;
		  });
	  }
	  function jY(e) {
		var t = DY.length,
		  i = (UY + e) % t;
		return i < 0 ? t + i : i;
	  }
	  function kY(e, t) {
		return Math.round(
		  (/%/.test(e) ? ("x" === t ? EY.width() : hY()) / 100 : 1) *
			parseInt(e, 10)
		);
	  }
	  function lY(e, t) {
		return e.get("photo") || e.get("photoRegex").test(t);
	  }
	  function mY(e, t) {
		return e.get("retinaUrl") && 1 < fY.devicePixelRatio
		  ? t.replace(e.get("photoRegex"), e.get("retinaSuffix"))
		  : t;
	  }
	  function nY(e) {
		"contains" in wY[0] &&
		  !wY[0].contains(e.target) &&
		  e.target !== vY[0] &&
		  (e.stopPropagation(), wY.focus());
	  }
	  function oY(e) {
		oY.str !== e &&
		  (wY.add(vY).removeClass(oY.str).addClass(e), (oY.str = e));
	  }
	  function qY(e) {
		dY(eY).trigger(e), kZ.triggerHandler(e);
	  }
	  function rY(e) {
		var t, i;
		if (!YY) {
		  if (
			((t = dY(e).data(bZ)),
			(PY = new iY(e, t)),
			(i = PY.get("rel")),
			(UY = 0),
			i && !1 !== i && "nofollow" !== i
			  ? ((DY = dY("." + dZ).filter(function () {
				  return new iY(this, dY.data(this, bZ)).get("rel") === i;
				})),
				-1 === (UY = DY.index(PY.el)) &&
				  ((DY = DY.add(PY.el)), (UY = DY.length - 1)))
			  : (DY = dY(PY.el)),
			!WY)
		  ) {
			(WY = XY = !0),
			  oY(PY.get("className")),
			  wY.css({ visibility: "hidden", display: "block", opacity: "" }),
			  (FY = gY(
				lZ,
				"LoadedContent",
				"width:0; height:0; overflow:hidden; visibility:hidden"
			  )),
			  yY.css({ width: "", height: "" }).append(FY),
			  (QY = zY.height() + CY.height() + yY.outerHeight(!0) - yY.height()),
			  (RY = AY.width() + BY.width() + yY.outerWidth(!0) - yY.width()),
			  (SY = FY.outerHeight(!0)),
			  (TY = FY.outerWidth(!0));
			var n = kY(PY.get("initialWidth"), "x"),
			  s = kY(PY.get("initialHeight"), "y"),
			  r = PY.get("maxWidth"),
			  a = PY.get("maxHeight");
			(PY.w = Math.max(
			  (!1 !== r ? Math.min(n, kY(r, "x")) : n) - TY - RY,
			  0
			)),
			  (PY.h = Math.max(
				(!1 !== a ? Math.min(s, kY(a, "y")) : s) - SY - QY,
				0
			  )),
			  FY.css({ width: "", height: PY.h }),
			  $Y.position(),
			  qY(eZ),
			  PY.get("onOpen"),
			  OY.add(IY).hide(),
			  wY.focus(),
			  PY.get("trapFocus") &&
				eY.addEventListener &&
				(eY.addEventListener("focus", nY, !0),
				kZ.one(iZ, function () {
				  eY.removeEventListener("focus", nY, !0);
				})),
			  PY.get("returnFocus") &&
				kZ.one(iZ, function () {
				  dY(PY.el).focus();
				});
		  }
		  var o = parseFloat(PY.get("opacity"));
		  vY
			.css({
			  opacity: o == o ? o : "",
			  cursor: PY.get("overlayClose") ? "pointer" : "",
			  visibility: "visible",
			})
			.show(),
			PY.get("closeButton")
			  ? NY.html(PY.get("close")).appendTo(yY)
			  : NY.appendTo("<div/>"),
			(function () {
			  var e,
				t,
				i,
				n = $Y.prep,
				s = ++mZ;
			  if (
				((VY = !(XY = !0)),
				qY(jZ),
				qY(fZ),
				PY.get("onLoad"),
				(PY.h = PY.get("height")
				  ? kY(PY.get("height"), "y") - SY - QY
				  : PY.get("innerHeight") && kY(PY.get("innerHeight"), "y")),
				(PY.w = PY.get("width")
				  ? kY(PY.get("width"), "x") - TY - RY
				  : PY.get("innerWidth") && kY(PY.get("innerWidth"), "x")),
				(PY.mw = PY.w),
				(PY.mh = PY.h),
				PY.get("maxWidth") &&
				  ((PY.mw = kY(PY.get("maxWidth"), "x") - TY - RY),
				  (PY.mw = PY.w && PY.w < PY.mw ? PY.w : PY.mw)),
				PY.get("maxHeight") &&
				  ((PY.mh = kY(PY.get("maxHeight"), "y") - SY - QY),
				  (PY.mh = PY.h && PY.h < PY.mh ? PY.h : PY.mh)),
				(e = PY.get("href")),
				(ZY = setTimeout(function () {
				  HY.show();
				}, 100)),
				PY.get("inline"))
			  ) {
				var r = dY(e).eq(0);
				(i = dY("<div>").hide().insertBefore(r)),
				  kZ.one(jZ, function () {
					i.replaceWith(r);
				  }),
				  n(r);
			  } else
				PY.get("iframe")
				  ? n(" ")
				  : PY.get("html")
				  ? n(PY.get("html"))
				  : lY(PY, e)
				  ? ((e = mY(PY, e)),
					(VY = PY.get("createImg")),
					dY(VY)
					  .addClass(cZ + "Photo")
					  .bind("error." + cZ, function () {
						n(gY(lZ, "Error").html(PY.get("imgError")));
					  })
					  .one("load", function () {
						s === mZ &&
						  setTimeout(function () {
							var e;
							PY.get("retinaImage") &&
							  1 < fY.devicePixelRatio &&
							  ((VY.height = VY.height / fY.devicePixelRatio),
							  (VY.width = VY.width / fY.devicePixelRatio)),
							  PY.get("scalePhotos") &&
								((t = function () {
								  (VY.height -= VY.height * e),
									(VY.width -= VY.width * e);
								}),
								PY.mw &&
								  VY.width > PY.mw &&
								  ((e = (VY.width - PY.mw) / VY.width), t()),
								PY.mh &&
								  VY.height > PY.mh &&
								  ((e = (VY.height - PY.mh) / VY.height), t())),
							  PY.h &&
								(VY.style.marginTop =
								  Math.max(PY.mh - VY.height, 0) / 2 + "px"),
							  DY[1] &&
								(PY.get("loop") || DY[UY + 1]) &&
								((VY.style.cursor = "pointer"),
								dY(VY).bind("click." + cZ, function () {
								  $Y.next();
								})),
							  (VY.style.width = VY.width + "px"),
							  (VY.style.height = VY.height + "px"),
							  n(VY);
						  }, 1);
					  }),
					(VY.src = e))
				  : e &&
					GY.load(e, PY.get("data"), function (e, t) {
					  s === mZ &&
						n(
						  "error" === t
							? gY(lZ, "Error").html(PY.get("xhrError"))
							: dY(this).contents()
						);
					});
			})();
		}
	  }
	  function sY() {
		wY ||
		  ((_Y = !1),
		  (EY = dY(fY)),
		  (wY = gY(lZ)
			.attr({
			  id: bZ,
			  class: !1 === dY.support.opacity ? cZ + "IE" : "",
			  role: "dialog",
			  tabindex: "-1",
			})
			.hide()),
		  (vY = gY(lZ, "Overlay").hide()),
		  (HY = dY([gY(lZ, "LoadingOverlay")[0], gY(lZ, "LoadingGraphic")[0]])),
		  (xY = gY(lZ, "Wrapper")),
		  (yY = gY(lZ, "Content").append(
			(IY = gY(lZ, "Title")),
			(JY = gY(lZ, "Current")),
			(MY = dY(
			  '<button type="button" aria-label="' +
				theme.strings.previous +
				'"/>'
			).attr({ id: cZ + "Previous" })),
			(LY = dY(
			  '<button type="button" aria-label="' + theme.strings.next + '"/>'
			).attr({ id: cZ + "Next" })),
			(KY = dY(
			  '<button type="button" aria-label="' +
				theme.strings.slideshow +
				'"/>'
			).attr({ id: cZ + "Slideshow" })),
			HY
		  )),
		  (NY = dY(
			'<button type="button" aria-label="' + theme.strings.close + '"/>'
		  ).attr({ id: cZ + "Close" })),
		  xY
			.append(
			  gY(lZ).append(
				gY(lZ, "TopLeft"),
				(zY = gY(lZ, "TopCenter")),
				gY(lZ, "TopRight")
			  ),
			  gY(lZ, !1, "clear:left").append(
				(AY = gY(lZ, "MiddleLeft")),
				yY,
				(BY = gY(lZ, "MiddleRight"))
			  ),
			  gY(lZ, !1, "clear:left").append(
				gY(lZ, "BottomLeft"),
				(CY = gY(lZ, "BottomCenter")),
				gY(lZ, "BottomRight")
			  )
			)
			.find("div div")
			.css({ float: "left" }),
		  (GY = gY(
			lZ,
			!1,
			"position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;"
		  )),
		  (OY = LY.add(MY).add(JY).add(KY))),
		  eY.body &&
			!wY.parent().length &&
			dY(eY.body).append(vY, wY.append(xY, GY));
	  }
	  function u$() {
		clearTimeout(A$);
	  }
	  function v$() {
		(PY.get("loop") || DY[UY + 1]) &&
		  (u$(), (A$ = setTimeout($Y.next, PY.get("slideshowSpeed"))));
	  }
	  function w$() {
		KY.html(PY.get("slideshowStop")).unbind(C$).one(C$, x$),
		  kZ.bind(gZ, v$).bind(fZ, u$),
		  wY.removeClass(B$ + "off").addClass(B$ + "on");
	  }
	  function x$() {
		u$(),
		  kZ.unbind(gZ, v$).unbind(fZ, u$),
		  KY.html(PY.get("slideshowStart"))
			.unbind(C$)
			.one(C$, function () {
			  $Y.next(), w$();
			}),
		  wY.removeClass(B$ + "on").addClass(B$ + "off");
	  }
	  function y$() {
		(z$ = !1),
		  KY.hide(),
		  u$(),
		  kZ.unbind(gZ, v$).unbind(fZ, u$),
		  wY.removeClass(B$ + "off " + B$ + "on");
	  }
	  (BM = window),
		(DM = (function (l, I) {
		  "use strict";
		  if (I.getElementsByClassName) {
			var H,
			  j,
			  q = I.documentElement,
			  d = l.Date,
			  s = l.HTMLPictureElement,
			  c = "addEventListener",
			  B = "getAttribute",
			  R = l[c],
			  W = l.setTimeout,
			  u = l.requestAnimationFrame || W,
			  h = l.requestIdleCallback,
			  F = /^picture$/i,
			  r = ["load", "error", "lazyincluded", "_lazyloaded"],
			  n = {},
			  X = Array.prototype.forEach,
			  _ = function e(t, i) {
				return (
				  n[i] || (n[i] = new RegExp("(\\s|^)" + i + "(\\s|$)")),
				  n[i].test(t[B]("class") || "") && n[i]
				);
			  },
			  V = function e(t, i) {
				_(t, i) ||
				  t.setAttribute("class", (t[B]("class") || "").trim() + " " + i);
			  },
			  Z = function e(t, i) {
				var n;
				(n = _(t, i)) &&
				  t.setAttribute("class", (t[B]("class") || "").replace(n, " "));
			  },
			  G = function e(t, i, n) {
				var s = n ? c : "removeEventListener";
				n && e(t, i),
				  r.forEach(function (e) {
					t[s](e, i);
				  });
			  },
			  U = function e(t, i, n, s, r) {
				var a = I.createEvent("CustomEvent");
				return (
				  n || (n = {}),
				  (n.instance = H),
				  a.initCustomEvent(i, !s, !r, n),
				  t.dispatchEvent(a),
				  a
				);
			  },
			  Q = function e(t, i) {
				var n;
				!s && (n = l.picturefill || j.pf)
				  ? n({ reevaluate: !0, elements: [t] })
				  : i && i.src && (t.src = i.src);
			  },
			  K = function e(t, i) {
				return (getComputedStyle(t, null) || {})[i];
			  },
			  a = function e(t, i, n) {
				for (
				  n = n || t.offsetWidth;
				  n < j.minSize && i && !t._lazysizesWidth;
  
				) {
				  (n = i.offsetWidth), (i = i.parentNode);
				}
				return n;
			  },
			  J = (function () {
				var n,
				  s,
				  i = [],
				  r = [],
				  a = i,
				  o = function e() {
					var t = a;
					for (a = i.length ? r : i, n = !0, s = !1; t.length; ) {
					  t.shift()();
					}
					n = !1;
				  },
				  e = function e(t, i) {
					n && !i
					  ? t.apply(this, arguments)
					  : (a.push(t), s || ((s = !0), (I.hidden ? W : u)(o)));
				  };
				return (e._lsFlush = o), e;
			  })(),
			  ee = function e(i, t) {
				return t
				  ? function () {
					  J(i);
					}
				  : function () {
					  var e = this,
						t = arguments;
					  J(function () {
						i.apply(e, t);
					  });
					};
			  },
			  e = function e(t) {
				var i,
				  n = 0,
				  s = 125,
				  r = j.ricTimeout,
				  a = function e() {
					(i = !1), (n = d.now()), t();
				  },
				  o =
					h && j.ricTimeout
					  ? function () {
						  h(a, { timeout: r }),
							r !== j.ricTimeout && (r = j.ricTimeout);
						}
					  : ee(function () {
						  W(a);
						}, !0);
				return function (e) {
				  var t;
				  (e = e === !0) && (r = 33),
					i ||
					  ((i = !0),
					  (t = s - (d.now() - n)),
					  0 > t && (t = 0),
					  e || (9 > t && h) ? o() : W(o, t));
				};
			  },
			  te = function e(t) {
				var i,
				  n,
				  s = 99,
				  r = function e() {
					(i = null), t();
				  },
				  a = function e() {
					var t = d.now() - n;
					s > t ? W(e, s - t) : (h || r)(r);
				  };
				return function () {
				  (n = d.now()), i || (i = W(a, s));
				};
			  };
			!(function () {
			  var e,
				t = {
				  lazyClass: "lazyload",
				  loadedClass: "lazyloaded",
				  loadingClass: "lazyloading",
				  preloadClass: "lazypreload",
				  errorClass: "lazyerror",
				  autosizesClass: "lazyautosizes",
				  srcAttr: "data-src",
				  srcsetAttr: "data-srcset",
				  sizesAttr: "data-sizes",
				  minSize: 40,
				  customMedia: {},
				  init: !0,
				  expFactor: 1.5,
				  hFac: 0.8,
				  loadMode: 2,
				  loadHidden: !0,
				  ricTimeout: 300,
				};
			  j = l.lazySizesConfig || l.lazysizesConfig || {};
			  for (e in t) {
				e in j || (j[e] = t[e]);
			  }
			  (l.lazySizesConfig = j),
				W(function () {
				  j.init && i();
				});
			})();
			var t = (function () {
				var u,
				  h,
				  p,
				  f,
				  i,
				  v,
				  g,
				  m,
				  y,
				  b,
				  w,
				  x,
				  T,
				  S,
				  a = /^img$/i,
				  C = /^iframe$/i,
				  E = "onscroll" in l && !/glebot/.test(navigator.userAgent),
				  k = 0,
				  Y = 0,
				  z = 0,
				  $ = -1,
				  P = function e(t) {
					z--,
					  t && t.target && G(t.target, e),
					  (!t || 0 > z || !t.target) && (z = 0);
				  },
				  A = function e(t, i) {
					var n,
					  s = t,
					  r =
						"hidden" == K(I.body, "visibility") ||
						"hidden" != K(t, "visibility");
					for (
					  m -= i, w += i, y -= i, b += i;
					  r && (s = s.offsetParent) && s != I.body && s != q;
  
					) {
					  (r = (K(s, "opacity") || 1) > 0),
						r &&
						  "visible" != K(s, "overflow") &&
						  ((n = s.getBoundingClientRect()),
						  (r =
							b > n.left &&
							y < n.right &&
							w > n.top - 1 &&
							m < n.bottom + 1));
					}
					return r;
				  },
				  t = function e() {
					var t,
					  i,
					  n,
					  s,
					  r,
					  a,
					  o,
					  l,
					  d,
					  c = H.elements;
					if ((f = j.loadMode) && 8 > z && (t = c.length)) {
					  (i = 0),
						$++,
						null == T &&
						  ("expand" in j ||
							(j.expand =
							  q.clientHeight > 500 && q.clientWidth > 500
								? 500
								: 370),
						  (x = j.expand),
						  (T = x * j.expFactor)),
						T > Y && 1 > z && $ > 2 && f > 2 && !I.hidden
						  ? ((Y = T), ($ = 0))
						  : (Y = f > 1 && $ > 1 && 6 > z ? x : k);
					  for (; t > i; i++) {
						if (c[i] && !c[i]._lazyRace)
						  if (E) {
							if (
							  (((l = c[i][B]("data-expand")) && (a = 1 * l)) ||
								(a = Y),
							  d !== a &&
								((v = innerWidth + a * S),
								(g = innerHeight + a),
								(o = -1 * a),
								(d = a)),
							  (n = c[i].getBoundingClientRect()),
							  (w = n.bottom) >= o &&
								(m = n.top) <= g &&
								(b = n.right) >= o * S &&
								(y = n.left) <= v &&
								(w || b || y || m) &&
								(j.loadHidden ||
								  "hidden" != K(c[i], "visibility")) &&
								((h && 3 > z && !l && (3 > f || 4 > $)) ||
								  A(c[i], a)))
							) {
							  if ((N(c[i]), (r = !0), z > 9)) break;
							} else
							  !r &&
								h &&
								!s &&
								4 > z &&
								4 > $ &&
								f > 2 &&
								(u[0] || j.preloadAfterLoad) &&
								(u[0] ||
								  (!l &&
									(w ||
									  b ||
									  y ||
									  m ||
									  "auto" != c[i][B](j.sizesAttr)))) &&
								(s = u[0] || c[i]);
						  } else N(c[i]);
					  }
					  s && !r && N(s);
					}
				  },
				  n = e(t),
				  M = function e(t) {
					V(t.target, j.loadedClass),
					  Z(t.target, j.loadingClass),
					  G(t.target, L),
					  U(t.target, "lazyloaded");
				  },
				  s = ee(M),
				  L = function e(t) {
					s({ target: t.target });
				  },
				  D = function e(t, i) {
					try {
					  t.contentWindow.location.replace(i);
					} catch (e) {
					  t.src = i;
					}
				  },
				  O = function e(t) {
					var i,
					  n = t[B](j.srcsetAttr);
					(i = j.customMedia[t[B]("data-media") || t[B]("media")]) &&
					  t.setAttribute("media", i),
					  n && t.setAttribute("srcset", n);
				  },
				  o = ee(function (e, t, i, n, s) {
					var r, a, o, l, d, c;
					(d = U(e, "lazybeforeunveil", t)).defaultPrevented ||
					  (n &&
						(i ? V(e, j.autosizesClass) : e.setAttribute("sizes", n)),
					  (a = e[B](j.srcsetAttr)),
					  (r = e[B](j.srcAttr)),
					  s &&
						((o = e.parentNode), (l = o && F.test(o.nodeName || ""))),
					  (c = t.firesLoad || ("src" in e && (a || r || l))),
					  (d = { target: e }),
					  c &&
						(G(e, P, !0),
						clearTimeout(p),
						(p = W(P, 2500)),
						V(e, j.loadingClass),
						G(e, L, !0)),
					  l && X.call(o.getElementsByTagName("source"), O),
					  a
						? e.setAttribute("srcset", a)
						: r && !l && (C.test(e.nodeName) ? D(e, r) : (e.src = r)),
					  s && (a || l) && Q(e, { src: r })),
					  e._lazyRace && delete e._lazyRace,
					  Z(e, j.lazyClass),
					  J(function () {
						(!c || (e.complete && e.naturalWidth > 1)) &&
						  (c ? P(d) : z--, M(d));
					  }, !0);
				  }),
				  N = function e(t) {
					var i,
					  n = a.test(t.nodeName),
					  s = n && (t[B](j.sizesAttr) || t[B]("sizes")),
					  r = "auto" == s;
					((!r && h) ||
					  !n ||
					  (!t[B]("src") && !t.srcset) ||
					  t.complete ||
					  _(t, j.errorClass) ||
					  !_(t, j.lazyClass)) &&
					  ((i = U(t, "lazyunveilread").detail),
					  r && ie.updateElem(t, !0, t.offsetWidth),
					  (t._lazyRace = !0),
					  z++,
					  o(t, i, r, s, n));
				  },
				  r = function e() {
					if (!h) {
					  if (d.now() - i < 999) return void W(e, 999);
					  var t = te(function () {
						(j.loadMode = 3), n();
					  });
					  (h = !0),
						(j.loadMode = 3),
						n(),
						R(
						  "scroll",
						  function () {
							3 == j.loadMode && (j.loadMode = 2), t();
						  },
						  !0
						);
					}
				  };
				return {
				  _: function e() {
					(i = d.now()),
					  (H.elements = I.getElementsByClassName(j.lazyClass)),
					  (u = I.getElementsByClassName(
						j.lazyClass + " " + j.preloadClass
					  )),
					  (S = j.hFac),
					  R("scroll", n, !0),
					  R("resize", n, !0),
					  l.MutationObserver
						? new MutationObserver(n).observe(q, {
							childList: !0,
							subtree: !0,
							attributes: !0,
						  })
						: (q[c]("DOMNodeInserted", n, !0),
						  q[c]("DOMAttrModified", n, !0),
						  setInterval(n, 999)),
					  R("hashchange", n, !0),
					  [
						"focus",
						"mouseover",
						"click",
						"load",
						"transitionend",
						"animationend",
						"webkitAnimationEnd",
					  ].forEach(function (e) {
						I[c](e, n, !0);
					  }),
					  /d$|^c/.test(I.readyState)
						? r()
						: (R("load", r), I[c]("DOMContentLoaded", n), W(r, 2e4)),
					  H.elements.length ? (t(), J._lsFlush()) : n();
				  },
				  checkElems: n,
				  unveil: N,
				};
			  })(),
			  ie = (function () {
				var n,
				  r = ee(function (e, t, i, n) {
					var s, r, a;
					if (
					  ((e._lazysizesWidth = n),
					  (n += "px"),
					  e.setAttribute("sizes", n),
					  F.test(t.nodeName || ""))
					)
					  for (
						s = t.getElementsByTagName("source"), r = 0, a = s.length;
						a > r;
						r++
					  ) {
						s[r].setAttribute("sizes", n);
					  }
					i.detail.dataAttr || Q(e, i.detail);
				  }),
				  s = function e(t, i, n) {
					var e,
					  s = t.parentNode;
					s &&
					  ((n = a(t, s, n)),
					  (e = U(t, "lazybeforesizes", { width: n, dataAttr: !!i })),
					  e.defaultPrevented ||
						((n = e.detail.width),
						n && n !== t._lazysizesWidth && r(t, s, e, n)));
				  },
				  e = function e() {
					var t,
					  i = n.length;
					if (i)
					  for (t = 0; i > t; t++) {
						s(n[t]);
					  }
				  },
				  t = te(e);
				return {
				  _: function e() {
					(n = I.getElementsByClassName(j.autosizesClass)),
					  R("resize", t);
				  },
				  checkElems: t,
				  updateElem: s,
				};
			  })(),
			  i = function e() {
				e.i || ((e.i = !0), ie._(), t._());
			  };
			return (H = {
			  cfg: j,
			  autoSizer: ie,
			  loader: t,
			  init: i,
			  uP: Q,
			  aC: V,
			  rC: Z,
			  hC: _,
			  fire: U,
			  gW: a,
			  rAF: J,
			});
		  }
		})(BM, BM.document)),
		(BM.lazySizes = DM),
		"object" ==
		  ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
		  module.exports &&
		  (module.exports = DM),
		(BQ = window),
		(CQ = function (u, d, f) {
		  "use strict";
		  function v(e, t, i) {
			var n,
			  s,
			  r,
			  a = 0,
			  o = 0,
			  l = i;
			if (e) {
			  if ("container" === t.ratio) {
				for (
				  a = l.scrollWidth, o = l.scrollHeight;
				  !((a && o) || l === d);
  
				)
				  (a = (l = l.parentNode).scrollWidth), (o = l.scrollHeight);
				a && o && (t.ratio = o / a);
			  }
			  (n = e),
				(s = t),
				((r = []).srcset = []),
				s.absUrl && (S.setAttribute("href", n), (n = S.href)),
				(n = ((s.prefix || "") + n + (s.postfix || "")).replace(
				  p,
				  function (e, t) {
					return c[_typeof(s[t])] ? s[t] : e;
				  }
				)),
				s.widths.forEach(function (e) {
				  var t = s.widthmap[e] || e,
					i = {
					  u: n
						.replace(w, t)
						.replace(h, s.ratio ? Math.round(e * s.ratio) : ""),
					  w: e,
					};
				  r.push(i), r.srcset.push((i.c = i.u + " " + e + "w"));
				}),
				((e = r).isPicture = t.isPicture),
				C && "IMG" == i.nodeName.toUpperCase()
				  ? i.removeAttribute(y.srcsetAttr)
				  : i.setAttribute(y.srcsetAttr, e.srcset.join(", ")),
				Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
			}
		  }
		  function g(e, t) {
			var i = (function (s, e) {
			  var t,
				i,
				n,
				r,
				a = u.getComputedStyle(s);
			  for (t in ((i = s.parentNode),
			  (r = { isPicture: !(!i || !l.test(i.nodeName || "")) }),
			  (n = function (e, t) {
				var i = s.getAttribute("data-" + e);
				if (!i) {
				  var n = a.getPropertyValue("--ls-" + e);
				  n && (i = n.trim());
				}
				if (i) {
				  if ("true" == i) i = !0;
				  else if ("false" == i) i = !1;
				  else if (o.test(i)) i = parseFloat(i);
				  else if ("function" == typeof b[e]) i = b[e](s, i);
				  else if (x.test(i))
					try {
					  i = JSON.parse(i);
					} catch (e) {}
				  r[e] = i;
				} else
				  e in b && "function" != typeof b[e]
					? (r[e] = b[e])
					: t && "function" == typeof b[e] && (r[e] = b[e](s, i));
			  }),
			  b))
				n(t);
			  return (
				e.replace(p, function (e, t) {
				  t in r || n(t, !0);
				}),
				r
			  );
			})(e, t);
			return (
			  b.modifyOptions.call(e, { target: e, details: i, detail: i }),
			  f.fire(e, "lazyriasmodifyoptions", i),
			  i
			);
		  }
		  function m(e) {
			return (
			  e.getAttribute(e.getAttribute("data-srcattr") || b.srcAttr) ||
			  e.getAttribute(y.srcsetAttr) ||
			  e.getAttribute(y.srcAttr) ||
			  e.getAttribute("data-pfsrcset") ||
			  ""
			);
		  }
		  var y,
			b,
			c = { string: 1, number: 1 },
			o = /^\-*\+*\d+\.*\d*$/,
			l = /^picture$/i,
			w = /\s*\{\s*width\s*\}\s*/i,
			h = /\s*\{\s*height\s*\}\s*/i,
			p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
			x = /^\[.*\]|\{.*\}$/,
			T = /^(?:auto|\d+(px)?)$/,
			S = d.createElement("a"),
			e = d.createElement("img"),
			C = "srcset" in e && !("sizes" in e),
			E = !!u.HTMLPictureElement && !C;
		  !(function () {
			var e,
			  t = {
				prefix: "",
				postfix: "",
				srcAttr: "data-src",
				absUrl: !1,
				modifyOptions: function () {},
				widthmap: {},
				ratio: !1,
			  };
			for (e in ((y = (f && f.cfg) || u.lazySizesConfig) ||
			  ((y = {}), (u.lazySizesConfig = y)),
			y.supportsType ||
			  (y.supportsType = function (e) {
				return !e;
			  }),
			y.rias || (y.rias = {}),
			"widths" in (b = y.rias) ||
			  ((b.widths = []),
			  (function (e) {
				for (var t, i = 0; !t || t < 3e3; )
				  30 < (i += 5) && (i += 1), (t = 36 * i), e.push(t);
			  })(b.widths)),
			t))
			  e in b || (b[e] = t[e]);
		  })(),
			addEventListener(
			  "lazybeforesizes",
			  function (e) {
				var t, i, n, s, r, a, o, l, d, c, u, h, p;
				if (
				  e.detail.instance == f &&
				  ((t = e.target),
				  e.detail.dataAttr &&
					!e.defaultPrevented &&
					!b.disabled &&
					(d =
					  t.getAttribute(y.sizesAttr) || t.getAttribute("sizes")) &&
					T.test(d))
				) {
				  if (
					((n = g(t, (i = m(t)))),
					(u = w.test(n.prefix) || w.test(n.postfix)),
					n.isPicture && (s = t.parentNode))
				  )
					for (
					  a = 0, o = (r = s.getElementsByTagName("source")).length;
					  a < o;
					  a++
					)
					  (u || w.test((l = m(r[a])))) && (v(l, n, r[a]), (h = !0));
				  u || w.test(i)
					? (v(i, n, t), (h = !0))
					: h &&
					  (((p = []).srcset = []),
					  (p.isPicture = !0),
					  Object.defineProperty(t, "_lazyrias", {
						value: p,
						writable: !0,
					  })),
					h &&
					  (E
						? t.removeAttribute(y.srcAttr)
						: "auto" != d &&
						  ((c = { width: parseInt(d, 10) }),
						  k({ target: t, detail: c })));
				}
			  },
			  !0
			);
		  var n,
			k =
			  ((n = function (e) {
				if (e.detail.instance == f) {
				  var t,
					i = e.target;
				  return !C &&
					(u.respimage || u.picturefill || lazySizesConfig.pf)
					? void d.removeEventListener("lazybeforesizes", n)
					: void (
						("_lazyrias" in i || (e.detail.dataAttr && z(i, !0))) &&
						(t = s(i, e.detail.width)) &&
						t.u &&
						i._lazyrias.cur != t.u &&
						((i._lazyrias.cur = t.u),
						(t.cached = !0),
						f.rAF(function () {
						  i.setAttribute(y.srcAttr, t.u),
							i.setAttribute("src", t.u);
						}))
					  );
				}
			  }),
			  E ? (n = function () {}) : addEventListener("lazybeforesizes", n),
			  n);
		  function Y(e, t) {
			return e.w - t.w;
		  }
		  function z(e, t) {
			var i;
			return (
			  !e._lazyrias &&
				f.pWS &&
				(i = f.pWS(e.getAttribute(y.srcsetAttr || ""))).length &&
				(Object.defineProperty(e, "_lazyrias", {
				  value: i,
				  writable: !0,
				}),
				t &&
				  e.parentNode &&
				  (i.isPicture =
					"PICTURE" == e.parentNode.nodeName.toUpperCase())),
			  e._lazyrias
			);
		  }
		  function s(e, t) {
			var i, n, s, r, a, o, l, d, c;
			if ((a = e._lazyrias).isPicture && u.matchMedia)
			  for (
				n = 0,
				  i = e.parentNode.getElementsByTagName("source"),
				  s = i.length;
				n < s;
				n++
			  )
				if (
				  z(i[n]) &&
				  !i[n].getAttribute("type") &&
				  (!(r = i[n].getAttribute("media")) ||
					(matchMedia(r) || {}).matches)
				) {
				  a = i[n]._lazyrias;
				  break;
				}
			return (
			  (!a.w || a.w < t) &&
				((a.w = t),
				(a.d =
				  ((l = e),
				  (d = u.devicePixelRatio || 1),
				  (c = f.getX && f.getX(l)),
				  Math.min(c || d, 2.4, d))),
				(o = (function (e) {
				  for (var t, i, n = e.length, s = e[n - 1], r = 0; r < n; r++)
					if (((s = e[r]), (s.d = s.w / e.w), s.d >= e.d)) {
					  !s.cached &&
						(t = e[r - 1]) &&
						t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
						((i = Math.pow(t.d - 0.6, 1.6)),
						t.cached && (t.d += 0.15 * i),
						t.d + (s.d - e.d) * i > e.d && (s = t));
					  break;
					}
				  return s;
				})(a.sort(Y)))),
			  o
			);
		  }
		}),
		(CQ = CQ.bind(null, BQ, BQ.document)),
		"object" ==
		  ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
		module.exports
		  ? CQ(require("lazysizes"))
		  : BQ.lazySizes
		  ? DQ()
		  : BQ.addEventListener("lazyunveilread", DQ, !0),
		(function (t, e) {
		  "use strict";
		  if (t.addEventListener) {
			var l,
			  a = /^picture$/i,
			  i = e.documentElement,
			  s =
				((g = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g),
				function (e) {
				  return (v = []), e.replace(g, f), v;
				}),
			  d = function (e, t) {
				var i, n, s, r;
				if (
				  !e[t] &&
				  ((r = e.parentNode || {}),
				  (e[t] = p(e, t)),
				  (e[t].isImg = !0),
				  a.test(r.nodeName || ""))
				)
				  for (
					e[t].picture = !0,
					  n = 0,
					  s = (i = r.getElementsByTagName("source")).length;
					n < s;
					n++
				  )
					p(i[n], t).isImg = !1;
				return e[t];
			  },
			  o = {
				_lazyOptimumx: function (e, t, i) {
				  var n, s, r, a, o, l, d;
				  for (n = 0; n < e.cands.length; n++)
					if (
					  (((s = e.cands[n]).d = (s.w || 1) / t), !(e.index >= n))
					) {
					  if (
						!(s.d <= i) &&
						((r = e.cands[n - 1]),
						(a = s.d),
						(o = i),
						(d = l = void 0),
						r &&
						  r.d &&
						  ((d = 0.7 < o ? 0.6 : 0.4),
						  r.d >= o ||
							((l = Math.pow(r.d - d, 1.6) || 0.1) < 0.1
							  ? (l = 0.1)
							  : 3 < l && (l = 3),
							!(r.d + (a - o) * l < o))))
					  )
						break;
					  e.cSrcset.push(s.c), (e.index = n);
					}
				},
			  },
			  c = function (e, t, i, n, s) {
				var r,
				  a,
				  o,
				  l,
				  d = e[s];
				if (((d.width = t), d.picture && (a = e.parentNode)))
				  for (
					l = 0, o = (r = a.getElementsByTagName("source")).length;
					l < o;
					l++
				  )
					h(r[l], t, i, n, s);
				h(e, t, i, n, s);
			  },
			  u = function (e) {
				var t =
				  e.getAttribute("data-optimumx") ||
				  e.getAttribute("data-maxdpr");
				return (
				  !t && l.constrainPixelDensity && (t = "auto"),
				  (t = t && ("auto" == t ? l.getOptimumX(e) : parseFloat(t, 10)))
				);
			  },
			  n = function e() {
				t.lazySizes &&
				  !t.lazySizes.getOptimumX &&
				  ((lazySizes.getX = u),
				  (lazySizes.pWS = s),
				  i.removeEventListener("lazybeforeunveil", e));
			  };
			i.addEventListener("lazybeforeunveil", n),
			  setTimeout(n),
			  (l = (t.lazySizes && lazySizes.cfg) || t.lazySizesConfig) ||
				((l = {}), (t.lazySizesConfig = l)),
			  "function" != typeof l.getOptimumX &&
				(l.getOptimumX = function () {
				  var e = t.devicePixelRatio || 1;
				  return (
					2.6 < e ? (e *= 0.6) : 1.9 < e ? (e *= 0.8) : (e -= 0.01),
					Math.min(Math.round(100 * e) / 100, 2)
				  );
				}),
			  t.devicePixelRatio &&
				addEventListener("lazybeforesizes", function (e) {
				  var t,
					i,
					n,
					s,
					r = e.target,
					a = e.detail,
					o = a.dataAttr;
				  e.defaultPrevented ||
					!(t = u(r)) ||
					t >= devicePixelRatio ||
					(!o ||
					  !r._lazyOptimumx ||
					  a.reloaded ||
					  (l.unloadedClass && lazySizes.hC(r, l.unloadedClass)) ||
					  (r._lazyOptimumx = null),
					(i = d(r, "_lazyOptimumx")),
					(n = a.width) &&
					  (i.width || 0) < n &&
					  ((s = o ? lazySizes.cfg.srcsetAttr : "srcset"),
					  lazySizes.rAF(function () {
						c(r, n, t, s, "_lazyOptimumx");
					  })));
				});
		  }
		  function h(e, t, i, n, s) {
			var r,
			  a = e[s];
			a &&
			  ((r = a.index),
			  o[s](a, t, i),
			  (a.dirty && r == a.index) ||
				(a.cSrcset.join(", "),
				e.setAttribute(n, a.cSrcset.join(", ")),
				(a.dirty = !0)));
		  }
		  function r(e, t) {
			return e.w - t.w;
		  }
		  function p(e, t) {
			var i = { srcset: e.getAttribute(lazySizes.cfg.srcsetAttr) || "" },
			  n = s(i.srcset);
			return (
			  Object.defineProperty(e, t, { value: i, writable: !0 }),
			  (i.cands = n),
			  (i.index = 0),
			  (i.dirty = !1),
			  n[0] && n[0].w
				? (n.sort(r), (i.cSrcset = [n[i.index].c]))
				: ((i.cSrcset = i.srcset ? [i.srcset] : []), (i.cands = [])),
			  i
			);
		  }
		  function f(e, t, i, n, s, r, a, o) {
			v.push({ c: t, u: i, w: +("w" == o ? a : n) });
		  }
		  var v, g;
		})(window, document),
		(qU = window),
		(rU = function (e, t, n) {
		  "use strict";
		  var s, r;
		  "srcset" in t.createElement("img") &&
			((s = /^img$/i),
			(r = function (e) {
			  (e.target.style.backgroundSize = ""),
				(e.target.style.backgroundImage = ""),
				e.target.removeEventListener(e.type, r);
			}),
			t.addEventListener(
			  "lazybeforeunveil",
			  function (e) {
				if (e.detail.instance == n) {
				  var t = e.target;
				  if (s.test(t.nodeName)) {
					var i = t.getAttribute("src");
					i &&
					  ((t.style.backgroundSize = "100% 100%"),
					  (t.style.backgroundImage = "url(" + i + ")"),
					  t.removeAttribute("src"),
					  t.addEventListener("load", r));
				  }
				}
			  },
			  !1
			));
		}),
		(rU = rU.bind(null, qU, qU.document)),
		"object" ==
		  ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
		module.exports
		  ? rU(require("lazysizes"))
		  : qU.lazySizes
		  ? sU()
		  : qU.addEventListener("lazyunveilread", sU, !0),
		(EU = window),
		(FU = function (o, e, i) {
		  "use strict";
		  if (o.addEventListener) {
			var l = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
			  a = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
			  d = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
			  c = /^picture$/i,
			  u = {
				getParent: function (e, t) {
				  var i = e,
					n = e.parentNode;
				  return (
					(t && "prev" != t) ||
					  !n ||
					  !c.test(n.nodeName || "") ||
					  (n = n.parentNode),
					"self" != t &&
					  (i =
						"prev" == t
						  ? e.previousElementSibling
						  : (t &&
							  (n.closest || o.jQuery) &&
							  (n.closest
								? n.closest(t)
								: jQuery(n).closest(t)[0])) ||
							n),
					i
				  );
				},
				getFit: function (e) {
				  var t,
					i,
					n = getComputedStyle(e, null) || {},
					s = n.content || n.fontFamily,
					r = {
					  fit:
						e._lazysizesParentFit ||
						e.getAttribute("data-parent-fit"),
					};
				  return (
					!r.fit && s && (t = s.match(a)) && (r.fit = t[1]),
					r.fit
					  ? (!(i =
						  e._lazysizesParentContainer ||
						  e.getAttribute("data-parent-container")) &&
						  s &&
						  (t = s.match(d)) &&
						  (i = t[1]),
						(r.parent = u.getParent(e, i)))
					  : (r.fit = n.objectFit),
					r
				  );
				},
				getImageRatio: function (e) {
				  var t,
					i,
					n,
					s,
					r = e.parentNode,
					a =
					  r && c.test(r.nodeName || "")
						? r.querySelectorAll("source, img")
						: [e];
				  for (t = 0; t < a.length; t++)
					if (
					  ((i =
						(e = a[t]).getAttribute(lazySizesConfig.srcsetAttr) ||
						e.getAttribute("srcset") ||
						e.getAttribute("data-pfsrcset") ||
						e.getAttribute("data-risrcset") ||
						""),
					  (n = e._lsMedia || e.getAttribute("media")),
					  (n =
						lazySizesConfig.customMedia[
						  e.getAttribute("data-media") || n
						] || n),
					  i &&
						(!n || ((o.matchMedia && matchMedia(n)) || {}).matches))
					) {
					  !(s = parseFloat(e.getAttribute("data-aspectratio"))) &&
						i.match(l) &&
						(s =
						  "w" == RegExp.$2
							? RegExp.$1 / RegExp.$3
							: RegExp.$3 / RegExp.$1);
					  break;
					}
				  return s;
				},
				calculateSize: function (e, t) {
				  var i,
					n,
					s,
					r,
					a = this.getFit(e),
					o = a.fit,
					l = a.parent;
				  return "width" == o ||
					(("contain" == o || "cover" == o) &&
					  (s = this.getImageRatio(e)))
					? (l ? (t = l.clientWidth) : (l = e),
					  (r = t),
					  "width" == o
						? (r = t)
						: 40 < (n = l.clientHeight) &&
						  (i = t / n) &&
						  (("cover" == o && i < s) ||
							("contain" == o && s < i)) &&
						  (r = t * (s / i)),
					  r)
					: t;
				},
			  };
			(i.parentFit = u),
			  e.addEventListener("lazybeforesizes", function (e) {
				if (!e.defaultPrevented && e.detail.instance == i) {
				  var t = e.target;
				  e.detail.width = u.calculateSize(t, e.detail.width);
				}
			  });
		  }
		}),
		(FU = FU.bind(null, EU, EU.document)),
		"object" ==
		  ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
		module.exports
		  ? FU(require("lazysizes"))
		  : EU.lazySizes
		  ? GU()
		  : EU.addEventListener("lazyunveilread", GU, !0),
		(xV = window),
		(yV = function (u, r, h) {
		  "use strict";
		  var n,
			a,
			o,
			t,
			s,
			i,
			l,
			p,
			d,
			f,
			v = (h && h.cfg) || u.lazySizesConfig,
			e = r.createElement("img"),
			c = "sizes" in e && "srcset" in e,
			g = /\s+\d+h/g,
			m =
			  ((a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
			  (o = Array.prototype.forEach),
			  function (e) {
				function i(e) {
				  var t,
					i,
					n = e.getAttribute(lazySizesConfig.srcsetAttr);
				  n &&
					(!(i = n.match(a)) ||
					  ((t = "w" == i[2] ? i[1] / i[3] : i[3] / i[1]) &&
						e.setAttribute("data-aspectratio", t)),
					e.setAttribute(lazySizesConfig.srcsetAttr, n.replace(g, "")));
				}
				function t(e) {
				  var t = e.target.parentNode;
				  t &&
					"PICTURE" == t.nodeName &&
					o.call(t.getElementsByTagName("source"), i),
					i(e.target);
				}
				function n() {
				  s.currentSrc && r.removeEventListener("lazybeforeunveil", t);
				}
				var s = r.createElement("img");
				e[1] &&
				  (r.addEventListener("lazybeforeunveil", t),
				  (s.onload = n),
				  (s.onerror = n),
				  (s.srcset = "data:,a 1w 1h"),
				  s.complete && n());
			  });
		  if (
			(v || ((v = {}), (u.lazySizesConfig = v)),
			v.supportsType ||
			  (v.supportsType = function (e) {
				return !e;
			  }),
			!u.picturefill && !v.pf)
		  ) {
			if (u.HTMLPictureElement && c)
			  return (
				r.msElementsFromPoint &&
				  m(navigator.userAgent.match(/Edge\/(\d+)/)),
				void (v.pf = function () {})
			  );
			(v.pf = function (e) {
			  var t, i;
			  if (!u.picturefill)
				for (t = 0, i = e.elements.length; t < i; t++) n(e.elements[t]);
			}),
			  (p = /^\s*\d+\.*\d*px\s*$/),
			  (i = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
			  (l = /\s/),
			  (f = function (e) {
				return u.matchMedia
				  ? (f = function (e) {
					  return !e || (matchMedia(e) || {}).matches;
					})(e)
				  : !e;
			  }),
			  (T.parse = d =
				function (e) {
				  return (
					(s = []),
					(e = e.trim()).replace(g, "").replace(i, S),
					s.length || !e || l.test(e) || s.push({ c: e, u: e, w: 99 }),
					s
				  );
				}),
			  (n = T),
			  v.loadedClass &&
				v.loadingClass &&
				((t = []),
				[
				  'img[sizes$="px"][srcset].',
				  "picture > img:not([srcset]).",
				].forEach(function (e) {
				  t.push(e + v.loadedClass), t.push(e + v.loadingClass);
				}),
				v.pf({ elements: r.querySelectorAll(t.join(", ")) }));
		  }
		  function y(e, t) {
			return e.w - t.w;
		  }
		  function b() {
			function e() {
			  var e, t;
			  for (e = 0, t = i.length; e < t; e++) n(i[e]);
			}
			var t, i;
			b.init ||
			  ((b.init = !0),
			  addEventListener(
				"resize",
				((i = r.getElementsByClassName("lazymatchmedia")),
				function () {
				  clearTimeout(t), (t = setTimeout(e, 66));
				})
			  ));
		  }
		  function w(e, t) {
			var i,
			  n = e.getAttribute("srcset") || e.getAttribute(v.srcsetAttr);
			!n &&
			  t &&
			  (n = e._lazypolyfill
				? e._lazypolyfill._set
				: e.getAttribute(v.srcAttr) || e.getAttribute("src")),
			  (e._lazypolyfill && e._lazypolyfill._set == n) ||
				((i = d(n || "")),
				t &&
				  e.parentNode &&
				  ((i.isPicture =
					"PICTURE" == e.parentNode.nodeName.toUpperCase()),
				  i.isPicture &&
					u.matchMedia &&
					(h.aC(e, "lazymatchmedia"), b())),
				(i._set = n),
				Object.defineProperty(e, "_lazypolyfill", {
				  value: i,
				  writable: !0,
				}));
		  }
		  function x(e) {
			var t, i, n, s, r, a, o, l, d, c;
			if ((w((s = e), !0), (r = s._lazypolyfill).isPicture))
			  for (
				i = 0,
				  n = (t = e.parentNode.getElementsByTagName("source")).length;
				i < n;
				i++
			  )
				if (
				  v.supportsType(t[i].getAttribute("type"), e) &&
				  f(t[i].getAttribute("media"))
				) {
				  (s = t[i]), w(s), (r = s._lazypolyfill);
				  break;
				}
			return (
			  1 < r.length
				? ((o = s.getAttribute("sizes") || ""),
				  (o = (p.test(o) && parseInt(o, 10)) || h.gW(e, e.parentNode)),
				  (r.d =
					((l = e),
					(d = u.devicePixelRatio || 1),
					(c = h.getX && h.getX(l)),
					Math.min(c || d, 2.5, d))),
				  !r.src || !r.w || r.w < o
					? ((r.w = o),
					  (a = (function (e) {
						for (
						  var t, i, n = e.length, s = e[n - 1], r = 0;
						  r < n;
						  r++
						)
						  if ((((s = e[r]).d = s.w / e.w), s.d >= e.d)) {
							!s.cached &&
							  (t = e[r - 1]) &&
							  t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
							  ((i = Math.pow(t.d - 0.6, 1.6)),
							  t.cached && (t.d += 0.15 * i),
							  t.d + (s.d - e.d) * i > e.d && (s = t));
							break;
						  }
						return s;
					  })(r.sort(y))),
					  (r.src = a))
					: (a = r.src))
				: (a = r[0]),
			  a
			);
		  }
		  function T(e) {
			if (
			  !c ||
			  !e.parentNode ||
			  "PICTURE" == e.parentNode.nodeName.toUpperCase()
			) {
			  var t = x(e);
			  t &&
				t.u &&
				e._lazypolyfill.cur != t.u &&
				((e._lazypolyfill.cur = t.u),
				(t.cached = !0),
				e.setAttribute(v.srcAttr, t.u),
				e.setAttribute("src", t.u));
			}
		  }
		  function S(e, t, i, n) {
			s.push({ c: t, u: i, w: +n });
		  }
		}),
		(yV = yV.bind(null, xV, xV.document)),
		"object" ==
		  ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
		module.exports
		  ? yV(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
		  : xV.lazySizes
		  ? zV()
		  : xV.addEventListener("lazyunveilread", zV, !0),
		(lX = window),
		(mX = function (e, u, h) {
		  "use strict";
		  if (e.addEventListener) {
			var p = /\s+/g,
			  f = /\s*\|\s+|\s+\|\s*/g,
			  v = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
			  s = /\(|\)|'/,
			  r = { contain: 1, cover: 1 },
			  g = function (e) {
				if (e.target._lazybgset) {
				  var t = e.target,
					i = t._lazybgset,
					n = t.currentSrc || t.src;
				  n &&
					(i.style.backgroundImage =
					  "url(" + (s.test(n) ? JSON.stringify(n) : n) + ")"),
					t._lazybgsetLoading &&
					  (h.fire(i, "_lazyloaded", {}, !1, !0),
					  delete t._lazybgsetLoading);
				}
			  };
			addEventListener("lazybeforeunveil", function (e) {
			  var t, i, n, s, r, a, o, l, d, c;
			  !e.defaultPrevented &&
				(t = e.target.getAttribute("data-bgset")) &&
				((n = e.target),
				((i = u.createElement("img")).alt = ""),
				(i._lazybgsetLoading = !0),
				(e.detail.firesLoad = !0),
				(s = t),
				(r = n),
				(a = i),
				(o = u.createElement("picture")),
				(l = r.getAttribute(lazySizesConfig.sizesAttr)),
				(d = r.getAttribute("data-ratio")),
				(c = r.getAttribute("data-optimumx")),
				r._lazybgset &&
				  r._lazybgset.parentNode == r &&
				  r.removeChild(r._lazybgset),
				Object.defineProperty(a, "_lazybgset", {
				  value: r,
				  writable: !0,
				}),
				Object.defineProperty(r, "_lazybgset", {
				  value: o,
				  writable: !0,
				}),
				(s = s.replace(p, " ").split(f)),
				(o.style.display = "none"),
				(a.className = lazySizesConfig.lazyClass),
				1 != s.length || l || (l = "auto"),
				s.forEach(function (e) {
				  var t = u.createElement("source");
				  l && "auto" != l && t.setAttribute("sizes", l),
					e.match(v) &&
					  (t.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
					  RegExp.$2 &&
						t.setAttribute(
						  "media",
						  lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2
						)),
					o.appendChild(t);
				}),
				l &&
				  (a.setAttribute(lazySizesConfig.sizesAttr, l),
				  r.removeAttribute(lazySizesConfig.sizesAttr),
				  r.removeAttribute("sizes")),
				c && a.setAttribute("data-optimumx", c),
				d && a.setAttribute("data-ratio", d),
				o.appendChild(a),
				r.appendChild(o),
				setTimeout(function () {
				  h.loader.unveil(i),
					h.rAF(function () {
					  h.fire(i, "_lazyloaded", {}, !0, !0),
						i.complete && g({ target: i });
					});
				}));
			}),
			  u.addEventListener("load", g, !0),
			  e.addEventListener(
				"lazybeforesizes",
				function (e) {
				  if (
					e.detail.instance == h &&
					e.target._lazybgset &&
					e.detail.dataAttr
				  ) {
					var t = e.target._lazybgset,
					  i =
						((n = t),
						(s = (
						  getComputedStyle(n) || {
							getPropertyValue: function () {},
						  }
						).getPropertyValue("background-size")),
						!r[s] &&
						  r[n.style.backgroundSize] &&
						  (s = n.style.backgroundSize),
						s);
					r[i] &&
					  ((e.target._lazysizesParentFit = i),
					  h.rAF(function () {
						e.target.setAttribute("data-parent-fit", i),
						  e.target._lazysizesParentFit &&
							delete e.target._lazysizesParentFit;
					  }));
				  }
				  var n, s;
				},
				!0
			  ),
			  u.documentElement.addEventListener("lazybeforesizes", function (e) {
				var t, i;
				!e.defaultPrevented &&
				  e.target._lazybgset &&
				  e.detail.instance == h &&
				  (e.detail.width =
					((t = e.target._lazybgset),
					(i = h.gW(t, t.parentNode)),
					(!t._lazysizesWidth || i > t._lazysizesWidth) &&
					  (t._lazysizesWidth = i),
					t._lazysizesWidth));
			  });
		  }
		}),
		(mX = mX.bind(null, lX, lX.document)),
		"object" ==
		  ("undefined" == typeof module ? "undefined" : _typeof(module)) &&
		module.exports
		  ? mX(require("lazysizes"))
		  : lX.lazySizes
		  ? nX()
		  : lX.addEventListener("lazyunveilread", nX, !0),
		document.addEventListener("lazyloaded", function (e) {
		  e.target.parentElement.className =
			e.target.parentElement.className.replace("lazyload--placeholder", "");
		}),
		(dY = jQuery),
		(eY = document),
		(fY = window),
		(aZ = {
		  html: !1,
		  photo: !1,
		  iframe: !1,
		  inline: !1,
		  transition: "elastic",
		  speed: 300,
		  fadeOut: 300,
		  width: !1,
		  initialWidth: "600",
		  innerWidth: !1,
		  maxWidth: !1,
		  height: !1,
		  initialHeight: "450",
		  innerHeight: !1,
		  maxHeight: !1,
		  scalePhotos: !0,
		  scrolling: !0,
		  opacity: 0.9,
		  preloading: !0,
		  className: !1,
		  overlayClose: !0,
		  escKey: !0,
		  arrowKey: !0,
		  top: !1,
		  bottom: !1,
		  left: !1,
		  right: !1,
		  fixed: !1,
		  data: void 0,
		  closeButton: !0,
		  fastIframe: !0,
		  open: !1,
		  reposition: !0,
		  loop: !0,
		  slideshow: !1,
		  slideshowAuto: !0,
		  slideshowSpeed: 2500,
		  slideshowStart: "start slideshow",
		  slideshowStop: "stop slideshow",
		  photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,
		  retinaImage: !1,
		  retinaUrl: !1,
		  retinaSuffix: "@2x.$1",
		  current: "image {current} of {total}",
		  previous: "previous",
		  next: "next",
		  close: "close",
		  xhrError: "This content failed to load.",
		  imgError: "This image failed to load.",
		  returnFocus: !0,
		  trapFocus: !0,
		  onOpen: !1,
		  onLoad: !1,
		  onComplete: !1,
		  onCleanup: !1,
		  onClosed: !1,
		  rel: function () {
			return this.rel;
		  },
		  href: function () {
			return dY(this).attr("href");
		  },
		  title: function () {
			return this.title;
		  },
		  createImg: function () {
			var i = new Image(),
			  e = dY(this).data("cbox-img-attrs");
			return (
			  "object" == _typeof(e) &&
				dY.each(e, function (e, t) {
				  i[e] = t;
				}),
			  i
			);
		  },
		  createIframe: function () {
			var i = eY.createElement("iframe"),
			  e = dY(this).data("cbox-iframe-attrs");
			return (
			  "object" == _typeof(e) &&
				dY.each(e, function (e, t) {
				  i[e] = t;
				}),
			  "frameBorder" in i && (i.frameBorder = 0),
			  "allowTransparency" in i && (i.allowTransparency = "true"),
			  (i.name = new Date().getTime()),
			  (i.allowFullscreen = !0),
			  i
			);
		  },
		}),
		(bZ = "colorbox"),
		(cZ = "cbox"),
		(dZ = cZ + "Element"),
		(eZ = cZ + "_open"),
		(fZ = cZ + "_load"),
		(gZ = cZ + "_complete"),
		(hZ = cZ + "_cleanup"),
		(iZ = cZ + "_closed"),
		(jZ = cZ + "_purge"),
		(kZ = dY("<a/>")),
		(lZ = "div"),
		(mZ = 0),
		(nZ = {}),
		(B$ = cZ + "Slideshow_"),
		(C$ = "click." + cZ),
		(oZ = function () {
		  z$
			? PY.get("slideshow") || (kZ.unbind(hZ, y$), y$())
			: PY.get("slideshow") &&
			  DY[1] &&
			  ((z$ = !0),
			  kZ.one(hZ, y$),
			  (PY.get("slideshowAuto") ? w$ : x$)(),
			  KY.show());
		}),
		dY[bZ] ||
		  (dY(sY),
		  (($Y =
			dY.fn[bZ] =
			dY[bZ] =
			  function (t, e) {
				var i = this;
				return (
				  (t = t || {}),
				  dY.isFunction(i) && ((i = dY("<a/>")), (t.open = !0)),
				  i[0] &&
					(sY(),
					wY &&
					  (_Y ||
						((_Y = !0),
						LY.click(function () {
						  $Y.next();
						}),
						MY.click(function () {
						  $Y.prev();
						}),
						NY.click(function () {
						  $Y.close();
						}),
						vY.click(function () {
						  PY.get("overlayClose") && $Y.close();
						}),
						dY(eY).bind("keydown." + cZ, function (e) {
						  var t = e.keyCode;
						  WY &&
							PY.get("escKey") &&
							27 === t &&
							(e.preventDefault(), $Y.close()),
							WY &&
							  PY.get("arrowKey") &&
							  DY[1] &&
							  !e.altKey &&
							  (37 === t
								? (e.preventDefault(), MY.click())
								: 39 === t && (e.preventDefault(), LY.click()));
						}),
						dY.isFunction(dY.fn.on)
						  ? dY(eY).on("click." + cZ, "." + dZ, n)
						  : dY("." + dZ).live("click." + cZ, n)),
					  1) &&
					  (e && (t.onComplete = e),
					  i
						.each(function () {
						  var e = dY.data(this, bZ) || {};
						  dY.data(this, bZ, dY.extend(e, t));
						})
						.addClass(dZ),
					  new iY(i[0], t).get("open") && rY(i[0]))),
				  i
				);
				function n(e) {
				  1 < e.which ||
					e.shiftKey ||
					e.altKey ||
					e.metaKey ||
					e.ctrlKey ||
					(e.preventDefault(), rY(this));
				}
			  }).position = function (t, e) {
			function i() {
			  (zY[0].style.width =
				CY[0].style.width =
				yY[0].style.width =
				  parseInt(wY[0].style.width, 10) - RY + "px"),
				(yY[0].style.height =
				  AY[0].style.height =
				  BY[0].style.height =
					parseInt(wY[0].style.height, 10) - QY + "px");
			}
			var n,
			  s,
			  r,
			  a = 0,
			  o = 0,
			  l = wY.offset();
			if (
			  (EY.unbind("resize." + cZ),
			  wY.css({ top: -9e4, left: -9e4 }),
			  (s = EY.scrollTop()),
			  (r = EY.scrollLeft()),
			  PY.get("fixed")
				? ((l.top -= s), (l.left -= r), wY.css({ position: "fixed" }))
				: ((a = s), (o = r), wY.css({ position: "absolute" })),
			  (o +=
				!1 !== PY.get("right")
				  ? Math.max(
					  EY.width() - PY.w - TY - RY - kY(PY.get("right"), "x"),
					  0
					)
				  : !1 !== PY.get("left")
				  ? kY(PY.get("left"), "x")
				  : Math.round(Math.max(EY.width() - PY.w - TY - RY, 0) / 2)),
			  (a +=
				!1 !== PY.get("bottom")
				  ? Math.max(hY() - PY.h - SY - QY - kY(PY.get("bottom"), "y"), 0)
				  : !1 !== PY.get("top")
				  ? kY(PY.get("top"), "y")
				  : Math.round(Math.max(hY() - PY.h - SY - QY, 0) / 2)),
			  wY.css({ top: l.top, left: l.left, visibility: "visible" }),
			  (xY[0].style.width = xY[0].style.height = "9999px"),
			  (n = {
				width: PY.w + TY + RY,
				height: PY.h + SY + QY,
				top: a,
				left: o,
			  }),
			  t)
			) {
			  var d = 0;
			  dY.each(n, function (e) {
				return n[e] !== nZ[e] ? void (d = t) : void 0;
			  }),
				(t = d);
			}
			(nZ = n),
			  t || wY.css(n),
			  wY.dequeue().animate(n, {
				duration: t || 0,
				complete: function () {
				  i(),
					(XY = !1),
					(xY[0].style.width = PY.w + TY + RY + "px"),
					(xY[0].style.height = PY.h + SY + QY + "px"),
					PY.get("reposition") &&
					  setTimeout(function () {
						EY.bind("resize." + cZ, $Y.position);
					  }, 1),
					dY.isFunction(e) && e();
				},
				step: i,
			  });
		  }),
		  ($Y.resize = function (e) {
			var t;
			WY &&
			  ((e = e || {}).width && (PY.w = kY(e.width, "x") - TY - RY),
			  e.innerWidth && (PY.w = kY(e.innerWidth, "x")),
			  FY.css({ width: PY.w }),
			  e.height && (PY.h = kY(e.height, "y") - SY - QY),
			  e.innerHeight && (PY.h = kY(e.innerHeight, "y")),
			  e.innerHeight ||
				e.height ||
				((t = FY.scrollTop()),
				FY.css({ height: "auto" }),
				(PY.h = FY.height())),
			  FY.css({ height: PY.h }),
			  t && FY.scrollTop(t),
			  $Y.position("none" === PY.get("transition") ? 0 : PY.get("speed")));
		  }),
		  ($Y.prep = function (e) {
			if (WY) {
			  var t,
				s = "none" === PY.get("transition") ? 0 : PY.get("speed");
			  FY.remove(),
				(FY = gY(lZ, "LoadedContent").append(e))
				  .hide()
				  .appendTo(GY.show())
				  .css({
					width:
					  ((PY.w = PY.w || FY.width()),
					  (PY.w = PY.mw && PY.mw < PY.w ? PY.mw : PY.w),
					  PY.w),
					overflow: PY.get("scrolling") ? "auto" : "hidden",
				  })
				  .css({
					height:
					  ((PY.h = PY.h || FY.height()),
					  (PY.h = PY.mh && PY.mh < PY.h ? PY.mh : PY.h),
					  PY.h),
				  })
				  .prependTo(yY),
				GY.hide(),
				dY(VY).css({ float: "none" }),
				oY(PY.get("className")),
				(t = function () {
				  function e() {
					!1 === dY.support.opacity &&
					  wY[0].style.removeAttribute("filter");
				  }
				  var t,
					i,
					n = DY.length;
				  WY &&
					((i = function () {
					  clearTimeout(ZY), HY.hide(), qY(gZ), PY.get("onComplete");
					}),
					IY.html(PY.get("title")).show(),
					FY.show(),
					1 < n
					  ? ("string" == typeof PY.get("current") &&
						  JY.html(
							PY.get("current")
							  .replace("{current}", UY + 1)
							  .replace("{total}", n)
						  ).show(),
						LY[PY.get("loop") || UY < n - 1 ? "show" : "hide"]().html(
						  PY.get("next")
						),
						MY[PY.get("loop") || UY ? "show" : "hide"]().html(
						  PY.get("previous")
						),
						oZ(),
						PY.get("preloading") &&
						  dY.each([jY(-1), jY(1)], function () {
							var e = DY[this],
							  t = new iY(e, dY.data(e, bZ)),
							  i = t.get("href");
							i &&
							  lY(t, i) &&
							  ((i = mY(t, i)), (eY.createElement("img").src = i));
						  }))
					  : OY.hide(),
					PY.get("iframe")
					  ? ((t = PY.get("createIframe")),
						PY.get("scrolling") || (t.scrolling = "no"),
						dY(t)
						  .attr({ src: PY.get("href"), class: cZ + "Iframe" })
						  .one("load", i)
						  .appendTo(FY),
						kZ.one(jZ, function () {
						  t.src = "//about:blank";
						}),
						PY.get("fastIframe") && dY(t).trigger("load"))
					  : i(),
					"fade" === PY.get("transition") ? wY.fadeTo(s, 1, e) : e());
				}),
				"fade" === PY.get("transition")
				  ? wY.fadeTo(s, 0, function () {
					  $Y.position(0, t);
					})
				  : $Y.position(s, t);
			}
		  }),
		  ($Y.next = function () {
			!XY &&
			  DY[1] &&
			  (PY.get("loop") || DY[UY + 1]) &&
			  ((UY = jY(1)), rY(DY[UY]));
		  }),
		  ($Y.prev = function () {
			!XY && DY[1] && (PY.get("loop") || UY) && ((UY = jY(-1)), rY(DY[UY]));
		  }),
		  ($Y.close = function () {
			WY &&
			  !YY &&
			  ((WY = !(YY = !0)),
			  qY(hZ),
			  PY.get("onCleanup"),
			  EY.unbind("." + cZ),
			  vY.fadeTo(PY.get("fadeOut") || 0, 0),
			  wY.stop().fadeTo(PY.get("fadeOut") || 0, 0, function () {
				wY.hide(),
				  vY.hide(),
				  qY(jZ),
				  FY.remove(),
				  setTimeout(function () {
					(YY = !1), qY(iZ), PY.get("onClosed");
				  }, 1);
			  }));
		  }),
		  ($Y.remove = function () {
			wY &&
			  (wY.stop(),
			  dY[bZ].close(),
			  wY.stop(!1, !0).remove(),
			  vY.remove(),
			  (YY = !1),
			  (wY = null),
			  dY("." + dZ)
				.removeData(bZ)
				.removeClass(dZ),
			  dY(eY)
				.unbind("click." + cZ)
				.unbind("keydown." + cZ));
		  }),
		  ($Y.element = function () {
			return dY(PY.el);
		  }),
		  ($Y.settings = aZ)),
		(j_ = this),
		(k_ = function () {
		  "use strict";
		  var f =
			  "undefined" == typeof document
				? {
					body: {},
					addEventListener: function () {},
					removeEventListener: function () {},
					activeElement: { blur: function () {}, nodeName: "" },
					querySelector: function () {
					  return null;
					},
					querySelectorAll: function () {
					  return [];
					},
					getElementById: function () {
					  return null;
					},
					createEvent: function () {
					  return { initEvent: function () {} };
					},
					createElement: function () {
					  return {
						children: [],
						childNodes: [],
						style: {},
						setAttribute: function () {},
						getElementsByTagName: function () {
						  return [];
						},
					  };
					},
					location: { hash: "" },
				  }
				: document,
			H =
			  "undefined" == typeof window
				? {
					document: f,
					navigator: { userAgent: "" },
					location: {},
					history: {},
					CustomEvent: function () {
					  return this;
					},
					addEventListener: function () {},
					removeEventListener: function () {},
					getComputedStyle: function () {
					  return {
						getPropertyValue: function () {
						  return "";
						},
					  };
					},
					Image: function () {},
					Date: function () {},
					screen: {},
					setTimeout: function () {},
					clearTimeout: function () {},
				  }
				: window,
			l = function (e) {
			  for (var t = 0; t < e.length; t += 1) this[t] = e[t];
			  return (this.length = e.length), this;
			};
		  function P(e, t) {
			var i = [],
			  n = 0;
			if (e && !t && e instanceof l) return e;
			if (e)
			  if ("string" == typeof e) {
				var s,
				  r,
				  a = e.trim();
				if (0 <= a.indexOf("<") && 0 <= a.indexOf(">")) {
				  var o = "div";
				  for (
					0 === a.indexOf("<li") && (o = "ul"),
					  0 === a.indexOf("<tr") && (o = "tbody"),
					  (0 !== a.indexOf("<td") && 0 !== a.indexOf("<th")) ||
						(o = "tr"),
					  0 === a.indexOf("<tbody") && (o = "table"),
					  0 === a.indexOf("<option") && (o = "select"),
					  (r = f.createElement(o)).innerHTML = a,
					  n = 0;
					n < r.childNodes.length;
					n += 1
				  )
					i.push(r.childNodes[n]);
				} else
				  for (
					s =
					  t || "#" !== e[0] || e.match(/[ .<>:~]/)
						? (t || f).querySelectorAll(e.trim())
						: [f.getElementById(e.trim().split("#")[1])],
					  n = 0;
					n < s.length;
					n += 1
				  )
					s[n] && i.push(s[n]);
			  } else if (e.nodeType || e === H || e === f) i.push(e);
			  else if (0 < e.length && e[0].nodeType)
				for (n = 0; n < e.length; n += 1) i.push(e[n]);
			return new l(i);
		  }
		  function r(e) {
			for (var t = [], i = 0; i < e.length; i += 1)
			  -1 === t.indexOf(e[i]) && t.push(e[i]);
			return t;
		  }
		  (P.fn = l.prototype), (P.Class = l), (P.Dom7 = l);
		  var t = {
			addClass: function (e) {
			  if (void 0 === e) return this;
			  for (var t = e.split(" "), i = 0; i < t.length; i += 1)
				for (var n = 0; n < this.length; n += 1)
				  void 0 !== this[n].classList && this[n].classList.add(t[i]);
			  return this;
			},
			removeClass: function (e) {
			  for (var t = e.split(" "), i = 0; i < t.length; i += 1)
				for (var n = 0; n < this.length; n += 1)
				  void 0 !== this[n].classList && this[n].classList.remove(t[i]);
			  return this;
			},
			hasClass: function (e) {
			  return !!this[0] && this[0].classList.contains(e);
			},
			toggleClass: function (e) {
			  for (var t = e.split(" "), i = 0; i < t.length; i += 1)
				for (var n = 0; n < this.length; n += 1)
				  void 0 !== this[n].classList && this[n].classList.toggle(t[i]);
			  return this;
			},
			attr: function (e, t) {
			  var i = arguments;
			  if (1 === arguments.length && "string" == typeof e)
				return this[0] ? this[0].getAttribute(e) : void 0;
			  for (var n = 0; n < this.length; n += 1)
				if (2 === i.length) this[n].setAttribute(e, t);
				else
				  for (var s in e)
					(this[n][s] = e[s]), this[n].setAttribute(s, e[s]);
			  return this;
			},
			removeAttr: function (e) {
			  for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
			  return this;
			},
			data: function (e, t) {
			  var i;
			  if (void 0 !== t) {
				for (var n = 0; n < this.length; n += 1)
				  (i = this[n]).dom7ElementDataStorage ||
					(i.dom7ElementDataStorage = {}),
					(i.dom7ElementDataStorage[e] = t);
				return this;
			  }
			  if ((i = this[0]))
				return i.dom7ElementDataStorage && e in i.dom7ElementDataStorage
				  ? i.dom7ElementDataStorage[e]
				  : i.getAttribute("data-" + e) || void 0;
			},
			transform: function (e) {
			  for (var t = 0; t < this.length; t += 1) {
				var i = this[t].style;
				(i.webkitTransform = e), (i.transform = e);
			  }
			  return this;
			},
			transition: function (e) {
			  "string" != typeof e && (e += "ms");
			  for (var t = 0; t < this.length; t += 1) {
				var i = this[t].style;
				(i.webkitTransitionDuration = e), (i.transitionDuration = e);
			  }
			  return this;
			},
			on: function () {
			  for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
			  var i = e[0],
				r = e[1],
				a = e[2],
				n = e[3];
			  function s(e) {
				var t = e.target;
				if (t) {
				  var i = e.target.dom7EventData || [];
				  if ((i.indexOf(e) < 0 && i.unshift(e), P(t).is(r)))
					a.apply(t, i);
				  else
					for (var n = P(t).parents(), s = 0; s < n.length; s += 1)
					  P(n[s]).is(r) && a.apply(n[s], i);
				}
			  }
			  function o(e) {
				var t = (e && e.target && e.target.dom7EventData) || [];
				t.indexOf(e) < 0 && t.unshift(e), a.apply(this, t);
			  }
			  "function" == typeof e[1] &&
				((i = e[0]), (a = e[1]), (n = e[2]), (r = void 0)),
				(n = n || !1);
			  for (var l, d = i.split(" "), c = 0; c < this.length; c += 1) {
				var u = this[c];
				if (r)
				  for (l = 0; l < d.length; l += 1) {
					var h = d[l];
					u.dom7LiveListeners || (u.dom7LiveListeners = {}),
					  u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []),
					  u.dom7LiveListeners[h].push({
						listener: a,
						proxyListener: s,
					  }),
					  u.addEventListener(h, s, n);
				  }
				else
				  for (l = 0; l < d.length; l += 1) {
					var p = d[l];
					u.dom7Listeners || (u.dom7Listeners = {}),
					  u.dom7Listeners[p] || (u.dom7Listeners[p] = []),
					  u.dom7Listeners[p].push({ listener: a, proxyListener: o }),
					  u.addEventListener(p, o, n);
				  }
			  }
			  return this;
			},
			off: function () {
			  for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
			  var i = e[0],
				n = e[1],
				s = e[2],
				r = e[3];
			  "function" == typeof e[1] &&
				((i = e[0]), (s = e[1]), (r = e[2]), (n = void 0)),
				(r = r || !1);
			  for (var a = i.split(" "), o = 0; o < a.length; o += 1)
				for (var l = a[o], d = 0; d < this.length; d += 1) {
				  var c = this[d],
					u = void 0;
				  if (
					(!n && c.dom7Listeners
					  ? (u = c.dom7Listeners[l])
					  : n && c.dom7LiveListeners && (u = c.dom7LiveListeners[l]),
					u && u.length)
				  )
					for (var h = u.length - 1; 0 <= h; --h) {
					  var p = u[h];
					  ((!s || p.listener !== s) && s) ||
						(c.removeEventListener(l, p.proxyListener, r),
						u.splice(h, 1));
					}
				}
			  return this;
			},
			trigger: function () {
			  for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
			  for (var i = e[0].split(" "), n = e[1], s = 0; s < i.length; s += 1)
				for (var r = i[s], a = 0; a < this.length; a += 1) {
				  var o = this[a],
					l = void 0;
				  try {
					l = new H.CustomEvent(r, {
					  detail: n,
					  bubbles: !0,
					  cancelable: !0,
					});
				  } catch (e) {
					(l = f.createEvent("Event")).initEvent(r, !0, !0),
					  (l.detail = n);
				  }
				  (o.dom7EventData = e.filter(function (e, t) {
					return 0 < t;
				  })),
					o.dispatchEvent(l),
					(o.dom7EventData = []),
					delete o.dom7EventData;
				}
			  return this;
			},
			transitionEnd: function (t) {
			  var i,
				n = ["webkitTransitionEnd", "transitionend"],
				s = this;
			  function r(e) {
				if (e.target === this)
				  for (t.call(this, e), i = 0; i < n.length; i += 1)
					s.off(n[i], r);
			  }
			  if (t) for (i = 0; i < n.length; i += 1) s.on(n[i], r);
			  return this;
			},
			outerWidth: function (e) {
			  if (0 < this.length) {
				if (e) {
				  var t = this.styles();
				  return (
					this[0].offsetWidth +
					parseFloat(t.getPropertyValue("margin-right")) +
					parseFloat(t.getPropertyValue("margin-left"))
				  );
				}
				return this[0].offsetWidth;
			  }
			  return null;
			},
			outerHeight: function (e) {
			  if (0 < this.length) {
				if (e) {
				  var t = this.styles();
				  return (
					this[0].offsetHeight +
					parseFloat(t.getPropertyValue("margin-top")) +
					parseFloat(t.getPropertyValue("margin-bottom"))
				  );
				}
				return this[0].offsetHeight;
			  }
			  return null;
			},
			offset: function () {
			  if (0 < this.length) {
				var e = this[0],
				  t = e.getBoundingClientRect(),
				  i = f.body,
				  n = e.clientTop || i.clientTop || 0,
				  s = e.clientLeft || i.clientLeft || 0,
				  r = e === H ? H.scrollY : e.scrollTop,
				  a = e === H ? H.scrollX : e.scrollLeft;
				return { top: t.top + r - n, left: t.left + a - s };
			  }
			  return null;
			},
			css: function (e, t) {
			  var i;
			  if (1 === arguments.length) {
				if ("string" != typeof e) {
				  for (i = 0; i < this.length; i += 1)
					for (var n in e) this[i].style[n] = e[n];
				  return this;
				}
				if (this[0])
				  return H.getComputedStyle(this[0], null).getPropertyValue(e);
			  }
			  if (2 !== arguments.length || "string" != typeof e) return this;
			  for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
			  return this;
			},
			each: function (e) {
			  if (!e) return this;
			  for (var t = 0; t < this.length; t += 1)
				if (!1 === e.call(this[t], t, this[t])) return this;
			  return this;
			},
			html: function (e) {
			  if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
			  for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
			  return this;
			},
			text: function (e) {
			  if (void 0 === e)
				return this[0] ? this[0].textContent.trim() : null;
			  for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
			  return this;
			},
			is: function (e) {
			  var t,
				i,
				n = this[0];
			  if (!n || void 0 === e) return !1;
			  if ("string" == typeof e) {
				if (n.matches) return n.matches(e);
				if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e);
				if (n.msMatchesSelector) return n.msMatchesSelector(e);
				for (t = P(e), i = 0; i < t.length; i += 1)
				  if (t[i] === n) return !0;
				return !1;
			  }
			  if (e === f) return n === f;
			  if (e === H) return n === H;
			  if (e.nodeType || e instanceof l) {
				for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1)
				  if (t[i] === n) return !0;
				return !1;
			  }
			  return !1;
			},
			index: function () {
			  var e,
				t = this[0];
			  if (t) {
				for (e = 0; null !== (t = t.previousSibling); )
				  1 === t.nodeType && (e += 1);
				return e;
			  }
			},
			eq: function (e) {
			  if (void 0 === e) return this;
			  var t,
				i = this.length;
			  return new l(
				i - 1 < e
				  ? []
				  : e < 0
				  ? (t = i + e) < 0
					? []
					: [this[t]]
				  : [this[e]]
			  );
			},
			append: function () {
			  for (var e, t = [], i = arguments.length; i--; )
				t[i] = arguments[i];
			  for (var n = 0; n < t.length; n += 1) {
				e = t[n];
				for (var s = 0; s < this.length; s += 1)
				  if ("string" == typeof e) {
					var r = f.createElement("div");
					for (r.innerHTML = e; r.firstChild; )
					  this[s].appendChild(r.firstChild);
				  } else if (e instanceof l)
					for (var a = 0; a < e.length; a += 1)
					  this[s].appendChild(e[a]);
				  else this[s].appendChild(e);
			  }
			  return this;
			},
			prepend: function (e) {
			  var t, i;
			  for (t = 0; t < this.length; t += 1)
				if ("string" == typeof e) {
				  var n = f.createElement("div");
				  for (n.innerHTML = e, i = n.childNodes.length - 1; 0 <= i; --i)
					this[t].insertBefore(n.childNodes[i], this[t].childNodes[0]);
				} else if (e instanceof l)
				  for (i = 0; i < e.length; i += 1)
					this[t].insertBefore(e[i], this[t].childNodes[0]);
				else this[t].insertBefore(e, this[t].childNodes[0]);
			  return this;
			},
			next: function (e) {
			  return 0 < this.length
				? e
				  ? this[0].nextElementSibling &&
					P(this[0].nextElementSibling).is(e)
					? new l([this[0].nextElementSibling])
					: new l([])
				  : this[0].nextElementSibling
				  ? new l([this[0].nextElementSibling])
				  : new l([])
				: new l([]);
			},
			nextAll: function (e) {
			  var t = [],
				i = this[0];
			  if (!i) return new l([]);
			  for (; i.nextElementSibling; ) {
				var n = i.nextElementSibling;
				(e && !P(n).is(e)) || t.push(n), (i = n);
			  }
			  return new l(t);
			},
			prev: function (e) {
			  if (0 < this.length) {
				var t = this[0];
				return e
				  ? t.previousElementSibling && P(t.previousElementSibling).is(e)
					? new l([t.previousElementSibling])
					: new l([])
				  : t.previousElementSibling
				  ? new l([t.previousElementSibling])
				  : new l([]);
			  }
			  return new l([]);
			},
			prevAll: function (e) {
			  var t = [],
				i = this[0];
			  if (!i) return new l([]);
			  for (; i.previousElementSibling; ) {
				var n = i.previousElementSibling;
				(e && !P(n).is(e)) || t.push(n), (i = n);
			  }
			  return new l(t);
			},
			parent: function (e) {
			  for (var t = [], i = 0; i < this.length; i += 1)
				null === this[i].parentNode ||
				  (e && !P(this[i].parentNode).is(e)) ||
				  t.push(this[i].parentNode);
			  return P(r(t));
			},
			parents: function (e) {
			  for (var t = [], i = 0; i < this.length; i += 1)
				for (var n = this[i].parentNode; n; )
				  (e && !P(n).is(e)) || t.push(n), (n = n.parentNode);
			  return P(r(t));
			},
			closest: function (e) {
			  var t = this;
			  return void 0 === e
				? new l([])
				: (t.is(e) || (t = t.parents(e).eq(0)), t);
			},
			find: function (e) {
			  for (var t = [], i = 0; i < this.length; i += 1)
				for (
				  var n = this[i].querySelectorAll(e), s = 0;
				  s < n.length;
				  s += 1
				)
				  t.push(n[s]);
			  return new l(t);
			},
			children: function (e) {
			  for (var t = [], i = 0; i < this.length; i += 1)
				for (var n = this[i].childNodes, s = 0; s < n.length; s += 1)
				  e
					? 1 === n[s].nodeType && P(n[s]).is(e) && t.push(n[s])
					: 1 === n[s].nodeType && t.push(n[s]);
			  return new l(r(t));
			},
			remove: function () {
			  for (var e = 0; e < this.length; e += 1)
				this[e].parentNode && this[e].parentNode.removeChild(this[e]);
			  return this;
			},
			add: function () {
			  for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
			  var i, n;
			  for (i = 0; i < e.length; i += 1) {
				var s = P(e[i]);
				for (n = 0; n < s.length; n += 1)
				  (this[this.length] = s[n]), (this.length += 1);
			  }
			  return this;
			},
			styles: function () {
			  return this[0] ? H.getComputedStyle(this[0], null) : {};
			},
		  };
		  Object.keys(t).forEach(function (e) {
			P.fn[e] = t[e];
		  });
		  function e(e) {
			void 0 === e && (e = {});
			var t = this;
			(t.params = e),
			  (t.eventsListeners = {}),
			  t.params &&
				t.params.on &&
				Object.keys(t.params.on).forEach(function (e) {
				  t.on(e, t.params.on[e]);
				});
		  }
		  var i,
			n,
			s,
			j = {
			  deleteProps: function (e) {
				var t = e;
				Object.keys(t).forEach(function (e) {
				  try {
					t[e] = null;
				  } catch (e) {}
				  try {
					delete t[e];
				  } catch (e) {}
				});
			  },
			  nextTick: function (e, t) {
				return void 0 === t && (t = 0), setTimeout(e, t);
			  },
			  now: function () {
				return Date.now();
			  },
			  getTranslate: function (e, t) {
				var i, n, s;
				void 0 === t && (t = "x");
				var r = H.getComputedStyle(e, null);
				return (
				  H.WebKitCSSMatrix
					? (6 <
						(n = r.transform || r.webkitTransform).split(",")
						  .length &&
						(n = n
						  .split(", ")
						  .map(function (e) {
							return e.replace(",", ".");
						  })
						  .join(", ")),
					  (s = new H.WebKitCSSMatrix("none" === n ? "" : n)))
					: (i = (s =
						r.MozTransform ||
						r.OTransform ||
						r.MsTransform ||
						r.msTransform ||
						r.transform ||
						r
						  .getPropertyValue("transform")
						  .replace("translate(", "matrix(1, 0, 0, 1,"))
						.toString()
						.split(",")),
				  "x" === t &&
					(n = H.WebKitCSSMatrix
					  ? s.m41
					  : 16 === i.length
					  ? parseFloat(i[12])
					  : parseFloat(i[4])),
				  "y" === t &&
					(n = H.WebKitCSSMatrix
					  ? s.m42
					  : 16 === i.length
					  ? parseFloat(i[13])
					  : parseFloat(i[5])),
				  n || 0
				);
			  },
			  parseUrlQuery: function (e) {
				var t,
				  i,
				  n,
				  s,
				  r = {},
				  a = e || H.location.href;
				if ("string" == typeof a && a.length)
				  for (
					s = (i = (a =
					  -1 < a.indexOf("?") ? a.replace(/\S*\?/, "") : "")
					  .split("&")
					  .filter(function (e) {
						return "" !== e;
					  })).length,
					  t = 0;
					t < s;
					t += 1
				  )
					(n = i[t].replace(/#\S+/g, "").split("=")),
					  (r[decodeURIComponent(n[0])] =
						void 0 === n[1]
						  ? void 0
						  : decodeURIComponent(n[1]) || "");
				return r;
			  },
			  isObject: function (e) {
				return (
				  "object" == _typeof(e) &&
				  null !== e &&
				  e.constructor &&
				  e.constructor === Object
				);
			  },
			  extend: function () {
				for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
				for (var i = Object(e[0]), n = 1; n < e.length; n += 1) {
				  var s = e[n];
				  if (null != s)
					for (
					  var r = Object.keys(Object(s)), a = 0, o = r.length;
					  a < o;
					  a += 1
					) {
					  var l = r[a],
						d = Object.getOwnPropertyDescriptor(s, l);
					  void 0 !== d &&
						d.enumerable &&
						(j.isObject(i[l]) && j.isObject(s[l])
						  ? j.extend(i[l], s[l])
						  : !j.isObject(i[l]) && j.isObject(s[l])
						  ? ((i[l] = {}), j.extend(i[l], s[l]))
						  : (i[l] = s[l]));
					}
				}
				return i;
			  },
			},
			q =
			  ((s = f.createElement("div")),
			  {
				touch:
				  (H.Modernizr && !0 === H.Modernizr.touch) ||
				  !!(
					"ontouchstart" in H ||
					(H.DocumentTouch && f instanceof H.DocumentTouch)
				  ),
				pointerEvents: !(!H.navigator.pointerEnabled && !H.PointerEvent),
				prefixedPointerEvents: !!H.navigator.msPointerEnabled,
				transition:
				  "transition" in (n = s.style) ||
				  "webkitTransition" in n ||
				  "MozTransition" in n,
				transforms3d:
				  (H.Modernizr && !0 === H.Modernizr.csstransforms3d) ||
				  "webkitPerspective" in (i = s.style) ||
				  "MozPerspective" in i ||
				  "OPerspective" in i ||
				  "MsPerspective" in i ||
				  "perspective" in i,
				flexbox: (function () {
				  for (
					var e = s.style,
					  t =
						"alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(
						  " "
						),
					  i = 0;
					i < t.length;
					i += 1
				  )
					if (t[i] in e) return !0;
				  return !1;
				})(),
				observer:
				  "MutationObserver" in H || "WebkitMutationObserver" in H,
				passiveListener: (function () {
				  var e = !1;
				  try {
					var t = Object.defineProperty({}, "passive", {
					  get: function () {
						e = !0;
					  },
					});
					H.addEventListener("testPassiveListener", null, t);
				  } catch (e) {}
				  return e;
				})(),
				gestures: "ongesturestart" in H,
			  }),
			a = { components: { configurable: !0 } };
		  (e.prototype.on = function (e, t, i) {
			var n = this;
			if ("function" != typeof t) return n;
			var s = i ? "unshift" : "push";
			return (
			  e.split(" ").forEach(function (e) {
				n.eventsListeners[e] || (n.eventsListeners[e] = []),
				  n.eventsListeners[e][s](t);
			  }),
			  n
			);
		  }),
			(e.prototype.once = function (n, s, e) {
			  var r = this;
			  return "function" != typeof s
				? r
				: r.on(
					n,
					function e() {
					  for (var t = [], i = arguments.length; i--; )
						t[i] = arguments[i];
					  s.apply(r, t), r.off(n, e);
					},
					e
				  );
			}),
			(e.prototype.off = function (e, n) {
			  var s = this;
			  return (
				s.eventsListeners &&
				  e.split(" ").forEach(function (i) {
					void 0 === n
					  ? (s.eventsListeners[i] = [])
					  : s.eventsListeners[i].forEach(function (e, t) {
						  e === n && s.eventsListeners[i].splice(t, 1);
						});
				  }),
				s
			  );
			}),
			(e.prototype.emit = function () {
			  for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
			  var i,
				n,
				s,
				r = this;
			  return (
				r.eventsListeners &&
				  ((s =
					"string" == typeof e[0] || Array.isArray(e[0])
					  ? ((i = e[0]), (n = e.slice(1, e.length)), r)
					  : ((i = e[0].events), (n = e[0].data), e[0].context || r)),
				  (Array.isArray(i) ? i : i.split(" ")).forEach(function (e) {
					if (r.eventsListeners && r.eventsListeners[e]) {
					  var t = [];
					  r.eventsListeners[e].forEach(function (e) {
						t.push(e);
					  }),
						t.forEach(function (e) {
						  e.apply(s, n);
						});
					}
				  })),
				r
			  );
			}),
			(e.prototype.useModulesParams = function (i) {
			  var n = this;
			  n.modules &&
				Object.keys(n.modules).forEach(function (e) {
				  var t = n.modules[e];
				  t.params && j.extend(i, t.params);
				});
			}),
			(e.prototype.useModules = function (n) {
			  void 0 === n && (n = {});
			  var s = this;
			  s.modules &&
				Object.keys(s.modules).forEach(function (e) {
				  var i = s.modules[e],
					t = n[e] || {};
				  i.instance &&
					Object.keys(i.instance).forEach(function (e) {
					  var t = i.instance[e];
					  s[e] = "function" == typeof t ? t.bind(s) : t;
					}),
					i.on &&
					  s.on &&
					  Object.keys(i.on).forEach(function (e) {
						s.on(e, i.on[e]);
					  }),
					i.create && i.create.bind(s)(t);
				});
			}),
			(a.components.set = function (e) {
			  this.use && this.use(e);
			}),
			(e.installModule = function (t) {
			  for (var e = [], i = arguments.length - 1; 0 < i--; )
				e[i] = arguments[i + 1];
			  var n = this;
			  n.prototype.modules || (n.prototype.modules = {});
			  var s =
				t.name || Object.keys(n.prototype.modules).length + "_" + j.now();
			  return (
				(n.prototype.modules[s] = t).proto &&
				  Object.keys(t.proto).forEach(function (e) {
					n.prototype[e] = t.proto[e];
				  }),
				t.static &&
				  Object.keys(t.static).forEach(function (e) {
					n[e] = t.static[e];
				  }),
				t.install && t.install.apply(n, e),
				n
			  );
			}),
			(e.use = function (e) {
			  for (var t = [], i = arguments.length - 1; 0 < i--; )
				t[i] = arguments[i + 1];
			  var n = this;
			  return Array.isArray(e)
				? (e.forEach(function (e) {
					return n.installModule(e);
				  }),
				  n)
				: n.installModule.apply(n, [e].concat(t));
			}),
			Object.defineProperties(e, a);
		  var o = {
			  updateSize: function () {
				var e,
				  t,
				  i = this.$el;
				(e =
				  void 0 !== this.params.width
					? this.params.width
					: i[0].clientWidth),
				  (t =
					void 0 !== this.params.height
					  ? this.params.height
					  : i[0].clientHeight),
				  (0 === e && this.isHorizontal()) ||
					(0 === t && this.isVertical()) ||
					((e =
					  e -
					  parseInt(i.css("padding-left"), 10) -
					  parseInt(i.css("padding-right"), 10)),
					(t =
					  t -
					  parseInt(i.css("padding-top"), 10) -
					  parseInt(i.css("padding-bottom"), 10)),
					j.extend(this, {
					  width: e,
					  height: t,
					  size: this.isHorizontal() ? e : t,
					}));
			  },
			  updateSlides: function () {
				var e = this.params,
				  t = this.$wrapperEl,
				  i = this.size,
				  n = this.rtlTranslate,
				  s = this.wrongRTL,
				  r = this.virtual && e.virtual.enabled,
				  a = r ? this.virtual.slides.length : this.slides.length,
				  o = t.children("." + this.params.slideClass),
				  l = r ? this.virtual.slides.length : o.length,
				  d = [],
				  c = [],
				  u = [],
				  h = e.slidesOffsetBefore;
				"function" == typeof h && (h = e.slidesOffsetBefore.call(this));
				var p = e.slidesOffsetAfter;
				"function" == typeof p && (p = e.slidesOffsetAfter.call(this));
				var f = this.snapGrid.length,
				  v = this.snapGrid.length,
				  g = e.spaceBetween,
				  m = -h,
				  y = 0,
				  b = 0;
				if (void 0 !== i) {
				  var w, x;
				  "string" == typeof g &&
					0 <= g.indexOf("%") &&
					(g = (parseFloat(g.replace("%", "")) / 100) * i),
					(this.virtualSize = -g),
					n
					  ? o.css({ marginLeft: "", marginTop: "" })
					  : o.css({ marginRight: "", marginBottom: "" }),
					1 < e.slidesPerColumn &&
					  ((w =
						Math.floor(l / e.slidesPerColumn) ===
						l / this.params.slidesPerColumn
						  ? l
						  : Math.ceil(l / e.slidesPerColumn) * e.slidesPerColumn),
					  "auto" !== e.slidesPerView &&
						"row" === e.slidesPerColumnFill &&
						(w = Math.max(w, e.slidesPerView * e.slidesPerColumn)));
				  for (
					var T,
					  S = e.slidesPerColumn,
					  C = w / S,
					  E = C - (e.slidesPerColumn * C - l),
					  k = 0;
					k < l;
					k += 1
				  ) {
					x = 0;
					var Y = o.eq(k);
					if (1 < e.slidesPerColumn) {
					  var z = void 0,
						$ = void 0,
						P = void 0;
					  "column" === e.slidesPerColumnFill
						? ((P = k - ($ = Math.floor(k / S)) * S),
						  (E < $ || ($ === E && P === S - 1)) &&
							(P += 1) >= S &&
							((P = 0), ($ += 1)),
						  (z = $ + (P * w) / S),
						  Y.css({
							"-webkit-box-ordinal-group": z,
							"-moz-box-ordinal-group": z,
							"-ms-flex-order": z,
							"-webkit-order": z,
							order: z,
						  }))
						: ($ = k - (P = Math.floor(k / C)) * C),
						Y.css(
						  "margin-" + (this.isHorizontal() ? "top" : "left"),
						  0 !== P && e.spaceBetween && e.spaceBetween + "px"
						)
						  .attr("data-swiper-column", $)
						  .attr("data-swiper-row", P);
					}
					if ("none" !== Y.css("display")) {
					  if ("auto" === e.slidesPerView) {
						var A = H.getComputedStyle(Y[0], null),
						  M = Y[0].style.transform,
						  L = Y[0].style.webkitTransform;
						M && (Y[0].style.transform = "none"),
						  L && (Y[0].style.webkitTransform = "none"),
						  (x = this.isHorizontal()
							? Y[0].getBoundingClientRect().width +
							  parseFloat(A.getPropertyValue("margin-left")) +
							  parseFloat(A.getPropertyValue("margin-right"))
							: Y[0].getBoundingClientRect().height +
							  parseFloat(A.getPropertyValue("margin-top")) +
							  parseFloat(A.getPropertyValue("margin-bottom"))),
						  M && (Y[0].style.transform = M),
						  L && (Y[0].style.webkitTransform = L),
						  e.roundLengths && (x = Math.floor(x));
					  } else
						(x = (i - (e.slidesPerView - 1) * g) / e.slidesPerView),
						  e.roundLengths && (x = Math.floor(x)),
						  o[k] &&
							(this.isHorizontal()
							  ? (o[k].style.width = x + "px")
							  : (o[k].style.height = x + "px"));
					  o[k] && (o[k].swiperSlideSize = x),
						u.push(x),
						e.centeredSlides
						  ? ((m = m + x / 2 + y / 2 + g),
							0 === y && 0 !== k && (m = m - i / 2 - g),
							0 === k && (m = m - i / 2 - g),
							Math.abs(m) < 0.001 && (m = 0),
							e.roundLengths && (m = Math.floor(m)),
							b % e.slidesPerGroup == 0 && d.push(m),
							c.push(m))
						  : (e.roundLengths && (m = Math.floor(m)),
							b % e.slidesPerGroup == 0 && d.push(m),
							c.push(m),
							(m = m + x + g)),
						(this.virtualSize += x + g),
						(y = x),
						(b += 1);
					}
				  }
				  if (
					((this.virtualSize = Math.max(this.virtualSize, i) + p),
					n &&
					  s &&
					  ("slide" === e.effect || "coverflow" === e.effect) &&
					  t.css({ width: this.virtualSize + e.spaceBetween + "px" }),
					(q.flexbox && !e.setWrapperSize) ||
					  (this.isHorizontal()
						? t.css({
							width: this.virtualSize + e.spaceBetween + "px",
						  })
						: t.css({
							height: this.virtualSize + e.spaceBetween + "px",
						  })),
					1 < e.slidesPerColumn &&
					  ((this.virtualSize = (x + e.spaceBetween) * w),
					  (this.virtualSize =
						Math.ceil(this.virtualSize / e.slidesPerColumn) -
						e.spaceBetween),
					  this.isHorizontal()
						? t.css({
							width: this.virtualSize + e.spaceBetween + "px",
						  })
						: t.css({
							height: this.virtualSize + e.spaceBetween + "px",
						  }),
					  e.centeredSlides))
				  ) {
					T = [];
					for (var D = 0; D < d.length; D += 1) {
					  var O = d[D];
					  e.roundLengths && (O = Math.floor(O)),
						d[D] < this.virtualSize + d[0] && T.push(O);
					}
					d = T;
				  }
				  if (!e.centeredSlides) {
					T = [];
					for (var N = 0; N < d.length; N += 1) {
					  var I = d[N];
					  e.roundLengths && (I = Math.floor(I)),
						d[N] <= this.virtualSize - i && T.push(I);
					}
					(d = T),
					  1 <
						Math.floor(this.virtualSize - i) -
						  Math.floor(d[d.length - 1]) &&
						d.push(this.virtualSize - i);
				  }
				  0 === d.length && (d = [0]),
					0 !== e.spaceBetween &&
					  (this.isHorizontal()
						? n
						  ? o.css({ marginLeft: g + "px" })
						  : o.css({ marginRight: g + "px" })
						: o.css({ marginBottom: g + "px" })),
					j.extend(this, {
					  slides: o,
					  snapGrid: d,
					  slidesGrid: c,
					  slidesSizesGrid: u,
					}),
					l !== a && this.emit("slidesLengthChange"),
					d.length !== f &&
					  (this.params.watchOverflow && this.checkOverflow(),
					  this.emit("snapGridLengthChange")),
					c.length !== v && this.emit("slidesGridLengthChange"),
					(e.watchSlidesProgress || e.watchSlidesVisibility) &&
					  this.updateSlidesOffset();
				}
			  },
			  updateAutoHeight: function (e) {
				var t,
				  i = [],
				  n = 0;
				if (
				  ("number" == typeof e
					? this.setTransition(e)
					: !0 === e && this.setTransition(this.params.speed),
				  "auto" !== this.params.slidesPerView &&
					1 < this.params.slidesPerView)
				)
				  for (t = 0; t < Math.ceil(this.params.slidesPerView); t += 1) {
					var s = this.activeIndex + t;
					if (s > this.slides.length) break;
					i.push(this.slides.eq(s)[0]);
				  }
				else i.push(this.slides.eq(this.activeIndex)[0]);
				for (t = 0; t < i.length; t += 1)
				  if (void 0 !== i[t]) {
					var r = i[t].offsetHeight;
					n = n < r ? r : n;
				  }
				n && this.$wrapperEl.css("height", n + "px");
			  },
			  updateSlidesOffset: function () {
				for (var e = this.slides, t = 0; t < e.length; t += 1)
				  e[t].swiperSlideOffset = this.isHorizontal()
					? e[t].offsetLeft
					: e[t].offsetTop;
			  },
			  updateSlidesProgress: function (e) {
				void 0 === e && (e = (this && this.translate) || 0);
				var t = this.params,
				  i = this.slides,
				  n = this.rtlTranslate;
				if (0 !== i.length) {
				  void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
				  var s = -e;
				  n && (s = e), i.removeClass(t.slideVisibleClass);
				  for (var r = 0; r < i.length; r += 1) {
					var a = i[r],
					  o =
						(s +
						  (t.centeredSlides ? this.minTranslate() : 0) -
						  a.swiperSlideOffset) /
						(a.swiperSlideSize + t.spaceBetween);
					if (t.watchSlidesVisibility) {
					  var l = -(s - a.swiperSlideOffset),
						d = l + this.slidesSizesGrid[r];
					  ((0 <= l && l < this.size) ||
						(0 < d && d <= this.size) ||
						(l <= 0 && d >= this.size)) &&
						i.eq(r).addClass(t.slideVisibleClass);
					}
					a.progress = n ? -o : o;
				  }
				}
			  },
			  updateProgress: function (e) {
				void 0 === e && (e = (this && this.translate) || 0);
				var t = this.params,
				  i = this.maxTranslate() - this.minTranslate(),
				  n = this.progress,
				  s = this.isBeginning,
				  r = this.isEnd,
				  a = s,
				  o = r;
				(r =
				  0 == i
					? (s = !(n = 0))
					: ((s = (n = (e - this.minTranslate()) / i) <= 0), 1 <= n)),
				  j.extend(this, { progress: n, isBeginning: s, isEnd: r }),
				  (t.watchSlidesProgress || t.watchSlidesVisibility) &&
					this.updateSlidesProgress(e),
				  s && !a && this.emit("reachBeginning toEdge"),
				  r && !o && this.emit("reachEnd toEdge"),
				  ((a && !s) || (o && !r)) && this.emit("fromEdge"),
				  this.emit("progress", n);
			  },
			  updateSlidesClasses: function () {
				var e,
				  t = this.slides,
				  i = this.params,
				  n = this.$wrapperEl,
				  s = this.activeIndex,
				  r = this.realIndex,
				  a = this.virtual && i.virtual.enabled;
				t.removeClass(
				  i.slideActiveClass +
					" " +
					i.slideNextClass +
					" " +
					i.slidePrevClass +
					" " +
					i.slideDuplicateActiveClass +
					" " +
					i.slideDuplicateNextClass +
					" " +
					i.slideDuplicatePrevClass
				),
				  (e = a
					? this.$wrapperEl.find(
						"." +
						  i.slideClass +
						  '[data-swiper-slide-index="' +
						  s +
						  '"]'
					  )
					: t.eq(s)).addClass(i.slideActiveClass),
				  i.loop &&
					(e.hasClass(i.slideDuplicateClass)
					  ? n
						  .children(
							"." +
							  i.slideClass +
							  ":not(." +
							  i.slideDuplicateClass +
							  ')[data-swiper-slide-index="' +
							  r +
							  '"]'
						  )
						  .addClass(i.slideDuplicateActiveClass)
					  : n
						  .children(
							"." +
							  i.slideClass +
							  "." +
							  i.slideDuplicateClass +
							  '[data-swiper-slide-index="' +
							  r +
							  '"]'
						  )
						  .addClass(i.slideDuplicateActiveClass));
				var o = e
				  .nextAll("." + i.slideClass)
				  .eq(0)
				  .addClass(i.slideNextClass);
				i.loop &&
				  0 === o.length &&
				  (o = t.eq(0)).addClass(i.slideNextClass);
				var l = e
				  .prevAll("." + i.slideClass)
				  .eq(0)
				  .addClass(i.slidePrevClass);
				i.loop &&
				  0 === l.length &&
				  (l = t.eq(-1)).addClass(i.slidePrevClass),
				  i.loop &&
					(o.hasClass(i.slideDuplicateClass)
					  ? n
						  .children(
							"." +
							  i.slideClass +
							  ":not(." +
							  i.slideDuplicateClass +
							  ')[data-swiper-slide-index="' +
							  o.attr("data-swiper-slide-index") +
							  '"]'
						  )
						  .addClass(i.slideDuplicateNextClass)
					  : n
						  .children(
							"." +
							  i.slideClass +
							  "." +
							  i.slideDuplicateClass +
							  '[data-swiper-slide-index="' +
							  o.attr("data-swiper-slide-index") +
							  '"]'
						  )
						  .addClass(i.slideDuplicateNextClass),
					l.hasClass(i.slideDuplicateClass)
					  ? n
						  .children(
							"." +
							  i.slideClass +
							  ":not(." +
							  i.slideDuplicateClass +
							  ')[data-swiper-slide-index="' +
							  l.attr("data-swiper-slide-index") +
							  '"]'
						  )
						  .addClass(i.slideDuplicatePrevClass)
					  : n
						  .children(
							"." +
							  i.slideClass +
							  "." +
							  i.slideDuplicateClass +
							  '[data-swiper-slide-index="' +
							  l.attr("data-swiper-slide-index") +
							  '"]'
						  )
						  .addClass(i.slideDuplicatePrevClass));
			  },
			  updateActiveIndex: function (e) {
				var t,
				  i = this.rtlTranslate ? this.translate : -this.translate,
				  n = this.slidesGrid,
				  s = this.snapGrid,
				  r = this.params,
				  a = this.activeIndex,
				  o = this.realIndex,
				  l = this.snapIndex,
				  d = e;
				if (void 0 === d) {
				  for (var c = 0; c < n.length; c += 1)
					void 0 !== n[c + 1]
					  ? i >= n[c] && i < n[c + 1] - (n[c + 1] - n[c]) / 2
						? (d = c)
						: i >= n[c] && i < n[c + 1] && (d = c + 1)
					  : i >= n[c] && (d = c);
				  r.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
				}
				if (
				  ((t =
					0 <= s.indexOf(i)
					  ? s.indexOf(i)
					  : Math.floor(d / r.slidesPerGroup)) >= s.length &&
					(t = s.length - 1),
				  d !== a)
				) {
				  var u = parseInt(
					this.slides.eq(d).attr("data-swiper-slide-index") || d,
					10
				  );
				  j.extend(this, {
					snapIndex: t,
					realIndex: u,
					previousIndex: a,
					activeIndex: d,
				  }),
					this.emit("activeIndexChange"),
					this.emit("snapIndexChange"),
					o !== u && this.emit("realIndexChange"),
					this.emit("slideChange");
				} else
				  t !== l && ((this.snapIndex = t), this.emit("snapIndexChange"));
			  },
			  updateClickedSlide: function (e) {
				var t = this.params,
				  i = P(e.target).closest("." + t.slideClass)[0],
				  n = !1;
				if (i)
				  for (var s = 0; s < this.slides.length; s += 1)
					this.slides[s] === i && (n = !0);
				if (!i || !n)
				  return (
					(this.clickedSlide = void 0),
					void (this.clickedIndex = void 0)
				  );
				(this.clickedSlide = i),
				  this.virtual && this.params.virtual.enabled
					? (this.clickedIndex = parseInt(
						P(i).attr("data-swiper-slide-index"),
						10
					  ))
					: (this.clickedIndex = P(i).index()),
				  t.slideToClickedSlide &&
					void 0 !== this.clickedIndex &&
					this.clickedIndex !== this.activeIndex &&
					this.slideToClickedSlide();
			  },
			},
			d = {
			  getTranslate: function (e) {
				void 0 === e && (e = this.isHorizontal() ? "x" : "y");
				var t = this.params,
				  i = this.rtlTranslate,
				  n = this.translate,
				  s = this.$wrapperEl;
				if (t.virtualTranslate) return i ? -n : n;
				var r = j.getTranslate(s[0], e);
				return i && (r = -r), r || 0;
			  },
			  setTranslate: function (e, t) {
				var i = this.rtlTranslate,
				  n = this.params,
				  s = this.$wrapperEl,
				  r = this.progress,
				  a = 0,
				  o = 0;
				this.isHorizontal() ? (a = i ? -e : e) : (o = e),
				  n.roundLengths && ((a = Math.floor(a)), (o = Math.floor(o))),
				  n.virtualTranslate ||
					(q.transforms3d
					  ? s.transform("translate3d(" + a + "px, " + o + "px, 0px)")
					  : s.transform("translate(" + a + "px, " + o + "px)")),
				  (this.previousTranslate = this.translate),
				  (this.translate = this.isHorizontal() ? a : o);
				var l = this.maxTranslate() - this.minTranslate();
				(0 == l ? 0 : (e - this.minTranslate()) / l) !== r &&
				  this.updateProgress(e),
				  this.emit("setTranslate", this.translate, t);
			  },
			  minTranslate: function () {
				return -this.snapGrid[0];
			  },
			  maxTranslate: function () {
				return -this.snapGrid[this.snapGrid.length - 1];
			  },
			},
			c = {
			  slideTo: function (e, t, i, n) {
				void 0 === e && (e = 0),
				  void 0 === t && (t = this.params.speed),
				  void 0 === i && (i = !0);
				var s = this,
				  r = e;
				r < 0 && (r = 0);
				var a = s.params,
				  o = s.snapGrid,
				  l = s.slidesGrid,
				  d = s.previousIndex,
				  c = s.activeIndex,
				  u = s.rtlTranslate;
				if (s.animating && a.preventIntercationOnTransition) return !1;
				var h = Math.floor(r / a.slidesPerGroup);
				h >= o.length && (h = o.length - 1),
				  (c || a.initialSlide || 0) === (d || 0) &&
					i &&
					s.emit("beforeSlideChangeStart");
				var p,
				  f = -o[h];
				if ((s.updateProgress(f), a.normalizeSlideIndex))
				  for (var v = 0; v < l.length; v += 1)
					-Math.floor(100 * f) >= Math.floor(100 * l[v]) && (r = v);
				if (s.initialized && r !== c) {
				  if (
					!s.allowSlideNext &&
					f < s.translate &&
					f < s.minTranslate()
				  )
					return !1;
				  if (
					!s.allowSlidePrev &&
					f > s.translate &&
					f > s.maxTranslate() &&
					(c || 0) !== r
				  )
					return !1;
				}
				return (
				  (p = c < r ? "next" : r < c ? "prev" : "reset"),
				  (u && -f === s.translate) || (!u && f === s.translate)
					? (s.updateActiveIndex(r),
					  a.autoHeight && s.updateAutoHeight(),
					  s.updateSlidesClasses(),
					  "slide" !== a.effect && s.setTranslate(f),
					  "reset" != p &&
						(s.transitionStart(i, p), s.transitionEnd(i, p)),
					  !1)
					: (0 !== t && q.transition
						? (s.setTransition(t),
						  s.setTranslate(f),
						  s.updateActiveIndex(r),
						  s.updateSlidesClasses(),
						  s.emit("beforeTransitionStart", t, n),
						  s.transitionStart(i, p),
						  s.animating ||
							((s.animating = !0),
							s.onSlideToWrapperTransitionEnd ||
							  (s.onSlideToWrapperTransitionEnd = function (e) {
								s &&
								  !s.destroyed &&
								  e.target === this &&
								  (s.$wrapperEl[0].removeEventListener(
									"transitionend",
									s.onSlideToWrapperTransitionEnd
								  ),
								  s.$wrapperEl[0].removeEventListener(
									"webkitTransitionEnd",
									s.onSlideToWrapperTransitionEnd
								  ),
								  s.transitionEnd(i, p));
							  }),
							s.$wrapperEl[0].addEventListener(
							  "transitionend",
							  s.onSlideToWrapperTransitionEnd
							),
							s.$wrapperEl[0].addEventListener(
							  "webkitTransitionEnd",
							  s.onSlideToWrapperTransitionEnd
							)))
						: (s.setTransition(0),
						  s.setTranslate(f),
						  s.updateActiveIndex(r),
						  s.updateSlidesClasses(),
						  s.emit("beforeTransitionStart", t, n),
						  s.transitionStart(i, p),
						  s.transitionEnd(i, p)),
					  !0)
				);
			  },
			  slideToLoop: function (e, t, i, n) {
				void 0 === e && (e = 0),
				  void 0 === t && (t = this.params.speed),
				  void 0 === i && (i = !0);
				var s = e;
				return (
				  this.params.loop && (s += this.loopedSlides),
				  this.slideTo(s, t, i, n)
				);
			  },
			  slideNext: function (e, t, i) {
				void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
				var n = this.params,
				  s = this.animating;
				return n.loop
				  ? !s &&
					  (this.loopFix(),
					  (this._clientLeft = this.$wrapperEl[0].clientLeft),
					  this.slideTo(this.activeIndex + n.slidesPerGroup, e, t, i))
				  : this.slideTo(this.activeIndex + n.slidesPerGroup, e, t, i);
			  },
			  slidePrev: function (e, t, i) {
				void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
				var n = this.params,
				  s = this.animating,
				  r = this.snapGrid,
				  a = this.slidesGrid,
				  o = this.rtlTranslate;
				if (n.loop) {
				  if (s) return !1;
				  this.loopFix(),
					(this._clientLeft = this.$wrapperEl[0].clientLeft);
				}
				function l(e) {
				  return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
				}
				var d,
				  c = l(o ? this.translate : -this.translate),
				  u = r.map(function (e) {
					return l(e);
				  }),
				  h =
					(a.map(function (e) {
					  return l(e);
					}),
					r[u.indexOf(c)],
					r[u.indexOf(c) - 1]);
				return (
				  void 0 !== h &&
					(d = a.indexOf(h)) < 0 &&
					(d = this.activeIndex - 1),
				  this.slideTo(d, e, t, i)
				);
			  },
			  slideReset: function (e, t, i) {
				return (
				  void 0 === e && (e = this.params.speed),
				  void 0 === t && (t = !0),
				  this.slideTo(this.activeIndex, e, t, i)
				);
			  },
			  slideToClosest: function (e, t, i) {
				void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
				var n = this.activeIndex,
				  s = Math.floor(n / this.params.slidesPerGroup);
				if (s < this.snapGrid.length - 1) {
				  var r = this.rtlTranslate ? this.translate : -this.translate,
					a = this.snapGrid[s];
				  r - a > (this.snapGrid[s + 1] - a) / 2 &&
					(n = this.params.slidesPerGroup);
				}
				return this.slideTo(n, e, t, i);
			  },
			  slideToClickedSlide: function () {
				var e,
				  t = this,
				  i = t.params,
				  n = t.$wrapperEl,
				  s =
					"auto" === i.slidesPerView
					  ? t.slidesPerViewDynamic()
					  : i.slidesPerView,
				  r = t.clickedIndex;
				if (i.loop) {
				  if (t.animating) return;
				  (e = parseInt(
					P(t.clickedSlide).attr("data-swiper-slide-index"),
					10
				  )),
					i.centeredSlides
					  ? r < t.loopedSlides - s / 2 ||
						r > t.slides.length - t.loopedSlides + s / 2
						? (t.loopFix(),
						  (r = n
							.children(
							  "." +
								i.slideClass +
								'[data-swiper-slide-index="' +
								e +
								'"]:not(.' +
								i.slideDuplicateClass +
								")"
							)
							.eq(0)
							.index()),
						  j.nextTick(function () {
							t.slideTo(r);
						  }))
						: t.slideTo(r)
					  : r > t.slides.length - s
					  ? (t.loopFix(),
						(r = n
						  .children(
							"." +
							  i.slideClass +
							  '[data-swiper-slide-index="' +
							  e +
							  '"]:not(.' +
							  i.slideDuplicateClass +
							  ")"
						  )
						  .eq(0)
						  .index()),
						j.nextTick(function () {
						  t.slideTo(r);
						}))
					  : t.slideTo(r);
				} else t.slideTo(r);
			  },
			},
			u = {
			  loopCreate: function () {
				var n = this,
				  e = n.params,
				  t = n.$wrapperEl;
				t.children(
				  "." + e.slideClass + "." + e.slideDuplicateClass
				).remove();
				var s = t.children("." + e.slideClass);
				if (e.loopFillGroupWithBlank) {
				  var i = e.slidesPerGroup - (s.length % e.slidesPerGroup);
				  if (i !== e.slidesPerGroup) {
					for (var r = 0; r < i; r += 1) {
					  var a = P(f.createElement("div")).addClass(
						e.slideClass + " " + e.slideBlankClass
					  );
					  t.append(a);
					}
					s = t.children("." + e.slideClass);
				  }
				}
				"auto" !== e.slidesPerView ||
				  e.loopedSlides ||
				  (e.loopedSlides = s.length),
				  (n.loopedSlides = parseInt(
					e.loopedSlides || e.slidesPerView,
					10
				  )),
				  (n.loopedSlides += e.loopAdditionalSlides),
				  n.loopedSlides > s.length && (n.loopedSlides = s.length);
				var o = [],
				  l = [];
				s.each(function (e, t) {
				  var i = P(t);
				  e < n.loopedSlides && l.push(t),
					e < s.length && e >= s.length - n.loopedSlides && o.push(t),
					i.attr("data-swiper-slide-index", e);
				});
				for (var d = 0; d < l.length; d += 1)
				  t.append(P(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
				for (var c = o.length - 1; 0 <= c; --c)
				  t.prepend(
					P(o[c].cloneNode(!0)).addClass(e.slideDuplicateClass)
				  );
			  },
			  loopFix: function () {
				var e,
				  t = this.params,
				  i = this.activeIndex,
				  n = this.slides,
				  s = this.loopedSlides,
				  r = this.allowSlidePrev,
				  a = this.allowSlideNext,
				  o = this.snapGrid,
				  l = this.rtlTranslate;
				(this.allowSlidePrev = !0), (this.allowSlideNext = !0);
				var d = -o[i] - this.getTranslate();
				i < s
				  ? ((e = n.length - 3 * s + i),
					(e += s),
					this.slideTo(e, 0, !1, !0) &&
					  0 != d &&
					  this.setTranslate(
						(l ? -this.translate : this.translate) - d
					  ))
				  : (("auto" === t.slidesPerView && 2 * s <= i) ||
					  i >= n.length - s) &&
					((e = -n.length + i + s),
					(e += s),
					this.slideTo(e, 0, !1, !0) &&
					  0 != d &&
					  this.setTranslate(
						(l ? -this.translate : this.translate) - d
					  )),
				  (this.allowSlidePrev = r),
				  (this.allowSlideNext = a);
			  },
			  loopDestroy: function () {
				var e = this.$wrapperEl,
				  t = this.params,
				  i = this.slides;
				e
				  .children("." + t.slideClass + "." + t.slideDuplicateClass)
				  .remove(),
				  i.removeAttr("data-swiper-slide-index");
			  },
			},
			h = {
			  setGrabCursor: function (e) {
				if (
				  !(
					q.touch ||
					!this.params.simulateTouch ||
					(this.params.watchOverflow && this.isLocked)
				  )
				) {
				  var t = this.el;
				  (t.style.cursor = "move"),
					(t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
					(t.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
					(t.style.cursor = e ? "grabbing" : "grab");
				}
			  },
			  unsetGrabCursor: function () {
				q.touch ||
				  (this.params.watchOverflow && this.isLocked) ||
				  (this.el.style.cursor = "");
			  },
			},
			p = {
			  appendSlide: function (e) {
				var t = this.$wrapperEl,
				  i = this.params;
				if (
				  (i.loop && this.loopDestroy(),
				  "object" == _typeof(e) && "length" in e)
				)
				  for (var n = 0; n < e.length; n += 1) e[n] && t.append(e[n]);
				else t.append(e);
				i.loop && this.loopCreate(),
				  (i.observer && q.observer) || this.update();
			  },
			  prependSlide: function (e) {
				var t = this.params,
				  i = this.$wrapperEl,
				  n = this.activeIndex;
				t.loop && this.loopDestroy();
				var s = n + 1;
				if ("object" == _typeof(e) && "length" in e) {
				  for (var r = 0; r < e.length; r += 1) e[r] && i.prepend(e[r]);
				  s = n + e.length;
				} else i.prepend(e);
				t.loop && this.loopCreate(),
				  (t.observer && q.observer) || this.update(),
				  this.slideTo(s, 0, !1);
			  },
			  addSlide: function (e, t) {
				var i = this.$wrapperEl,
				  n = this.params,
				  s = this.activeIndex;
				n.loop &&
				  ((s -= this.loopedSlides),
				  this.loopDestroy(),
				  (this.slides = i.children("." + n.slideClass)));
				var r = this.slides.length;
				if (e <= 0) this.prependSlide(t);
				else if (r <= e) this.appendSlide(t);
				else {
				  for (
					var a = e < s ? s + 1 : s, o = [], l = r - 1;
					e <= l;
					--l
				  ) {
					var d = this.slides.eq(l);
					d.remove(), o.unshift(d);
				  }
				  if ("object" == _typeof(t) && "length" in t) {
					for (var c = 0; c < t.length; c += 1) t[c] && i.append(t[c]);
					a = e < s ? s + t.length : s;
				  } else i.append(t);
				  for (var u = 0; u < o.length; u += 1) i.append(o[u]);
				  n.loop && this.loopCreate(),
					(n.observer && q.observer) || this.update(),
					n.loop
					  ? this.slideTo(a + this.loopedSlides, 0, !1)
					  : this.slideTo(a, 0, !1);
				}
			  },
			  removeSlide: function (e) {
				var t = this.params,
				  i = this.$wrapperEl,
				  n = this.activeIndex;
				t.loop &&
				  ((n -= this.loopedSlides),
				  this.loopDestroy(),
				  (this.slides = i.children("." + t.slideClass)));
				var s,
				  r = n;
				if ("object" == _typeof(e) && "length" in e) {
				  for (var a = 0; a < e.length; a += 1)
					(s = e[a]),
					  this.slides[s] && this.slides.eq(s).remove(),
					  s < r && --r;
				  r = Math.max(r, 0);
				} else
				  (s = e),
					this.slides[s] && this.slides.eq(s).remove(),
					s < r && --r,
					(r = Math.max(r, 0));
				t.loop && this.loopCreate(),
				  (t.observer && q.observer) || this.update(),
				  t.loop
					? this.slideTo(r + this.loopedSlides, 0, !1)
					: this.slideTo(r, 0, !1);
			  },
			  removeAllSlides: function () {
				for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
				this.removeSlide(e);
			  },
			},
			v = (function () {
			  var e = H.navigator.userAgent,
				t = {
				  ios: !1,
				  android: !1,
				  androidChrome: !1,
				  desktop: !1,
				  windows: !1,
				  iphone: !1,
				  ipod: !1,
				  ipad: !1,
				  cordova: H.cordova || H.phonegap,
				  phonegap: H.cordova || H.phonegap,
				},
				i = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
				n = e.match(/(Android);?[\s\/]+([\d.]+)?/),
				s = e.match(/(iPad).*OS\s([\d_]+)/),
				r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
				a = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
			  if (
				(i &&
				  ((t.os = "windows"), (t.osVersion = i[2]), (t.windows = !0)),
				n &&
				  !i &&
				  ((t.os = "android"),
				  (t.osVersion = n[2]),
				  (t.android = !0),
				  (t.androidChrome = 0 <= e.toLowerCase().indexOf("chrome"))),
				(s || a || r) && ((t.os = "ios"), (t.ios = !0)),
				a &&
				  !r &&
				  ((t.osVersion = a[2].replace(/_/g, ".")), (t.iphone = !0)),
				s && ((t.osVersion = s[2].replace(/_/g, ".")), (t.ipad = !0)),
				r &&
				  ((t.osVersion = r[3] ? r[3].replace(/_/g, ".") : null),
				  (t.iphone = !0)),
				t.ios &&
				  t.osVersion &&
				  0 <= e.indexOf("Version/") &&
				  "10" === t.osVersion.split(".")[0] &&
				  (t.osVersion = e
					.toLowerCase()
					.split("version/")[1]
					.split(" ")[0]),
				(t.desktop = !(t.os || t.android || t.webView)),
				(t.webView =
				  (a || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i)),
				t.os && "ios" === t.os)
			  ) {
				var o = t.osVersion.split("."),
				  l = f.querySelector('meta[name="viewport"]');
				t.minimalUi =
				  !t.webView &&
				  (r || a) &&
				  (7 == +o[0] ? 1 <= +o[1] : 7 < +o[0]) &&
				  l &&
				  0 <= l.getAttribute("content").indexOf("minimal-ui");
			  }
			  return (t.pixelRatio = H.devicePixelRatio || 1), t;
			})();
		  function g() {
			var e = this.params,
			  t = this.el;
			if (!t || 0 !== t.offsetWidth) {
			  e.breakpoints && this.setBreakpoint();
			  var i = this.allowSlideNext,
				n = this.allowSlidePrev,
				s = this.snapGrid;
			  if (
				((this.allowSlideNext = !0),
				(this.allowSlidePrev = !0),
				this.updateSize(),
				this.updateSlides(),
				e.freeMode)
			  ) {
				var r = Math.min(
				  Math.max(this.translate, this.maxTranslate()),
				  this.minTranslate()
				);
				this.setTranslate(r),
				  this.updateActiveIndex(),
				  this.updateSlidesClasses(),
				  e.autoHeight && this.updateAutoHeight();
			  } else
				this.updateSlidesClasses(),
				  ("auto" === e.slidesPerView || 1 < e.slidesPerView) &&
				  this.isEnd &&
				  !this.params.centeredSlides
					? this.slideTo(this.slides.length - 1, 0, !1, !0)
					: this.slideTo(this.activeIndex, 0, !1, !0);
			  (this.allowSlidePrev = n),
				(this.allowSlideNext = i),
				this.params.watchOverflow &&
				  s !== this.snapGrid &&
				  this.checkOverflow();
			}
		  }
		  var m,
			y = {
			  attachEvents: function () {
				var e = this.params,
				  t = this.touchEvents,
				  i = this.el,
				  n = this.wrapperEl;
				(this.onTouchStart = function (e) {
				  var t = this.touchEventsData,
					i = this.params,
					n = this.touches;
				  if (!this.animating || !i.preventIntercationOnTransition) {
					var s = e;
					if (
					  (s.originalEvent && (s = s.originalEvent),
					  (t.isTouchEvent = "touchstart" === s.type),
					  (t.isTouchEvent || !("which" in s) || 3 !== s.which) &&
						(!t.isTouched || !t.isMoved))
					)
					  if (
						i.noSwiping &&
						P(s.target).closest(
						  i.noSwipingSelector
							? i.noSwipingSelector
							: "." + i.noSwipingClass
						)[0]
					  )
						this.allowClick = !0;
					  else if (
						!i.swipeHandler ||
						P(s).closest(i.swipeHandler)[0]
					  ) {
						(n.currentX =
						  "touchstart" === s.type
							? s.targetTouches[0].pageX
							: s.pageX),
						  (n.currentY =
							"touchstart" === s.type
							  ? s.targetTouches[0].pageY
							  : s.pageY);
						var r = n.currentX,
						  a = n.currentY;
						if (
						  !v.ios ||
						  v.cordova ||
						  !i.iOSEdgeSwipeDetection ||
						  !(
							r <= i.iOSEdgeSwipeThreshold ||
							r >= H.screen.width - i.iOSEdgeSwipeThreshold
						  )
						) {
						  if (
							(j.extend(t, {
							  isTouched: !0,
							  isMoved: !1,
							  allowTouchCallbacks: !0,
							  isScrolling: void 0,
							  startMoving: void 0,
							}),
							(n.startX = r),
							(n.startY = a),
							(t.touchStartTime = j.now()),
							(this.allowClick = !0),
							this.updateSize(),
							(this.swipeDirection = void 0),
							0 < i.threshold && (t.allowThresholdMove = !1),
							"touchstart" !== s.type)
						  ) {
							var o = !0;
							P(s.target).is(t.formElements) && (o = !1),
							  f.activeElement &&
								P(f.activeElement).is(t.formElements) &&
								f.activeElement !== s.target &&
								f.activeElement.blur(),
							  o && this.allowTouchMove && s.preventDefault();
						  }
						  this.emit("touchStart", s);
						}
					  }
				  }
				}.bind(this)),
				  (this.onTouchMove = function (e) {
					var t = this.touchEventsData,
					  i = this.params,
					  n = this.touches,
					  s = this.rtlTranslate,
					  r = e;
					if ((r.originalEvent && (r = r.originalEvent), t.isTouched)) {
					  if (!t.isTouchEvent || "mousemove" !== r.type) {
						var a =
							"touchmove" === r.type
							  ? r.targetTouches[0].pageX
							  : r.pageX,
						  o =
							"touchmove" === r.type
							  ? r.targetTouches[0].pageY
							  : r.pageY;
						if (r.preventedByNestedSwiper)
						  return (n.startX = a), void (n.startY = o);
						if (!this.allowTouchMove)
						  return (
							(this.allowClick = !1),
							void (
							  t.isTouched &&
							  (j.extend(n, {
								startX: a,
								startY: o,
								currentX: a,
								currentY: o,
							  }),
							  (t.touchStartTime = j.now()))
							)
						  );
						if (t.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
						  if (this.isVertical()) {
							if (
							  (o < n.startY &&
								this.translate <= this.maxTranslate()) ||
							  (o > n.startY &&
								this.translate >= this.minTranslate())
							)
							  return (t.isTouched = !1), void (t.isMoved = !1);
						  } else if (
							(a < n.startX &&
							  this.translate <= this.maxTranslate()) ||
							(a > n.startX &&
							  this.translate >= this.minTranslate())
						  )
							return;
						if (
						  t.isTouchEvent &&
						  f.activeElement &&
						  r.target === f.activeElement &&
						  P(r.target).is(t.formElements)
						)
						  return (t.isMoved = !0), void (this.allowClick = !1);
						if (
						  (t.allowTouchCallbacks && this.emit("touchMove", r),
						  !(r.targetTouches && 1 < r.targetTouches.length))
						) {
						  (n.currentX = a), (n.currentY = o);
						  var l,
							d = n.currentX - n.startX,
							c = n.currentY - n.startY;
						  if (
							(void 0 === t.isScrolling &&
							  ((this.isHorizontal() && n.currentY === n.startY) ||
							  (this.isVertical() && n.currentX === n.startX)
								? (t.isScrolling = !1)
								: 25 <= d * d + c * c &&
								  ((l =
									(180 * Math.atan2(Math.abs(c), Math.abs(d))) /
									Math.PI),
								  (t.isScrolling = this.isHorizontal()
									? l > i.touchAngle
									: 90 - l > i.touchAngle))),
							t.isScrolling && this.emit("touchMoveOpposite", r),
							"undefined" == typeof startMoving &&
							  ((n.currentX === n.startX &&
								n.currentY === n.startY) ||
								(t.startMoving = !0)),
							t.isScrolling)
						  )
							t.isTouched = !1;
						  else if (t.startMoving) {
							(this.allowClick = !1),
							  r.preventDefault(),
							  i.touchMoveStopPropagation &&
								!i.nested &&
								r.stopPropagation(),
							  t.isMoved ||
								(i.loop && this.loopFix(),
								(t.startTranslate = this.getTranslate()),
								this.setTransition(0),
								this.animating &&
								  this.$wrapperEl.trigger(
									"webkitTransitionEnd transitionend"
								  ),
								(t.allowMomentumBounce = !1),
								!i.grabCursor ||
								  (!0 !== this.allowSlideNext &&
									!0 !== this.allowSlidePrev) ||
								  this.setGrabCursor(!0),
								this.emit("sliderFirstMove", r)),
							  this.emit("sliderMove", r),
							  (t.isMoved = !0);
							var u = this.isHorizontal() ? d : c;
							(n.diff = u),
							  (u *= i.touchRatio),
							  s && (u = -u),
							  (this.swipeDirection = 0 < u ? "prev" : "next"),
							  (t.currentTranslate = u + t.startTranslate);
							var h = !0,
							  p = i.resistanceRatio;
							if (
							  (i.touchReleaseOnEdges && (p = 0),
							  0 < u && t.currentTranslate > this.minTranslate()
								? ((h = !1),
								  i.resistance &&
									(t.currentTranslate =
									  this.minTranslate() -
									  1 +
									  Math.pow(
										-this.minTranslate() +
										  t.startTranslate +
										  u,
										p
									  )))
								: u < 0 &&
								  t.currentTranslate < this.maxTranslate() &&
								  ((h = !1),
								  i.resistance &&
									(t.currentTranslate =
									  this.maxTranslate() +
									  1 -
									  Math.pow(
										this.maxTranslate() -
										  t.startTranslate -
										  u,
										p
									  ))),
							  h && (r.preventedByNestedSwiper = !0),
							  !this.allowSlideNext &&
								"next" === this.swipeDirection &&
								t.currentTranslate < t.startTranslate &&
								(t.currentTranslate = t.startTranslate),
							  !this.allowSlidePrev &&
								"prev" === this.swipeDirection &&
								t.currentTranslate > t.startTranslate &&
								(t.currentTranslate = t.startTranslate),
							  0 < i.threshold)
							) {
							  if (
								!(
								  Math.abs(u) > i.threshold ||
								  t.allowThresholdMove
								)
							  )
								return void (t.currentTranslate =
								  t.startTranslate);
							  if (!t.allowThresholdMove)
								return (
								  (t.allowThresholdMove = !0),
								  (n.startX = n.currentX),
								  (n.startY = n.currentY),
								  (t.currentTranslate = t.startTranslate),
								  void (n.diff = this.isHorizontal()
									? n.currentX - n.startX
									: n.currentY - n.startY)
								);
							}
							i.followFinger &&
							  ((i.freeMode ||
								i.watchSlidesProgress ||
								i.watchSlidesVisibility) &&
								(this.updateActiveIndex(),
								this.updateSlidesClasses()),
							  i.freeMode &&
								(0 === t.velocities.length &&
								  t.velocities.push({
									position:
									  n[
										this.isHorizontal() ? "startX" : "startY"
									  ],
									time: t.touchStartTime,
								  }),
								t.velocities.push({
								  position:
									n[
									  this.isHorizontal()
										? "currentX"
										: "currentY"
									],
								  time: j.now(),
								})),
							  this.updateProgress(t.currentTranslate),
							  this.setTranslate(t.currentTranslate));
						  }
						}
					  }
					} else
					  t.startMoving &&
						t.isScrolling &&
						this.emit("touchMoveOpposite", r);
				  }.bind(this)),
				  (this.onTouchEnd = function (e) {
					var t = this,
					  i = t.touchEventsData,
					  n = t.params,
					  s = t.touches,
					  r = t.rtlTranslate,
					  a = t.$wrapperEl,
					  o = t.slidesGrid,
					  l = t.snapGrid,
					  d = e;
					if (
					  (d.originalEvent && (d = d.originalEvent),
					  i.allowTouchCallbacks && t.emit("touchEnd", d),
					  (i.allowTouchCallbacks = !1),
					  !i.isTouched)
					)
					  return (
						i.isMoved && n.grabCursor && t.setGrabCursor(!1),
						(i.isMoved = !1),
						void (i.startMoving = !1)
					  );
					n.grabCursor &&
					  i.isMoved &&
					  i.isTouched &&
					  (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
					  t.setGrabCursor(!1);
					var c,
					  u = j.now(),
					  h = u - i.touchStartTime;
					if (
					  (t.allowClick &&
						(t.updateClickedSlide(d),
						t.emit("tap", d),
						h < 300 &&
						  300 < u - i.lastClickTime &&
						  (i.clickTimeout && clearTimeout(i.clickTimeout),
						  (i.clickTimeout = j.nextTick(function () {
							t && !t.destroyed && t.emit("click", d);
						  }, 300))),
						h < 300 &&
						  u - i.lastClickTime < 300 &&
						  (i.clickTimeout && clearTimeout(i.clickTimeout),
						  t.emit("doubleTap", d))),
					  (i.lastClickTime = j.now()),
					  j.nextTick(function () {
						t.destroyed || (t.allowClick = !0);
					  }),
					  !i.isTouched ||
						!i.isMoved ||
						!t.swipeDirection ||
						0 === s.diff ||
						i.currentTranslate === i.startTranslate)
					)
					  return (
						(i.isTouched = !1),
						(i.isMoved = !1),
						void (i.startMoving = !1)
					  );
					if (
					  ((i.isTouched = !1),
					  (i.isMoved = !1),
					  (i.startMoving = !1),
					  (c = n.followFinger
						? r
						  ? t.translate
						  : -t.translate
						: -i.currentTranslate),
					  n.freeMode)
					) {
					  if (c < -t.minTranslate())
						return void t.slideTo(t.activeIndex);
					  if (c > -t.maxTranslate())
						return void (t.slides.length < l.length
						  ? t.slideTo(l.length - 1)
						  : t.slideTo(t.slides.length - 1));
					  if (n.freeModeMomentum) {
						if (1 < i.velocities.length) {
						  var p = i.velocities.pop(),
							f = i.velocities.pop(),
							v = p.position - f.position,
							g = p.time - f.time;
						  (t.velocity = v / g),
							(t.velocity /= 2),
							Math.abs(t.velocity) < n.freeModeMinimumVelocity &&
							  (t.velocity = 0),
							(150 < g || 300 < j.now() - p.time) &&
							  (t.velocity = 0);
						} else t.velocity = 0;
						(t.velocity *= n.freeModeMomentumVelocityRatio),
						  (i.velocities.length = 0);
						var m = 1e3 * n.freeModeMomentumRatio,
						  y = t.velocity * m,
						  b = t.translate + y;
						r && (b = -b);
						var w,
						  x,
						  T = !1,
						  S =
							20 *
							Math.abs(t.velocity) *
							n.freeModeMomentumBounceRatio;
						if (b < t.maxTranslate())
						  n.freeModeMomentumBounce
							? (b + t.maxTranslate() < -S &&
								(b = t.maxTranslate() - S),
							  (w = t.maxTranslate()),
							  (T = !0),
							  (i.allowMomentumBounce = !0))
							: (b = t.maxTranslate()),
							n.loop && n.centeredSlides && (x = !0);
						else if (b > t.minTranslate())
						  n.freeModeMomentumBounce
							? (b - t.minTranslate() > S &&
								(b = t.minTranslate() + S),
							  (w = t.minTranslate()),
							  (T = !0),
							  (i.allowMomentumBounce = !0))
							: (b = t.minTranslate()),
							n.loop && n.centeredSlides && (x = !0);
						else if (n.freeModeSticky) {
						  for (var C, E = 0; E < l.length; E += 1)
							if (l[E] > -b) {
							  C = E;
							  break;
							}
						  b = -(Math.abs(l[C] - b) < Math.abs(l[C - 1] - b) ||
						  "next" === t.swipeDirection
							? l[C]
							: l[C - 1]);
						}
						if (
						  (x &&
							t.once("transitionEnd", function () {
							  t.loopFix();
							}),
						  0 !== t.velocity)
						)
						  m = r
							? Math.abs((-b - t.translate) / t.velocity)
							: Math.abs((b - t.translate) / t.velocity);
						else if (n.freeModeSticky) return void t.slideToClosest();
						n.freeModeMomentumBounce && T
						  ? (t.updateProgress(w),
							t.setTransition(m),
							t.setTranslate(b),
							t.transitionStart(!0, t.swipeDirection),
							(t.animating = !0),
							a.transitionEnd(function () {
							  t &&
								!t.destroyed &&
								i.allowMomentumBounce &&
								(t.emit("momentumBounce"),
								t.setTransition(n.speed),
								t.setTranslate(w),
								a.transitionEnd(function () {
								  t && !t.destroyed && t.transitionEnd();
								}));
							}))
						  : t.velocity
						  ? (t.updateProgress(b),
							t.setTransition(m),
							t.setTranslate(b),
							t.transitionStart(!0, t.swipeDirection),
							t.animating ||
							  ((t.animating = !0),
							  a.transitionEnd(function () {
								t && !t.destroyed && t.transitionEnd();
							  })))
						  : t.updateProgress(b),
						  t.updateActiveIndex(),
						  t.updateSlidesClasses();
					  } else if (n.freeModeSticky) return void t.slideToClosest();
					  (!n.freeModeMomentum || h >= n.longSwipesMs) &&
						(t.updateProgress(),
						t.updateActiveIndex(),
						t.updateSlidesClasses());
					} else {
					  for (
						var k = 0, Y = t.slidesSizesGrid[0], z = 0;
						z < o.length;
						z += n.slidesPerGroup
					  )
						void 0 !== o[z + n.slidesPerGroup]
						  ? c >= o[z] &&
							c < o[z + n.slidesPerGroup] &&
							(Y = o[(k = z) + n.slidesPerGroup] - o[z])
						  : c >= o[z] &&
							((k = z), (Y = o[o.length - 1] - o[o.length - 2]));
					  var $ = (c - o[k]) / Y;
					  if (h > n.longSwipesMs) {
						if (!n.longSwipes) return void t.slideTo(t.activeIndex);
						"next" === t.swipeDirection &&
						  ($ >= n.longSwipesRatio
							? t.slideTo(k + n.slidesPerGroup)
							: t.slideTo(k)),
						  "prev" === t.swipeDirection &&
							($ > 1 - n.longSwipesRatio
							  ? t.slideTo(k + n.slidesPerGroup)
							  : t.slideTo(k));
					  } else {
						if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
						"next" === t.swipeDirection &&
						  t.slideTo(k + n.slidesPerGroup),
						  "prev" === t.swipeDirection && t.slideTo(k);
					  }
					}
				  }.bind(this)),
				  (this.onClick = function (e) {
					this.allowClick ||
					  (this.params.preventClicks && e.preventDefault(),
					  this.params.preventClicksPropagation &&
						this.animating &&
						(e.stopPropagation(), e.stopImmediatePropagation()));
				  }.bind(this));
				var s = "container" === e.touchEventsTarget ? i : n,
				  r = !!e.nested;
				if (q.touch || (!q.pointerEvents && !q.prefixedPointerEvents)) {
				  if (q.touch) {
					var a = !(
					  "touchstart" !== t.start ||
					  !q.passiveListener ||
					  !e.passiveListeners
					) && { passive: !0, capture: !1 };
					s.addEventListener(t.start, this.onTouchStart, a),
					  s.addEventListener(
						t.move,
						this.onTouchMove,
						q.passiveListener ? { passive: !1, capture: r } : r
					  ),
					  s.addEventListener(t.end, this.onTouchEnd, a);
				  }
				  ((e.simulateTouch && !v.ios && !v.android) ||
					(e.simulateTouch && !q.touch && v.ios)) &&
					(s.addEventListener("mousedown", this.onTouchStart, !1),
					f.addEventListener("mousemove", this.onTouchMove, r),
					f.addEventListener("mouseup", this.onTouchEnd, !1));
				} else
				  s.addEventListener(t.start, this.onTouchStart, !1),
					f.addEventListener(t.move, this.onTouchMove, r),
					f.addEventListener(t.end, this.onTouchEnd, !1);
				(e.preventClicks || e.preventClicksPropagation) &&
				  s.addEventListener("click", this.onClick, !0),
				  this.on(
					v.ios || v.android
					  ? "resize orientationchange observerUpdate"
					  : "resize observerUpdate",
					g,
					!0
				  );
			  },
			  detachEvents: function () {
				var e = this.params,
				  t = this.touchEvents,
				  i = this.el,
				  n = this.wrapperEl,
				  s = "container" === e.touchEventsTarget ? i : n,
				  r = !!e.nested;
				if (q.touch || (!q.pointerEvents && !q.prefixedPointerEvents)) {
				  if (q.touch) {
					var a = !(
					  "onTouchStart" !== t.start ||
					  !q.passiveListener ||
					  !e.passiveListeners
					) && { passive: !0, capture: !1 };
					s.removeEventListener(t.start, this.onTouchStart, a),
					  s.removeEventListener(t.move, this.onTouchMove, r),
					  s.removeEventListener(t.end, this.onTouchEnd, a);
				  }
				  ((e.simulateTouch && !v.ios && !v.android) ||
					(e.simulateTouch && !q.touch && v.ios)) &&
					(s.removeEventListener("mousedown", this.onTouchStart, !1),
					f.removeEventListener("mousemove", this.onTouchMove, r),
					f.removeEventListener("mouseup", this.onTouchEnd, !1));
				} else
				  s.removeEventListener(t.start, this.onTouchStart, !1),
					f.removeEventListener(t.move, this.onTouchMove, r),
					f.removeEventListener(t.end, this.onTouchEnd, !1);
				(e.preventClicks || e.preventClicksPropagation) &&
				  s.removeEventListener("click", this.onClick, !0),
				  this.off(
					v.ios || v.android
					  ? "resize orientationchange observerUpdate"
					  : "resize observerUpdate",
					g
				  );
			  },
			},
			b = {
			  setBreakpoint: function () {
				var e = this.activeIndex,
				  t = this.initialized,
				  i = this.loopedSlides;
				void 0 === i && (i = 0);
				var n = this.params,
				  s = n.breakpoints;
				if (s && (!s || 0 !== Object.keys(s).length)) {
				  var r = this.getBreakpoint(s);
				  if (r && this.currentBreakpoint !== r) {
					var a = r in s ? s[r] : this.originalParams,
					  o = n.loop && a.slidesPerView !== n.slidesPerView;
					j.extend(this.params, a),
					  j.extend(this, {
						allowTouchMove: this.params.allowTouchMove,
						allowSlideNext: this.params.allowSlideNext,
						allowSlidePrev: this.params.allowSlidePrev,
					  }),
					  (this.currentBreakpoint = r),
					  o &&
						t &&
						(this.loopDestroy(),
						this.loopCreate(),
						this.updateSlides(),
						this.slideTo(e - i + this.loopedSlides, 0, !1)),
					  this.emit("breakpoint", a);
				  }
				}
			  },
			  getBreakpoint: function (e) {
				if (e) {
				  var t = !1,
					i = [];
				  Object.keys(e).forEach(function (e) {
					i.push(e);
				  }),
					i.sort(function (e, t) {
					  return parseInt(e, 10) - parseInt(t, 10);
					});
				  for (var n = 0; n < i.length; n += 1) {
					var s = i[n];
					s >= H.innerWidth && !t && (t = s);
				  }
				  return t || "max";
				}
			  },
			},
			A = {
			  isIE:
				!!H.navigator.userAgent.match(/Trident/g) ||
				!!H.navigator.userAgent.match(/MSIE/g),
			  isSafari:
				0 <=
				  (m = H.navigator.userAgent.toLowerCase()).indexOf("safari") &&
				m.indexOf("chrome") < 0 &&
				m.indexOf("android") < 0,
			  isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
				H.navigator.userAgent
			  ),
			},
			w = {
			  init: !0,
			  direction: "horizontal",
			  touchEventsTarget: "container",
			  initialSlide: 0,
			  speed: 300,
			  preventIntercationOnTransition: !1,
			  iOSEdgeSwipeDetection: !1,
			  iOSEdgeSwipeThreshold: 20,
			  freeMode: !1,
			  freeModeMomentum: !0,
			  freeModeMomentumRatio: 1,
			  freeModeMomentumBounce: !0,
			  freeModeMomentumBounceRatio: 1,
			  freeModeMomentumVelocityRatio: 1,
			  freeModeSticky: !1,
			  freeModeMinimumVelocity: 0.02,
			  autoHeight: !1,
			  setWrapperSize: !1,
			  virtualTranslate: !1,
			  effect: "slide",
			  breakpoints: void 0,
			  spaceBetween: 0,
			  slidesPerView: 1,
			  slidesPerColumn: 1,
			  slidesPerColumnFill: "column",
			  slidesPerGroup: 1,
			  centeredSlides: !1,
			  slidesOffsetBefore: 0,
			  slidesOffsetAfter: 0,
			  normalizeSlideIndex: !0,
			  watchOverflow: !1,
			  roundLengths: !1,
			  touchRatio: 1,
			  touchAngle: 45,
			  simulateTouch: !0,
			  shortSwipes: !0,
			  longSwipes: !0,
			  longSwipesRatio: 0.5,
			  longSwipesMs: 300,
			  followFinger: !0,
			  allowTouchMove: !0,
			  threshold: 0,
			  touchMoveStopPropagation: !0,
			  touchReleaseOnEdges: !1,
			  uniqueNavElements: !0,
			  resistance: !0,
			  resistanceRatio: 0.85,
			  watchSlidesProgress: !1,
			  watchSlidesVisibility: !1,
			  grabCursor: !1,
			  preventClicks: !0,
			  preventClicksPropagation: !0,
			  slideToClickedSlide: !1,
			  preloadImages: !0,
			  updateOnImagesReady: !0,
			  loop: !1,
			  loopAdditionalSlides: 0,
			  loopedSlides: null,
			  loopFillGroupWithBlank: !1,
			  allowSlidePrev: !0,
			  allowSlideNext: !0,
			  swipeHandler: null,
			  noSwiping: !0,
			  noSwipingClass: "swiper-no-swiping",
			  noSwipingSelector: null,
			  passiveListeners: !0,
			  containerModifierClass: "swiper-container-",
			  slideClass: "swiper-slide",
			  slideBlankClass: "swiper-slide-invisible-blank",
			  slideActiveClass: "swiper-slide-active",
			  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
			  slideVisibleClass: "swiper-slide-visible",
			  slideDuplicateClass: "swiper-slide-duplicate",
			  slideNextClass: "swiper-slide-next",
			  slideDuplicateNextClass: "swiper-slide-duplicate-next",
			  slidePrevClass: "swiper-slide-prev",
			  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
			  wrapperClass: "swiper-wrapper",
			  runCallbacksOnInit: !0,
			},
			x = {
			  update: o,
			  translate: d,
			  transition: {
				setTransition: function (e, t) {
				  this.$wrapperEl.transition(e), this.emit("setTransition", e, t);
				},
				transitionStart: function (e, t) {
				  void 0 === e && (e = !0);
				  var i = this.activeIndex,
					n = this.params,
					s = this.previousIndex;
				  n.autoHeight && this.updateAutoHeight();
				  var r = t;
				  if (
					((r = r || (s < i ? "next" : i < s ? "prev" : "reset")),
					this.emit("transitionStart"),
					e && i !== s)
				  ) {
					if ("reset" === r)
					  return void this.emit("slideResetTransitionStart");
					this.emit("slideChangeTransitionStart"),
					  "next" === r
						? this.emit("slideNextTransitionStart")
						: this.emit("slidePrevTransitionStart");
				  }
				},
				transitionEnd: function (e, t) {
				  void 0 === e && (e = !0);
				  var i = this.activeIndex,
					n = this.previousIndex;
				  (this.animating = !1), this.setTransition(0);
				  var s = t;
				  if (
					((s = s || (n < i ? "next" : i < n ? "prev" : "reset")),
					this.emit("transitionEnd"),
					e && i !== n)
				  ) {
					if ("reset" === s)
					  return void this.emit("slideResetTransitionEnd");
					this.emit("slideChangeTransitionEnd"),
					  "next" === s
						? this.emit("slideNextTransitionEnd")
						: this.emit("slidePrevTransitionEnd");
				  }
				},
			  },
			  slide: c,
			  loop: u,
			  grabCursor: h,
			  manipulation: p,
			  events: y,
			  breakpoints: b,
			  checkOverflow: {
				checkOverflow: function () {
				  var e = this.isLocked;
				  (this.isLocked = 1 === this.snapGrid.length),
					(this.allowSlideNext = !this.isLocked),
					(this.allowSlidePrev = !this.isLocked),
					e !== this.isLocked &&
					  this.emit(this.isLocked ? "lock" : "unlock"),
					e &&
					  e !== this.isLocked &&
					  ((this.isEnd = !1), this.navigation.update());
				},
			  },
			  classes: {
				addClasses: function () {
				  var t = this.classNames,
					i = this.params,
					e = this.rtl,
					n = this.$el,
					s = [];
				  s.push(i.direction),
					i.freeMode && s.push("free-mode"),
					q.flexbox || s.push("no-flexbox"),
					i.autoHeight && s.push("autoheight"),
					e && s.push("rtl"),
					1 < i.slidesPerColumn && s.push("multirow"),
					v.android && s.push("android"),
					v.ios && s.push("ios"),
					A.isIE &&
					  (q.pointerEvents || q.prefixedPointerEvents) &&
					  s.push("wp8-" + i.direction),
					s.forEach(function (e) {
					  t.push(i.containerModifierClass + e);
					}),
					n.addClass(t.join(" "));
				},
				removeClasses: function () {
				  var e = this.$el,
					t = this.classNames;
				  e.removeClass(t.join(" "));
				},
			  },
			  images: {
				loadImage: function (e, t, i, n, s, r) {
				  var a;
				  function o() {
					r && r();
				  }
				  (!e.complete || !s) && t
					? (((a = new H.Image()).onload = o),
					  (a.onerror = o),
					  n && (a.sizes = n),
					  i && (a.srcset = i),
					  t && (a.src = t))
					: o();
				},
				preloadImages: function () {
				  var e = this;
				  function t() {
					null != e &&
					  e &&
					  !e.destroyed &&
					  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
					  e.imagesLoaded === e.imagesToLoad.length &&
						(e.params.updateOnImagesReady && e.update(),
						e.emit("imagesReady")));
				  }
				  e.imagesToLoad = e.$el.find("img");
				  for (var i = 0; i < e.imagesToLoad.length; i += 1) {
					var n = e.imagesToLoad[i];
					e.loadImage(
					  n,
					  n.currentSrc || n.getAttribute("src"),
					  n.srcset || n.getAttribute("srcset"),
					  n.sizes || n.getAttribute("sizes"),
					  !0,
					  t
					);
				  }
				},
			  },
			},
			T = {},
			S = (function (u) {
			  function h() {
				for (var e, s, t = [], i = arguments.length; i--; )
				  t[i] = arguments[i];
				(s =
				  (s =
					1 === t.length &&
					t[0].constructor &&
					t[0].constructor === Object
					  ? t[0]
					  : ((e = t[0]), t[1])) || {}),
				  (s = j.extend({}, s)),
				  e && !s.el && (s.el = e),
				  u.call(this, s),
				  Object.keys(x).forEach(function (t) {
					Object.keys(x[t]).forEach(function (e) {
					  h.prototype[e] || (h.prototype[e] = x[t][e]);
					});
				  });
				var r = this;
				void 0 === r.modules && (r.modules = {}),
				  Object.keys(r.modules).forEach(function (e) {
					var t = r.modules[e];
					if (t.params) {
					  var i = Object.keys(t.params)[0],
						n = t.params[i];
					  if ("object" != _typeof(n)) return;
					  if (!(i in s && "enabled" in n)) return;
					  !0 === s[i] && (s[i] = { enabled: !0 }),
						"object" != _typeof(s[i]) ||
						  "enabled" in s[i] ||
						  (s[i].enabled = !0),
						s[i] || (s[i] = { enabled: !1 });
					}
				  });
				var n = j.extend({}, w);
				r.useModulesParams(n),
				  (r.params = j.extend({}, n, T, s)),
				  (r.originalParams = j.extend({}, r.params)),
				  (r.passedParams = j.extend({}, s));
				var a = (r.$ = P)(r.params.el);
				if ((e = a[0])) {
				  if (1 < a.length) {
					var o = [];
					return (
					  a.each(function (e, t) {
						var i = j.extend({}, s, { el: t });
						o.push(new h(i));
					  }),
					  o
					);
				  }
				  (e.swiper = r), a.data("swiper", r);
				  var l,
					d,
					c = a.children("." + r.params.wrapperClass);
				  return (
					j.extend(r, {
					  $el: a,
					  el: e,
					  $wrapperEl: c,
					  wrapperEl: c[0],
					  classNames: [],
					  slides: P(),
					  slidesGrid: [],
					  snapGrid: [],
					  slidesSizesGrid: [],
					  isHorizontal: function () {
						return "horizontal" === r.params.direction;
					  },
					  isVertical: function () {
						return "vertical" === r.params.direction;
					  },
					  rtl:
						"rtl" === e.dir.toLowerCase() ||
						"rtl" === a.css("direction"),
					  rtlTranslate:
						"horizontal" === r.params.direction &&
						("rtl" === e.dir.toLowerCase() ||
						  "rtl" === a.css("direction")),
					  wrongRTL: "-webkit-box" === c.css("display"),
					  activeIndex: 0,
					  realIndex: 0,
					  isBeginning: !0,
					  isEnd: !1,
					  translate: 0,
					  previousTranslate: 0,
					  progress: 0,
					  velocity: 0,
					  animating: !1,
					  allowSlideNext: r.params.allowSlideNext,
					  allowSlidePrev: r.params.allowSlidePrev,
					  touchEvents:
						((l = ["touchstart", "touchmove", "touchend"]),
						(d = ["mousedown", "mousemove", "mouseup"]),
						q.pointerEvents
						  ? (d = ["pointerdown", "pointermove", "pointerup"])
						  : q.prefixedPointerEvents &&
							(d = [
							  "MSPointerDown",
							  "MSPointerMove",
							  "MSPointerUp",
							]),
						(r.touchEventsTouch = {
						  start: l[0],
						  move: l[1],
						  end: l[2],
						}),
						(r.touchEventsDesktop = {
						  start: d[0],
						  move: d[1],
						  end: d[2],
						}),
						q.touch || !r.params.simulateTouch
						  ? r.touchEventsTouch
						  : r.touchEventsDesktop),
					  touchEventsData: {
						isTouched: void 0,
						isMoved: void 0,
						allowTouchCallbacks: void 0,
						touchStartTime: void 0,
						isScrolling: void 0,
						currentTranslate: void 0,
						startTranslate: void 0,
						allowThresholdMove: void 0,
						formElements:
						  "input, select, option, textarea, button, video",
						lastClickTime: j.now(),
						clickTimeout: void 0,
						velocities: [],
						allowMomentumBounce: void 0,
						isTouchEvent: void 0,
						startMoving: void 0,
					  },
					  allowClick: !0,
					  allowTouchMove: r.params.allowTouchMove,
					  touches: {
						startX: 0,
						startY: 0,
						currentX: 0,
						currentY: 0,
						diff: 0,
					  },
					  imagesToLoad: [],
					  imagesLoaded: 0,
					}),
					r.useModules(),
					r.params.init && r.init(),
					r
				  );
				}
			  }
			  u && (h.__proto__ = u);
			  var e = {
				extendedDefaults: { configurable: !0 },
				defaults: { configurable: !0 },
				Class: { configurable: !0 },
				$: { configurable: !0 },
			  };
			  return (
				(((h.prototype = Object.create(u && u.prototype)).constructor =
				  h).prototype.slidesPerViewDynamic = function () {
				  var e = this.params,
					t = this.slides,
					i = this.slidesGrid,
					n = this.size,
					s = this.activeIndex,
					r = 1;
				  if (e.centeredSlides) {
					for (
					  var a, o = t[s].swiperSlideSize, l = s + 1;
					  l < t.length;
					  l += 1
					)
					  t[l] &&
						!a &&
						((r += 1), (o += t[l].swiperSlideSize) > n && (a = !0));
					for (var d = s - 1; 0 <= d; --d)
					  t[d] &&
						!a &&
						((r += 1), (o += t[d].swiperSlideSize) > n && (a = !0));
				  } else
					for (var c = s + 1; c < t.length; c += 1)
					  i[c] - i[s] < n && (r += 1);
				  return r;
				}),
				(h.prototype.update = function () {
				  var i = this;
				  if (i && !i.destroyed) {
					var e = i.snapGrid,
					  t = i.params;
					t.breakpoints && i.setBreakpoint(),
					  i.updateSize(),
					  i.updateSlides(),
					  i.updateProgress(),
					  i.updateSlidesClasses(),
					  i.params.freeMode
						? (n(), i.params.autoHeight && i.updateAutoHeight())
						: (("auto" === i.params.slidesPerView ||
							1 < i.params.slidesPerView) &&
						  i.isEnd &&
						  !i.params.centeredSlides
							? i.slideTo(i.slides.length - 1, 0, !1, !0)
							: i.slideTo(i.activeIndex, 0, !1, !0)) || n(),
					  t.watchOverflow && e !== i.snapGrid && i.checkOverflow(),
					  i.emit("update");
				  }
				  function n() {
					var e = i.rtlTranslate ? -1 * i.translate : i.translate,
					  t = Math.min(
						Math.max(e, i.maxTranslate()),
						i.minTranslate()
					  );
					i.setTranslate(t),
					  i.updateActiveIndex(),
					  i.updateSlidesClasses();
				  }
				}),
				(h.prototype.init = function () {
				  this.initialized ||
					(this.emit("beforeInit"),
					this.params.breakpoints && this.setBreakpoint(),
					this.addClasses(),
					this.params.loop && this.loopCreate(),
					this.updateSize(),
					this.updateSlides(),
					this.params.watchOverflow && this.checkOverflow(),
					this.params.grabCursor && this.setGrabCursor(),
					this.params.preloadImages && this.preloadImages(),
					this.params.loop
					  ? this.slideTo(
						  this.params.initialSlide + this.loopedSlides,
						  0,
						  this.params.runCallbacksOnInit
						)
					  : this.slideTo(
						  this.params.initialSlide,
						  0,
						  this.params.runCallbacksOnInit
						),
					this.attachEvents(),
					(this.initialized = !0),
					this.emit("init"));
				}),
				(h.prototype.destroy = function (e, t) {
				  void 0 === e && (e = !0), void 0 === t && (t = !0);
				  var i = this,
					n = i.params,
					s = i.$el,
					r = i.$wrapperEl,
					a = i.slides;
				  return (
					void 0 === i.params ||
					  i.destroyed ||
					  (i.emit("beforeDestroy"),
					  (i.initialized = !1),
					  i.detachEvents(),
					  n.loop && i.loopDestroy(),
					  t &&
						(i.removeClasses(),
						s.removeAttr("style"),
						r.removeAttr("style"),
						a &&
						  a.length &&
						  a
							.removeClass(
							  [
								n.slideVisibleClass,
								n.slideActiveClass,
								n.slideNextClass,
								n.slidePrevClass,
							  ].join(" ")
							)
							.removeAttr("style")
							.removeAttr("data-swiper-slide-index")
							.removeAttr("data-swiper-column")
							.removeAttr("data-swiper-row")),
					  i.emit("destroy"),
					  Object.keys(i.eventsListeners).forEach(function (e) {
						i.off(e);
					  }),
					  !1 !== e &&
						((i.$el[0].swiper = null),
						i.$el.data("swiper", null),
						j.deleteProps(i)),
					  (i.destroyed = !0)),
					null
				  );
				}),
				(h.extendDefaults = function (e) {
				  j.extend(T, e);
				}),
				(e.extendedDefaults.get = function () {
				  return T;
				}),
				(e.defaults.get = function () {
				  return w;
				}),
				(e.Class.get = function () {
				  return u;
				}),
				(e.$.get = function () {
				  return P;
				}),
				Object.defineProperties(h, e),
				h
			  );
			})(e),
			C = { name: "device", proto: { device: v }, static: { device: v } },
			E = {
			  name: "support",
			  proto: { support: q },
			  static: { support: q },
			},
			k = {
			  name: "browser",
			  proto: { browser: A },
			  static: { browser: A },
			},
			Y = {
			  name: "resize",
			  create: function () {
				var e = this;
				j.extend(e, {
				  resize: {
					resizeHandler: function () {
					  e &&
						!e.destroyed &&
						e.initialized &&
						(e.emit("beforeResize"), e.emit("resize"));
					},
					orientationChangeHandler: function () {
					  e &&
						!e.destroyed &&
						e.initialized &&
						e.emit("orientationchange");
					},
				  },
				});
			  },
			  on: {
				init: function () {
				  H.addEventListener("resize", this.resize.resizeHandler),
					H.addEventListener(
					  "orientationchange",
					  this.resize.orientationChangeHandler
					);
				},
				destroy: function () {
				  H.removeEventListener("resize", this.resize.resizeHandler),
					H.removeEventListener(
					  "orientationchange",
					  this.resize.orientationChangeHandler
					);
				},
			  },
			},
			z = {
			  func: H.MutationObserver || H.WebkitMutationObserver,
			  attach: function (e, t) {
				void 0 === t && (t = {});
				var i = this,
				  n = new z.func(function (e) {
					e.forEach(function (e) {
					  i.emit("observerUpdate", e);
					});
				  });
				n.observe(e, {
				  attributes: void 0 === t.attributes || t.attributes,
				  childList: void 0 === t.childList || t.childList,
				  characterData: void 0 === t.characterData || t.characterData,
				}),
				  i.observer.observers.push(n);
			  },
			  init: function () {
				if (q.observer && this.params.observer) {
				  if (this.params.observeParents)
					for (var e = this.$el.parents(), t = 0; t < e.length; t += 1)
					  this.observer.attach(e[t]);
				  this.observer.attach(this.$el[0], { childList: !1 }),
					this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
				}
			  },
			  destroy: function () {
				this.observer.observers.forEach(function (e) {
				  e.disconnect();
				}),
				  (this.observer.observers = []);
			  },
			},
			$ = {
			  name: "observer",
			  params: { observer: !1, observeParents: !1 },
			  create: function () {
				j.extend(this, {
				  observer: {
					init: z.init.bind(this),
					attach: z.attach.bind(this),
					destroy: z.destroy.bind(this),
					observers: [],
				  },
				});
			  },
			  on: {
				init: function () {
				  this.observer.init();
				},
				destroy: function () {
				  this.observer.destroy();
				},
			  },
			},
			M = {
			  update: function (e) {
				var t = this,
				  i = t.params,
				  n = i.slidesPerView,
				  s = i.slidesPerGroup,
				  r = i.centeredSlides,
				  a = t.virtual,
				  o = a.from,
				  l = a.to,
				  d = a.slides,
				  c = a.slidesGrid,
				  u = a.renderSlide,
				  h = a.offset;
				t.updateActiveIndex();
				var p,
				  f,
				  v,
				  g = t.activeIndex || 0;
				(p = t.rtlTranslate
				  ? "right"
				  : t.isHorizontal()
				  ? "left"
				  : "top"),
				  (v = r
					? ((f = Math.floor(n / 2) + s), Math.floor(n / 2) + s)
					: ((f = n + (s - 1)), s));
				var m = Math.max((g || 0) - v, 0),
				  y = Math.min((g || 0) + f, d.length - 1),
				  b = (t.slidesGrid[m] || 0) - (t.slidesGrid[0] || 0);
				function w() {
				  t.updateSlides(),
					t.updateProgress(),
					t.updateSlidesClasses(),
					t.lazy && t.params.lazy.enabled && t.lazy.load();
				}
				if (
				  (j.extend(t.virtual, {
					from: m,
					to: y,
					offset: b,
					slidesGrid: t.slidesGrid,
				  }),
				  o === m && l === y && !e)
				)
				  return (
					t.slidesGrid !== c && b !== h && t.slides.css(p, b + "px"),
					void t.updateProgress()
				  );
				if (t.params.virtual.renderExternal)
				  return (
					t.params.virtual.renderExternal.call(t, {
					  offset: b,
					  from: m,
					  to: y,
					  slides: (function () {
						for (var e = [], t = m; t <= y; t += 1) e.push(d[t]);
						return e;
					  })(),
					}),
					void w()
				  );
				var x = [],
				  T = [];
				if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
				else
				  for (var S = o; S <= l; S += 1)
					(S < m || y < S) &&
					  t.$wrapperEl
						.find(
						  "." +
							t.params.slideClass +
							'[data-swiper-slide-index="' +
							S +
							'"]'
						)
						.remove();
				for (var C = 0; C < d.length; C += 1)
				  m <= C &&
					C <= y &&
					(void 0 === l || e
					  ? T.push(C)
					  : (l < C && T.push(C), C < o && x.push(C)));
				T.forEach(function (e) {
				  t.$wrapperEl.append(u(d[e], e));
				}),
				  x
					.sort(function (e, t) {
					  return e < t;
					})
					.forEach(function (e) {
					  t.$wrapperEl.prepend(u(d[e], e));
					}),
				  t.$wrapperEl.children(".swiper-slide").css(p, b + "px"),
				  w();
			  },
			  renderSlide: function (e, t) {
				var i = this.params.virtual;
				if (i.cache && this.virtual.cache[t])
				  return this.virtual.cache[t];
				var n = i.renderSlide
				  ? P(i.renderSlide.call(this, e, t))
				  : P(
					  '<div class="' +
						this.params.slideClass +
						'" data-swiper-slide-index="' +
						t +
						'">' +
						e +
						"</div>"
					);
				return (
				  n.attr("data-swiper-slide-index") ||
					n.attr("data-swiper-slide-index", t),
				  i.cache && (this.virtual.cache[t] = n),
				  n
				);
			  },
			  appendSlide: function (e) {
				this.virtual.slides.push(e), this.virtual.update(!0);
			  },
			  prependSlide: function (e) {
				if ((this.virtual.slides.unshift(e), this.params.virtual.cache)) {
				  var t = this.virtual.cache,
					i = {};
				  Object.keys(t).forEach(function (e) {
					i[e + 1] = t[e];
				  }),
					(this.virtual.cache = i);
				}
				this.virtual.update(!0), this.slideNext(0);
			  },
			},
			L = {
			  name: "virtual",
			  params: {
				virtual: {
				  enabled: !1,
				  slides: [],
				  cache: !0,
				  renderSlide: null,
				  renderExternal: null,
				},
			  },
			  create: function () {
				j.extend(this, {
				  virtual: {
					update: M.update.bind(this),
					appendSlide: M.appendSlide.bind(this),
					prependSlide: M.prependSlide.bind(this),
					renderSlide: M.renderSlide.bind(this),
					slides: this.params.virtual.slides,
					cache: {},
				  },
				});
			  },
			  on: {
				beforeInit: function () {
				  if (this.params.virtual.enabled) {
					this.classNames.push(
					  this.params.containerModifierClass + "virtual"
					);
					var e = { watchSlidesProgress: !0 };
					j.extend(this.params, e),
					  j.extend(this.originalParams, e),
					  this.virtual.update();
				  }
				},
				setTranslate: function () {
				  this.params.virtual.enabled && this.virtual.update();
				},
			  },
			},
			D = {
			  handle: function (e) {
				var t = this.rtlTranslate,
				  i = e;
				i.originalEvent && (i = i.originalEvent);
				var n = i.keyCode || i.charCode;
				if (
				  !this.allowSlideNext &&
				  ((this.isHorizontal() && 39 === n) ||
					(this.isVertical() && 40 === n))
				)
				  return !1;
				if (
				  !this.allowSlidePrev &&
				  ((this.isHorizontal() && 37 === n) ||
					(this.isVertical() && 38 === n))
				)
				  return !1;
				if (
				  !(
					i.shiftKey ||
					i.altKey ||
					i.ctrlKey ||
					i.metaKey ||
					(f.activeElement &&
					  f.activeElement.nodeName &&
					  ("input" === f.activeElement.nodeName.toLowerCase() ||
						"textarea" === f.activeElement.nodeName.toLowerCase()))
				  )
				) {
				  if (
					this.params.keyboard.onlyInViewport &&
					(37 === n || 39 === n || 38 === n || 40 === n)
				  ) {
					var s = !1;
					if (
					  0 < this.$el.parents("." + this.params.slideClass).length &&
					  0 ===
						this.$el.parents("." + this.params.slideActiveClass)
						  .length
					)
					  return;
					var r = H.innerWidth,
					  a = H.innerHeight,
					  o = this.$el.offset();
					t && (o.left -= this.$el[0].scrollLeft);
					for (
					  var l = [
						  [o.left, o.top],
						  [o.left + this.width, o.top],
						  [o.left, o.top + this.height],
						  [o.left + this.width, o.top + this.height],
						],
						d = 0;
					  d < l.length;
					  d += 1
					) {
					  var c = l[d];
					  0 <= c[0] &&
						c[0] <= r &&
						0 <= c[1] &&
						c[1] <= a &&
						(s = !0);
					}
					if (!s) return;
				  }
				  this.isHorizontal()
					? ((37 !== n && 39 !== n) ||
						(i.preventDefault
						  ? i.preventDefault()
						  : (i.returnValue = !1)),
					  ((39 === n && !t) || (37 === n && t)) && this.slideNext(),
					  ((37 === n && !t) || (39 === n && t)) && this.slidePrev())
					: ((38 !== n && 40 !== n) ||
						(i.preventDefault
						  ? i.preventDefault()
						  : (i.returnValue = !1)),
					  40 === n && this.slideNext(),
					  38 === n && this.slidePrev()),
					this.emit("keyPress", n);
				}
			  },
			  enable: function () {
				this.keyboard.enabled ||
				  (P(f).on("keydown", this.keyboard.handle),
				  (this.keyboard.enabled = !0));
			  },
			  disable: function () {
				this.keyboard.enabled &&
				  (P(f).off("keydown", this.keyboard.handle),
				  (this.keyboard.enabled = !1));
			  },
			},
			O = {
			  name: "keyboard",
			  params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
			  create: function () {
				j.extend(this, {
				  keyboard: {
					enabled: !1,
					enable: D.enable.bind(this),
					disable: D.disable.bind(this),
					handle: D.handle.bind(this),
				  },
				});
			  },
			  on: {
				init: function () {
				  this.params.keyboard.enabled && this.keyboard.enable();
				},
				destroy: function () {
				  this.keyboard.enabled && this.keyboard.disable();
				},
			  },
			},
			N = {
			  lastScrollTime: j.now(),
			  event:
				-1 < H.navigator.userAgent.indexOf("firefox")
				  ? "DOMMouseScroll"
				  : (function () {
					  var e = "onwheel" in f;
					  if (!e) {
						var t = f.createElement("div");
						t.setAttribute("onwheel", "return;"),
						  (e = "function" == typeof t.onwheel);
					  }
					  return (
						!e &&
						  f.implementation &&
						  f.implementation.hasFeature &&
						  !0 !== f.implementation.hasFeature("", "") &&
						  (e = f.implementation.hasFeature(
							"Events.wheel",
							"3.0"
						  )),
						e
					  );
					})()
				  ? "wheel"
				  : "mousewheel",
			  normalize: function (e) {
				var t = 0,
				  i = 0,
				  n = 0,
				  s = 0;
				return (
				  "detail" in e && (i = e.detail),
				  "wheelDelta" in e && (i = -e.wheelDelta / 120),
				  "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120),
				  "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
				  "axis" in e &&
					e.axis === e.HORIZONTAL_AXIS &&
					((t = i), (i = 0)),
				  (n = 10 * t),
				  (s = 10 * i),
				  "deltaY" in e && (s = e.deltaY),
				  "deltaX" in e && (n = e.deltaX),
				  (n || s) &&
					e.deltaMode &&
					(1 === e.deltaMode
					  ? ((n *= 40), (s *= 40))
					  : ((n *= 800), (s *= 800))),
				  n && !t && (t = n < 1 ? -1 : 1),
				  s && !i && (i = s < 1 ? -1 : 1),
				  { spinX: t, spinY: i, pixelX: n, pixelY: s }
				);
			  },
			  handleMouseEnter: function () {
				this.mouseEntered = !0;
			  },
			  handleMouseLeave: function () {
				this.mouseEntered = !1;
			  },
			  handle: function (e) {
				var t = e,
				  i = this,
				  n = i.params.mousewheel;
				if (!i.mouseEntered && !n.releaseOnEdges) return !0;
				t.originalEvent && (t = t.originalEvent);
				var s = 0,
				  r = i.rtlTranslate ? -1 : 1,
				  a = N.normalize(t);
				if (n.forceToAxis)
				  if (i.isHorizontal()) {
					if (!(Math.abs(a.pixelX) > Math.abs(a.pixelY))) return !0;
					s = a.pixelX * r;
				  } else {
					if (!(Math.abs(a.pixelY) > Math.abs(a.pixelX))) return !0;
					s = a.pixelY;
				  }
				else
				  s =
					Math.abs(a.pixelX) > Math.abs(a.pixelY)
					  ? -a.pixelX * r
					  : -a.pixelY;
				if (0 === s) return !0;
				if ((n.invert && (s = -s), i.params.freeMode)) {
				  i.params.loop && i.loopFix();
				  var o = i.getTranslate() + s * n.sensitivity,
					l = i.isBeginning,
					d = i.isEnd;
				  if (
					(o >= i.minTranslate() && (o = i.minTranslate()),
					o <= i.maxTranslate() && (o = i.maxTranslate()),
					i.setTransition(0),
					i.setTranslate(o),
					i.updateProgress(),
					i.updateActiveIndex(),
					i.updateSlidesClasses(),
					((!l && i.isBeginning) || (!d && i.isEnd)) &&
					  i.updateSlidesClasses(),
					i.params.freeModeSticky &&
					  (clearTimeout(i.mousewheel.timeout),
					  (i.mousewheel.timeout = j.nextTick(function () {
						i.slideToClosest();
					  }, 300))),
					i.emit("scroll", t),
					i.params.autoplay &&
					  i.params.autoplayDisableOnInteraction &&
					  i.autoplay.stop(),
					o === i.minTranslate() || o === i.maxTranslate())
				  )
					return !0;
				} else {
				  if (60 < j.now() - i.mousewheel.lastScrollTime)
					if (s < 0)
					  if ((i.isEnd && !i.params.loop) || i.animating) {
						if (n.releaseOnEdges) return !0;
					  } else i.slideNext(), i.emit("scroll", t);
					else if ((i.isBeginning && !i.params.loop) || i.animating) {
					  if (n.releaseOnEdges) return !0;
					} else i.slidePrev(), i.emit("scroll", t);
				  i.mousewheel.lastScrollTime = new H.Date().getTime();
				}
				return (
				  t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1
				);
			  },
			  enable: function () {
				if (!N.event) return !1;
				if (this.mousewheel.enabled) return !1;
				var e = this.$el;
				return (
				  "container" !== this.params.mousewheel.eventsTarged &&
					(e = P(this.params.mousewheel.eventsTarged)),
				  e.on("mouseenter", this.mousewheel.handleMouseEnter),
				  e.on("mouseleave", this.mousewheel.handleMouseLeave),
				  e.on(N.event, this.mousewheel.handle),
				  (this.mousewheel.enabled = !0)
				);
			  },
			  disable: function () {
				if (!N.event) return !1;
				if (!this.mousewheel.enabled) return !1;
				var e = this.$el;
				return (
				  "container" !== this.params.mousewheel.eventsTarged &&
					(e = P(this.params.mousewheel.eventsTarged)),
				  e.off(N.event, this.mousewheel.handle),
				  !(this.mousewheel.enabled = !1)
				);
			  },
			},
			I = {
			  update: function () {
				var e = this.params.navigation;
				if (!this.params.loop) {
				  var t = this.navigation,
					i = t.$nextEl,
					n = t.$prevEl;
				  n &&
					0 < n.length &&
					(this.isBeginning
					  ? n.addClass(e.disabledClass)
					  : n.removeClass(e.disabledClass),
					n[
					  this.params.watchOverflow && this.isLocked
						? "addClass"
						: "removeClass"
					](e.lockClass)),
					i &&
					  0 < i.length &&
					  (this.isEnd
						? i.addClass(e.disabledClass)
						: i.removeClass(e.disabledClass),
					  i[
						this.params.watchOverflow && this.isLocked
						  ? "addClass"
						  : "removeClass"
					  ](e.lockClass));
				}
			  },
			  init: function () {
				var e,
				  t,
				  i = this,
				  n = i.params.navigation;
				(n.nextEl || n.prevEl) &&
				  (n.nextEl &&
					((e = P(n.nextEl)),
					i.params.uniqueNavElements &&
					  "string" == typeof n.nextEl &&
					  1 < e.length &&
					  1 === i.$el.find(n.nextEl).length &&
					  (e = i.$el.find(n.nextEl))),
				  n.prevEl &&
					((t = P(n.prevEl)),
					i.params.uniqueNavElements &&
					  "string" == typeof n.prevEl &&
					  1 < t.length &&
					  1 === i.$el.find(n.prevEl).length &&
					  (t = i.$el.find(n.prevEl))),
				  e &&
					0 < e.length &&
					e.on("click", function (e) {
					  e.preventDefault(),
						(i.isEnd && !i.params.loop) || i.slideNext();
					}),
				  t &&
					0 < t.length &&
					t.on("click", function (e) {
					  e.preventDefault(),
						(i.isBeginning && !i.params.loop) || i.slidePrev();
					}),
				  j.extend(i.navigation, {
					$nextEl: e,
					nextEl: e && e[0],
					$prevEl: t,
					prevEl: t && t[0],
				  }));
			  },
			  destroy: function () {
				var e = this.navigation,
				  t = e.$nextEl,
				  i = e.$prevEl;
				t &&
				  t.length &&
				  (t.off("click"),
				  t.removeClass(this.params.navigation.disabledClass)),
				  i &&
					i.length &&
					(i.off("click"),
					i.removeClass(this.params.navigation.disabledClass));
			  },
			},
			B = {
			  update: function () {
				var e = this.rtl,
				  s = this.params.pagination;
				if (
				  s.el &&
				  this.pagination.el &&
				  this.pagination.$el &&
				  0 !== this.pagination.$el.length
				) {
				  var r,
					t =
					  this.virtual && this.params.virtual.enabled
						? this.virtual.slides.length
						: this.slides.length,
					i = this.pagination.$el,
					n = this.params.loop
					  ? Math.ceil(
						  (t - 2 * this.loopedSlides) / this.params.slidesPerGroup
						)
					  : this.snapGrid.length;
				  if (
					(this.params.loop
					  ? ((r = Math.ceil(
						  (this.activeIndex - this.loopedSlides) /
							this.params.slidesPerGroup
						)) >
						  t - 1 - 2 * this.loopedSlides &&
						  (r -= t - 2 * this.loopedSlides),
						n - 1 < r && (r -= n),
						r < 0 &&
						  "bullets" !== this.params.paginationType &&
						  (r = n + r))
					  : (r =
						  void 0 !== this.snapIndex
							? this.snapIndex
							: this.activeIndex || 0),
					"bullets" === s.type &&
					  this.pagination.bullets &&
					  0 < this.pagination.bullets.length)
				  ) {
					var a,
					  o,
					  l,
					  d = this.pagination.bullets;
					if (
					  (s.dynamicBullets &&
						((this.pagination.bulletSize = d
						  .eq(0)
						  [this.isHorizontal() ? "outerWidth" : "outerHeight"](
							!0
						  )),
						i.css(
						  this.isHorizontal() ? "width" : "height",
						  this.pagination.bulletSize *
							(s.dynamicMainBullets + 4) +
							"px"
						),
						1 < s.dynamicMainBullets &&
						  void 0 !== this.previousIndex &&
						  ((this.pagination.dynamicBulletIndex +=
							r - this.previousIndex),
						  this.pagination.dynamicBulletIndex >
						  s.dynamicMainBullets - 1
							? (this.pagination.dynamicBulletIndex =
								s.dynamicMainBullets - 1)
							: this.pagination.dynamicBulletIndex < 0 &&
							  (this.pagination.dynamicBulletIndex = 0)),
						(a = r - this.pagination.dynamicBulletIndex),
						(l =
						  ((o =
							a + (Math.min(d.length, s.dynamicMainBullets) - 1)) +
							a) /
						  2)),
					  d.removeClass(
						s.bulletActiveClass +
						  " " +
						  s.bulletActiveClass +
						  "-next " +
						  s.bulletActiveClass +
						  "-next-next " +
						  s.bulletActiveClass +
						  "-prev " +
						  s.bulletActiveClass +
						  "-prev-prev " +
						  s.bulletActiveClass +
						  "-main"
					  ),
					  1 < i.length)
					)
					  d.each(function (e, t) {
						var i = P(t),
						  n = i.index();
						n === r && i.addClass(s.bulletActiveClass),
						  s.dynamicBullets &&
							(a <= n &&
							  n <= o &&
							  i.addClass(s.bulletActiveClass + "-main"),
							n === a &&
							  i
								.prev()
								.addClass(s.bulletActiveClass + "-prev")
								.prev()
								.addClass(s.bulletActiveClass + "-prev-prev"),
							n === o &&
							  i
								.next()
								.addClass(s.bulletActiveClass + "-next")
								.next()
								.addClass(s.bulletActiveClass + "-next-next"));
					  });
					else if (
					  (d.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets)
					) {
					  for (var c = d.eq(a), u = d.eq(o), h = a; h <= o; h += 1)
						d.eq(h).addClass(s.bulletActiveClass + "-main");
					  c
						.prev()
						.addClass(s.bulletActiveClass + "-prev")
						.prev()
						.addClass(s.bulletActiveClass + "-prev-prev"),
						u
						  .next()
						  .addClass(s.bulletActiveClass + "-next")
						  .next()
						  .addClass(s.bulletActiveClass + "-next-next");
					}
					if (s.dynamicBullets) {
					  var p = Math.min(d.length, s.dynamicMainBullets + 4),
						f =
						  (this.pagination.bulletSize * p -
							this.pagination.bulletSize) /
							2 -
						  l * this.pagination.bulletSize,
						v = e ? "right" : "left";
					  d.css(this.isHorizontal() ? v : "top", f + "px");
					}
				  }
				  if (
					("fraction" === s.type &&
					  (i
						.find("." + s.currentClass)
						.text(s.formatFractionCurrent(r + 1)),
					  i.find("." + s.totalClass).text(s.formatFractionTotal(n))),
					"progressbar" === s.type)
				  ) {
					var g;
					g = s.progressbarOpposite
					  ? this.isHorizontal()
						? "vertical"
						: "horizontal"
					  : this.isHorizontal()
					  ? "horizontal"
					  : "vertical";
					var m = (r + 1) / n,
					  y = 1,
					  b = 1;
					"horizontal" == g ? (y = m) : (b = m),
					  i
						.find("." + s.progressbarFillClass)
						.transform(
						  "translate3d(0,0,0) scaleX(" + y + ") scaleY(" + b + ")"
						)
						.transition(this.params.speed);
				  }
				  "custom" === s.type && s.renderCustom
					? (i.html(s.renderCustom(this, r + 1, n)),
					  this.emit("paginationRender", this, i[0]))
					: this.emit("paginationUpdate", this, i[0]),
					i[
					  this.params.watchOverflow && this.isLocked
						? "addClass"
						: "removeClass"
					](s.lockClass);
				}
			  },
			  render: function () {
				var e = this.params.pagination;
				if (
				  e.el &&
				  this.pagination.el &&
				  this.pagination.$el &&
				  0 !== this.pagination.$el.length
				) {
				  var t =
					  this.virtual && this.params.virtual.enabled
						? this.virtual.slides.length
						: this.slides.length,
					i = this.pagination.$el,
					n = "";
				  if ("bullets" === e.type) {
					for (
					  var s = this.params.loop
						  ? Math.ceil(
							  (t - 2 * this.loopedSlides) /
								this.params.slidesPerGroup
							)
						  : this.snapGrid.length,
						r = 0;
					  r < s;
					  r += 1
					)
					  e.renderBullet
						? (n += e.renderBullet.call(this, r, e.bulletClass))
						: (n +=
							"<" +
							e.bulletElement +
							' class="' +
							e.bulletClass +
							'"></' +
							e.bulletElement +
							">");
					i.html(n),
					  (this.pagination.bullets = i.find("." + e.bulletClass));
				  }
				  "fraction" === e.type &&
					((n = e.renderFraction
					  ? e.renderFraction.call(this, e.currentClass, e.totalClass)
					  : '<span class="' +
						e.currentClass +
						'"></span> / <span class="' +
						e.totalClass +
						'"></span>'),
					i.html(n)),
					"progressbar" === e.type &&
					  ((n = e.renderProgressbar
						? e.renderProgressbar.call(this, e.progressbarFillClass)
						: '<span class="' + e.progressbarFillClass + '"></span>'),
					  i.html(n)),
					"custom" !== e.type &&
					  this.emit("paginationRender", this.pagination.$el[0]);
				}
			  },
			  init: function () {
				var i = this,
				  e = i.params.pagination;
				if (e.el) {
				  var t = P(e.el);
				  0 !== t.length &&
					(i.params.uniqueNavElements &&
					  "string" == typeof e.el &&
					  1 < t.length &&
					  1 === i.$el.find(e.el).length &&
					  (t = i.$el.find(e.el)),
					"bullets" === e.type &&
					  e.clickable &&
					  t.addClass(e.clickableClass),
					t.addClass(e.modifierClass + e.type),
					"bullets" === e.type &&
					  e.dynamicBullets &&
					  (t.addClass("" + e.modifierClass + e.type + "-dynamic"),
					  (i.pagination.dynamicBulletIndex = 0),
					  e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
					"progressbar" === e.type &&
					  e.progressbarOpposite &&
					  t.addClass(e.progressbarOppositeClass),
					e.clickable &&
					  t.on("click", "." + e.bulletClass, function (e) {
						e.preventDefault();
						var t = P(this).index() * i.params.slidesPerGroup;
						i.params.loop && (t += i.loopedSlides), i.slideTo(t);
					  }),
					j.extend(i.pagination, { $el: t, el: t[0] }));
				}
			  },
			  destroy: function () {
				var e = this.params.pagination;
				if (
				  e.el &&
				  this.pagination.el &&
				  this.pagination.$el &&
				  0 !== this.pagination.$el.length
				) {
				  var t = this.pagination.$el;
				  t.removeClass(e.hiddenClass),
					t.removeClass(e.modifierClass + e.type),
					this.pagination.bullets &&
					  this.pagination.bullets.removeClass(e.bulletActiveClass),
					e.clickable && t.off("click", "." + e.bulletClass);
				}
			  },
			},
			R = {
			  setTranslate: function () {
				if (this.params.scrollbar.el && this.scrollbar.el) {
				  var e = this.scrollbar,
					t = this.rtlTranslate,
					i = this.progress,
					n = e.dragSize,
					s = e.trackSize,
					r = e.$dragEl,
					a = e.$el,
					o = this.params.scrollbar,
					l = n,
					d = (s - n) * i;
				  t
					? 0 < (d = -d)
					  ? ((l = n - d), (d = 0))
					  : s < -d + n && (l = s + d)
					: d < 0
					? ((l = n + d), (d = 0))
					: s < d + n && (l = s - d),
					this.isHorizontal()
					  ? (q.transforms3d
						  ? r.transform("translate3d(" + d + "px, 0, 0)")
						  : r.transform("translateX(" + d + "px)"),
						(r[0].style.width = l + "px"))
					  : (q.transforms3d
						  ? r.transform("translate3d(0px, " + d + "px, 0)")
						  : r.transform("translateY(" + d + "px)"),
						(r[0].style.height = l + "px")),
					o.hide &&
					  (clearTimeout(this.scrollbar.timeout),
					  (a[0].style.opacity = 1),
					  (this.scrollbar.timeout = setTimeout(function () {
						(a[0].style.opacity = 0), a.transition(400);
					  }, 1e3)));
				}
			  },
			  setTransition: function (e) {
				this.params.scrollbar.el &&
				  this.scrollbar.el &&
				  this.scrollbar.$dragEl.transition(e);
			  },
			  updateSize: function () {
				if (this.params.scrollbar.el && this.scrollbar.el) {
				  var e = this.scrollbar,
					t = e.$dragEl,
					i = e.$el;
				  (t[0].style.width = ""), (t[0].style.height = "");
				  var n,
					s = this.isHorizontal()
					  ? i[0].offsetWidth
					  : i[0].offsetHeight,
					r = this.size / this.virtualSize,
					a = r * (s / this.size);
				  (n =
					"auto" === this.params.scrollbar.dragSize
					  ? s * r
					  : parseInt(this.params.scrollbar.dragSize, 10)),
					this.isHorizontal()
					  ? (t[0].style.width = n + "px")
					  : (t[0].style.height = n + "px"),
					(i[0].style.display = 1 <= r ? "none" : ""),
					this.params.scrollbarHide && (i[0].style.opacity = 0),
					j.extend(e, {
					  trackSize: s,
					  divider: r,
					  moveDivider: a,
					  dragSize: n,
					}),
					e.$el[
					  this.params.watchOverflow && this.isLocked
						? "addClass"
						: "removeClass"
					](this.params.scrollbar.lockClass);
				}
			  },
			  setDragPosition: function (e) {
				var t,
				  i = this.scrollbar,
				  n = this.rtlTranslate,
				  s = i.$el,
				  r = i.dragSize,
				  a = i.trackSize;
				(t =
				  ((this.isHorizontal()
					? "touchstart" === e.type || "touchmove" === e.type
					  ? e.targetTouches[0].pageX
					  : e.pageX || e.clientX
					: "touchstart" === e.type || "touchmove" === e.type
					? e.targetTouches[0].pageY
					: e.pageY || e.clientY) -
					s.offset()[this.isHorizontal() ? "left" : "top"] -
					r / 2) /
				  (a - r)),
				  (t = Math.max(Math.min(t, 1), 0)),
				  n && (t = 1 - t);
				var o =
				  this.minTranslate() +
				  (this.maxTranslate() - this.minTranslate()) * t;
				this.updateProgress(o),
				  this.setTranslate(o),
				  this.updateActiveIndex(),
				  this.updateSlidesClasses();
			  },
			  onDragStart: function (e) {
				var t = this.params.scrollbar,
				  i = this.scrollbar,
				  n = this.$wrapperEl,
				  s = i.$el,
				  r = i.$dragEl;
				(this.scrollbar.isTouched = !0),
				  e.preventDefault(),
				  e.stopPropagation(),
				  n.transition(100),
				  r.transition(100),
				  i.setDragPosition(e),
				  clearTimeout(this.scrollbar.dragTimeout),
				  s.transition(0),
				  t.hide && s.css("opacity", 1),
				  this.emit("scrollbarDragStart", e);
			  },
			  onDragMove: function (e) {
				var t = this.scrollbar,
				  i = this.$wrapperEl,
				  n = t.$el,
				  s = t.$dragEl;
				this.scrollbar.isTouched &&
				  (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
				  t.setDragPosition(e),
				  i.transition(0),
				  n.transition(0),
				  s.transition(0),
				  this.emit("scrollbarDragMove", e));
			  },
			  onDragEnd: function (e) {
				var t = this.params.scrollbar,
				  i = this.scrollbar.$el;
				this.scrollbar.isTouched &&
				  ((this.scrollbar.isTouched = !1),
				  t.hide &&
					(clearTimeout(this.scrollbar.dragTimeout),
					(this.scrollbar.dragTimeout = j.nextTick(function () {
					  i.css("opacity", 0), i.transition(400);
					}, 1e3))),
				  this.emit("scrollbarDragEnd", e),
				  t.snapOnRelease && this.slideToClosest());
			  },
			  enableDraggable: function () {
				if (this.params.scrollbar.el) {
				  var e = this.scrollbar,
					t = this.touchEvents,
					i = this.touchEventsDesktop,
					n = this.params,
					s = e.$el[0],
					r = !(!q.passiveListener || !n.passiveListener) && {
					  passive: !1,
					  capture: !1,
					},
					a = !(!q.passiveListener || !n.passiveListener) && {
					  passive: !0,
					  capture: !1,
					};
				  q.touch || (!q.pointerEvents && !q.prefixedPointerEvents)
					? (q.touch &&
						(s.addEventListener(
						  t.start,
						  this.scrollbar.onDragStart,
						  r
						),
						s.addEventListener(t.move, this.scrollbar.onDragMove, r),
						s.addEventListener(t.end, this.scrollbar.onDragEnd, a)),
					  ((n.simulateTouch && !v.ios && !v.android) ||
						(n.simulateTouch && !q.touch && v.ios)) &&
						(s.addEventListener(
						  "mousedown",
						  this.scrollbar.onDragStart,
						  r
						),
						f.addEventListener(
						  "mousemove",
						  this.scrollbar.onDragMove,
						  r
						),
						f.addEventListener(
						  "mouseup",
						  this.scrollbar.onDragEnd,
						  a
						)))
					: (s.addEventListener(i.start, this.scrollbar.onDragStart, r),
					  f.addEventListener(i.move, this.scrollbar.onDragMove, r),
					  f.addEventListener(i.end, this.scrollbar.onDragEnd, a));
				}
			  },
			  disableDraggable: function () {
				if (this.params.scrollbar.el) {
				  var e = this.scrollbar,
					t = this.touchEvents,
					i = this.touchEventsDesktop,
					n = this.params,
					s = e.$el[0],
					r = !(!q.passiveListener || !n.passiveListener) && {
					  passive: !1,
					  capture: !1,
					},
					a = !(!q.passiveListener || !n.passiveListener) && {
					  passive: !0,
					  capture: !1,
					};
				  q.touch || (!q.pointerEvents && !q.prefixedPointerEvents)
					? (q.touch &&
						(s.removeEventListener(
						  t.start,
						  this.scrollbar.onDragStart,
						  r
						),
						s.removeEventListener(
						  t.move,
						  this.scrollbar.onDragMove,
						  r
						),
						s.removeEventListener(
						  t.end,
						  this.scrollbar.onDragEnd,
						  a
						)),
					  ((n.simulateTouch && !v.ios && !v.android) ||
						(n.simulateTouch && !q.touch && v.ios)) &&
						(s.removeEventListener(
						  "mousedown",
						  this.scrollbar.onDragStart,
						  r
						),
						f.removeEventListener(
						  "mousemove",
						  this.scrollbar.onDragMove,
						  r
						),
						f.removeEventListener(
						  "mouseup",
						  this.scrollbar.onDragEnd,
						  a
						)))
					: (s.removeEventListener(
						i.start,
						this.scrollbar.onDragStart,
						r
					  ),
					  f.removeEventListener(i.move, this.scrollbar.onDragMove, r),
					  f.removeEventListener(i.end, this.scrollbar.onDragEnd, a));
				}
			  },
			  init: function () {
				if (this.params.scrollbar.el) {
				  var e = this.scrollbar,
					t = this.$el,
					i = this.params.scrollbar,
					n = P(i.el);
				  this.params.uniqueNavElements &&
					"string" == typeof i.el &&
					1 < n.length &&
					1 === t.find(i.el).length &&
					(n = t.find(i.el));
				  var s = n.find("." + this.params.scrollbar.dragClass);
				  0 === s.length &&
					((s = P(
					  '<div class="' +
						this.params.scrollbar.dragClass +
						'"></div>'
					)),
					n.append(s)),
					j.extend(e, { $el: n, el: n[0], $dragEl: s, dragEl: s[0] }),
					i.draggable && e.enableDraggable();
				}
			  },
			  destroy: function () {
				this.scrollbar.disableDraggable();
			  },
			},
			W = {
			  setTransform: function (e, t) {
				var i = this.rtl,
				  n = P(e),
				  s = i ? -1 : 1,
				  r = n.attr("data-swiper-parallax") || "0",
				  a = n.attr("data-swiper-parallax-x"),
				  o = n.attr("data-swiper-parallax-y"),
				  l = n.attr("data-swiper-parallax-scale"),
				  d = n.attr("data-swiper-parallax-opacity");
				if (
				  (a || o
					? ((a = a || "0"), (o = o || "0"))
					: this.isHorizontal()
					? ((a = r), (o = "0"))
					: ((o = r), (a = "0")),
				  (a =
					0 <= a.indexOf("%")
					  ? parseInt(a, 10) * t * s + "%"
					  : a * t * s + "px"),
				  (o =
					0 <= o.indexOf("%")
					  ? parseInt(o, 10) * t + "%"
					  : o * t + "px"),
				  null != d)
				) {
				  var c = d - (d - 1) * (1 - Math.abs(t));
				  n[0].style.opacity = c;
				}
				if (null == l)
				  n.transform("translate3d(" + a + ", " + o + ", 0px)");
				else {
				  var u = l - (l - 1) * (1 - Math.abs(t));
				  n.transform(
					"translate3d(" + a + ", " + o + ", 0px) scale(" + u + ")"
				  );
				}
			  },
			  setTranslate: function () {
				var n = this,
				  e = n.$el,
				  t = n.slides,
				  s = n.progress,
				  r = n.snapGrid;
				e
				  .children(
					"[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]"
				  )
				  .each(function (e, t) {
					n.parallax.setTransform(t, s);
				  }),
				  t.each(function (e, t) {
					var i = t.progress;
					1 < n.params.slidesPerGroup &&
					  "auto" !== n.params.slidesPerView &&
					  (i += Math.ceil(e / 2) - s * (r.length - 1)),
					  (i = Math.min(Math.max(i, -1), 1)),
					  P(t)
						.find(
						  "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]"
						)
						.each(function (e, t) {
						  n.parallax.setTransform(t, i);
						});
				  });
			  },
			  setTransition: function (s) {
				void 0 === s && (s = this.params.speed),
				  this.$el
					.find(
					  "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]"
					)
					.each(function (e, t) {
					  var i = P(t),
						n =
						  parseInt(i.attr("data-swiper-parallax-duration"), 10) ||
						  s;
					  0 === s && (n = 0), i.transition(n);
					});
			  },
			},
			F = {
			  getDistanceBetweenTouches: function (e) {
				if (e.targetTouches.length < 2) return 1;
				var t = e.targetTouches[0].pageX,
				  i = e.targetTouches[0].pageY,
				  n = e.targetTouches[1].pageX,
				  s = e.targetTouches[1].pageY;
				return Math.sqrt(Math.pow(n - t, 2) + Math.pow(s - i, 2));
			  },
			  onGestureStart: function (e) {
				var t = this.params.zoom,
				  i = this.zoom,
				  n = i.gesture;
				if (
				  ((i.fakeGestureTouched = !1),
				  (i.fakeGestureMoved = !1),
				  !q.gestures)
				) {
				  if (
					"touchstart" !== e.type ||
					("touchstart" === e.type && e.targetTouches.length < 2)
				  )
					return;
				  (i.fakeGestureTouched = !0),
					(n.scaleStart = F.getDistanceBetweenTouches(e));
				}
				(n.$slideEl && n.$slideEl.length) ||
				((n.$slideEl = P(e.target).closest(".swiper-slide")),
				0 === n.$slideEl.length &&
				  (n.$slideEl = this.slides.eq(this.activeIndex)),
				(n.$imageEl = n.$slideEl.find("img, svg, canvas")),
				(n.$imageWrapEl = n.$imageEl.parent("." + t.containerClass)),
				(n.maxRatio =
				  n.$imageWrapEl.attr("data-swiper-zoom") || t.maxRatio),
				0 !== n.$imageWrapEl.length)
				  ? (n.$imageEl.transition(0), (this.zoom.isScaling = !0))
				  : (n.$imageEl = void 0);
			  },
			  onGestureChange: function (e) {
				var t = this.params.zoom,
				  i = this.zoom,
				  n = i.gesture;
				if (!q.gestures) {
				  if (
					"touchmove" !== e.type ||
					("touchmove" === e.type && e.targetTouches.length < 2)
				  )
					return;
				  (i.fakeGestureMoved = !0),
					(n.scaleMove = F.getDistanceBetweenTouches(e));
				}
				n.$imageEl &&
				  0 !== n.$imageEl.length &&
				  (q.gestures
					? (this.zoom.scale = e.scale * i.currentScale)
					: (i.scale = (n.scaleMove / n.scaleStart) * i.currentScale),
				  i.scale > n.maxRatio &&
					(i.scale =
					  n.maxRatio - 1 + Math.pow(i.scale - n.maxRatio + 1, 0.5)),
				  i.scale < t.minRatio &&
					(i.scale =
					  t.minRatio + 1 - Math.pow(t.minRatio - i.scale + 1, 0.5)),
				  n.$imageEl.transform(
					"translate3d(0,0,0) scale(" + i.scale + ")"
				  ));
			  },
			  onGestureEnd: function (e) {
				var t = this.params.zoom,
				  i = this.zoom,
				  n = i.gesture;
				if (!q.gestures) {
				  if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
				  if (
					"touchend" !== e.type ||
					("touchend" === e.type &&
					  e.changedTouches.length < 2 &&
					  !v.android)
				  )
					return;
				  (i.fakeGestureTouched = !1), (i.fakeGestureMoved = !1);
				}
				n.$imageEl &&
				  0 !== n.$imageEl.length &&
				  ((i.scale = Math.max(
					Math.min(i.scale, n.maxRatio),
					t.minRatio
				  )),
				  n.$imageEl
					.transition(this.params.speed)
					.transform("translate3d(0,0,0) scale(" + i.scale + ")"),
				  (i.currentScale = i.scale),
				  (i.isScaling = !1),
				  1 === i.scale && (n.$slideEl = void 0));
			  },
			  onTouchStart: function (e) {
				var t = this.zoom,
				  i = t.gesture,
				  n = t.image;
				i.$imageEl &&
				  0 !== i.$imageEl.length &&
				  (n.isTouched ||
					(v.android && e.preventDefault(),
					(n.isTouched = !0),
					(n.touchesStart.x =
					  "touchstart" === e.type
						? e.targetTouches[0].pageX
						: e.pageX),
					(n.touchesStart.y =
					  "touchstart" === e.type
						? e.targetTouches[0].pageY
						: e.pageY)));
			  },
			  onTouchMove: function (e) {
				var t = this.zoom,
				  i = t.gesture,
				  n = t.image,
				  s = t.velocity;
				if (
				  i.$imageEl &&
				  0 !== i.$imageEl.length &&
				  ((this.allowClick = !1), n.isTouched && i.$slideEl)
				) {
				  n.isMoved ||
					((n.width = i.$imageEl[0].offsetWidth),
					(n.height = i.$imageEl[0].offsetHeight),
					(n.startX = j.getTranslate(i.$imageWrapEl[0], "x") || 0),
					(n.startY = j.getTranslate(i.$imageWrapEl[0], "y") || 0),
					(i.slideWidth = i.$slideEl[0].offsetWidth),
					(i.slideHeight = i.$slideEl[0].offsetHeight),
					i.$imageWrapEl.transition(0),
					this.rtl && ((n.startX = -n.startX), (n.startY = -n.startY)));
				  var r = n.width * t.scale,
					a = n.height * t.scale;
				  if (!(r < i.slideWidth && a < i.slideHeight)) {
					if (
					  ((n.minX = Math.min(i.slideWidth / 2 - r / 2, 0)),
					  (n.maxX = -n.minX),
					  (n.minY = Math.min(i.slideHeight / 2 - a / 2, 0)),
					  (n.maxY = -n.minY),
					  (n.touchesCurrent.x =
						"touchmove" === e.type
						  ? e.targetTouches[0].pageX
						  : e.pageX),
					  (n.touchesCurrent.y =
						"touchmove" === e.type
						  ? e.targetTouches[0].pageY
						  : e.pageY),
					  !n.isMoved && !t.isScaling)
					) {
					  if (
						this.isHorizontal() &&
						((Math.floor(n.minX) === Math.floor(n.startX) &&
						  n.touchesCurrent.x < n.touchesStart.x) ||
						  (Math.floor(n.maxX) === Math.floor(n.startX) &&
							n.touchesCurrent.x > n.touchesStart.x))
					  )
						return void (n.isTouched = !1);
					  if (
						!this.isHorizontal() &&
						((Math.floor(n.minY) === Math.floor(n.startY) &&
						  n.touchesCurrent.y < n.touchesStart.y) ||
						  (Math.floor(n.maxY) === Math.floor(n.startY) &&
							n.touchesCurrent.y > n.touchesStart.y))
					  )
						return void (n.isTouched = !1);
					}
					e.preventDefault(),
					  e.stopPropagation(),
					  (n.isMoved = !0),
					  (n.currentX =
						n.touchesCurrent.x - n.touchesStart.x + n.startX),
					  (n.currentY =
						n.touchesCurrent.y - n.touchesStart.y + n.startY),
					  n.currentX < n.minX &&
						(n.currentX =
						  n.minX + 1 - Math.pow(n.minX - n.currentX + 1, 0.8)),
					  n.currentX > n.maxX &&
						(n.currentX =
						  n.maxX - 1 + Math.pow(n.currentX - n.maxX + 1, 0.8)),
					  n.currentY < n.minY &&
						(n.currentY =
						  n.minY + 1 - Math.pow(n.minY - n.currentY + 1, 0.8)),
					  n.currentY > n.maxY &&
						(n.currentY =
						  n.maxY - 1 + Math.pow(n.currentY - n.maxY + 1, 0.8)),
					  s.prevPositionX || (s.prevPositionX = n.touchesCurrent.x),
					  s.prevPositionY || (s.prevPositionY = n.touchesCurrent.y),
					  s.prevTime || (s.prevTime = Date.now()),
					  (s.x =
						(n.touchesCurrent.x - s.prevPositionX) /
						(Date.now() - s.prevTime) /
						2),
					  (s.y =
						(n.touchesCurrent.y - s.prevPositionY) /
						(Date.now() - s.prevTime) /
						2),
					  Math.abs(n.touchesCurrent.x - s.prevPositionX) < 2 &&
						(s.x = 0),
					  Math.abs(n.touchesCurrent.y - s.prevPositionY) < 2 &&
						(s.y = 0),
					  (s.prevPositionX = n.touchesCurrent.x),
					  (s.prevPositionY = n.touchesCurrent.y),
					  (s.prevTime = Date.now()),
					  i.$imageWrapEl.transform(
						"translate3d(" +
						  n.currentX +
						  "px, " +
						  n.currentY +
						  "px,0)"
					  );
				  }
				}
			  },
			  onTouchEnd: function () {
				var e = this.zoom,
				  t = e.gesture,
				  i = e.image,
				  n = e.velocity;
				if (t.$imageEl && 0 !== t.$imageEl.length) {
				  if (!i.isTouched || !i.isMoved)
					return (i.isTouched = !1), void (i.isMoved = !1);
				  (i.isTouched = !1), (i.isMoved = !1);
				  var s = 300,
					r = 300,
					a = n.x * s,
					o = i.currentX + a,
					l = n.y * r,
					d = i.currentY + l;
				  0 !== n.x && (s = Math.abs((o - i.currentX) / n.x)),
					0 !== n.y && (r = Math.abs((d - i.currentY) / n.y));
				  var c = Math.max(s, r);
				  (i.currentX = o), (i.currentY = d);
				  var u = i.width * e.scale,
					h = i.height * e.scale;
				  (i.minX = Math.min(t.slideWidth / 2 - u / 2, 0)),
					(i.maxX = -i.minX),
					(i.minY = Math.min(t.slideHeight / 2 - h / 2, 0)),
					(i.maxY = -i.minY),
					(i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX)),
					(i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY)),
					t.$imageWrapEl
					  .transition(c)
					  .transform(
						"translate3d(" +
						  i.currentX +
						  "px, " +
						  i.currentY +
						  "px,0)"
					  );
				}
			  },
			  onTransitionEnd: function () {
				var e = this.zoom,
				  t = e.gesture;
				t.$slideEl &&
				  this.previousIndex !== this.activeIndex &&
				  (t.$imageEl.transform("translate3d(0,0,0) scale(1)"),
				  t.$imageWrapEl.transform("translate3d(0,0,0)"),
				  (t.$slideEl = void 0),
				  (t.$imageEl = void 0),
				  (t.$imageWrapEl = void 0),
				  (e.scale = 1),
				  (e.currentScale = 1));
			  },
			  toggle: function (e) {
				var t = this.zoom;
				t.scale && 1 !== t.scale ? t.out() : t.in(e);
			  },
			  in: function (e) {
				var t,
				  i,
				  n,
				  s,
				  r,
				  a,
				  o,
				  l,
				  d,
				  c,
				  u,
				  h,
				  p,
				  f,
				  v,
				  g,
				  m = this.zoom,
				  y = this.params.zoom,
				  b = m.gesture,
				  w = m.image;
				b.$slideEl ||
				  ((b.$slideEl = this.clickedSlide
					? P(this.clickedSlide)
					: this.slides.eq(this.activeIndex)),
				  (b.$imageEl = b.$slideEl.find("img, svg, canvas")),
				  (b.$imageWrapEl = b.$imageEl.parent("." + y.containerClass))),
				  b.$imageEl &&
					0 !== b.$imageEl.length &&
					(b.$slideEl.addClass("" + y.zoomedSlideClass),
					(i =
					  void 0 === w.touchesStart.x && e
						? ((t =
							"touchend" === e.type
							  ? e.changedTouches[0].pageX
							  : e.pageX),
						  "touchend" === e.type
							? e.changedTouches[0].pageY
							: e.pageY)
						: ((t = w.touchesStart.x), w.touchesStart.y)),
					(m.scale =
					  b.$imageWrapEl.attr("data-swiper-zoom") || y.maxRatio),
					(m.currentScale =
					  b.$imageWrapEl.attr("data-swiper-zoom") || y.maxRatio),
					e
					  ? ((v = b.$slideEl[0].offsetWidth),
						(g = b.$slideEl[0].offsetHeight),
						(n = b.$slideEl.offset().left + v / 2 - t),
						(s = b.$slideEl.offset().top + g / 2 - i),
						(o = b.$imageEl[0].offsetWidth),
						(l = b.$imageEl[0].offsetHeight),
						(d = o * m.scale),
						(c = l * m.scale),
						(p = -(u = Math.min(v / 2 - d / 2, 0))),
						(f = -(h = Math.min(g / 2 - c / 2, 0))),
						(r = n * m.scale) < u && (r = u),
						p < r && (r = p),
						(a = s * m.scale) < h && (a = h),
						f < a && (a = f))
					  : (a = r = 0),
					b.$imageWrapEl
					  .transition(300)
					  .transform("translate3d(" + r + "px, " + a + "px,0)"),
					b.$imageEl
					  .transition(300)
					  .transform("translate3d(0,0,0) scale(" + m.scale + ")"));
			  },
			  out: function () {
				var e = this.zoom,
				  t = this.params.zoom,
				  i = e.gesture;
				i.$slideEl ||
				  ((i.$slideEl = this.clickedSlide
					? P(this.clickedSlide)
					: this.slides.eq(this.activeIndex)),
				  (i.$imageEl = i.$slideEl.find("img, svg, canvas")),
				  (i.$imageWrapEl = i.$imageEl.parent("." + t.containerClass))),
				  i.$imageEl &&
					0 !== i.$imageEl.length &&
					((e.scale = 1),
					(e.currentScale = 1),
					i.$imageWrapEl
					  .transition(300)
					  .transform("translate3d(0,0,0)"),
					i.$imageEl
					  .transition(300)
					  .transform("translate3d(0,0,0) scale(1)"),
					i.$slideEl.removeClass("" + t.zoomedSlideClass),
					(i.$slideEl = void 0));
			  },
			  enable: function () {
				var e = this.zoom;
				if (!e.enabled) {
				  e.enabled = !0;
				  var t = !(
					"touchstart" !== this.touchEvents.start ||
					!q.passiveListener ||
					!this.params.passiveListeners
				  ) && { passive: !0, capture: !1 };
				  q.gestures
					? (this.$wrapperEl.on(
						"gesturestart",
						".swiper-slide",
						e.onGestureStart,
						t
					  ),
					  this.$wrapperEl.on(
						"gesturechange",
						".swiper-slide",
						e.onGestureChange,
						t
					  ),
					  this.$wrapperEl.on(
						"gestureend",
						".swiper-slide",
						e.onGestureEnd,
						t
					  ))
					: "touchstart" === this.touchEvents.start &&
					  (this.$wrapperEl.on(
						this.touchEvents.start,
						".swiper-slide",
						e.onGestureStart,
						t
					  ),
					  this.$wrapperEl.on(
						this.touchEvents.move,
						".swiper-slide",
						e.onGestureChange,
						t
					  ),
					  this.$wrapperEl.on(
						this.touchEvents.end,
						".swiper-slide",
						e.onGestureEnd,
						t
					  )),
					this.$wrapperEl.on(
					  this.touchEvents.move,
					  "." + this.params.zoom.containerClass,
					  e.onTouchMove
					);
				}
			  },
			  disable: function () {
				var e = this.zoom;
				if (e.enabled) {
				  this.zoom.enabled = !1;
				  var t = !(
					"touchstart" !== this.touchEvents.start ||
					!q.passiveListener ||
					!this.params.passiveListeners
				  ) && { passive: !0, capture: !1 };
				  q.gestures
					? (this.$wrapperEl.off(
						"gesturestart",
						".swiper-slide",
						e.onGestureStart,
						t
					  ),
					  this.$wrapperEl.off(
						"gesturechange",
						".swiper-slide",
						e.onGestureChange,
						t
					  ),
					  this.$wrapperEl.off(
						"gestureend",
						".swiper-slide",
						e.onGestureEnd,
						t
					  ))
					: "touchstart" === this.touchEvents.start &&
					  (this.$wrapperEl.off(
						this.touchEvents.start,
						".swiper-slide",
						e.onGestureStart,
						t
					  ),
					  this.$wrapperEl.off(
						this.touchEvents.move,
						".swiper-slide",
						e.onGestureChange,
						t
					  ),
					  this.$wrapperEl.off(
						this.touchEvents.end,
						".swiper-slide",
						e.onGestureEnd,
						t
					  )),
					this.$wrapperEl.off(
					  this.touchEvents.move,
					  "." + this.params.zoom.containerClass,
					  e.onTouchMove
					);
				}
			  },
			},
			X = {
			  loadInSlide: function (e, l) {
				void 0 === l && (l = !0);
				var d = this,
				  c = d.params.lazy;
				if (void 0 !== e && 0 !== d.slides.length) {
				  var u =
					  d.virtual && d.params.virtual.enabled
						? d.$wrapperEl.children(
							"." +
							  d.params.slideClass +
							  '[data-swiper-slide-index="' +
							  e +
							  '"]'
						  )
						: d.slides.eq(e),
					t = u.find(
					  "." +
						c.elementClass +
						":not(." +
						c.loadedClass +
						"):not(." +
						c.loadingClass +
						")"
					);
				  !u.hasClass(c.elementClass) ||
					u.hasClass(c.loadedClass) ||
					u.hasClass(c.loadingClass) ||
					(t = t.add(u[0])),
					0 !== t.length &&
					  t.each(function (e, t) {
						var n = P(t);
						n.addClass(c.loadingClass);
						var s = n.attr("data-background"),
						  r = n.attr("data-src"),
						  a = n.attr("data-srcset"),
						  o = n.attr("data-sizes");
						d.loadImage(n[0], r || s, a, o, !1, function () {
						  if (
							null != d &&
							d &&
							(!d || d.params) &&
							!d.destroyed
						  ) {
							if (
							  (s
								? (n.css("background-image", 'url("' + s + '")'),
								  n.removeAttr("data-background"))
								: (a &&
									(n.attr("srcset", a),
									n.removeAttr("data-srcset")),
								  o &&
									(n.attr("sizes", o),
									n.removeAttr("data-sizes")),
								  r &&
									(n.attr("src", r), n.removeAttr("data-src"))),
							  n
								.addClass(c.loadedClass)
								.removeClass(c.loadingClass),
							  u.find("." + c.preloaderClass).remove(),
							  d.params.loop && l)
							) {
							  var e = u.attr("data-swiper-slide-index");
							  if (u.hasClass(d.params.slideDuplicateClass)) {
								var t = d.$wrapperEl.children(
								  '[data-swiper-slide-index="' +
									e +
									'"]:not(.' +
									d.params.slideDuplicateClass +
									")"
								);
								d.lazy.loadInSlide(t.index(), !1);
							  } else {
								var i = d.$wrapperEl.children(
								  "." +
									d.params.slideDuplicateClass +
									'[data-swiper-slide-index="' +
									e +
									'"]'
								);
								d.lazy.loadInSlide(i.index(), !1);
							  }
							}
							d.emit("lazyImageReady", u[0], n[0]);
						  }
						}),
						  d.emit("lazyImageLoad", u[0], n[0]);
					  });
				}
			  },
			  load: function () {
				var n = this,
				  t = n.$wrapperEl,
				  i = n.params,
				  s = n.slides,
				  e = n.activeIndex,
				  r = n.virtual && i.virtual.enabled,
				  a = i.lazy,
				  o = i.slidesPerView;
				function l(e) {
				  if (r) {
					if (
					  t.children(
						"." +
						  i.slideClass +
						  '[data-swiper-slide-index="' +
						  e +
						  '"]'
					  ).length
					)
					  return 1;
				  } else if (s[e]) return 1;
				}
				function d(e) {
				  return r ? P(e).attr("data-swiper-slide-index") : P(e).index();
				}
				if (
				  ("auto" === o && (o = 0),
				  n.lazy.initialImageLoaded || (n.lazy.initialImageLoaded = !0),
				  n.params.watchSlidesVisibility)
				)
				  t.children("." + i.slideVisibleClass).each(function (e, t) {
					var i = r
					  ? P(t).attr("data-swiper-slide-index")
					  : P(t).index();
					n.lazy.loadInSlide(i);
				  });
				else if (1 < o)
				  for (var c = e; c < e + o; c += 1)
					l(c) && n.lazy.loadInSlide(c);
				else n.lazy.loadInSlide(e);
				if (a.loadPrevNext)
				  if (
					1 < o ||
					(a.loadPrevNextAmount && 1 < a.loadPrevNextAmount)
				  ) {
					for (
					  var u = a.loadPrevNextAmount,
						h = o,
						p = Math.min(e + h + Math.max(u, h), s.length),
						f = Math.max(e - Math.max(h, u), 0),
						v = e + o;
					  v < p;
					  v += 1
					)
					  l(v) && n.lazy.loadInSlide(v);
					for (var g = f; g < e; g += 1) l(g) && n.lazy.loadInSlide(g);
				  } else {
					var m = t.children("." + i.slideNextClass);
					0 < m.length && n.lazy.loadInSlide(d(m));
					var y = t.children("." + i.slidePrevClass);
					0 < y.length && n.lazy.loadInSlide(d(y));
				  }
			  },
			},
			_ = {
			  LinearSpline: function (e, t) {
				var i, n, s, r, a;
				return (
				  (this.x = e),
				  (this.y = t),
				  (this.lastIndex = e.length - 1),
				  (this.interpolate = function (e) {
					return e
					  ? ((a = (function (e, t) {
						  for (n = -1, i = e.length; 1 < i - n; )
							e[(s = (i + n) >> 1)] <= t ? (n = s) : (i = s);
						  return i;
						})(this.x, e)),
						(r = a - 1),
						((e - this.x[r]) * (this.y[a] - this.y[r])) /
						  (this.x[a] - this.x[r]) +
						  this.y[r])
					  : 0;
				  }),
				  this
				);
			  },
			  getInterpolateFunction: function (e) {
				this.controller.spline ||
				  (this.controller.spline = this.params.loop
					? new _.LinearSpline(this.slidesGrid, e.slidesGrid)
					: new _.LinearSpline(this.snapGrid, e.snapGrid));
			  },
			  setTranslate: function (e, t) {
				var i,
				  n,
				  s = this,
				  r = s.controller.control;
				function a(e) {
				  var t = s.rtlTranslate ? -s.translate : s.translate;
				  "slide" === s.params.controller.by &&
					(s.controller.getInterpolateFunction(e),
					(n = -s.controller.spline.interpolate(-t))),
					(n && "container" !== s.params.controller.by) ||
					  ((i =
						(e.maxTranslate() - e.minTranslate()) /
						(s.maxTranslate() - s.minTranslate())),
					  (n = (t - s.minTranslate()) * i + e.minTranslate())),
					s.params.controller.inverse && (n = e.maxTranslate() - n),
					e.updateProgress(n),
					e.setTranslate(n, s),
					e.updateActiveIndex(),
					e.updateSlidesClasses();
				}
				if (Array.isArray(r))
				  for (var o = 0; o < r.length; o += 1)
					r[o] !== t && r[o] instanceof S && a(r[o]);
				else r instanceof S && t !== r && a(r);
			  },
			  setTransition: function (t, e) {
				var i,
				  n = this,
				  s = n.controller.control;
				function r(e) {
				  e.setTransition(t, n),
					0 !== t &&
					  (e.transitionStart(),
					  e.$wrapperEl.transitionEnd(function () {
						s &&
						  (e.params.loop &&
							"slide" === n.params.controller.by &&
							e.loopFix(),
						  e.transitionEnd());
					  }));
				}
				if (Array.isArray(s))
				  for (i = 0; i < s.length; i += 1)
					s[i] !== e && s[i] instanceof S && r(s[i]);
				else s instanceof S && e !== s && r(s);
			  },
			},
			V = {
			  makeElFocusable: function (e) {
				return e.attr("tabIndex", "0"), e;
			  },
			  addElRole: function (e, t) {
				return e.attr("role", t), e;
			  },
			  addElLabel: function (e, t) {
				return e.attr("aria-label", t), e;
			  },
			  disableEl: function (e) {
				return e.attr("aria-disabled", !0), e;
			  },
			  enableEl: function (e) {
				return e.attr("aria-disabled", !1), e;
			  },
			  onEnterKey: function (e) {
				var t = this.params.a11y;
				if (13 === e.keyCode) {
				  var i = P(e.target);
				  this.navigation &&
					this.navigation.$nextEl &&
					i.is(this.navigation.$nextEl) &&
					((this.isEnd && !this.params.loop) || this.slideNext(),
					this.isEnd
					  ? this.a11y.notify(t.lastSlideMessage)
					  : this.a11y.notify(t.nextSlideMessage)),
					this.navigation &&
					  this.navigation.$prevEl &&
					  i.is(this.navigation.$prevEl) &&
					  ((this.isBeginning && !this.params.loop) ||
						this.slidePrev(),
					  this.isBeginning
						? this.a11y.notify(t.firstSlideMessage)
						: this.a11y.notify(t.prevSlideMessage)),
					this.pagination &&
					  i.is("." + this.params.pagination.bulletClass) &&
					  i[0].click();
				}
			  },
			  notify: function (e) {
				var t = this.a11y.liveRegion;
				0 !== t.length && (t.html(""), t.html(e));
			  },
			  updateNavigation: function () {
				if (!this.params.loop) {
				  var e = this.navigation,
					t = e.$nextEl,
					i = e.$prevEl;
				  i &&
					0 < i.length &&
					(this.isBeginning
					  ? this.a11y.disableEl(i)
					  : this.a11y.enableEl(i)),
					t &&
					  0 < t.length &&
					  (this.isEnd
						? this.a11y.disableEl(t)
						: this.a11y.enableEl(t));
				}
			  },
			  updatePagination: function () {
				var n = this,
				  s = n.params.a11y;
				n.pagination &&
				  n.params.pagination.clickable &&
				  n.pagination.bullets &&
				  n.pagination.bullets.length &&
				  n.pagination.bullets.each(function (e, t) {
					var i = P(t);
					n.a11y.makeElFocusable(i),
					  n.a11y.addElRole(i, "button"),
					  n.a11y.addElLabel(
						i,
						s.paginationBulletMessage.replace(
						  /{{index}}/,
						  i.index() + 1
						)
					  );
				  });
			  },
			  init: function () {
				this.$el.append(this.a11y.liveRegion);
				var e,
				  t,
				  i = this.params.a11y;
				this.navigation &&
				  this.navigation.$nextEl &&
				  (e = this.navigation.$nextEl),
				  this.navigation &&
					this.navigation.$prevEl &&
					(t = this.navigation.$prevEl),
				  e &&
					(this.a11y.makeElFocusable(e),
					this.a11y.addElRole(e, "button"),
					this.a11y.addElLabel(e, i.nextSlideMessage),
					e.on("keydown", this.a11y.onEnterKey)),
				  t &&
					(this.a11y.makeElFocusable(t),
					this.a11y.addElRole(t, "button"),
					this.a11y.addElLabel(t, i.prevSlideMessage),
					t.on("keydown", this.a11y.onEnterKey)),
				  this.pagination &&
					this.params.pagination.clickable &&
					this.pagination.bullets &&
					this.pagination.bullets.length &&
					this.pagination.$el.on(
					  "keydown",
					  "." + this.params.pagination.bulletClass,
					  this.a11y.onEnterKey
					);
			  },
			  destroy: function () {
				var e, t;
				this.a11y.liveRegion &&
				  0 < this.a11y.liveRegion.length &&
				  this.a11y.liveRegion.remove(),
				  this.navigation &&
					this.navigation.$nextEl &&
					(e = this.navigation.$nextEl),
				  this.navigation &&
					this.navigation.$prevEl &&
					(t = this.navigation.$prevEl),
				  e && e.off("keydown", this.a11y.onEnterKey),
				  t && t.off("keydown", this.a11y.onEnterKey),
				  this.pagination &&
					this.params.pagination.clickable &&
					this.pagination.bullets &&
					this.pagination.bullets.length &&
					this.pagination.$el.off(
					  "keydown",
					  "." + this.params.pagination.bulletClass,
					  this.a11y.onEnterKey
					);
			  },
			},
			Z = {
			  init: function () {
				if (this.params.history) {
				  if (!H.history || !H.history.pushState)
					return (
					  (this.params.history.enabled = !1),
					  void (this.params.hashNavigation.enabled = !0)
					);
				  var e = this.history;
				  (e.initialized = !0),
					(e.paths = Z.getPathValues()),
					(e.paths.key || e.paths.value) &&
					  (e.scrollToSlide(
						0,
						e.paths.value,
						this.params.runCallbacksOnInit
					  ),
					  this.params.history.replaceState ||
						H.addEventListener(
						  "popstate",
						  this.history.setHistoryPopState
						));
				}
			  },
			  destroy: function () {
				this.params.history.replaceState ||
				  H.removeEventListener(
					"popstate",
					this.history.setHistoryPopState
				  );
			  },
			  setHistoryPopState: function () {
				(this.history.paths = Z.getPathValues()),
				  this.history.scrollToSlide(
					this.params.speed,
					this.history.paths.value,
					!1
				  );
			  },
			  getPathValues: function () {
				var e = H.location.pathname
					.slice(1)
					.split("/")
					.filter(function (e) {
					  return "" !== e;
					}),
				  t = e.length;
				return { key: e[t - 2], value: e[t - 1] };
			  },
			  setHistory: function (e, t) {
				if (this.history.initialized && this.params.history.enabled) {
				  var i = this.slides.eq(t),
					n = Z.slugify(i.attr("data-history"));
				  H.location.pathname.includes(e) || (n = e + "/" + n);
				  var s = H.history.state;
				  (s && s.value === n) ||
					(this.params.history.replaceState
					  ? H.history.replaceState({ value: n }, null, n)
					  : H.history.pushState({ value: n }, null, n));
				}
			  },
			  slugify: function (e) {
				return e
				  .toString()
				  .toLowerCase()
				  .replace(/\s+/g, "-")
				  .replace(/[^\w-]+/g, "")
				  .replace(/--+/g, "-")
				  .replace(/^-+/, "")
				  .replace(/-+$/, "");
			  },
			  scrollToSlide: function (e, t, i) {
				if (t)
				  for (var n = 0, s = this.slides.length; n < s; n += 1) {
					var r = this.slides.eq(n);
					if (
					  Z.slugify(r.attr("data-history")) === t &&
					  !r.hasClass(this.params.slideDuplicateClass)
					) {
					  var a = r.index();
					  this.slideTo(a, e, i);
					}
				  }
				else this.slideTo(0, e, i);
			  },
			},
			G = {
			  onHashCange: function () {
				var e = f.location.hash.replace("#", "");
				e !== this.slides.eq(this.activeIndex).attr("data-hash") &&
				  this.slideTo(
					this.$wrapperEl
					  .children(
						"." + this.params.slideClass + '[data-hash="' + e + '"]'
					  )
					  .index()
				  );
			  },
			  setHash: function () {
				if (
				  this.hashNavigation.initialized &&
				  this.params.hashNavigation.enabled
				)
				  if (
					this.params.hashNavigation.replaceState &&
					H.history &&
					H.history.replaceState
				  )
					H.history.replaceState(
					  null,
					  null,
					  "#" + this.slides.eq(this.activeIndex).attr("data-hash") ||
						""
					);
				  else {
					var e = this.slides.eq(this.activeIndex),
					  t = e.attr("data-hash") || e.attr("data-history");
					f.location.hash = t || "";
				  }
			  },
			  init: function () {
				if (
				  !(
					!this.params.hashNavigation.enabled ||
					(this.params.history && this.params.history.enabled)
				  )
				) {
				  this.hashNavigation.initialized = !0;
				  var e = f.location.hash.replace("#", "");
				  if (e)
					for (var t = 0, i = this.slides.length; t < i; t += 1) {
					  var n = this.slides.eq(t);
					  if (
						(n.attr("data-hash") || n.attr("data-history")) === e &&
						!n.hasClass(this.params.slideDuplicateClass)
					  ) {
						var s = n.index();
						this.slideTo(s, 0, this.params.runCallbacksOnInit, !0);
					  }
					}
				  this.params.hashNavigation.watchState &&
					P(H).on("hashchange", this.hashNavigation.onHashCange);
				}
			  },
			  destroy: function () {
				this.params.hashNavigation.watchState &&
				  P(H).off("hashchange", this.hashNavigation.onHashCange);
			  },
			},
			U = {
			  run: function () {
				var e = this,
				  t = e.slides.eq(e.activeIndex),
				  i = e.params.autoplay.delay;
				t.attr("data-swiper-autoplay") &&
				  (i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
				  (e.autoplay.timeout = j.nextTick(function () {
					e.params.autoplay.reverseDirection
					  ? e.params.loop
						? (e.loopFix(),
						  e.slidePrev(e.params.speed, !0, !0),
						  e.emit("autoplay"))
						: e.isBeginning
						? e.params.autoplay.stopOnLastSlide
						  ? e.autoplay.stop()
						  : (e.slideTo(
							  e.slides.length - 1,
							  e.params.speed,
							  !0,
							  !0
							),
							e.emit("autoplay"))
						: (e.slidePrev(e.params.speed, !0, !0),
						  e.emit("autoplay"))
					  : e.params.loop
					  ? (e.loopFix(),
						e.slideNext(e.params.speed, !0, !0),
						e.emit("autoplay"))
					  : e.isEnd
					  ? e.params.autoplay.stopOnLastSlide
						? e.autoplay.stop()
						: (e.slideTo(0, e.params.speed, !0, !0),
						  e.emit("autoplay"))
					  : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"));
				  }, i));
			  },
			  start: function () {
				return (
				  void 0 === this.autoplay.timeout &&
				  !this.autoplay.running &&
				  ((this.autoplay.running = !0),
				  this.emit("autoplayStart"),
				  this.autoplay.run(),
				  !0)
				);
			  },
			  stop: function () {
				return (
				  !!this.autoplay.running &&
				  void 0 !== this.autoplay.timeout &&
				  (this.autoplay.timeout &&
					(clearTimeout(this.autoplay.timeout),
					(this.autoplay.timeout = void 0)),
				  (this.autoplay.running = !1),
				  this.emit("autoplayStop"),
				  !0)
				);
			  },
			  pause: function (e) {
				this.autoplay.running &&
				  (this.autoplay.paused ||
					(this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
					(this.autoplay.paused = !0),
					0 !== e && this.params.autoplay.waitForTransition
					  ? (this.$wrapperEl[0].addEventListener(
						  "transitionend",
						  this.autoplay.onTransitionEnd
						),
						this.$wrapperEl[0].addEventListener(
						  "webkitTransitionEnd",
						  this.autoplay.onTransitionEnd
						))
					  : ((this.autoplay.paused = !1), this.autoplay.run())));
			  },
			},
			Q = {
			  setTranslate: function () {
				for (var e = this.slides, t = 0; t < e.length; t += 1) {
				  var i = this.slides.eq(t),
					n = -i[0].swiperSlideOffset;
				  this.params.virtualTranslate || (n -= this.translate);
				  var s = 0;
				  this.isHorizontal() || ((s = n), (n = 0));
				  var r = this.params.fadeEffect.crossFade
					? Math.max(1 - Math.abs(i[0].progress), 0)
					: 1 + Math.min(Math.max(i[0].progress, -1), 0);
				  i.css({ opacity: r }).transform(
					"translate3d(" + n + "px, " + s + "px, 0px)"
				  );
				}
			  },
			  setTransition: function (e) {
				var i = this,
				  t = i.slides,
				  n = i.$wrapperEl;
				if ((t.transition(e), i.params.virtualTranslate && 0 !== e)) {
				  var s = !1;
				  t.transitionEnd(function () {
					if (!s && i && !i.destroyed) {
					  (s = !0), (i.animating = !1);
					  for (
						var e = ["webkitTransitionEnd", "transitionend"], t = 0;
						t < e.length;
						t += 1
					  )
						n.trigger(e[t]);
					}
				  });
				}
			  },
			},
			K = {
			  setTranslate: function () {
				var e,
				  t = this.$el,
				  i = this.$wrapperEl,
				  n = this.slides,
				  s = this.width,
				  r = this.height,
				  a = this.rtlTranslate,
				  o = this.size,
				  l = this.params.cubeEffect,
				  d = this.isHorizontal(),
				  c = this.virtual && this.params.virtual.enabled,
				  u = 0;
				l.shadow &&
				  (d
					? (0 === (e = i.find(".swiper-cube-shadow")).length &&
						((e = P('<div class="swiper-cube-shadow"></div>')),
						i.append(e)),
					  e.css({ height: s + "px" }))
					: 0 === (e = t.find(".swiper-cube-shadow")).length &&
					  ((e = P('<div class="swiper-cube-shadow"></div>')),
					  t.append(e)));
				for (var h = 0; h < n.length; h += 1) {
				  var p = n.eq(h),
					f = h;
				  c && (f = parseInt(p.attr("data-swiper-slide-index"), 10));
				  var v = 90 * f,
					g = Math.floor(v / 360);
				  a && ((v = -v), (g = Math.floor(-v / 360)));
				  var m = Math.max(Math.min(p[0].progress, 1), -1),
					y = 0,
					b = 0,
					w = 0;
				  f % 4 == 0
					? ((y = 4 * -g * o), (w = 0))
					: (f - 1) % 4 == 0
					? ((y = 0), (w = 4 * -g * o))
					: (f - 2) % 4 == 0
					? ((y = o + 4 * g * o), (w = o))
					: (f - 3) % 4 == 0 && ((y = -o), (w = 3 * o + 4 * o * g)),
					a && (y = -y),
					d || ((b = y), (y = 0));
				  var x =
					"rotateX(" +
					(d ? 0 : -v) +
					"deg) rotateY(" +
					(d ? v : 0) +
					"deg) translate3d(" +
					y +
					"px, " +
					b +
					"px, " +
					w +
					"px)";
				  if (
					(m <= 1 &&
					  -1 < m &&
					  ((u = 90 * f + 90 * m), a && (u = 90 * -f - 90 * m)),
					p.transform(x),
					l.slideShadows)
				  ) {
					var T = d
						? p.find(".swiper-slide-shadow-left")
						: p.find(".swiper-slide-shadow-top"),
					  S = d
						? p.find(".swiper-slide-shadow-right")
						: p.find(".swiper-slide-shadow-bottom");
					0 === T.length &&
					  ((T = P(
						'<div class="swiper-slide-shadow-' +
						  (d ? "left" : "top") +
						  '"></div>'
					  )),
					  p.append(T)),
					  0 === S.length &&
						((S = P(
						  '<div class="swiper-slide-shadow-' +
							(d ? "right" : "bottom") +
							'"></div>'
						)),
						p.append(S)),
					  T.length && (T[0].style.opacity = Math.max(-m, 0)),
					  S.length && (S[0].style.opacity = Math.max(m, 0));
				  }
				}
				if (
				  (i.css({
					"-webkit-transform-origin": "50% 50% -" + o / 2 + "px",
					"-moz-transform-origin": "50% 50% -" + o / 2 + "px",
					"-ms-transform-origin": "50% 50% -" + o / 2 + "px",
					"transform-origin": "50% 50% -" + o / 2 + "px",
				  }),
				  l.shadow)
				)
				  if (d)
					e.transform(
					  "translate3d(0px, " +
						(s / 2 + l.shadowOffset) +
						"px, " +
						-s / 2 +
						"px) rotateX(90deg) rotateZ(0deg) scale(" +
						l.shadowScale +
						")"
					);
				  else {
					var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
					  E =
						1.5 -
						(Math.sin((2 * C * Math.PI) / 360) / 2 +
						  Math.cos((2 * C * Math.PI) / 360) / 2),
					  k = l.shadowScale,
					  Y = l.shadowScale / E,
					  z = l.shadowOffset;
					e.transform(
					  "scale3d(" +
						k +
						", 1, " +
						Y +
						") translate3d(0px, " +
						(r / 2 + z) +
						"px, " +
						-r / 2 / Y +
						"px) rotateX(-90deg)"
					);
				  }
				var $ = A.isSafari || A.isUiWebView ? -o / 2 : 0;
				i.transform(
				  "translate3d(0px,0," +
					$ +
					"px) rotateX(" +
					(this.isHorizontal() ? 0 : u) +
					"deg) rotateY(" +
					(this.isHorizontal() ? -u : 0) +
					"deg)"
				);
			  },
			  setTransition: function (e) {
				var t = this.$el;
				this.slides
				  .transition(e)
				  .find(
					".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
				  )
				  .transition(e),
				  this.params.cubeEffect.shadow &&
					!this.isHorizontal() &&
					t.find(".swiper-cube-shadow").transition(e);
			  },
			},
			J = {
			  setTranslate: function () {
				for (
				  var e = this.slides, t = this.rtlTranslate, i = 0;
				  i < e.length;
				  i += 1
				) {
				  var n = e.eq(i),
					s = n[0].progress;
				  this.params.flipEffect.limitRotation &&
					(s = Math.max(Math.min(n[0].progress, 1), -1));
				  var r = -180 * s,
					a = 0,
					o = -n[0].swiperSlideOffset,
					l = 0;
				  if (
					(this.isHorizontal()
					  ? t && (r = -r)
					  : ((l = o), (a = -r), (r = o = 0)),
					(n[0].style.zIndex = -Math.abs(Math.round(s)) + e.length),
					this.params.flipEffect.slideShadows)
				  ) {
					var d = this.isHorizontal()
						? n.find(".swiper-slide-shadow-left")
						: n.find(".swiper-slide-shadow-top"),
					  c = this.isHorizontal()
						? n.find(".swiper-slide-shadow-right")
						: n.find(".swiper-slide-shadow-bottom");
					0 === d.length &&
					  ((d = P(
						'<div class="swiper-slide-shadow-' +
						  (this.isHorizontal() ? "left" : "top") +
						  '"></div>'
					  )),
					  n.append(d)),
					  0 === c.length &&
						((c = P(
						  '<div class="swiper-slide-shadow-' +
							(this.isHorizontal() ? "right" : "bottom") +
							'"></div>'
						)),
						n.append(c)),
					  d.length && (d[0].style.opacity = Math.max(-s, 0)),
					  c.length && (c[0].style.opacity = Math.max(s, 0));
				  }
				  n.transform(
					"translate3d(" +
					  o +
					  "px, " +
					  l +
					  "px, 0px) rotateX(" +
					  a +
					  "deg) rotateY(" +
					  r +
					  "deg)"
				  );
				}
			  },
			  setTransition: function (e) {
				var i = this,
				  t = i.slides,
				  n = i.activeIndex,
				  s = i.$wrapperEl;
				if (
				  (t
					.transition(e)
					.find(
					  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
					)
					.transition(e),
				  i.params.virtualTranslate && 0 !== e)
				) {
				  var r = !1;
				  t.eq(n).transitionEnd(function () {
					if (!r && i && !i.destroyed) {
					  (r = !0), (i.animating = !1);
					  for (
						var e = ["webkitTransitionEnd", "transitionend"], t = 0;
						t < e.length;
						t += 1
					  )
						s.trigger(e[t]);
					}
				  });
				}
			  },
			},
			ee = {
			  setTranslate: function () {
				for (
				  var e = this.width,
					t = this.height,
					i = this.slides,
					n = this.$wrapperEl,
					s = this.slidesSizesGrid,
					r = this.params.coverflowEffect,
					a = this.isHorizontal(),
					o = this.translate,
					l = a ? e / 2 - o : t / 2 - o,
					d = a ? r.rotate : -r.rotate,
					c = r.depth,
					u = 0,
					h = i.length;
				  u < h;
				  u += 1
				) {
				  var p = i.eq(u),
					f = s[u],
					v = ((l - p[0].swiperSlideOffset - f / 2) / f) * r.modifier,
					g = a ? d * v : 0,
					m = a ? 0 : d * v,
					y = -c * Math.abs(v),
					b = a ? 0 : r.stretch * v,
					w = a ? r.stretch * v : 0;
				  Math.abs(w) < 0.001 && (w = 0),
					Math.abs(b) < 0.001 && (b = 0),
					Math.abs(y) < 0.001 && (y = 0),
					Math.abs(g) < 0.001 && (g = 0),
					Math.abs(m) < 0.001 && (m = 0);
				  var x =
					"translate3d(" +
					w +
					"px," +
					b +
					"px," +
					y +
					"px)  rotateX(" +
					m +
					"deg) rotateY(" +
					g +
					"deg)";
				  if (
					(p.transform(x),
					(p[0].style.zIndex = 1 - Math.abs(Math.round(v))),
					r.slideShadows)
				  ) {
					var T = a
						? p.find(".swiper-slide-shadow-left")
						: p.find(".swiper-slide-shadow-top"),
					  S = a
						? p.find(".swiper-slide-shadow-right")
						: p.find(".swiper-slide-shadow-bottom");
					0 === T.length &&
					  ((T = P(
						'<div class="swiper-slide-shadow-' +
						  (a ? "left" : "top") +
						  '"></div>'
					  )),
					  p.append(T)),
					  0 === S.length &&
						((S = P(
						  '<div class="swiper-slide-shadow-' +
							(a ? "right" : "bottom") +
							'"></div>'
						)),
						p.append(S)),
					  T.length && (T[0].style.opacity = 0 < v ? v : 0),
					  S.length && (S[0].style.opacity = 0 < -v ? -v : 0);
				  }
				}
				(q.pointerEvents || q.prefixedPointerEvents) &&
				  (n[0].style.perspectiveOrigin = l + "px 50%");
			  },
			  setTransition: function (e) {
				this.slides
				  .transition(e)
				  .find(
					".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
				  )
				  .transition(e);
			  },
			},
			te = [
			  C,
			  E,
			  k,
			  Y,
			  $,
			  L,
			  O,
			  {
				name: "mousewheel",
				params: {
				  mousewheel: {
					enabled: !1,
					releaseOnEdges: !1,
					invert: !1,
					forceToAxis: !1,
					sensitivity: 1,
					eventsTarged: "container",
				  },
				},
				create: function () {
				  j.extend(this, {
					mousewheel: {
					  enabled: !1,
					  enable: N.enable.bind(this),
					  disable: N.disable.bind(this),
					  handle: N.handle.bind(this),
					  handleMouseEnter: N.handleMouseEnter.bind(this),
					  handleMouseLeave: N.handleMouseLeave.bind(this),
					  lastScrollTime: j.now(),
					},
				  });
				},
				on: {
				  init: function () {
					this.params.mousewheel.enabled && this.mousewheel.enable();
				  },
				  destroy: function () {
					this.mousewheel.enabled && this.mousewheel.disable();
				  },
				},
			  },
			  {
				name: "navigation",
				params: {
				  navigation: {
					nextEl: null,
					prevEl: null,
					hideOnClick: !1,
					disabledClass: "swiper-button-disabled",
					hiddenClass: "swiper-button-hidden",
					lockClass: "swiper-button-lock",
				  },
				},
				create: function () {
				  j.extend(this, {
					navigation: {
					  init: I.init.bind(this),
					  update: I.update.bind(this),
					  destroy: I.destroy.bind(this),
					},
				  });
				},
				on: {
				  init: function () {
					this.navigation.init(), this.navigation.update();
				  },
				  toEdge: function () {
					this.navigation.update();
				  },
				  fromEdge: function () {
					this.navigation.update();
				  },
				  destroy: function () {
					this.navigation.destroy();
				  },
				  click: function (e) {
					var t = this.navigation,
					  i = t.$nextEl,
					  n = t.$prevEl;
					!this.params.navigation.hideOnClick ||
					  P(e.target).is(n) ||
					  P(e.target).is(i) ||
					  (i && i.toggleClass(this.params.navigation.hiddenClass),
					  n && n.toggleClass(this.params.navigation.hiddenClass));
				  },
				},
			  },
			  {
				name: "pagination",
				params: {
				  pagination: {
					el: null,
					bulletElement: "span",
					clickable: !1,
					hideOnClick: !1,
					renderBullet: null,
					renderProgressbar: null,
					renderFraction: null,
					renderCustom: null,
					progressbarOpposite: !1,
					type: "bullets",
					dynamicBullets: !1,
					dynamicMainBullets: 1,
					formatFractionCurrent: function (e) {
					  return e;
					},
					formatFractionTotal: function (e) {
					  return e;
					},
					bulletClass: "swiper-pagination-bullet",
					bulletActiveClass: "swiper-pagination-bullet-active",
					modifierClass: "swiper-pagination-",
					currentClass: "swiper-pagination-current",
					totalClass: "swiper-pagination-total",
					hiddenClass: "swiper-pagination-hidden",
					progressbarFillClass: "swiper-pagination-progressbar-fill",
					progressbarOppositeClass:
					  "swiper-pagination-progressbar-opposite",
					clickableClass: "swiper-pagination-clickable",
					lockClass: "swiper-pagination-lock",
				  },
				},
				create: function () {
				  j.extend(this, {
					pagination: {
					  init: B.init.bind(this),
					  render: B.render.bind(this),
					  update: B.update.bind(this),
					  destroy: B.destroy.bind(this),
					  dynamicBulletIndex: 0,
					},
				  });
				},
				on: {
				  init: function () {
					this.pagination.init(),
					  this.pagination.render(),
					  this.pagination.update();
				  },
				  activeIndexChange: function () {
					(!this.params.loop && void 0 !== this.snapIndex) ||
					  this.pagination.update();
				  },
				  snapIndexChange: function () {
					this.params.loop || this.pagination.update();
				  },
				  slidesLengthChange: function () {
					this.params.loop &&
					  (this.pagination.render(), this.pagination.update());
				  },
				  snapGridLengthChange: function () {
					this.params.loop ||
					  (this.pagination.render(), this.pagination.update());
				  },
				  destroy: function () {
					this.pagination.destroy();
				  },
				  click: function (e) {
					this.params.pagination.el &&
					  this.params.pagination.hideOnClick &&
					  0 < this.pagination.$el.length &&
					  !P(e.target).hasClass(this.params.pagination.bulletClass) &&
					  this.pagination.$el.toggleClass(
						this.params.pagination.hiddenClass
					  );
				  },
				},
			  },
			  {
				name: "scrollbar",
				params: {
				  scrollbar: {
					el: null,
					dragSize: "auto",
					hide: !1,
					draggable: !1,
					snapOnRelease: !0,
					lockClass: "swiper-scrollbar-lock",
					dragClass: "swiper-scrollbar-drag",
				  },
				},
				create: function () {
				  j.extend(this, {
					scrollbar: {
					  init: R.init.bind(this),
					  destroy: R.destroy.bind(this),
					  updateSize: R.updateSize.bind(this),
					  setTranslate: R.setTranslate.bind(this),
					  setTransition: R.setTransition.bind(this),
					  enableDraggable: R.enableDraggable.bind(this),
					  disableDraggable: R.disableDraggable.bind(this),
					  setDragPosition: R.setDragPosition.bind(this),
					  onDragStart: R.onDragStart.bind(this),
					  onDragMove: R.onDragMove.bind(this),
					  onDragEnd: R.onDragEnd.bind(this),
					  isTouched: !1,
					  timeout: null,
					  dragTimeout: null,
					},
				  });
				},
				on: {
				  init: function () {
					this.scrollbar.init(),
					  this.scrollbar.updateSize(),
					  this.scrollbar.setTranslate();
				  },
				  update: function () {
					this.scrollbar.updateSize();
				  },
				  resize: function () {
					this.scrollbar.updateSize();
				  },
				  observerUpdate: function () {
					this.scrollbar.updateSize();
				  },
				  setTranslate: function () {
					this.scrollbar.setTranslate();
				  },
				  setTransition: function (e) {
					this.scrollbar.setTransition(e);
				  },
				  destroy: function () {
					this.scrollbar.destroy();
				  },
				},
			  },
			  {
				name: "parallax",
				params: { parallax: { enabled: !1 } },
				create: function () {
				  j.extend(this, {
					parallax: {
					  setTransform: W.setTransform.bind(this),
					  setTranslate: W.setTranslate.bind(this),
					  setTransition: W.setTransition.bind(this),
					},
				  });
				},
				on: {
				  beforeInit: function () {
					this.params.parallax.enabled &&
					  (this.params.watchSlidesProgress = !0);
				  },
				  init: function () {
					this.params.parallax && this.parallax.setTranslate();
				  },
				  setTranslate: function () {
					this.params.parallax && this.parallax.setTranslate();
				  },
				  setTransition: function (e) {
					this.params.parallax && this.parallax.setTransition(e);
				  },
				},
			  },
			  {
				name: "zoom",
				params: {
				  zoom: {
					enabled: !1,
					maxRatio: 3,
					minRatio: 1,
					toggle: !0,
					containerClass: "swiper-zoom-container",
					zoomedSlideClass: "swiper-slide-zoomed",
				  },
				},
				create: function () {
				  var t = this,
					i = {
					  enabled: !1,
					  scale: 1,
					  currentScale: 1,
					  isScaling: !1,
					  gesture: {
						$slideEl: void 0,
						slideWidth: void 0,
						slideHeight: void 0,
						$imageEl: void 0,
						$imageWrapEl: void 0,
						maxRatio: 3,
					  },
					  image: {
						isTouched: void 0,
						isMoved: void 0,
						currentX: void 0,
						currentY: void 0,
						minX: void 0,
						minY: void 0,
						maxX: void 0,
						maxY: void 0,
						width: void 0,
						height: void 0,
						startX: void 0,
						startY: void 0,
						touchesStart: {},
						touchesCurrent: {},
					  },
					  velocity: {
						x: void 0,
						y: void 0,
						prevPositionX: void 0,
						prevPositionY: void 0,
						prevTime: void 0,
					  },
					};
				  "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
					.split(" ")
					.forEach(function (e) {
					  i[e] = F[e].bind(t);
					}),
					j.extend(t, { zoom: i });
				},
				on: {
				  init: function () {
					this.params.zoom.enabled && this.zoom.enable();
				  },
				  destroy: function () {
					this.zoom.disable();
				  },
				  touchStart: function (e) {
					this.zoom.enabled && this.zoom.onTouchStart(e);
				  },
				  touchEnd: function (e) {
					this.zoom.enabled && this.zoom.onTouchEnd(e);
				  },
				  doubleTap: function (e) {
					this.params.zoom.enabled &&
					  this.zoom.enabled &&
					  this.params.zoom.toggle &&
					  this.zoom.toggle(e);
				  },
				  transitionEnd: function () {
					this.zoom.enabled &&
					  this.params.zoom.enabled &&
					  this.zoom.onTransitionEnd();
				  },
				},
			  },
			  {
				name: "lazy",
				params: {
				  lazy: {
					enabled: !1,
					loadPrevNext: !1,
					loadPrevNextAmount: 1,
					loadOnTransitionStart: !1,
					elementClass: "swiper-lazy",
					loadingClass: "swiper-lazy-loading",
					loadedClass: "swiper-lazy-loaded",
					preloaderClass: "swiper-lazy-preloader",
				  },
				},
				create: function () {
				  j.extend(this, {
					lazy: {
					  initialImageLoaded: !1,
					  load: X.load.bind(this),
					  loadInSlide: X.loadInSlide.bind(this),
					},
				  });
				},
				on: {
				  beforeInit: function () {
					this.params.lazy.enabled &&
					  this.params.preloadImages &&
					  (this.params.preloadImages = !1);
				  },
				  init: function () {
					this.params.lazy.enabled &&
					  !this.params.loop &&
					  0 === this.params.initialSlide &&
					  this.lazy.load();
				  },
				  scroll: function () {
					this.params.freeMode &&
					  !this.params.freeModeSticky &&
					  this.lazy.load();
				  },
				  resize: function () {
					this.params.lazy.enabled && this.lazy.load();
				  },
				  scrollbarDragMove: function () {
					this.params.lazy.enabled && this.lazy.load();
				  },
				  transitionStart: function () {
					this.params.lazy.enabled &&
					  (this.params.lazy.loadOnTransitionStart ||
						(!this.params.lazy.loadOnTransitionStart &&
						  !this.lazy.initialImageLoaded)) &&
					  this.lazy.load();
				  },
				  transitionEnd: function () {
					this.params.lazy.enabled &&
					  !this.params.lazy.loadOnTransitionStart &&
					  this.lazy.load();
				  },
				},
			  },
			  {
				name: "controller",
				params: {
				  controller: { control: void 0, inverse: !1, by: "slide" },
				},
				create: function () {
				  j.extend(this, {
					controller: {
					  control: this.params.controller.control,
					  getInterpolateFunction: _.getInterpolateFunction.bind(this),
					  setTranslate: _.setTranslate.bind(this),
					  setTransition: _.setTransition.bind(this),
					},
				  });
				},
				on: {
				  update: function () {
					this.controller.control &&
					  this.controller.spline &&
					  ((this.controller.spline = void 0),
					  delete this.controller.spline);
				  },
				  resize: function () {
					this.controller.control &&
					  this.controller.spline &&
					  ((this.controller.spline = void 0),
					  delete this.controller.spline);
				  },
				  observerUpdate: function () {
					this.controller.control &&
					  this.controller.spline &&
					  ((this.controller.spline = void 0),
					  delete this.controller.spline);
				  },
				  setTranslate: function (e, t) {
					this.controller.control && this.controller.setTranslate(e, t);
				  },
				  setTransition: function (e, t) {
					this.controller.control &&
					  this.controller.setTransition(e, t);
				  },
				},
			  },
			  {
				name: "a11y",
				params: {
				  a11y: {
					enabled: !0,
					notificationClass: "swiper-notification",
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
					firstSlideMessage: "This is the first slide",
					lastSlideMessage: "This is the last slide",
					paginationBulletMessage: "Go to slide {{index}}",
				  },
				},
				create: function () {
				  var t = this;
				  j.extend(t, {
					a11y: {
					  liveRegion: P(
						'<span class="' +
						  t.params.a11y.notificationClass +
						  '" aria-live="assertive" aria-atomic="true"></span>'
					  ),
					},
				  }),
					Object.keys(V).forEach(function (e) {
					  t.a11y[e] = V[e].bind(t);
					});
				},
				on: {
				  init: function () {
					this.params.a11y.enabled &&
					  (this.a11y.init(), this.a11y.updateNavigation());
				  },
				  toEdge: function () {
					this.params.a11y.enabled && this.a11y.updateNavigation();
				  },
				  fromEdge: function () {
					this.params.a11y.enabled && this.a11y.updateNavigation();
				  },
				  paginationUpdate: function () {
					this.params.a11y.enabled && this.a11y.updatePagination();
				  },
				  destroy: function () {
					this.params.a11y.enabled && this.a11y.destroy();
				  },
				},
			  },
			  {
				name: "history",
				params: {
				  history: { enabled: !1, replaceState: !1, key: "slides" },
				},
				create: function () {
				  j.extend(this, {
					history: {
					  init: Z.init.bind(this),
					  setHistory: Z.setHistory.bind(this),
					  setHistoryPopState: Z.setHistoryPopState.bind(this),
					  scrollToSlide: Z.scrollToSlide.bind(this),
					  destroy: Z.destroy.bind(this),
					},
				  });
				},
				on: {
				  init: function () {
					this.params.history.enabled && this.history.init();
				  },
				  destroy: function () {
					this.params.history.enabled && this.history.destroy();
				  },
				  transitionEnd: function () {
					this.history.initialized &&
					  this.history.setHistory(
						this.params.history.key,
						this.activeIndex
					  );
				  },
				},
			  },
			  {
				name: "hash-navigation",
				params: {
				  hashNavigation: {
					enabled: !1,
					replaceState: !1,
					watchState: !1,
				  },
				},
				create: function () {
				  j.extend(this, {
					hashNavigation: {
					  initialized: !1,
					  init: G.init.bind(this),
					  destroy: G.destroy.bind(this),
					  setHash: G.setHash.bind(this),
					  onHashCange: G.onHashCange.bind(this),
					},
				  });
				},
				on: {
				  init: function () {
					this.params.hashNavigation.enabled &&
					  this.hashNavigation.init();
				  },
				  destroy: function () {
					this.params.hashNavigation.enabled &&
					  this.hashNavigation.destroy();
				  },
				  transitionEnd: function () {
					this.hashNavigation.initialized &&
					  this.hashNavigation.setHash();
				  },
				},
			  },
			  {
				name: "autoplay",
				params: {
				  autoplay: {
					enabled: !1,
					delay: 3e3,
					waitForTransition: !0,
					disableOnInteraction: !0,
					stopOnLastSlide: !1,
					reverseDirection: !1,
				  },
				},
				create: function () {
				  var t = this;
				  j.extend(t, {
					autoplay: {
					  running: !1,
					  paused: !1,
					  run: U.run.bind(t),
					  start: U.start.bind(t),
					  stop: U.stop.bind(t),
					  pause: U.pause.bind(t),
					  onTransitionEnd: function (e) {
						t &&
						  !t.destroyed &&
						  t.$wrapperEl &&
						  e.target === this &&
						  (t.$wrapperEl[0].removeEventListener(
							"transitionend",
							t.autoplay.onTransitionEnd
						  ),
						  t.$wrapperEl[0].removeEventListener(
							"webkitTransitionEnd",
							t.autoplay.onTransitionEnd
						  ),
						  (t.autoplay.paused = !1),
						  t.autoplay.running
							? t.autoplay.run()
							: t.autoplay.stop());
					  },
					},
				  });
				},
				on: {
				  init: function () {
					this.params.autoplay.enabled && this.autoplay.start();
				  },
				  beforeTransitionStart: function (e, t) {
					this.autoplay.running &&
					  (t || !this.params.autoplay.disableOnInteraction
						? this.autoplay.pause(e)
						: this.autoplay.stop());
				  },
				  sliderFirstMove: function () {
					this.autoplay.running &&
					  (this.params.autoplay.disableOnInteraction
						? this.autoplay.stop()
						: this.autoplay.pause());
				  },
				  destroy: function () {
					this.autoplay.running && this.autoplay.stop();
				  },
				},
			  },
			  {
				name: "effect-fade",
				params: { fadeEffect: { crossFade: !1 } },
				create: function () {
				  j.extend(this, {
					fadeEffect: {
					  setTranslate: Q.setTranslate.bind(this),
					  setTransition: Q.setTransition.bind(this),
					},
				  });
				},
				on: {
				  beforeInit: function () {
					if ("fade" === this.params.effect) {
					  this.classNames.push(
						this.params.containerModifierClass + "fade"
					  );
					  var e = {
						slidesPerView: 1,
						slidesPerColumn: 1,
						slidesPerGroup: 1,
						watchSlidesProgress: !0,
						spaceBetween: 0,
						virtualTranslate: !0,
					  };
					  j.extend(this.params, e), j.extend(this.originalParams, e);
					}
				  },
				  setTranslate: function () {
					"fade" === this.params.effect &&
					  this.fadeEffect.setTranslate();
				  },
				  setTransition: function (e) {
					"fade" === this.params.effect &&
					  this.fadeEffect.setTransition(e);
				  },
				},
			  },
			  {
				name: "effect-cube",
				params: {
				  cubeEffect: {
					slideShadows: !0,
					shadow: !0,
					shadowOffset: 20,
					shadowScale: 0.94,
				  },
				},
				create: function () {
				  j.extend(this, {
					cubeEffect: {
					  setTranslate: K.setTranslate.bind(this),
					  setTransition: K.setTransition.bind(this),
					},
				  });
				},
				on: {
				  beforeInit: function () {
					if ("cube" === this.params.effect) {
					  this.classNames.push(
						this.params.containerModifierClass + "cube"
					  ),
						this.classNames.push(
						  this.params.containerModifierClass + "3d"
						);
					  var e = {
						slidesPerView: 1,
						slidesPerColumn: 1,
						slidesPerGroup: 1,
						watchSlidesProgress: !0,
						resistanceRatio: 0,
						spaceBetween: 0,
						centeredSlides: !1,
						virtualTranslate: !0,
					  };
					  j.extend(this.params, e), j.extend(this.originalParams, e);
					}
				  },
				  setTranslate: function () {
					"cube" === this.params.effect &&
					  this.cubeEffect.setTranslate();
				  },
				  setTransition: function (e) {
					"cube" === this.params.effect &&
					  this.cubeEffect.setTransition(e);
				  },
				},
			  },
			  {
				name: "effect-flip",
				params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
				create: function () {
				  j.extend(this, {
					flipEffect: {
					  setTranslate: J.setTranslate.bind(this),
					  setTransition: J.setTransition.bind(this),
					},
				  });
				},
				on: {
				  beforeInit: function () {
					if ("flip" === this.params.effect) {
					  this.classNames.push(
						this.params.containerModifierClass + "flip"
					  ),
						this.classNames.push(
						  this.params.containerModifierClass + "3d"
						);
					  var e = {
						slidesPerView: 1,
						slidesPerColumn: 1,
						slidesPerGroup: 1,
						watchSlidesProgress: !0,
						spaceBetween: 0,
						virtualTranslate: !0,
					  };
					  j.extend(this.params, e), j.extend(this.originalParams, e);
					}
				  },
				  setTranslate: function () {
					"flip" === this.params.effect &&
					  this.flipEffect.setTranslate();
				  },
				  setTransition: function (e) {
					"flip" === this.params.effect &&
					  this.flipEffect.setTransition(e);
				  },
				},
			  },
			  {
				name: "effect-coverflow",
				params: {
				  coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: !0,
				  },
				},
				create: function () {
				  j.extend(this, {
					coverflowEffect: {
					  setTranslate: ee.setTranslate.bind(this),
					  setTransition: ee.setTransition.bind(this),
					},
				  });
				},
				on: {
				  beforeInit: function () {
					"coverflow" === this.params.effect &&
					  (this.classNames.push(
						this.params.containerModifierClass + "coverflow"
					  ),
					  this.classNames.push(
						this.params.containerModifierClass + "3d"
					  ),
					  (this.params.watchSlidesProgress = !0),
					  (this.originalParams.watchSlidesProgress = !0));
				  },
				  setTranslate: function () {
					"coverflow" === this.params.effect &&
					  this.coverflowEffect.setTranslate();
				  },
				  setTransition: function (e) {
					"coverflow" === this.params.effect &&
					  this.coverflowEffect.setTransition(e);
				  },
				},
			  },
			];
		  return (
			void 0 === S.use &&
			  ((S.use = S.Class.use), (S.installModule = S.Class.installModule)),
			S.use(te),
			S
		  );
		}),
		"object" ==
		  ("undefined" == typeof exports ? "undefined" : _typeof(exports)) &&
		"undefined" != typeof module
		  ? (module.exports = k_())
		  : "function" == typeof define && define.amd
		  ? define(k_)
		  : (j_.Swiper = k_()),
		(function (e) {
		  "use strict";
		  "function" == typeof define && define.amd
			? define(["jquery"], e)
			: "undefined" != typeof exports
			? (module.exports = e(require("jquery")))
			: e(jQuery);
		})(function (d) {
		  "use strict";
		  var s,
			r = window.Slick || {};
		  (s = 0),
			((r = function (e, t) {
			  var i,
				n = this;
			  (n.defaults = {
				accessibility: !0,
				adaptiveHeight: !1,
				appendArrows: d(e),
				appendDots: d(e),
				arrows: !0,
				asNavFor: null,
				prevArrow:
				  '<button type="button" data-role="none" class="slick-prev" aria-label="' +
				  theme.strings.previous +
				  '" tabindex="0" role="button">' +
				  theme.strings.previous +
				  "</button>",
				nextArrow:
				  '<button type="button" data-role="none" class="slick-next" aria-label="' +
				  theme.strings.next +
				  '" tabindex="0" role="button">' +
				  theme.strings.next +
				  "</button>",
				autoplay: !1,
				autoplaySpeed: 3e3,
				centerMode: !1,
				centerPadding: "50px",
				cssEase: "ease",
				customPaging: function (e, t) {
				  return d(
					'<button type="button" data-role="none" role="button" tabindex="0" />'
				  ).text(t + 1);
				},
				dots: !1,
				dotsClass: "slick-dots",
				draggable: !0,
				easing: "linear",
				edgeFriction: 0.35,
				fade: !1,
				focusOnSelect: !1,
				infinite: !0,
				initialSlide: 0,
				lazyLoad: "ondemand",
				mobileFirst: !1,
				pauseOnHover: !0,
				pauseOnFocus: !0,
				pauseOnDotsHover: !1,
				respondTo: "window",
				responsive: null,
				rows: 1,
				rtl: !1,
				slide: "",
				slidesPerRow: 1,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				swipe: !0,
				swipeToSlide: !1,
				touchMove: !0,
				touchThreshold: 5,
				useCSS: !0,
				useTransform: !0,
				variableWidth: !1,
				vertical: !1,
				verticalSwiping: !1,
				waitForAnimate: !0,
				zIndex: 1e3,
			  }),
				(n.initials = {
				  animating: !1,
				  dragging: !1,
				  autoPlayTimer: null,
				  currentDirection: 0,
				  currentLeft: null,
				  currentSlide: 0,
				  direction: 1,
				  $dots: null,
				  listWidth: null,
				  listHeight: null,
				  loadIndex: 0,
				  $nextArrow: null,
				  $prevArrow: null,
				  slideCount: null,
				  slideWidth: null,
				  $slideTrack: null,
				  $slides: null,
				  sliding: !1,
				  slideOffset: 0,
				  swipeLeft: null,
				  $list: null,
				  touchObject: {},
				  transformsEnabled: !1,
				  unslicked: !1,
				}),
				d.extend(n, n.initials),
				(n.activeBreakpoint = null),
				(n.animType = null),
				(n.animProp = null),
				(n.breakpoints = []),
				(n.breakpointSettings = []),
				(n.cssTransitions = !1),
				(n.focussed = !1),
				(n.interrupted = !1),
				(n.hidden = "hidden"),
				(n.paused = !0),
				(n.positionProp = null),
				(n.respondTo = null),
				(n.rowCount = 1),
				(n.shouldClick = !0),
				(n.$slider = d(e)),
				(n.$slidesCache = null),
				(n.transformType = null),
				(n.transitionType = null),
				(n.visibilityChange = "visibilitychange"),
				(n.windowWidth = 0),
				(n.windowTimer = null),
				(i = d(e).data("slick") || {}),
				(n.options = d.extend({}, n.defaults, t, i)),
				(n.currentSlide = n.options.initialSlide),
				(n.originalSettings = n.options),
				void 0 !== document.mozHidden
				  ? ((n.hidden = "mozHidden"),
					(n.visibilityChange = "mozvisibilitychange"))
				  : void 0 !== document.webkitHidden &&
					((n.hidden = "webkitHidden"),
					(n.visibilityChange = "webkitvisibilitychange")),
				(n.autoPlay = d.proxy(n.autoPlay, n)),
				(n.autoPlayClear = d.proxy(n.autoPlayClear, n)),
				(n.autoPlayIterator = d.proxy(n.autoPlayIterator, n)),
				(n.changeSlide = d.proxy(n.changeSlide, n)),
				(n.clickHandler = d.proxy(n.clickHandler, n)),
				(n.selectHandler = d.proxy(n.selectHandler, n)),
				(n.setPosition = d.proxy(n.setPosition, n)),
				(n.swipeHandler = d.proxy(n.swipeHandler, n)),
				(n.dragHandler = d.proxy(n.dragHandler, n)),
				(n.keyHandler = d.proxy(n.keyHandler, n)),
				(n.instanceUid = s++),
				(n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
				n.registerBreakpoints(),
				n.init(!0);
			}).prototype.activateADA = function () {
			  this.$slideTrack
				.find(".slick-active")
				.attr({ "aria-hidden": "false" })
				.find("a, input, button, select")
				.attr({ tabindex: "0" });
			}),
			(r.prototype.addSlide = r.prototype.slickAdd =
			  function (e, t, i) {
				var n = this;
				if ("boolean" == typeof t) (i = t), (t = null);
				else if (t < 0 || t >= n.slideCount) return !1;
				n.unload(),
				  "number" == typeof t
					? 0 === t && 0 === n.$slides.length
					  ? d(e).appendTo(n.$slideTrack)
					  : i
					  ? d(e).insertBefore(n.$slides.eq(t))
					  : d(e).insertAfter(n.$slides.eq(t))
					: !0 === i
					? d(e).prependTo(n.$slideTrack)
					: d(e).appendTo(n.$slideTrack),
				  (n.$slides = n.$slideTrack.children(this.options.slide)),
				  n.$slideTrack.children(this.options.slide).detach(),
				  n.$slideTrack.append(n.$slides),
				  n.$slides.each(function (e, t) {
					d(t).attr("data-slick-index", e);
				  }),
				  (n.$slidesCache = n.$slides),
				  n.reinit();
			  }),
			(r.prototype.animateHeight = function () {
			  if (
				1 === this.options.slidesToShow &&
				!0 === this.options.adaptiveHeight &&
				!1 === this.options.vertical
			  ) {
				var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
				this.$list.animate({ height: e }, this.options.speed);
			  }
			}),
			(r.prototype.animateSlide = function (e, t) {
			  var i = {},
				n = this;
			  n.animateHeight(),
				!0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
				!1 === n.transformsEnabled
				  ? !1 === n.options.vertical
					? n.$slideTrack.animate(
						{ left: e },
						n.options.speed,
						n.options.easing,
						t
					  )
					: n.$slideTrack.animate(
						{ top: e },
						n.options.speed,
						n.options.easing,
						t
					  )
				  : !1 === n.cssTransitions
				  ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
					d({ animStart: n.currentLeft }).animate(
					  { animStart: e },
					  {
						duration: n.options.speed,
						easing: n.options.easing,
						step: function (e) {
						  (e = n.$slider.hasClass('ql_filters-content') ?
							  Math.ceil(e) < 0 ?
							  Math.ceil(e) - n.$slides.eq(0)?.width() + n.$slides.eq(1)?.width() : 0
							: Math.ceil(e)),
							!1 === n.options.vertical
							  ? (i[n.animType] = "translate(" + e + "px, 0px)")
							  : (i[n.animType] = "translate(0px," + e + "px)"),
							n.$slideTrack.css(i);
						},
						complete: function () {
						  t && t.call();
						},
					  }
					))
				  : (n.applyTransition(),
				  (e = n.$slider.hasClass('ql_filters-content') ?
				  Math.ceil(e) < 0 ?
				  Math.ceil(e) - n.$slides.eq(0)?.width() + n.$slides.eq(1)?.width() : 0
				 : Math.ceil(e)),
					!1 === n.options.vertical
					  ? (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)")
					  : (i[n.animType] = "translate3d(0px," + e + "px, 0px)"),
					n.$slideTrack.css(i),
					t &&
					  setTimeout(function () {
						n.disableTransition(), t.call();
					  }, n.options.speed));
			}),
			(r.prototype.getNavTarget = function () {
			  var e = this.options.asNavFor;
			  return e && null !== e && (e = d(e).not(this.$slider)), e;
			}),
			(r.prototype.asNavFor = function (t) {
			  var e = this.getNavTarget();
			  null !== e &&
				"object" == _typeof(e) &&
				e.each(function () {
				  var e = d(this).slick("getSlick");
				  e.unslicked || e.slideHandler(t, !0);
				});
			}),
			(r.prototype.applyTransition = function (e) {
			  var t = this,
				i = {};
			  !1 === t.options.fade
				? (i[t.transitionType] =
					t.transformType +
					" " +
					t.options.speed +
					"ms " +
					t.options.cssEase)
				: (i[t.transitionType] =
					"opacity " + t.options.speed + "ms " + t.options.cssEase),
				!1 === t.options.fade
				  ? t.$slideTrack.css(i)
				  : t.$slides.eq(e).css(i);
			}),
			(r.prototype.autoPlay = function () {
			  this.autoPlayClear(),
				this.slideCount > this.options.slidesToShow &&
				  (this.autoPlayTimer = setInterval(
					this.autoPlayIterator,
					this.options.autoplaySpeed
				  ));
			}),
			(r.prototype.autoPlayClear = function () {
			  this.autoPlayTimer && clearInterval(this.autoPlayTimer);
			}),
			(r.prototype.autoPlayIterator = function () {
			  var e = this,
				t = e.currentSlide + e.options.slidesToScroll;
			  e.paused ||
				e.interrupted ||
				e.focussed ||
				(!1 === e.options.infinite &&
				  (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
					? (e.direction = 0)
					: 0 === e.direction &&
					  ((t = e.currentSlide - e.options.slidesToScroll),
					  e.currentSlide - 1 == 0 && (e.direction = 1))),
				e.slideHandler(t));
			}),
			(r.prototype.buildArrows = function () {
			  var e = this;
			  var isFiltersContent = e.$slider.hasClass('ql_filters-content') ? e.slideCount >= e.options.slidesToShow : e.slideCount > e.options.slidesToShow;
			  !0 === e.options.arrows &&
				((e.$prevArrow = d(e.options.prevArrow).addClass("slick-arrow")),
				(e.$nextArrow = d(e.options.nextArrow).addClass("slick-arrow")),
				isFiltersContent
				  ? (e.$prevArrow
					  .removeClass("slick-hidden")
					  .removeAttr("aria-hidden tabindex"),
					e.$nextArrow
					  .removeClass("slick-hidden")
					  .removeAttr("aria-hidden tabindex"),
					e.htmlExpr.test(e.options.prevArrow) &&
					  e.$prevArrow.prependTo(e.options.appendArrows),
					e.htmlExpr.test(e.options.nextArrow) &&
					  e.$nextArrow.appendTo(e.options.appendArrows),
					!0 !== e.options.infinite &&
					  e.$prevArrow
						.addClass("slick-disabled")
						.attr("aria-disabled", "true"))
				  : e.$prevArrow
					  .add(e.$nextArrow)
					  .addClass("slick-hidden")
					  .attr({ "aria-disabled": "true", tabindex: "-1" }));
			}),
			(r.prototype.buildDots = function () {
			  var e,
				t,
				i = this;
			  if (
				!0 === i.options.dots &&
				i.slideCount > i.options.slidesToShow
			  ) {
				for (
				  i.$slider.addClass("slick-dotted"),
					t = d("<ul />").addClass(i.options.dotsClass),
					e = 0;
				  e <= i.getDotCount();
				  e += 1
				)
				  t.append(
					d("<li />").append(i.options.customPaging.call(this, i, e))
				  );
				(i.$dots = t.appendTo(i.options.appendDots)),
				  i.$dots
					.find("li")
					.first()
					.addClass("slick-active")
					.attr("aria-hidden", "false");
			  }
			}),
			(r.prototype.buildOut = function () {
			  var e = this;
			  (e.$slides = e.$slider
				.children(e.options.slide + ":not(.slick-cloned)")
				.addClass("slick-slide")),
				(e.slideCount = e.$slides.length),
				e.$slides.each(function (e, t) {
				  d(t)
					.attr("data-slick-index", e)
					.data("originalStyling", d(t).attr("style") || "");
				}),
				e.$slider.addClass("slick-slider"),
				(e.$slideTrack =
				  0 === e.slideCount
					? d(
						'<div class="slick-track" aria-label="'.concat(
						  theme.strings.imageSlider
							? theme.strings.imageSlider
							: "",
						  '"/>'
						)
					  ).appendTo(e.$slider)
					: e.$slides
						.wrapAll(
						  '<div class="slick-track" aria-label="'.concat(
							theme.strings.imageSlider
							  ? theme.strings.imageSlider
							  : "",
							'"/>'
						  )
						)
						.parent()),
				(e.$list = e.$slideTrack
				  .wrap('<div aria-live="polite" class="slick-list"/>')
				  .parent()),
				e.$slideTrack.css("opacity", 0),
				(!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
				  (e.options.slidesToScroll = 1),
				d("img[data-lazy]", e.$slider)
				  .not("[src]")
				  .addClass("slick-loading"),
				e.setupInfinite(),
				e.buildArrows(),
				e.buildDots(),
				e.updateDots(),
				e.setSlideClasses(
				  "number" == typeof e.currentSlide ? e.currentSlide : 0
				),
				!0 === e.options.draggable && e.$list.addClass("draggable");
			}),
			(r.prototype.buildRows = function () {
			  var e,
				t,
				i,
				n,
				s,
				r,
				a,
				o = this;
			  if (
				((n = document.createDocumentFragment()),
				(r = o.$slider.children()),
				1 < o.options.rows)
			  ) {
				for (
				  a = o.options.slidesPerRow * o.options.rows,
					s = Math.ceil(r.length / a),
					e = 0;
				  e < s;
				  e++
				) {
				  var l = document.createElement("div");
				  for (t = 0; t < o.options.rows; t++) {
					var d = document.createElement("div");
					for (i = 0; i < o.options.slidesPerRow; i++) {
					  var c = e * a + (t * o.options.slidesPerRow + i);
					  r.get(c) && d.appendChild(r.get(c));
					}
					l.appendChild(d);
				  }
				  n.appendChild(l);
				}
				o.$slider.empty().append(n),
				  o.$slider
					.children()
					.children()
					.children()
					.css({
					  width: 100 / o.options.slidesPerRow + "%",
					  display: "inline-block",
					});
			  }
			}),
			(r.prototype.checkResponsive = function (e, t) {
			  var i,
				n,
				s,
				r = this,
				a = !1,
				o = r.$slider.width(),
				l = window.innerWidth || d(window).width();
			  if (
				("window" === r.respondTo
				  ? (s = l)
				  : "slider" === r.respondTo
				  ? (s = o)
				  : "min" === r.respondTo && (s = Math.min(l, o)),
				r.options.responsive &&
				  r.options.responsive.length &&
				  null !== r.options.responsive)
			  ) {
				for (i in ((n = null), r.breakpoints))
				  r.breakpoints.hasOwnProperty(i) &&
					(!1 === r.originalSettings.mobileFirst
					  ? s < r.breakpoints[i] && (n = r.breakpoints[i])
					  : s > r.breakpoints[i] && (n = r.breakpoints[i]));
				null !== n
				  ? (null !== r.activeBreakpoint &&
					  n === r.activeBreakpoint &&
					  !t) ||
					((r.activeBreakpoint = n),
					"unslick" === r.breakpointSettings[n]
					  ? r.unslick(n)
					  : ((r.options = d.extend(
						  {},
						  r.originalSettings,
						  r.breakpointSettings[n]
						)),
						!0 === e && (r.currentSlide = r.options.initialSlide),
						r.refresh(e)),
					(a = n))
				  : null !== r.activeBreakpoint &&
					((r.activeBreakpoint = null),
					(r.options = r.originalSettings),
					!0 === e && (r.currentSlide = r.options.initialSlide),
					r.refresh(e),
					(a = n)),
				  e || !1 === a || r.$slider.trigger("breakpoint", [r, a]);
			  }
			}),
			(r.prototype.changeSlide = function (e, t) {
			  var i,
				n,
				s = this,
				r = d(e.currentTarget);
			  var isFiltersContent = s.$slider.hasClass('ql_filters-content');
			  switch (
				(r.is("a") && e.preventDefault(),
				r.is("li") || (r = r.closest("li")),
				(i =
				  s.slideCount % s.options.slidesToScroll != 0
					? 0
					: (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
				e.data.message)
			  ) {
				case "previous":
				  (n =
					0 == i
					  ? s.options.slidesToScroll
					  : s.options.slidesToShow - i),
					s.slideCount > s.options.slidesToShow &&
					  s.slideHandler(s.currentSlide - n, !1, t);
				  isFiltersContent && 
				  s.slideCount == s.options.slidesToShow && 
				  (s.$slideTrack.css("transform","translate3d(0px, 0px, 0px)"),
				  s.$prevArrow.addClass("slick-disabled"),
				  s.$nextArrow.removeClass("slick-disabled"));
				  break;
				case "next":
					var dd = s.$slides.eq(1)?.width() - s.$slides.eq(0)?.width();
				  (n = 0 == i ? s.options.slidesToScroll : i),
					s.slideCount > s.options.slidesToShow ?
					  s.slideHandler(s.currentSlide + n, !1, t)
					  :
					  isFiltersContent && 
					  s.slideCount == s.options.slidesToShow && 
					  (s.$slideTrack.css("transform","translate3d(" + dd + "px, 0px, 0px)"),
					  s.$prevArrow.removeClass("slick-disabled"),
					  s.$nextArrow.addClass("slick-disabled"));
					  
				  break;
				case "index":
				  var a =
					0 === e.data.index
					  ? 0
					  : e.data.index || r.index() * s.options.slidesToScroll;
				  s.slideHandler(s.checkNavigable(a), !1, t),
					r.children().trigger("focus");
				  break;
				default:
				  return;
			  }
			}),
			(r.prototype.checkNavigable = function (e) {
			  var t, i;
			  if (((i = 0), e > (t = this.getNavigableIndexes())[t.length - 1]))
				e = t[t.length - 1];
			  else
				for (var n in t) {
				  if (e < t[n]) {
					e = i;
					break;
				  }
				  i = t[n];
				}
			  return e;
			}),
			(r.prototype.cleanUpEvents = function () {
			  var e = this;
			  e.options.dots &&
				null !== e.$dots &&
				d("li", e.$dots)
				  .off("click.slick", e.changeSlide)
				  .off("mouseenter.slick", d.proxy(e.interrupt, e, !0))
				  .off("mouseleave.slick", d.proxy(e.interrupt, e, !1)),
				e.$slider.off("focus.slick blur.slick"),
				!0 === e.options.arrows &&
				  e.slideCount > e.options.slidesToShow &&
				  (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
				  e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
				e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
				e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
				e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
				e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
				e.$list.off("click.slick", e.clickHandler),
				d(document).off(e.visibilityChange, e.visibility),
				e.cleanUpSlideEvents(),
				!0 === e.options.accessibility &&
				  e.$list.off("keydown.slick", e.keyHandler),
				!0 === e.options.focusOnSelect &&
				  d(e.$slideTrack).children().off("click.slick", e.selectHandler),
				d(window).off(
				  "orientationchange.slick.slick-" + e.instanceUid,
				  e.orientationChange
				),
				d(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
				d("[draggable!=true]", e.$slideTrack).off(
				  "dragstart",
				  e.preventDefault
				),
				d(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
				d(document).off(
				  "ready.slick.slick-" + e.instanceUid,
				  e.setPosition
				);
			}),
			(r.prototype.cleanUpSlideEvents = function () {
			  this.$list.off(
				"mouseenter.slick",
				d.proxy(this.interrupt, this, !0)
			  ),
				this.$list.off(
				  "mouseleave.slick",
				  d.proxy(this.interrupt, this, !1)
				);
			}),
			(r.prototype.cleanUpRows = function () {
			  var e;
			  1 < this.options.rows &&
				((e = this.$slides.children().children()).removeAttr("style"),
				this.$slider.empty().append(e));
			}),
			(r.prototype.clickHandler = function (e) {
			  !1 === this.shouldClick &&
				(e.stopImmediatePropagation(),
				e.stopPropagation(),
				e.preventDefault());
			}),
			(r.prototype.destroy = function (e) {
			  var t = this;
			  t.autoPlayClear(),
				(t.touchObject = {}),
				t.cleanUpEvents(),
				d(".slick-cloned", t.$slider).detach(),
				t.$dots && t.$dots.remove(),
				t.$prevArrow &&
				  t.$prevArrow.length &&
				  (t.$prevArrow
					.removeClass("slick-disabled slick-arrow slick-hidden")
					.removeAttr("aria-hidden aria-disabled tabindex")
					.css("display", ""),
				  t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
				t.$nextArrow &&
				  t.$nextArrow.length &&
				  (t.$nextArrow
					.removeClass("slick-disabled slick-arrow slick-hidden")
					.removeAttr("aria-hidden aria-disabled tabindex")
					.css("display", ""),
				  t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
				t.$slides &&
				  (t.$slides
					.removeClass(
					  "slick-slide slick-active slick-center slick-visible slick-current"
					)
					.removeAttr("aria-hidden")
					.removeAttr("data-slick-index")
					.each(function () {
					  d(this).attr("style", d(this).data("originalStyling"));
					}),
				  t.$slideTrack.children(this.options.slide).detach(),
				  t.$slideTrack.detach(),
				  t.$list.detach(),
				  t.$slider.append(t.$slides)),
				t.cleanUpRows(),
				t.$slider.removeClass("slick-slider"),
				t.$slider.removeClass("slick-initialized"),
				t.$slider.removeClass("slick-dotted"),
				(t.unslicked = !0),
				e || t.$slider.trigger("destroy", [t]);
			}),
			(r.prototype.disableTransition = function (e) {
			  var t = {};
			  (t[this.transitionType] = ""),
				!1 === this.options.fade
				  ? this.$slideTrack.css(t)
				  : this.$slides.eq(e).css(t);
			}),
			(r.prototype.fadeSlide = function (e, t) {
			  var i = this;
			  !1 === i.cssTransitions
				? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
				  i.$slides
					.eq(e)
					.animate(
					  { opacity: 1 },
					  i.options.speed,
					  i.options.easing,
					  t
					))
				: (i.applyTransition(e),
				  i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
				  t &&
					setTimeout(function () {
					  i.disableTransition(e), t.call();
					}, i.options.speed));
			}),
			(r.prototype.fadeSlideOut = function (e) {
			  !1 === this.cssTransitions
				? this.$slides
					.eq(e)
					.animate(
					  { opacity: 0, zIndex: this.options.zIndex - 2 },
					  this.options.speed,
					  this.options.easing
					)
				: (this.applyTransition(e),
				  this.$slides
					.eq(e)
					.css({ opacity: 0, zIndex: this.options.zIndex - 2 }));
			}),
			(r.prototype.filterSlides = r.prototype.slickFilter =
			  function (e) {
				null !== e &&
				  ((this.$slidesCache = this.$slides),
				  this.unload(),
				  this.$slideTrack.children(this.options.slide).detach(),
				  this.$slidesCache.filter(e).appendTo(this.$slideTrack),
				  this.reinit());
			  }),
			(r.prototype.focusHandler = function () {
			  var i = this;
			  i.$slider
				.off("focus.slick blur.slick")
				.on(
				  "focus.slick blur.slick",
				  "*:not(.slick-arrow)",
				  function (e) {
					var t = d(this);
					setTimeout(function () {
					  i.options.pauseOnFocus &&
						((i.focussed = t.is(":focus")), i.autoPlay());
					}, 0);
				  }
				);
			}),
			(r.prototype.getCurrent = r.prototype.slickCurrentSlide =
			  function () {
				return this.currentSlide;
			  }),
			(r.prototype.getDotCount = function () {
			  var e = this,
				t = 0,
				i = 0,
				n = 0;
			  if (!0 === e.options.infinite)
				for (; t < e.slideCount; )
				  ++n,
					(t = i + e.options.slidesToScroll),
					(i +=
					  e.options.slidesToScroll <= e.options.slidesToShow
						? e.options.slidesToScroll
						: e.options.slidesToShow);
			  else if (!0 === e.options.centerMode) n = e.slideCount;
			  else if (e.options.asNavFor)
				for (; t < e.slideCount; )
				  ++n,
					(t = i + e.options.slidesToScroll),
					(i +=
					  e.options.slidesToScroll <= e.options.slidesToShow
						? e.options.slidesToScroll
						: e.options.slidesToShow);
			  else
				n =
				  1 +
				  Math.ceil(
					(e.slideCount - e.options.slidesToShow) /
					  e.options.slidesToScroll
				  );
			  return n - 1;
			}),
			(r.prototype.getLeft = function (e) {
			  var t,
				i,
				n,
				s = this,
				r = 0;
			  return (
				(s.slideOffset = 0),
				(i = s.$slides.first().outerHeight(!0)),
				!0 === s.options.infinite
				  ? (s.slideCount > s.options.slidesToShow &&
					  ((s.slideOffset =
						s.slideWidth * s.options.slidesToShow * -1),
					  (r = i * s.options.slidesToShow * -1)),
					s.slideCount % s.options.slidesToScroll != 0 &&
					  e + s.options.slidesToScroll > s.slideCount &&
					  s.slideCount > s.options.slidesToShow &&
					  (r =
						e > s.slideCount
						  ? ((s.slideOffset =
							  (s.options.slidesToShow - (e - s.slideCount)) *
							  s.slideWidth *
							  -1),
							(s.options.slidesToShow - (e - s.slideCount)) *
							  i *
							  -1)
						  : ((s.slideOffset =
							  (s.slideCount % s.options.slidesToScroll) *
							  s.slideWidth *
							  -1),
							(s.slideCount % s.options.slidesToScroll) * i * -1)))
				  : e + s.options.slidesToShow > s.slideCount &&
					((s.slideOffset =
					  (e + s.options.slidesToShow - s.slideCount) * s.slideWidth),
					(r = (e + s.options.slidesToShow - s.slideCount) * i)),
				s.slideCount <= s.options.slidesToShow && (r = s.slideOffset = 0),
				!0 === s.options.centerMode && !0 === s.options.infinite
				  ? (s.slideOffset +=
					  s.slideWidth * Math.floor(s.options.slidesToShow / 2) -
					  s.slideWidth)
				  : !0 === s.options.centerMode &&
					((s.slideOffset = 0),
					(s.slideOffset +=
					  s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
				(t =
				  !1 === s.options.vertical
					? e * s.slideWidth * -1 + s.slideOffset
					: e * i * -1 + r),
				!0 === s.options.variableWidth &&
				  ((n =
					s.slideCount <= s.options.slidesToShow ||
					!1 === s.options.infinite
					  ? s.$slideTrack.children(".slick-slide").eq(e)
					  : s.$slideTrack
						  .children(".slick-slide")
						  .eq(e + s.options.slidesToShow)),
				  (t =
					!0 === s.options.rtl
					  ? n[0]
						? -1 *
						  (s.$slideTrack.width() - n[0].offsetLeft - n.width())
						: 0
					  : n[0]
					  ? -1 * n[0].offsetLeft
					  : 0),
				  !0 === s.options.centerMode &&
					((n =
					  s.slideCount <= s.options.slidesToShow ||
					  !1 === s.options.infinite
						? s.$slideTrack.children(".slick-slide").eq(e)
						: s.$slideTrack
							.children(".slick-slide")
							.eq(e + s.options.slidesToShow + 1)),
					(t =
					  !0 === s.options.rtl
						? n[0]
						  ? -1 *
							(s.$slideTrack.width() - n[0].offsetLeft - n.width())
						  : 0
						: n[0]
						? -1 * n[0].offsetLeft
						: 0),
					(t += (s.$list.width() - n.outerWidth()) / 2))),
				t
			  );
			}),
			(r.prototype.getOption = r.prototype.slickGetOption =
			  function (e) {
				return this.options[e];
			  }),
			(r.prototype.getNavigableIndexes = function () {
			  var e,
				t = this,
				i = 0,
				n = 0,
				s = [];
			  for (
				e =
				  !1 === t.options.infinite
					? t.slideCount
					: ((i = -1 * t.options.slidesToScroll),
					  (n = -1 * t.options.slidesToScroll),
					  2 * t.slideCount);
				i < e;
  
			  )
				s.push(i),
				  (i = n + t.options.slidesToScroll),
				  (n +=
					t.options.slidesToScroll <= t.options.slidesToShow
					  ? t.options.slidesToScroll
					  : t.options.slidesToShow);
			  return s;
			}),
			(r.prototype.getSlick = function () {
			  return this;
			}),
			(r.prototype.getSlideCount = function () {
			  var i,
				n,
				s = this;
			  return (
				(n =
				  !0 === s.options.centerMode
					? s.slideWidth * Math.floor(s.options.slidesToShow / 2)
					: 0),
				!0 === s.options.swipeToSlide
				  ? (s.$slideTrack.find(".slick-slide").each(function (e, t) {
					  return t.offsetLeft - n + d(t).outerWidth() / 2 >
						-1 * s.swipeLeft
						? ((i = t), !1)
						: void 0;
					}),
					Math.abs(d(i).attr("data-slick-index") - s.currentSlide) || 1)
				  : s.options.slidesToScroll
			  );
			}),
			(r.prototype.goTo = r.prototype.slickGoTo =
			  function (e, t) {
				this.changeSlide(
				  { data: { message: "index", index: parseInt(e) } },
				  t
				);
			  }),
			(r.prototype.init = function (e) {
			  var t = this;
			  d(t.$slider).hasClass("slick-initialized") ||
				(d(t.$slider).addClass("slick-initialized"),
				t.buildRows(),
				t.buildOut(),
				t.setProps(),
				t.startLoad(),
				t.loadSlider(),
				t.initializeEvents(),
				t.updateArrows(),
				t.updateDots(),
				t.checkResponsive(!0),
				t.focusHandler()),
				e && t.$slider.trigger("init", [t]),
				!0 === t.options.accessibility && t.initADA(),
				t.options.autoplay && ((t.paused = !1), t.autoPlay());
			}),
			(r.prototype.initADA = function () {
			  var t = this;
			  t.$slides
				.add(t.$slideTrack.find(".slick-cloned"))
				.attr({ "aria-hidden": "true", tabindex: "-1" })
				.find("a, input, button, select")
				.attr({ tabindex: "-1" }),
				t.$slideTrack.attr("role", "listbox"),
				t.$slides
				  .not(t.$slideTrack.find(".slick-cloned"))
				  .each(function (e) {
					d(this).attr({ role: "option" });
				  }),
				null !== t.$dots &&
				  t.$dots
					.attr("aria-hidden", "true")
					.find("li")
					.each(function (e) {
					  d(this).attr({
						role: "presentation",
						"aria-selected": "false",
						"aria-controls": "navigation" + t.instanceUid + e,
						id: "slick-slide" + t.instanceUid + e,
					  });
					})
					.first()
					.attr("aria-selected", "true")
					.end()
					.find("button")
					.attr("role", "button")
					.end()
					.closest("div")
					.attr("role", "toolbar"),
				t.activateADA();
			}),
			(r.prototype.initArrowEvents = function () {
				var isFiltersContent = this.$slider.hasClass('ql_filters-content') ? this.slideCount >= this.options.slidesToShow : this.slideCount > this.options.slidesToShow;
			  !0 === this.options.arrows &&
			  isFiltersContent &&
				(this.$prevArrow
				  .off("click.slick")
				  .on("click.slick", { message: "previous" }, this.changeSlide),
				this.$nextArrow
				  .off("click.slick")
				  .on("click.slick", { message: "next" }, this.changeSlide));
			}),
			(r.prototype.initDotEvents = function () {
			  var e = this;
			  !0 === e.options.dots &&
				e.slideCount > e.options.slidesToShow &&
				d("li", e.$dots).on(
				  "click.slick",
				  { message: "index" },
				  e.changeSlide
				),
				!0 === e.options.dots &&
				  !0 === e.options.pauseOnDotsHover &&
				  d("li", e.$dots)
					.on("mouseenter.slick", d.proxy(e.interrupt, e, !0))
					.on("mouseleave.slick", d.proxy(e.interrupt, e, !1));
			}),
			(r.prototype.initSlideEvents = function () {
			  this.options.pauseOnHover &&
				(this.$list.on(
				  "mouseenter.slick",
				  d.proxy(this.interrupt, this, !0)
				),
				this.$list.on(
				  "mouseleave.slick",
				  d.proxy(this.interrupt, this, !1)
				));
			}),
			(r.prototype.initializeEvents = function () {
			  var e = this;
			  e.initArrowEvents(),
				e.initDotEvents(),
				e.initSlideEvents(),
				e.$list.on(
				  "touchstart.slick mousedown.slick",
				  { action: "start" },
				  e.swipeHandler
				),
				e.$list.on(
				  "touchmove.slick mousemove.slick",
				  { action: "move" },
				  e.swipeHandler
				),
				e.$list.on(
				  "touchend.slick mouseup.slick",
				  { action: "end" },
				  e.swipeHandler
				),
				e.$list.on(
				  "touchcancel.slick mouseleave.slick",
				  { action: "end" },
				  e.swipeHandler
				),
				e.$list.on("click.slick", e.clickHandler),
				d(document).on(e.visibilityChange, d.proxy(e.visibility, e)),
				!0 === e.options.accessibility &&
				  e.$list.on("keydown.slick", e.keyHandler),
				!0 === e.options.focusOnSelect &&
				  d(e.$slideTrack).children().on("click.slick", e.selectHandler),
				d(window).on(
				  "orientationchange.slick.slick-" + e.instanceUid,
				  d.proxy(e.orientationChange, e)
				),
				d(window).on(
				  "resize.slick.slick-" + e.instanceUid,
				  d.proxy(e.resize, e)
				),
				d("[draggable!=true]", e.$slideTrack).on(
				  "dragstart",
				  e.preventDefault
				),
				d(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
				d(document).on(
				  "ready.slick.slick-" + e.instanceUid,
				  e.setPosition
				);
			}),
			(r.prototype.initUI = function () {
			  !0 === this.options.arrows &&
				this.slideCount > this.options.slidesToShow &&
				(this.$prevArrow.show(), this.$nextArrow.show()),
				!0 === this.options.dots &&
				  this.slideCount > this.options.slidesToShow &&
				  this.$dots.show();
			}),
			(r.prototype.keyHandler = function (e) {
			  e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
				(37 === e.keyCode && !0 === this.options.accessibility
				  ? this.changeSlide({
					  data: {
						message: !0 === this.options.rtl ? "next" : "previous",
					  },
					})
				  : 39 === e.keyCode &&
					!0 === this.options.accessibility &&
					this.changeSlide({
					  data: {
						message: !0 === this.options.rtl ? "previous" : "next",
					  },
					}));
			}),
			(r.prototype.lazyLoad = function () {
			  function e(e) {
				d("img[data-lazy]", e).each(function () {
				  var e = d(this),
					t = d(this).attr("data-lazy"),
					i = document.createElement("img");
				  (i.onload = function () {
					e.animate({ opacity: 0 }, 100, function () {
					  e.attr("src", t).animate({ opacity: 1 }, 200, function () {
						e.removeAttr("data-lazy").removeClass("slick-loading");
					  }),
						n.$slider.trigger("lazyLoaded", [n, e, t]);
					});
				  }),
					(i.onerror = function () {
					  e
						.removeAttr("data-lazy")
						.removeClass("slick-loading")
						.addClass("slick-lazyload-error"),
						n.$slider.trigger("lazyLoadError", [n, e, t]);
					}),
					(i.src = t);
				});
			  }
			  var t,
				i,
				n = this;
			  !0 === n.options.centerMode
				? (i =
					!0 === n.options.infinite
					  ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
						n.options.slidesToShow +
						2
					  : ((t = Math.max(
						  0,
						  n.currentSlide - (n.options.slidesToShow / 2 + 1)
						)),
						n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
				: ((t = n.options.infinite
					? n.options.slidesToShow + n.currentSlide
					: n.currentSlide),
				  (i = Math.ceil(t + n.options.slidesToShow)),
				  !0 === n.options.fade &&
					(0 < t && t--, i <= n.slideCount && i++)),
				e(n.$slider.find(".slick-slide").slice(t, i)),
				n.slideCount <= n.options.slidesToShow
				  ? e(n.$slider.find(".slick-slide"))
				  : n.currentSlide >= n.slideCount - n.options.slidesToShow
				  ? e(
					  n.$slider
						.find(".slick-cloned")
						.slice(0, n.options.slidesToShow)
					)
				  : 0 === n.currentSlide &&
					e(
					  n.$slider
						.find(".slick-cloned")
						.slice(-1 * n.options.slidesToShow)
					);
			}),
			(r.prototype.loadSlider = function () {
			  this.setPosition(),
				this.$slideTrack.css({ opacity: 1 }),
				this.$slider.removeClass("slick-loading"),
				this.initUI(),
				"progressive" === this.options.lazyLoad &&
				  this.progressiveLazyLoad();
			}),
			(r.prototype.next = r.prototype.slickNext =
			  function () {
				this.changeSlide({ data: { message: "next" } });
			  }),
			(r.prototype.orientationChange = function () {
			  this.checkResponsive(), this.setPosition();
			}),
			(r.prototype.pause = r.prototype.slickPause =
			  function () {
				this.autoPlayClear(), (this.paused = !0);
			  }),
			(r.prototype.play = r.prototype.slickPlay =
			  function () {
				this.autoPlay(),
				  (this.options.autoplay = !0),
				  (this.paused = !1),
				  (this.focussed = !1),
				  (this.interrupted = !1);
			  }),
			(r.prototype.postSlide = function (e) {
			  var t = this;
			  t.unslicked ||
				(t.$slider.trigger("afterChange", [t, e]),
				(t.animating = !1),
				t.setPosition(),
				(t.swipeLeft = null),
				t.options.autoplay && t.autoPlay(),
				!0 === t.options.accessibility && t.initADA());
			}),
			(r.prototype.prev = r.prototype.slickPrev =
			  function () {
				this.changeSlide({ data: { message: "previous" } });
			  }),
			(r.prototype.preventDefault = function (e) {
			  e.preventDefault();
			}),
			(r.prototype.progressiveLazyLoad = function (e) {
			  e = e || 1;
			  var t,
				i,
				n,
				s = this,
				r = d("img[data-lazy]", s.$slider);
			  r.length
				? ((t = r.first()),
				  (i = t.attr("data-lazy")),
				  ((n = document.createElement("img")).onload = function () {
					t
					  .attr("src", i)
					  .removeAttr("data-lazy")
					  .removeClass("slick-loading"),
					  !0 === s.options.adaptiveHeight && s.setPosition(),
					  s.$slider.trigger("lazyLoaded", [s, t, i]),
					  s.progressiveLazyLoad();
				  }),
				  (n.onerror = function () {
					e < 3
					  ? setTimeout(function () {
						  s.progressiveLazyLoad(e + 1);
						}, 500)
					  : (t
						  .removeAttr("data-lazy")
						  .removeClass("slick-loading")
						  .addClass("slick-lazyload-error"),
						s.$slider.trigger("lazyLoadError", [s, t, i]),
						s.progressiveLazyLoad());
				  }),
				  (n.src = i))
				: s.$slider.trigger("allImagesLoaded", [s]);
			}),
			(r.prototype.refresh = function (e) {
			  var t,
				i,
				n = this;
			  (i = n.slideCount - n.options.slidesToShow),
				!n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
				n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
				(t = n.currentSlide),
				n.destroy(!0),
				d.extend(n, n.initials, { currentSlide: t }),
				n.init(),
				e || n.changeSlide({ data: { message: "index", index: t } }, !1);
			}),
			(r.prototype.registerBreakpoints = function () {
			  var e,
				t,
				i,
				n = this,
				s = n.options.responsive || null;
			  if ("array" === d.type(s) && s.length) {
				for (e in ((n.respondTo = n.options.respondTo || "window"), s))
				  if (
					((i = n.breakpoints.length - 1),
					(t = s[e].breakpoint),
					s.hasOwnProperty(e))
				  ) {
					for (; 0 <= i; )
					  n.breakpoints[i] &&
						n.breakpoints[i] === t &&
						n.breakpoints.splice(i, 1),
						i--;
					n.breakpoints.push(t),
					  (n.breakpointSettings[t] = s[e].settings);
				  }
				n.breakpoints.sort(function (e, t) {
				  return n.options.mobileFirst ? e - t : t - e;
				});
			  }
			}),
			(r.prototype.reinit = function () {
			  var e = this;
			  (e.$slides = e.$slideTrack
				.children(e.options.slide)
				.addClass("slick-slide")),
				(e.slideCount = e.$slides.length),
				e.currentSlide >= e.slideCount &&
				  0 !== e.currentSlide &&
				  (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
				e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
				e.registerBreakpoints(),
				e.setProps(),
				e.setupInfinite(),
				e.buildArrows(),
				e.updateArrows(),
				e.initArrowEvents(),
				e.buildDots(),
				e.updateDots(),
				e.initDotEvents(),
				e.cleanUpSlideEvents(),
				e.initSlideEvents(),
				e.checkResponsive(!1, !0),
				!0 === e.options.focusOnSelect &&
				  d(e.$slideTrack).children().on("click.slick", e.selectHandler),
				e.setSlideClasses(
				  "number" == typeof e.currentSlide ? e.currentSlide : 0
				),
				e.setPosition(),
				e.focusHandler(),
				(e.paused = !e.options.autoplay),
				e.autoPlay(),
				e.$slider.trigger("reInit", [e]);
			}),
			(r.prototype.resize = function () {
			  var e = this;
			  d(window).width() !== e.windowWidth &&
				(clearTimeout(e.windowDelay),
				(e.windowDelay = window.setTimeout(function () {
				  (e.windowWidth = d(window).width()),
					e.checkResponsive(),
					e.unslicked || e.setPosition();
				}, 50)));
			}),
			(r.prototype.removeSlide = r.prototype.slickRemove =
			  function (e, t, i) {
				var n = this;
				return (
				  (e =
					"boolean" == typeof e
					  ? !0 === (t = e)
						? 0
						: n.slideCount - 1
					  : !0 === t
					  ? --e
					  : e),
				  !(n.slideCount < 1 || e < 0 || e > n.slideCount - 1) &&
					(n.unload(),
					!0 === i
					  ? n.$slideTrack.children().remove()
					  : n.$slideTrack.children(this.options.slide).eq(e).remove(),
					(n.$slides = n.$slideTrack.children(this.options.slide)),
					n.$slideTrack.children(this.options.slide).detach(),
					n.$slideTrack.append(n.$slides),
					(n.$slidesCache = n.$slides),
					void n.reinit())
				);
			  }),
			(r.prototype.setCSS = function (e) {
			  var t,
				i,
				n = this,
				s = {};
			  !0 === n.options.rtl && (e = -e),
				(t = "left" == n.positionProp ? 
					n.$slider.hasClass('ql_filters-content') ? 
					  Math.ceil(e) < 0 ? (Math.ceil(e) - n.$slides.eq(0)?.width() + n.$slides.eq(1)?.width()) + "px" : "0px"
				  : Math.ceil(e) + "px" : "0px"),
				(i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
				(s[n.positionProp] = e),
				!1 === n.transformsEnabled ||
				  (!(s = {}) === n.cssTransitions
					? (s[n.animType] = "translate(" + t + ", " + i + ")")
					: (s[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
				n.$slideTrack.css(s);
			}),
			(r.prototype.setDimensions = function () {
			  var e = this;
			  var slideTrackWidth = e.$slider.hasClass('ql_filters-content') ? e.$slides.eq(0)?.width() + e.slideWidth * (e.$slideTrack.children(".slick-slide").length - 1)
			  : e.slideWidth * e.$slideTrack.children(".slick-slide").length;
			  var slideWidth = e.$slider.hasClass('ql_filters-content') ? e.listWidth / e.options.slidesToShow + 10 : e.listWidth / e.options.slidesToShow;
			  !1 === e.options.vertical
				? !0 === e.options.centerMode &&
				  e.$list.css({ padding: "0px " + e.options.centerPadding })
				: (e.$list.height(
					e.$slides.first().outerHeight(!0) * e.options.slidesToShow
				  ),
				  !0 === e.options.centerMode &&
					e.$list.css({ padding: e.options.centerPadding + " 0px" })),
				(e.listWidth = e.$list.width()),
				(e.listHeight = e.$list.height()),
				!1 === e.options.vertical && !1 === e.options.variableWidth
				  ? ((e.slideWidth = Math.ceil(
					e.listWidth / e.options.slidesToShow
					)),
					e.$slideTrack.width(
						Math.ceil(
						e.slideWidth *
							e.$slideTrack.children(".slick-slide").length
						)
					))
				  : !0 === e.options.variableWidth
				  ? e.$slideTrack.width(5e3 * e.slideCount)
				  : ((e.slideWidth = Math.ceil(e.listWidth)),
					e.$slideTrack.height(
					  Math.ceil(
						e.$slides.first().outerHeight(!0) *
						  e.$slideTrack.children(".slick-slide").length
					  )
					));
			  var t =
				e.$slides.first().outerWidth(!0) - e.$slides.first().width();
			  !1 === e.options.variableWidth && 
				(
					e.$slideTrack.children(".slick-slide").eq(0).hasClass("filter--cover-image")
					?
					(
						e.$slideTrack.children(".slick-slide").width(e.slideWidth - t),
						e.$slideTrack.children(".slick-slide").eq(0).width(e.slideWidth - t + 30)
					)
					:
					e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)

				);
			}),
			(r.prototype.setFade = function () {
			  var i,
				n = this;
			  n.$slides.each(function (e, t) {
				(i = n.slideWidth * e * -1),
				  !0 === n.options.rtl
					? d(t).css({
						position: "relative",
						right: i,
						top: 0,
						zIndex: n.options.zIndex - 2,
						opacity: 0,
					  })
					: d(t).css({
						position: "relative",
						left: i,
						top: 0,
						zIndex: n.options.zIndex - 2,
						opacity: 0,
					  });
			  }),
				n.$slides
				  .eq(n.currentSlide)
				  .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
			}),
			(r.prototype.setHeight = function () {
			  if (
				1 === this.options.slidesToShow &&
				!0 === this.options.adaptiveHeight &&
				!1 === this.options.vertical
			  ) {
				var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
				this.$list.css("height", e);
			  }
			}),
			(r.prototype.setOption = r.prototype.slickSetOption =
			  function () {
				var e,
				  t,
				  i,
				  n,
				  s,
				  r = this,
				  a = !1;
				if (
				  ("object" === d.type(arguments[0])
					? ((i = arguments[0]), (a = arguments[1]), (s = "multiple"))
					: "string" === d.type(arguments[0]) &&
					  ((n = arguments[1]),
					  (a = arguments[2]),
					  "responsive" === (i = arguments[0]) &&
					  "array" === d.type(arguments[1])
						? (s = "responsive")
						: void 0 !== arguments[1] && (s = "single")),
				  "single" === s)
				)
				  r.options[i] = n;
				else if ("multiple" === s)
				  d.each(i, function (e, t) {
					r.options[e] = t;
				  });
				else if ("responsive" === s)
				  for (t in n)
					if ("array" !== d.type(r.options.responsive))
					  r.options.responsive = [n[t]];
					else {
					  for (e = r.options.responsive.length - 1; 0 <= e; )
						r.options.responsive[e].breakpoint === n[t].breakpoint &&
						  r.options.responsive.splice(e, 1),
						  e--;
					  r.options.responsive.push(n[t]);
					}
				a && (r.unload(), r.reinit());
			  }),
			(r.prototype.setPosition = function () {
			  this.setDimensions(),
				this.setHeight(),
				!1 === this.options.fade
				  ? this.setCSS(this.getLeft(this.currentSlide))
				  : this.setFade(),
				this.$slider.trigger("setPosition", [this]);
			}),
			(r.prototype.setProps = function () {
			  var e = this,
				t = document.body.style;
			  (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
				"top" === e.positionProp
				  ? e.$slider.addClass("slick-vertical")
				  : e.$slider.removeClass("slick-vertical"),
				(void 0 === t.WebkitTransition &&
				  void 0 === t.MozTransition &&
				  void 0 === t.msTransition) ||
				  !0 !== e.options.useCSS ||
				  (e.cssTransitions = !0),
				e.options.fade &&
				  ("number" == typeof e.options.zIndex
					? e.options.zIndex < 3 && (e.options.zIndex = 3)
					: (e.options.zIndex = e.defaults.zIndex)),
				void 0 !== t.OTransform &&
				  ((e.animType = "OTransform"),
				  (e.transformType = "-o-transform"),
				  (e.transitionType = "OTransition"),
				  void 0 === t.perspectiveProperty &&
					void 0 === t.webkitPerspective &&
					(e.animType = !1)),
				void 0 !== t.MozTransform &&
				  ((e.animType = "MozTransform"),
				  (e.transformType = "-moz-transform"),
				  (e.transitionType = "MozTransition"),
				  void 0 === t.perspectiveProperty &&
					void 0 === t.MozPerspective &&
					(e.animType = !1)),
				void 0 !== t.webkitTransform &&
				  ((e.animType = "webkitTransform"),
				  (e.transformType = "-webkit-transform"),
				  (e.transitionType = "webkitTransition"),
				  void 0 === t.perspectiveProperty &&
					void 0 === t.webkitPerspective &&
					(e.animType = !1)),
				void 0 !== t.msTransform &&
				  ((e.animType = "msTransform"),
				  (e.transformType = "-ms-transform"),
				  (e.transitionType = "msTransition"),
				  void 0 === t.msTransform && (e.animType = !1)),
				void 0 !== t.transform &&
				  !1 !== e.animType &&
				  ((e.animType = "transform"),
				  (e.transformType = "transform"),
				  (e.transitionType = "transition")),
				(e.transformsEnabled =
				  e.options.useTransform &&
				  null !== e.animType &&
				  !1 !== e.animType);
			}),
			(r.prototype.setSlideClasses = function (e) {
			  var t,
				i,
				n,
				s,
				r = this;
			  (i = r.$slider
				.find(".slick-slide")
				.removeClass("slick-active slick-center slick-current")
				.attr("aria-hidden", "true")),
				r.$slides.eq(e).addClass("slick-current"),
				!0 === r.options.centerMode
				  ? ((t = Math.floor(r.options.slidesToShow / 2)),
					!0 === r.options.infinite &&
					  (t <= e && e <= r.slideCount - 1 - t
						? r.$slides
							.slice(e - t, e + t + 1)
							.addClass("slick-active")
							.attr("aria-hidden", "false")
						: ((n = r.options.slidesToShow + e),
						  i
							.slice(n - t + 1, n + t + 2)
							.addClass("slick-active")
							.attr("aria-hidden", "false")),
					  0 === e
						? i
							.eq(i.length - 1 - r.options.slidesToShow)
							.addClass("slick-center")
						: e === r.slideCount - 1 &&
						  i.eq(r.options.slidesToShow).addClass("slick-center")),
					r.$slides.eq(e).addClass("slick-center"))
				  : 0 <= e && e <= r.slideCount - r.options.slidesToShow
				  ? r.$slides
					  .slice(e, e + r.options.slidesToShow)
					  .addClass("slick-active")
					  .attr("aria-hidden", "false")
				  : i.length <= r.options.slidesToShow
				  ? i.addClass("slick-active").attr("aria-hidden", "false")
				  : ((s = r.slideCount % r.options.slidesToShow),
					(n =
					  !0 === r.options.infinite ? r.options.slidesToShow + e : e),
					r.options.slidesToShow == r.options.slidesToScroll &&
					r.slideCount - e < r.options.slidesToShow
					  ? i
						  .slice(n - (r.options.slidesToShow - s), n + s)
						  .addClass("slick-active")
						  .attr("aria-hidden", "false")
					  : i
						  .slice(n, n + r.options.slidesToShow)
						  .addClass("slick-active")
						  .attr("aria-hidden", "false")),
				"ondemand" === r.options.lazyLoad && r.lazyLoad();
			}),
			(r.prototype.setupInfinite = function () {
			  var e,
				t,
				i,
				n = this;
			  if (
				(!0 === n.options.fade && (n.options.centerMode = !1),
				!0 === n.options.infinite &&
				  !1 === n.options.fade &&
				  ((t = null), n.slideCount > n.options.slidesToShow))
			  ) {
				for (
				  i =
					!0 === n.options.centerMode
					  ? n.options.slidesToShow + 1
					  : n.options.slidesToShow,
					e = n.slideCount;
				  e > n.slideCount - i;
				  --e
				)
				  (t = e - 1),
					d(n.$slides[t])
					  .clone(!0)
					  .attr("id", "")
					  .attr("data-slick-index", t - n.slideCount)
					  .prependTo(n.$slideTrack)
					  .addClass("slick-cloned");
				for (e = 0; e < i; e += 1)
				  (t = e),
					d(n.$slides[t])
					  .clone(!0)
					  .attr("id", "")
					  .attr("data-slick-index", t + n.slideCount)
					  .appendTo(n.$slideTrack)
					  .addClass("slick-cloned");
				n.$slideTrack
				  .find(".slick-cloned")
				  .find("[id]")
				  .each(function () {
					d(this).attr("id", "");
				  });
			  }
			}),
			(r.prototype.interrupt = function (e) {
			  e || this.autoPlay(), (this.interrupted = e);
			}),
			(r.prototype.selectHandler = function (e) {
			  var t = d(e.target).is(".slick-slide")
				  ? d(e.target)
				  : d(e.target).parents(".slick-slide"),
				i = parseInt(t.attr("data-slick-index"));
			  return (
				(i = i || 0),
				this.slideCount <= this.options.slidesToShow
				  ? (this.setSlideClasses(i), void this.asNavFor(i))
				  : void this.slideHandler(i)
			  );
			}),
			(r.prototype.slideHandler = function (e, t, i) {
			  var n,
				s,
				r,
				a,
				o,
				l = null,
				d = this;
			  return (
				(t = t || !1),
				(!0 === d.animating && !0 === d.options.waitForAnimate) ||
				(!0 === d.options.fade && d.currentSlide === e) ||
				d.slideCount <= d.options.slidesToShow
				  ? void 0
				  : (!1 === t && d.asNavFor(e),
					(n = e),
					(l = d.getLeft(n)),
					(a = d.getLeft(d.currentSlide)),
					(d.currentLeft = null === d.swipeLeft ? a : d.swipeLeft),
					(!1 === d.options.infinite &&
					  !1 === d.options.centerMode &&
					  (e < 0 ||
						e > d.getDotCount() * d.options.slidesToScroll)) ||
					(!1 === d.options.infinite &&
					  !0 === d.options.centerMode &&
					  (e < 0 || e > d.slideCount - d.options.slidesToScroll))
					  ? void (
						  !1 === d.options.fade &&
						  ((n = d.currentSlide),
						  !0 !== i
							? d.animateSlide(a, function () {
								d.postSlide(n);
							  })
							: d.postSlide(n))
						)
					  : (d.options.autoplay && clearInterval(d.autoPlayTimer),
						(s =
						  n < 0
							? d.slideCount % d.options.slidesToScroll != 0
							  ? d.slideCount -
								(d.slideCount % d.options.slidesToScroll)
							  : d.slideCount + n
							: n >= d.slideCount
							? d.slideCount % d.options.slidesToScroll != 0
							  ? 0
							  : n - d.slideCount
							: n),
						(d.animating = !0),
						d.$slider.trigger("beforeChange", [d, d.currentSlide, s]),
						(r = d.currentSlide),
						(d.currentSlide = s),
						d.setSlideClasses(d.currentSlide),
						d.options.asNavFor &&
						  (o = (o = d.getNavTarget()).slick("getSlick"))
							.slideCount <= o.options.slidesToShow &&
						  o.setSlideClasses(d.currentSlide),
						d.updateDots(),
						d.updateArrows(),
						!0 === d.options.fade
						  ? (!0 !== i
							  ? (d.fadeSlideOut(r),
								d.fadeSlide(s, function () {
								  d.postSlide(s);
								}))
							  : d.postSlide(s),
							void d.animateHeight())
						  : void (!0 !== i
							  ? d.animateSlide(l, function () {
								  d.postSlide(s);
								})
							  : d.postSlide(s))))
			  );
			}),
			(r.prototype.startLoad = function () {
			  var e = this;
			  !0 === e.options.arrows &&
				e.slideCount > e.options.slidesToShow &&
				(e.$prevArrow.hide(), e.$nextArrow.hide()),
				!0 === e.options.dots &&
				  e.slideCount > e.options.slidesToShow &&
				  e.$dots.hide(),
				e.$slider.addClass("slick-loading");
			}),
			(r.prototype.swipeDirection = function () {
			  var e, t, i, n;
			  return (
				(e = this.touchObject.startX - this.touchObject.curX),
				(t = this.touchObject.startY - this.touchObject.curY),
				(i = Math.atan2(t, e)),
				(n = Math.round((180 * i) / Math.PI)) < 0 &&
				  (n = 360 - Math.abs(n)),
				(n <= 45 && 0 <= n) || (n <= 360 && 315 <= n)
				  ? !1 === this.options.rtl
					? "left"
					: "right"
				  : 135 <= n && n <= 225
				  ? !1 === this.options.rtl
					? "right"
					: "left"
				  : !0 === this.options.verticalSwiping
				  ? 35 <= n && n <= 135
					? "down"
					: "up"
				  : "vertical"
			  );
			}),
			(r.prototype.swipeEnd = function (e) {
			  var t,
				i,
				n = this;
			  if (
				((n.dragging = !1),
				(n.interrupted = !1),
				(n.shouldClick = !(10 < n.touchObject.swipeLength)),
				void 0 === n.touchObject.curX)
			  )
				return !1;
			  if (
				(!0 === n.touchObject.edgeHit &&
				  n.$slider.trigger("edge", [n, n.swipeDirection()]),
				n.touchObject.swipeLength >= n.touchObject.minSwipe)
			  ) {
				switch ((i = n.swipeDirection())) {
				  case "left":
				  case "down":
					(t = n.options.swipeToSlide
					  ? n.checkNavigable(n.currentSlide + n.getSlideCount())
					  : n.currentSlide + n.getSlideCount()),
					  (n.currentDirection = 0);
					break;
				  case "right":
				  case "up":
					(t = n.options.swipeToSlide
					  ? n.checkNavigable(n.currentSlide - n.getSlideCount())
					  : n.currentSlide - n.getSlideCount()),
					  (n.currentDirection = 1);
				}
				"vertical" != i &&
				  (n.slideHandler(t),
				  (n.touchObject = {}),
				  n.$slider.trigger("swipe", [n, i]));
			  } else
				n.touchObject.startX !== n.touchObject.curX &&
				  (n.slideHandler(n.currentSlide), (n.touchObject = {}));
			}),
			(r.prototype.swipeHandler = function (e) {
			  var t = this;
			  if (
				!(
				  !1 === t.options.swipe ||
				  ("ontouchend" in document && !1 === t.options.swipe) ||
				  (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
				)
			  )
				switch (
				  ((t.touchObject.fingerCount =
					e.originalEvent && void 0 !== e.originalEvent.touches
					  ? e.originalEvent.touches.length
					  : 1),
				  (t.touchObject.minSwipe =
					t.listWidth / t.options.touchThreshold),
				  !0 === t.options.verticalSwiping &&
					(t.touchObject.minSwipe =
					  t.listHeight / t.options.touchThreshold),
				  e.data.action)
				) {
				  case "start":
					t.swipeStart(e);
					break;
				  case "move":
					t.swipeMove(e);
					break;
				  case "end":
					t.swipeEnd(e);
				}
			}),
			(r.prototype.swipeMove = function (e) {
			  var t,
				i,
				n,
				s,
				r,
				a = this;
			  return (
				(r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
				!(!a.dragging || (r && 1 !== r.length)) &&
				  ((t = a.getLeft(a.currentSlide)),
				  (a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
				  (a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
				  (a.touchObject.swipeLength = Math.round(
					Math.sqrt(
					  Math.pow(a.touchObject.curX - a.touchObject.startX, 2)
					)
				  )),
				  !0 === a.options.verticalSwiping &&
					(a.touchObject.swipeLength = Math.round(
					  Math.sqrt(
						Math.pow(a.touchObject.curY - a.touchObject.startY, 2)
					  )
					)),
				  "vertical" !== (i = a.swipeDirection())
					? (void 0 !== e.originalEvent &&
						4 < a.touchObject.swipeLength &&
						e.preventDefault(),
					  (s =
						(!1 === a.options.rtl ? 1 : -1) *
						(a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
					  !0 === a.options.verticalSwiping &&
						(s = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
					  (n = a.touchObject.swipeLength),
					  (a.touchObject.edgeHit = !1) === a.options.infinite &&
						((0 === a.currentSlide && "right" === i) ||
						  (a.currentSlide >= a.getDotCount() && "left" === i)) &&
						((n = a.touchObject.swipeLength * a.options.edgeFriction),
						(a.touchObject.edgeHit = !0)),
					  !1 === a.options.vertical
						? (a.swipeLeft = t + n * s)
						: (a.swipeLeft =
							t + n * (a.$list.height() / a.listWidth) * s),
					  !0 === a.options.verticalSwiping &&
						(a.swipeLeft = t + n * s),
					  !0 !== a.options.fade &&
						!1 !== a.options.touchMove &&
						(!0 === a.animating
						  ? ((a.swipeLeft = null), !1)
						  : void a.setCSS(a.swipeLeft)))
					: void 0)
			  );
			}),
			(r.prototype.swipeStart = function (e) {
			  var t,
				i = this;
			  return (
				(i.interrupted = !0),
				1 !== i.touchObject.fingerCount ||
				i.slideCount <= i.options.slidesToShow
				  ? !(i.touchObject = {})
				  : (void 0 !== e.originalEvent &&
					  void 0 !== e.originalEvent.touches &&
					  (t = e.originalEvent.touches[0]),
					(i.touchObject.startX = i.touchObject.curX =
					  void 0 !== t ? t.pageX : e.clientX),
					(i.touchObject.startY = i.touchObject.curY =
					  void 0 !== t ? t.pageY : e.clientY),
					void (i.dragging = !0))
			  );
			}),
			(r.prototype.unfilterSlides = r.prototype.slickUnfilter =
			  function () {
				null !== this.$slidesCache &&
				  (this.unload(),
				  this.$slideTrack.children(this.options.slide).detach(),
				  this.$slidesCache.appendTo(this.$slideTrack),
				  this.reinit());
			  }),
			(r.prototype.unload = function () {
			  var e = this;
			  d(".slick-cloned", e.$slider).remove(),
				e.$dots && e.$dots.remove(),
				e.$prevArrow &&
				  e.htmlExpr.test(e.options.prevArrow) &&
				  e.$prevArrow.remove(),
				e.$nextArrow &&
				  e.htmlExpr.test(e.options.nextArrow) &&
				  e.$nextArrow.remove(),
				e.$slides
				  .removeClass(
					"slick-slide slick-active slick-visible slick-current"
				  )
				  .attr("aria-hidden", "true")
				  .css("width", "");
			}),
			(r.prototype.unslick = function (e) {
			  this.$slider.trigger("unslick", [this, e]), this.destroy();
			}),
			(r.prototype.updateArrows = function () {
			  var e = this;
			  Math.floor(e.options.slidesToShow / 2),
				!0 === e.options.arrows &&
				  e.slideCount > e.options.slidesToShow &&
				  !e.options.infinite &&
				  (e.$prevArrow
					.removeClass("slick-disabled")
					.attr("aria-disabled", "false"),
				  e.$nextArrow
					.removeClass("slick-disabled")
					.attr("aria-disabled", "false"),
				  0 === e.currentSlide
					? (e.$prevArrow
						.addClass("slick-disabled")
						.attr("aria-disabled", "true"),
					  e.$nextArrow
						.removeClass("slick-disabled")
						.attr("aria-disabled", "false"))
					: ((e.currentSlide >= e.slideCount - e.options.slidesToShow &&
						!1 === e.options.centerMode) ||
						(e.currentSlide >= e.slideCount - 1 &&
						  !0 === e.options.centerMode)) &&
					  (e.$nextArrow
						.addClass("slick-disabled")
						.attr("aria-disabled", "true"),
					  e.$prevArrow
						.removeClass("slick-disabled")
						.attr("aria-disabled", "false")));
			}),
			(r.prototype.updateDots = function () {
			  null !== this.$dots &&
				(this.$dots
				  .find("li")
				  .removeClass("slick-active")
				  .attr("aria-hidden", "true"),
				this.$dots
				  .find("li")
				  .eq(Math.floor(this.currentSlide / this.options.slidesToScroll))
				  .addClass("slick-active")
				  .attr("aria-hidden", "false"));
			}),
			(r.prototype.visibility = function () {
			  this.options.autoplay &&
				(document[this.hidden]
				  ? (this.interrupted = !0)
				  : (this.interrupted = !1));
			}),
			(d.fn.slick = function () {
			  var e,
				t,
				i = arguments[0],
				n = Array.prototype.slice.call(arguments, 1),
				s = this.length;
			  for (e = 0; e < s; e++)
				if (
				  ("object" == _typeof(i) || void 0 === i
					? (this[e].slick = new r(this[e], i))
					: (t = this[e].slick[i].apply(this[e].slick, n)),
				  void 0 !== t)
				)
				  return t;
			  return this;
			});
		}),
		(wxa = jQuery),
		(wxa.fn.autogrow = function (a) {
		  function s(e) {
			var t,
			  i = wxa(this),
			  n = i.innerHeight(),
			  s = this.scrollHeight,
			  r = i.data("autogrow-start-height") || 0;
			if (n < s)
			  (this.scrollTop = 0),
				a.animate
				  ? i.stop().animate({ height: s }, a.speed)
				  : i.innerHeight(s);
			else if (
			  !e ||
			  8 == e.which ||
			  46 == e.which ||
			  (e.ctrlKey && 88 == e.which)
			)
			  if (r < n) {
				for (
				  t = i
					.clone()
					.addClass(a.cloneClass)
					.css({ position: "absolute", zIndex: -10 })
					.val(i.val()),
					i.after(t);
				  (s = t[0].scrollHeight - 1),
					t.innerHeight(s),
					s === t[0].scrollHeight;
  
				);
				s++,
				  t.remove(),
				  s < r && (s = r),
				  s < n && a.animate
					? i.stop().animate({ height: s }, a.speed)
					: i.innerHeight(s);
			  } else i.innerHeight(r);
		  }
		  var e = wxa(this).css({ overflow: "hidden", resize: "none" }),
			t = e.selector,
			i = {
			  context: wxa(document),
			  animate: !0,
			  speed: 200,
			  fixMinHeight: !0,
			  cloneClass: "autogrowclone",
			  onInitialize: !1,
			};
		  return (
			(a = wxa.isPlainObject(a) ? a : { context: a || wxa(document) }),
			(a = wxa.extend({}, i, a)),
			e.each(function (e, t) {
			  var i, n;
			  (t = wxa(t)).is(":visible") || 0 < parseInt(t.css("height"), 10)
				? (i = parseInt(t.css("height"), 10) || t.innerHeight())
				: ((n = t
					.clone()
					.addClass(a.cloneClass)
					.val(t.val())
					.css({
					  position: "absolute",
					  visibility: "hidden",
					  display: "block",
					})),
				  wxa("body").append(n),
				  (i = n.innerHeight()),
				  n.remove()),
				a.fixMinHeight && t.data("autogrow-start-height", i),
				t.css("height", i),
				a.onInitialize && s.call(t);
			}),
			a.context.on("keyup paste", t, s),
			e
		  );
		}),
		(function () {
		  for (
			var e = [
				{ base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" },
				{ base: "AA", letters: "Ꜳ" },
				{ base: "AE", letters: "ÆǼǢ" },
				{ base: "AO", letters: "Ꜵ" },
				{ base: "AU", letters: "Ꜷ" },
				{ base: "AV", letters: "ꜸꜺ" },
				{ base: "AY", letters: "Ꜽ" },
				{ base: "B", letters: "BⒷＢḂḄḆɃƂƁ" },
				{ base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" },
				{ base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹÐ" },
				{ base: "DZ", letters: "ǱǄ" },
				{ base: "Dz", letters: "ǲǅ" },
				{ base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" },
				{ base: "F", letters: "FⒻＦḞƑꝻ" },
				{ base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" },
				{ base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" },
				{ base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" },
				{ base: "J", letters: "JⒿＪĴɈ" },
				{ base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" },
				{ base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" },
				{ base: "LJ", letters: "Ǉ" },
				{ base: "Lj", letters: "ǈ" },
				{ base: "M", letters: "MⓂＭḾṀṂⱮƜ" },
				{ base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" },
				{ base: "NJ", letters: "Ǌ" },
				{ base: "Nj", letters: "ǋ" },
				{
				  base: "O",
				  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ",
				},
				{ base: "OI", letters: "Ƣ" },
				{ base: "OO", letters: "Ꝏ" },
				{ base: "OU", letters: "Ȣ" },
				{ base: "OE", letters: "Œ" },
				{ base: "oe", letters: "œ" },
				{ base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" },
				{ base: "Q", letters: "QⓆＱꝖꝘɊ" },
				{ base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" },
				{ base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" },
				{ base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" },
				{ base: "TZ", letters: "Ꜩ" },
				{ base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" },
				{ base: "V", letters: "VⓋＶṼṾƲꝞɅ" },
				{ base: "VY", letters: "Ꝡ" },
				{ base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" },
				{ base: "X", letters: "XⓍＸẊẌ" },
				{ base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" },
				{ base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" },
				{ base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" },
				{ base: "aa", letters: "ꜳ" },
				{ base: "ae", letters: "æǽǣ" },
				{ base: "ao", letters: "ꜵ" },
				{ base: "au", letters: "ꜷ" },
				{ base: "av", letters: "ꜹꜻ" },
				{ base: "ay", letters: "ꜽ" },
				{ base: "b", letters: "bⓑｂḃḅḇƀƃɓ" },
				{ base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" },
				{ base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" },
				{ base: "dz", letters: "ǳǆ" },
				{ base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" },
				{ base: "f", letters: "fⓕｆḟƒꝼ" },
				{ base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" },
				{ base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" },
				{ base: "hv", letters: "ƕ" },
				{ base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" },
				{ base: "j", letters: "jⓙｊĵǰɉ" },
				{ base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" },
				{ base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" },
				{ base: "lj", letters: "ǉ" },
				{ base: "m", letters: "mⓜｍḿṁṃɱɯ" },
				{ base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" },
				{ base: "nj", letters: "ǌ" },
				{
				  base: "o",
				  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ",
				},
				{ base: "oi", letters: "ƣ" },
				{ base: "ou", letters: "ȣ" },
				{ base: "oo", letters: "ꝏ" },
				{ base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" },
				{ base: "q", letters: "qⓠｑɋꝗꝙ" },
				{ base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" },
				{ base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" },
				{ base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" },
				{ base: "tz", letters: "ꜩ" },
				{ base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" },
				{ base: "v", letters: "vⓥｖṽṿʋꝟʌ" },
				{ base: "vy", letters: "ꝡ" },
				{ base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" },
				{ base: "x", letters: "xⓧｘẋẍ" },
				{ base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" },
				{ base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" },
			  ],
			  t = {},
			  i = 0;
			i < e.length;
			i++
		  )
			for (var n = e[i].letters, s = 0; s < n.length; s++)
			  t[n[s]] = e[i].base;
		  window.removeDiacritics = function (e) {
			return "string" != typeof e
			  ? (console.warn(
				  "Invalid parameter passed to window.removeDiacritics (".concat(
					_typeof(e),
					")"
				  ),
				  e
				),
				e)
			  : e.replace(/[^\u0000-\u007E]/g, function (e) {
				  return t[e] || e;
				});
		  };
		})(),
		(Txa = $.event),
		(Wxa = window.innerWidth),
		(Uxa = Txa.special.debouncedresize =
		  {
			setup: function () {
			  $(this).on("resize", Uxa.handler);
			},
			teardown: function () {
			  $(this).off("resize", Uxa.handler);
			},
			handler: function (e, t) {
			  function i() {
				(e.type = "debouncedresize"),
				  Txa.dispatch.apply(n, s),
				  Wxa !== window.innerWidth &&
					((e.type = "debouncedresizewidth"),
					Txa.dispatch.apply(n, s),
					(Wxa = window.innerWidth));
			  }
			  var n = this,
				s = arguments;
			  Vxa && clearTimeout(Vxa),
				t ? i() : (Vxa = setTimeout(i, Uxa.threshold));
			},
			threshold: 150,
		  }),
		(function (e) {
		  "use strict";
		  "function" == typeof define && define.amd
			? define(["jquery"], e)
			: "undefined" != typeof exports
			? (module.exports = e(require("jquery")))
			: e(jQuery);
		})(function ($) {
		  "use strict";
		  var ArrayProto = Array.prototype,
			ObjProto = Object.prototype,
			push = ArrayProto.push,
			splice = ArrayProto.splice,
			hasOwnProperty = ObjProto.hasOwnProperty,
			namespace = "Scrollax",
			lownamespace = namespace.toLowerCase(),
			numberRegExp = /[-+]?\d+(\.\d+)?/g,
			transforms = [
			  "translateX",
			  "translateY",
			  "rotate",
			  "rotateX",
			  "rotateY",
			  "rotateZ",
			  "skewX",
			  "skewY",
			  "scaleX",
			  "scaleY",
			],
			$win = $(window),
			$doc = $(document.body),
			transform,
			gpuAcceleration,
			_position,
			bind,
			unbind,
			Scrollax = function i(n, e, t) {
			  var l = this,
				s = (n && $(n).eq(0)) || $win,
				r = i.instances,
				a = null;
			  if (
				((n = s[0]),
				$.each(r, function (e, t) {
				  e && e.frame === n && (a = !0);
				}),
				n && !a)
			  ) {
				var o,
				  d,
				  c,
				  u,
				  h,
				  p,
				  f,
				  v,
				  g,
				  m,
				  y,
				  b,
				  w,
				  x,
				  T,
				  S,
				  C,
				  E,
				  k,
				  Y,
				  z,
				  P,
				  A = $.extend({}, i.defaults, e),
				  M = [],
				  L = null,
				  D = A.parentSelector || "[data-" + lownamespace + "-parent]",
				  O = A.elementsSelector || "[data-" + lownamespace + "]",
				  N = {},
				  I = [],
				  H = isWindow(n);
				(l.frame = n),
				  (l.options = A),
				  (l.parents = M),
				  (l.initialized = !1),
				  (l.reload = q);
				var j = function (e, t) {
				  var i = $(t),
					n = getInlineOptions($(t)),
					s = {};
				  (s.element = t),
					(s.options = n),
					(s.parallaxElements = []),
					i.find(O).each(function (e, t) {
					  var i = getInlineOptions($(t));
					  (i.element = t), push.call(s.parallaxElements, i);
					}),
					push.call(M, s);
				};
				(l.scroll = R),
				  (l.getIndex = function (e) {
					return void 0 !== e
					  ? is_numeric(e)
						? 0 <= e && e < M.length
						  ? e
						  : -1
						: L.index(e)
					  : -1;
				  }),
				  (l.one = function (t, i) {
					return (
					  l.on(t, function e() {
						i.apply(l, arguments), l.off(t, e);
					  }),
					  l
					);
				  }),
				  (l.on = function (e, t) {
					if ("object" === _typeof(e))
					  for (var i in e) hasOwnProperty.call(e, i) && l.on(i, e[i]);
					else if ("function" == typeof t)
					  for (var n = e.split(" "), s = 0, r = n.length; s < r; s++)
						(N[n[s]] = N[n[s]] || []),
						  -1 === _(n[s], t) && push.call(N[n[s]], t);
					else if ("array" == typeof t)
					  for (var a = 0, o = t.length; a < o; a++) l.on(e, t[a]);
					return l;
				  }),
				  (l.off = function (e, t) {
					if (t instanceof Array)
					  for (var i = 0, n = t.length; i < n; i++) l.off(e, t[i]);
					else
					  for (var s = e.split(" "), r = 0, a = s.length; r < a; r++)
						if (((N[s[r]] = N[s[r]] || []), void 0 === t))
						  N[s[r]].length = 0;
						else {
						  var o = _(s[r], t);
						  -1 !== o && splice.call(N[s[r]], o, 1);
						}
					return l;
				  }),
				  (l.set = function (e, t) {
					return (
					  $.isPlainObject(e)
						? $.extend(A, e)
						: hasOwnProperty.call(A, e) && (A[e] = t),
					  q(),
					  l
					);
				  }),
				  (l.destroy = function () {
					return (
					  unbind(window, "resize", B),
					  unbind(n, "scroll", R),
					  $.each(r, function (e, t) {
						e && e.frame === n && splice.call(i.instances, t, 1);
					  }),
					  (M.length = 0),
					  (l.initialized = !1),
					  X("destroy"),
					  l
					);
				  }),
				  (l.init = function () {
					if (!l.initialized)
					  return (
						l.on(t),
						q(),
						bind(window, "resize", B),
						bind(n, "scroll", R),
						push.call(i.instances, l),
						(l.initialized = !0),
						X("initialized"),
						l
					  );
				  });
			  } else
				warn(
				  a
					? namespace +
						": Scrollax has been initialized for this frame!"
					: namespace + ": Frame is not available!"
				);
			  function q() {
				return (
				  (L = H ? $doc.find(D) : s.find(D)),
				  (M.length = 0),
				  (v = !!A.horizontal),
				  L.each(j),
				  R(),
				  A.performanceTrick && (u = H ? $doc : s),
				  X("load"),
				  l
				);
			  }
			  function B() {
				(o = o && clearTimeout(o)),
				  (o = setTimeout(function () {
					l.reload();
				  }));
			  }
			  function R() {
				var e = M.length;
				if (
				  (A.performanceTrick &&
					u &&
					(clearTimeout(h),
					p || (u.addClass("scrollax-performance"), (p = !0)),
					(h = setTimeout(function () {
					  u.removeClass("scrollax-performance"), (p = !1);
					}, 100))),
				  e)
				) {
				  f = getOffset(n);
				  for (var t = 0; t < e; t++)
					(y = M[t]),
					  (m = _position(y.element, n))[v ? "right" : "bottom"] < 0 ||
						m[v ? "left" : "top"] > f[v ? "width" : "height"] ||
						((b = y.options),
						(g = b.offset || A.offset || 0),
						(x = m[v ? "right" : "bottom"]),
						(T = m[v ? "width" : "height"]),
						(w = (T - x + g) / T) < 0 &&
						  ((x = m[v ? "left" : "top"]),
						  (T = f[v ? "width" : "height"]),
						  (w = (T - x + g) / T - 1)),
						1 < w || w < -1 || W(y, w));
				  X("scroll", f);
				}
			  }
			  function W(e, t) {
				var i = (S = e.parallaxElements).length;
				if (i) for (var n = 0; n < i; n++) (C = S[n]), F(C.element, C, t);
			  }
			  function F(e, t, i) {
				for (k in ((E =
				  t.properties ||
				  (v ? { translateX: "100%" } : { translateY: "100%" })),
				(z = ""),
				E)) {
				  if ("number" == typeof (Y = E[k])) Y *= i;
				  else if ("string" == typeof Y)
					for (
					  P = Y.match(numberRegExp), Y = Y, d = 0, c = P.length;
					  d < c;
					  d++
					)
					  Y = Y.replace(P[d], parseFloat(P[d] * i));
				  -1 !== $.inArray(k, transforms)
					? (z += k + "(" + Y + ")")
					: (e.style[k] =
						"opacity" === k
						  ? within(i < 0 ? 1 + Y : 1 - Y, 0, 1)
						  : Y);
				}
				z && (e.style[transform] = gpuAcceleration + z);
			  }
			  function X(e, t) {
				if (N[e]) {
				  for (c = N[e].length, I.length = 0, d = 0; d < c; d++)
					push.call(I, N[e][d]);
				  for (d = 0; d < c; d++) I[d].call(l, e, t);
				}
			  }
			  function _(e, t) {
				for (var i = 0, n = N[e].length; i < n; i++)
				  if (N[e][i] === t) return i;
				return -1;
			  }
			},
			hAa,
			iAa,
			jAa,
			kAa,
			lAa,
			mAa,
			nAa,
			oAa,
			PAa,
			QAa;
		  function warn(e) {
			if (!console || !console.warn) throw namespace + ": " + e;
			console.warn(namespace + ": " + e);
		  }
		  function getOffset(e) {
			var t = !!("pageYOffset" in e);
			return {
			  width: t
				? window.innerWidth ||
				  document.documentElement.clientWidth ||
				  document.body.clientWidth
				: e.offsetWidth,
			  height: t
				? window.innerHeight ||
				  document.documentElement.clientHeight ||
				  document.body.clientHeight
				: e.offsetHeight,
			  left: e[t ? "pageXOffset" : "scrollLeft"],
			  top: e[t ? "pageYOffset" : "scrollTop"],
			};
		  }
		  function is_numeric(e) {
			return (
			  ("number" == typeof e || "string" == typeof e) &&
			  "" !== e &&
			  !isNaN(e)
			);
		  }
		  function within(e, t, i) {
			return e < t ? t : i < e ? i : e;
		  }
		  function getInlineOptions($element) {
			var data = $element.data(lownamespace.toLowerCase());
			return (data && eval("({" + data + "})")) || {};
		  }
		  function isWindow(e) {
			var t, i;
			return !!(
			  e &&
			  "object" === _typeof(e) &&
			  "object" === _typeof(e.window) &&
			  e.window == e &&
			  e.setTimeout &&
			  e.alert &&
			  (t = e.document) &&
			  "object" === _typeof(t) &&
			  (i = t.defaultView || t.parentWindow) &&
			  "object" === _typeof(i) &&
			  i == e
			);
		  }
		  function vAa() {
			this.returnValue = !1;
		  }
		  function wAa() {
			this.cancelBubble = !0;
		  }
		  function RAa(e) {
			for (var t = 0, i = PAa.length; t < i; t++) {
			  var n = PAa[t]
				? PAa[t] + e.charAt(0).toUpperCase() + e.slice(1)
				: e;
			  if (null != QAa.style[n]) return n;
			}
		  }
		  (Scrollax.instances = []),
			(_position = function (e, t) {
			  return (
				(iAa = e.ownerDocument || e),
				(jAa = iAa.documentElement),
				(kAa = isWindow(t) ? t : iAa.defaultView || window),
				(t = t && t !== iAa ? t : jAa),
				(lAa = (kAa.pageYOffset || jAa.scrollTop) - jAa.clientTop),
				(mAa = (kAa.pageXOffset || jAa.scrollLeft) - jAa.clientLeft),
				(nAa = { top: 0, left: 0 }),
				e && e.getBoundingClientRect
				  ? (((nAa = (function (e, t) {
					  for (hAa in t) e[hAa] = t[hAa];
					  return e;
					})({}, e.getBoundingClientRect())).width =
					  nAa.right - nAa.left),
					(nAa.height = nAa.bottom - nAa.top),
					t === kAa
					  ? nAa
					  : ((nAa.top += lAa),
						(nAa.left += mAa),
						(nAa.right += mAa),
						(nAa.bottom += lAa),
						t === jAa ||
						  ((oAa = _position(t)),
						  (nAa.left -= oAa.left),
						  (nAa.right -= oAa.left),
						  (nAa.top -= oAa.top),
						  (nAa.bottom -= oAa.top)),
						nAa))
				  : null
			  );
			}),
			(bind = window.addEventListener
			  ? function (e, t, i, n) {
				  return e.addEventListener(t, i, n || !1), i;
				}
			  : function (t, e, i) {
				  var n = e + i;
				  return (
					(t[n] =
					  t[n] ||
					  function () {
						var e = window.event;
						(e.target = e.srcElement),
						  (e.preventDefault = vAa),
						  (e.stopPropagation = wAa),
						  i.call(t, e);
					  }),
					t.attachEvent("on" + e, t[n]),
					i
				  );
				}),
			(unbind = window.removeEventListener
			  ? function (e, t, i, n) {
				  return e.removeEventListener(t, i, n || !1), i;
				}
			  : function (t, e, i) {
				  var n = e + i;
				  t.detachEvent("on" + e, t[n]);
				  try {
					delete t[n];
				  } catch (e) {
					t[n] = void 0;
				  }
				  return i;
				}),
			(PAa = ["", "webkit", "moz", "ms", "o"]),
			(QAa = document.createElement("div")),
			(transform = RAa("transform")),
			(gpuAcceleration = RAa("perspective") ? "translateZ(0) " : ""),
			(Scrollax.defaults = {
			  horizontal: !1,
			  offset: 0,
			  parentSelector: null,
			  elementsSelector: null,
			  performanceTrick: !1,
			}),
			(window.Scrollax = Scrollax),
			($.fn.Scrollax = function (n, s) {
			  var r, a;
			  return (
				$.isPlainObject(n) ||
				  (("string" != typeof n && !1 !== n) ||
					((r = !1 === n ? "destroy" : n), (a = null)),
				  (n = {})),
				this.each(function (e, t) {
				  var i = $.data(t, lownamespace);
				  i || r
					? i && r && i[r] && i[r].apply(i, a)
					: (i = $.data(t, lownamespace, new Scrollax(t, n, s).init()));
				})
			  );
			}),
			($.Scrollax = function (e, t) {
			  $win.Scrollax(e, t);
			});
		  var css =
			  ".scrollax-performance, .scrollax-performance *, .scrollax-performance *:before, .scrollax-performance *:after { pointer-events: none !important; -webkit-animation-play-state: paused !important; animation-play-state: paused !important; };",
			head = document.head || document.getElementsByTagName("head")[0],
			style = document.createElement("style");
		  return (
			(style.type = "text/css"),
			style.styleSheet
			  ? (style.styleSheet.cssText = css)
			  : style.appendChild(document.createTextNode(css)),
			head.appendChild(style),
			Scrollax
		  );
		});
	})(theme.jQuery);
  